(function () {
    'use strict';

    var stateProviderRef;
    var moduloMenu = angular.module('menu', []);

    moduloMenu.config(function($stateProvider){
        stateProviderRef = $stateProvider;
    });

    moduloMenu.run(function ($rootScope, $http, $mdToast, $interval){
      var intervalPromise = $interval(function () {
        var urlBuscarMenu = "";
        var usuarioLogado = $rootScope.usuarioLogado;
          if(usuarioLogado.id){
              urlBuscarMenu = 'api/item-menu/buscar-menu/id-usuario/' + usuarioLogado.id + '/id-sistema/1';
          }else{
              urlBuscarMenu = 'api/item-menu/public/buscar-menu-publico/id-sistema/1';
          }

          $http.get(urlBuscarMenu).then(function(retorno) {
          $rootScope.menu = retorno.data;
          var states = [];

          var retornaUrl = function(url){
            if(url && url.length > 0){
              return url.substring(0,1) == '/' ? url : '/' + url;
            }
            return undefined;
          };

          var montarStates = function(itens){

            angular.forEach(itens, function(item){

              if(item.url){
                var state = {
                  state: item.codigoIdentificador,
                  url: retornaUrl(item.url),
                  templateUrl: item.templateUrl,
                  controller: item.controller + ' as ' + item.apelidoController
                };

                states.push(state);
              }

              if(item.nos && item.nos.length > 0){
                montarStates(item.nos);
              }
            });
          };

          //montarStates($rootScope.menu);

          angular.forEach(states, function (state) {
            stateProviderRef.state(state.state, state);
          });


          }, function(error){
            $mdToast.show($mdToast.simple().content("Ocorreu um erro ao tentar carregar o menu.").position('top right'));
          });

          $interval.cancel(intervalPromise);

      }, 1000);
    });

    (function () {

        var directive = function ($mdSidenav, $rootScope) {
            return {
                restrict: 'EA',
                templateUrl: 'scripts/menu-modulo/src/menu.tmpl.html',
                link: function ($scope) {

                    $scope.toggleMenu= function() {
                        $mdSidenav('left').toggle();
                    };
                    $scope.closeMenu= function() {
                        $mdSidenav('left').close();
                    };

                    $rootScope.$watch('menu', function(newValue) {
                        if (newValue) {
                            $scope.menuAcessos = $rootScope.menu;
                        }
                    });
                }
            };
        };

        angular
            .module('menu')
            .directive('menu',['$mdSidenav', '$rootScope', directive]);

    }());

})();

(function () {
    'use strict';

    angular.module('acessos', [
        'LocalStorageModule',
        'ngResource',
        'ngCookies',
        'ngAria',
        'ngCacheBuster',
        'ngFileUpload',
        'ui.router',
        'infinite-scroll',
        'angular-loading-bar',
        'ngAnimate',
        'ngMaterial',
        'ngMdIcons',
        'vAccordion',
        'ui.utils.masks',
        'idf.br-filters',
        'md.data.table',
        'lfNgMdFileInput',
        'ui.tree',
        'ngMessages',
        'angularMoment',
        'menu'
    ]);

})();


(function(){
  'use strict';
  angular
    .module('acessos')
    .directive('solicitarAcesso', directive);

  function directive(Modulo, Sistema, Unidade, Organizacao, $q, Perfil, $mdToast){
    return {
      restrict: 'EA',
      templateUrl: 'scripts/directives/solicitar_acesso/solicitarAcesso.html',
      scope:{
        model: "=?"
      },
      link: function($scope){
        var vm = $scope;
        vm.formSistema = {
          modulos: []
        };
        vm.unidades = [];

        var queryDefault = {
          order: 'nome',
          limit: 20,
          page:1
        };

        vm.searchTerm;
        vm.query = angular.copy(queryDefault);
        vm.query.inicio = new Date();
        vm.query.inicio.setMonth(vm.query.inicio.getMonth() - 1);
        vm.query.fim = new Date();

        vm.consultarSistemas = function () {
          vm.promise = Sistema.consultar_sistemas.query(vm.query, consultarSucessoSistema).$promise;
        };

        vm.carregarModulos = function () {
          vm.query.idSistema = vm.formSistema.sistema ? vm.formSistema.sistema : null;
          Modulo.consultar_modulos.query(vm.query).$promise.then(function (result) {
            vm.modulos = result;
            vm.formSistema.modulo = vm.modulos.length == 1 ? vm.modulos[0] : null;
          });
        };

        var consultarSucessoSistema = function (data) {
          vm.sistemas = data;
        };

        vm.carregarUnidadePorNome = function (nome) {
          vm.query.textoPesquisa = nome;
          vm.query.origem = vm.origem;
          return Unidade.listar_nome_sigla_completa_por_texto.get(vm.query).$promise.then(function (data) {
            var deferred = $q.defer();
            deferred.resolve(data.content);
            return deferred.promise;
          });
        };

        vm.consultarPerfis = function () {
          if(!vm.perfis || vm.perfis.length === 0 ||
            (vm.formSistema.modulo && vm.formSistema.modulo.id !== vm.query.idModulo)) {
            vm.query.idModulo = vm.formSistema.modulo ? vm.formSistema.modulo.id : null;
            Perfil.consultar_perfis.query(vm.query).$promise.then(function (result) {
              vm.perfis = result;
            });
          }
        };

        vm.validarConcederAcessoUsuario = function(){
          if(vm.formSolicitarAcesso.$invalid){
            $mdToast.show($mdToast.simple().content("Campos obrigatórios não preenchidos.").position('top right'));
          } else if (!vm.formSistema.nuncaExpira && !vm.formSistema.dataExpiracao) {
            $mdToast.show($mdToast.simple().content('Informe a data de expiração ou marque a checkbox "O acesso nunca expira"').position('top right'));
          } else {
            vm.concederAcesso();
          }
        };

        vm.concederAcesso = function(){
          var mensagem = false;
          vm.formSistema.perfisSelecionados.forEach(function(perfil){
            var acesso = {
              modulo: vm.formSistema.modulo,
              organizacao: vm.formSistema.unidadeExecutora,
              validade: vm.formSistema.nuncaExpira ? null : vm.formSistema.dataExpiracao,
              observacao: vm.formSistema.justificativa,
              perfil: perfil
            };
            if(vm.model.length === 0){
              vm.model.push(acesso);
            }else{
              if(verificarDuplicidade(acesso)){
                mensagem = true;
              }
            }
          });
          if(mensagem){
            $mdToast.show($mdToast.simple().content("Acesso(os) já solicitado.").position('top right'));
          }
        };

        var verificarDuplicidade = function (acesso) {
          var existe = false;
          for(var i = 0; i<vm.model.length; i++){
            if(isEquals(vm.model[i], acesso)){
              existe = true;
              break;
            }
          }
          if(!existe){
            vm.model.push(acesso);
          }
          return existe;
        };

        var isEquals = function(acesso, novoAcesso){
          if((acesso.modulo.id == novoAcesso.modulo.id) &&
             (acesso.organizacao.id == novoAcesso.organizacao.id) &&
             (acesso.validade == novoAcesso.validade) &&
             (acesso.perfil.id == novoAcesso.perfil.id)){
              return true;
          }
        };

        vm.removerAcesso = function($index){
          vm.model.splice($index, 1);
        };

        vm.limparForm = function () {
          vm.formSolicitarAcesso.$setPristine();
          vm.formSolicitarAcesso.$setUntouched();
          // vm.formSistema = {
          //   modulos: []
          // };
        }

      }
    };
  }

})();

( function () {
  "use strict";
  angular.module("acessos").directive("isolateForm", directive);

  function directive() {
    return {
      restrict: 'A',
      require: '?form',
      link: function (scope, elm, attrs, ctrl) {
        if (!ctrl) {
          return;
        }

        var parentForm = ctrl.$$parentForm;
        if (!parentForm) {
          return;
        }

        parentForm.$removeControl(ctrl);
      }
    };
  }
})();

/**
 * Created by guilherme.lima on 14/06/17.
 */

(function(){

  'use strict';
  angular
    .module('acessos')
    .directive('historicoUnidadePadrao', directive);


  function directive(HistoricoUnidadePadrao){
    return {
      restrict: 'EA',
      templateUrl: 'scripts/directives/historico_unidade_padrao/historicoUnidadePadrao.html',
      scope:{
        idUsuario: '=',
        atualizarHistorico: '@'
      },
      link: function($scope){
      $scope.historicoUsuario = [];
        if($scope.atualizarHistorico) {
          $scope.$watch("atualizarHistorico", function () {
            recuperarHistoricoUsuario();
          });
        }

        function recuperarHistoricoUsuario(){
          HistoricoUnidadePadrao.historico_usuario.query({id : $scope.idUsuario}, function(data){
            $scope.historicoUsuario = data;
          });
        }
        recuperarHistoricoUsuario();
      }
    };
  }

})();

/**
 * Created by guilherme.lima on 29/05/17.
 */

(function(){
  'use strict';
  angular
    .module('acessos')
    .directive('historicoAcesso', directive);

  function directive(Acesso, SolicitacaoAcesso, $mdToast, $mdDialog){
    return {
      restrict: 'EA',
      templateUrl: 'scripts/directives/historico_acesso/historicoAcesso.html',
      scope:{
        idUsuario: '=',
        atualizarHistorico: '@',
        meusAcessos: '='
      },
      link: function($scope){
        $scope.acessosVencidosInativos = [];
        $scope.acessosPendentes = [];
        $scope.acessosRecusados = [];
        if($scope.atualizarHistorico) {
          $scope.$watch("atualizarHistorico", function () {
            recuperarAcessosInativos();
            recuperarAcessosPendentes();
          });
        }

        function recuperarAcessosInativos(){
          Acesso.listar_acessos_vencidos_inativos.query({_id : $scope.idUsuario}, function(data){
            $scope.acessosVencidosInativos = data;
          });
        }
        function recuperarAcessosPendentes(){
          var filtros = {};
          if(!$scope.meusAcessos) {
            filtros = {idUsuario : $scope.idUsuario};
          }
          SolicitacaoAcesso.pendentes_logado.query(filtros).$promise.then(function(result){
            $scope.acessosPendentes = [];
            $scope.acessosRecusados = [];
            result.forEach(function (solicitacaoAcesso){
              if(solicitacaoAcesso.solicitacao.situacao == 'NEGADA'){
                $scope.acessosRecusados.push(solicitacaoAcesso);
              } else {
                $scope.acessosPendentes.push(solicitacaoAcesso);
              }
            });
          });
        }

        $scope.reenviarSolicitacao = function (id){
          var confirm = $mdDialog.confirm()
            .title('Reenviar Solicitação')
            .textContent('Um novo email será enviado aos responsáveis pela autorização, deseja continuar ?')
            .ariaLabel('Reenviar Solicitação')
            .targetEvent(event)
            .ok('Enviar')
            .cancel('Retornar');

          $mdDialog.show(confirm).then(function() {
            SolicitacaoAcesso.reenviar_solicitacao.get({_id: id}).$promise.then(function(result){
                $mdToast.show($mdToast.simple().content("Solicitação reenviada com sucesso").position('top right'));
            });
          });
        };
      }
    };
  }

})();

/**
 * Created by guilherme.lima on 20/06/17.
 */
angular.module('acessos')
  .directive("exibirElementoPorPermissao", function ($rootScope) {
      return ({
        link: function link($scope, element, attributes) {
          var usuarioLogado = $rootScope.usuarioLogado;
          var roles = (attributes.exibirElementoPorPermissao || "").split(",");
          var permissaoEncontrada = false;

          for(var i = 0; i < roles.length; i++) {
            if(usuarioLogado.acessos){
              angular.forEach(usuarioLogado.acessos, function(acesso){
                if(acesso.permissoes.indexOf(roles[i].trim()) != -1){
                  permissaoEncontrada = true;
                }
              })
            }
          }
          if(!permissaoEncontrada){
            angular.element(element).remove();
          }
        },
        restrict: "A"
      });
    }
  );

/**
 * Created by guilherme.lima on 29/05/17.
 */

(function(){
  'use strict';
  angular
    .module('acessos')
    .directive('dadosPerfil', directive);

  function directive(){
    return {
      restrict: 'EA',
      templateUrl: 'scripts/directives/dados_perfil/dadosPerfil.html',
      scope:{
        perfil: '='
      },
      link: function($scope){
      }
    };
  }

})();

angular
    .module('acessos')
    .directive('cpfCnpjMask', 
        function cpfCnpjMask() {

            return {
                restrict: 'A',
                require: 'ngModel',
                link : function(scope, element, attrs, ctrl) {
                    var clearValue, format, validations;

                        clearValue = function(rawValue) {
                            return rawValue.replace(/[^A-Z0-9]/g, '').slice(0, 14);
                        };

                        format = function(cleanValue) {

                            var formatedValue;

                            if (isCnpj(cleanValue)) {                                                                         
                                cleanValue = removeLetrasDv(cleanValue); //dv nao permite letras
                                formatedValue =  cleanValue.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/g,"\$1.\$2.\$3\/\$4\-\$5");                                
                                return formatedValue.trim().replace(/[^A-Z0-9]$/, '');
                            } else {
                                formatedValue = cleanValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,"\$1.\$2.\$3\-\$4");
                                return formatedValue.trim().replace(/[^0-9]$/, '');
                            }

                        };

                        validations = {
                            cpf: function(value) {
                                return validaCpf(value);

                            },
                            cnpj: function(value) {
                                return validaCnpj(value);
                            }
                        };

                        ctrl.$formatters.push(function formatter(value) {
                            if (ctrl.$isEmpty(value)) {
                                return value;
                            }

                            var cleanValue = clearValue(value);
                            return format(cleanValue);
                        });

                        ctrl.$parsers.push(function parser(value) {
                            if (ctrl.$isEmpty(value)) {
                                return value;
                            }

                            var cleanValue = clearValue(value);
                            var formattedValue = format(cleanValue);

                            if (ctrl.$viewValue !== formattedValue) {
                                ctrl.$setViewValue(formattedValue);
                                ctrl.$render();
                            }
                            
                            return cleanValue;

                        });

                    function isCnpj(cnpj) {
                        const letrasMauisculas = /[A-Z]/;
                        return cnpj.length > 11 || letrasMauisculas.test(cnpj);
                    }

                    function removeLetrasDv(cnpj) {
                        //apenas retira letras do dv se o cnpj preenchido já possuir 12 caracteres
                        return cnpj.length >= 13
                               ? cnpj.substring(0, cnpj.length-1) + cnpj.substring(cnpj.length-1).replace(/[^0-9]/g, '')
                               : cnpj;
                    }

                    function calcDigitosPosicoes( digitos, posicoes, somaDigitos ) {

                        posicoes = 10;
                        somaDigitos = 0;
                        digitos = digitos.toString();

                        for ( var i = 0; i < digitos.length; i++  ) {

                            somaDigitos = somaDigitos + ( digitos[i] * posicoes );
                            posicoes--;
                            if ( posicoes < 2 ) {
                                posicoes = 9;
                            }
                        }

                        somaDigitos = somaDigitos % 11;
                        if ( somaDigitos < 2 ) {
                            somaDigitos = 0;
                        } else {
                            somaDigitos = 11 - somaDigitos;
                        }

                        var cpf = digitos + somaDigitos;

                        return cpf;

                    };

                    function validaCpf(cpf)
                    {
                        var numeros, digitos, soma, i, resultado, digitosIguais;
                        digitosIguais = 1;
                        if (cpf.length < 11)
                            return false;
                        for (i = 0; i < cpf.length - 1; i++)
                            if (cpf.charAt(i) != cpf.charAt(i + 1))
                            {
                                digitosIguais = 0;
                                break;
                            }
                        if (!digitosIguais)
                        {
                            numeros = cpf.substring(0,9);
                            digitos = cpf.substring(9);
                            soma = 0;
                            for (i = 10; i > 1; i--)
                                soma += numeros.charAt(10 - i) * i;
                            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                            if (resultado != digitos.charAt(0))
                                return false;
                            numeros = cpf.substring(0,10);
                            soma = 0;
                            for (i = 11; i > 1; i--)
                                soma += numeros.charAt(11 - i) * i;
                            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                            if (resultado != digitos.charAt(1))
                                return false;
                            return true;
                        }
                        else
                            return false;
                    };

                    function removeMascaraCNPJ(cnpj) {
                        const regexCaracteresMascara = /[./-]/g;
                        return cnpj.replace(this.regexCaracteresMascara, "");
                    }

                    function validaCnpj(cnpj) {    
                        
                        const tamanhoCNPJSemDV = 12;
                        const regexCNPJSemDV = /^([A-Z\d]){12}$/;
                        const regexCNPJ = /^([A-Z\d]){12}(\d){2}$/;                
                        const regexCaracteresNaoPermitidos = /[^A-Z\d./-]/i;
                        const valorBase = "0".charCodeAt(0);
                        const pesosDV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
                        const cnpjZerado = "00000000000000";


                        if (!this.regexCaracteresNaoPermitidos.test(cnpj)) {
                            var cnpjSemMascara = this.removeMascaraCNPJ(cnpj);
                            if (this.regexCNPJSemDV.test(cnpjSemMascara.substring(0, this.tamanhoCNPJSemDV)) 
                                && cnpjSemMascara !== this.cnpjZerado.substring(0, this.tamanhoCNPJSemDV)) {
                                var somatorioDV1 = 0;
                                var somatorioDV2 = 0;
                                for (var i = 0; i < this.tamanhoCNPJSemDV; i++) {
                                    const asciiDigito = cnpjSemMascara.charCodeAt(i) - this.valorBase;
                                    somatorioDV1 += asciiDigito * this.pesosDV[i + 1];
                                    somatorioDV2 += asciiDigito * this.pesosDV[i];
                                }
                                const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11);
                                somatorioDV2 += dv1 * this.pesosDV[this.tamanhoCNPJSemDV];
                                const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11);
                                const cnpjCalculado = cnpjSemMascara.substring(0, this.tamanhoCNPJSemDV) + dv1 + dv2;
                                return (cnpjCalculado === cnpjSemMascara);
                            }
                        }
                        return false;
                    }

                }
            };

        }
    );

/**
 * Created by guilherme.lima on 07/06/17.
 */
(function(){
  'use strict';
  angular
    .module('acessos')
    .directive('concessaoAcessoEmLote', directive);

  function directive(Usuario, Acesso, Unidade, Organizacao, $q, $state, $mdToast, $mdDialog){
    return {
      restrict: 'EA',
      templateUrl: 'scripts/directives/concessao_acesso_em_lote/concessaoAcessoEmLote.html',
      scope:{
        perfil: '='
      },
      link: function($scope, $element){
        $scope.acessosAssociados = [];

        $scope.termoPesquisa;
        $scope.nuncaExpira = true;
        $scope.dataExpiracao = new Date();

        $scope.usuariosSelecionados = [];

        var queryDefault = {
          order: 'nome',
          limit: 20,
          page:1
        };

        $scope.query = angular.copy(queryDefault);

        var carregarUsuarios = function(){
          Usuario.listar_usuarios_ativos_dados_basicos.query().$promise.then(function(result){
            $scope.usuarios = result;
          });
        };

        $scope.pesquisarUsuario = function(filtro) {
          return Usuario.nome_cpf_ativos.query({param: filtro}).$promise;
        };

        var carregarAcessos = function(){
          Acesso.listar_acessos_ativos_por_perfil.query({_id: $scope.perfil.id}).$promise.then(function(retorno){
            $scope.acessosAssociados = retorno;
          });
        };

        var consultarSucesso = function (data) {
          $scope.acessos = data;
        };

        $scope.consultar = function () {
          $scope.promise = Acesso.resource.query($scope.query, consultarSucesso).$promise;
        };

        var criarObjetoAcessoLoteDto = function(){
          $scope.acessoLoteDto = {
            perfil: $scope.perfil,
            usuariosSelecionados: [],
            dataValidade: null
          };
        };

        $scope.transformChip = function (chip) {
          // Se o parametro for um objeto, ele já é um chip
          if (angular.isObject(chip)) {
            return chip;
          }
          // Senão, cria um novo chip
          return { name: chip, type: 'new' }
        };


        $scope.limparTermoPesquisa = function() {
          $scope.termoPesquisa = '';
        };

        $scope.carregarUnidadePorNome = function (nome) {
          $scope.query.textoPesquisa = nome;
          return Unidade.listar_nome_sigla_completa_por_texto.get($scope.query).$promise.then(function (data) {
            var deferred = $q.defer();
            deferred.resolve(data.content);
            return deferred.promise;
          });
        };

        $scope.associarAcessos = function(){
          if($scope.dataExpiracao && !$scope.nuncaExpira && !$scope.formAcessoEmLote.dataExpiracao.$valid ){
            $mdToast.show($mdToast.simple().content("Preencha a data de expiração corretamente.").position('top right'));
          }else if(!$scope.acessoLoteDto.unidadeExecutora) {
            $mdToast.show($mdToast.simple().content("Informe a UG Executora.").position('top right'));
          } else if (!$scope.acessoLoteDto.usuariosSelecionados || $scope.acessoLoteDto.usuariosSelecionados.length < 1) {
            $mdToast.show($mdToast.simple().content('Selecione ao menos um usuário para ter acesso concedido').position('top right'));
          } else if(!$scope.acessoLoteDto.justificativa) {
            $mdToast.show($mdToast.simple().content("Informe a justificativa").position('top right'));
          } else if (!$scope.nuncaExpira && !$scope.dataExpiracao) {
            $mdToast.show($mdToast.simple().content('Informe a data de expiração ou marque a checkbox "O acesso nunca expira"').position('top right'));
          }else{
            $scope.acessoLoteDto.dataValidade = $scope.nuncaExpira ? null : $scope.dataExpiracao;
            Acesso.salvar_em_lote.save($scope.acessoLoteDto, function(retorno){
              carregarAcessos();
              criarObjetoAcessoLoteDto();
            });
          }
        };

        $scope.setDataValidade = function(datePicker){
          $scope.dataExpiracao = datePicker ? datePicker.dataExpiracao : null;
        };

        $scope.voltarConsultarPerfil = function(){
          $state.go('consultarPerfil');
        };

        $scope.revogarAcessoAssociado = function(id){
          var confirm = $mdDialog.confirm()
            .title('Revogar Acesso')
            .textContent('Deseja confirmar a revogação de acesso do usuário?')
            .ariaLabel('Revogar Acesso')
            .targetEvent(event)
            .ok('Avançar')
            .cancel('Retornar');

          $mdDialog.show(confirm).then(function() {
            Acesso.revogar_acesso.update({_id: id}, function(){
              $mdToast.show($mdToast.simple().content("Acesso revogado").position('top right'));
              carregarAcessos();
            });
          });
        };



        criarObjetoAcessoLoteDto();
        carregarUsuarios();
        carregarAcessos();


        $element.find('input').on('keydown', function(ev) {
          ev.stopPropagation();
        });

      }
    };
  }

})();

(function () {
    'use strict';

    angular.module('acessos')
           .directive('captcha', directive);
            
    function directive(CAPTCHAKEY){
        return {
          restrict: 'E',
          scope: {
            ngModel: '=',
            resetCaptcha: '='
          },
          templateUrl: 'scripts/directives/captcha/captcha.html',
          link: function($scope, $element){
  
            var renderCaptcha = function () {
              hcaptcha.render($element[0].querySelector('#captcha-container'), {
              sitekey: CAPTCHAKEY,
              callback: onCaptchaSuccess,
              'expired-callback': onCaptchaExpired
              });
            };
        
            var onCaptchaSuccess = function (token) {
              $scope.ngModel = token;
              $scope.$apply();
            };
        
            var onCaptchaExpired = function () {
              $scope.ngModel = null;
              $scope.$apply();
            };

            $scope.resetCaptcha = function () {
              $scope.ngModel = null;
              hcaptcha.reset();
            };

            renderCaptcha();
          }
        };
    }
})();
'use strict';

angular.module('acessos')
    .factory('successInterceptor', function ($mdToast) {
        return {
            'responseSucces': function (response) {
                if (response.status == 201) {
                    $mdToast.simple().content("Inclusão realizada com sucesso").theme("success-toast")
                }
            }
        };
    });
'use strict';

angular.module('acessos')
    .factory('errorHandlerInterceptor', function ($q, $rootScope, $window) {
        return {
            'responseError': function (response) {

              if (!(response.status == 401 && response.data.path.indexOf("/api/account") == 0 )) {
                    $rootScope.$emit('acessos.httpError', response);
                }
                if (response.status == 403) {
                    if($rootScope.usuarioLogado && $rootScope.usuarioLogado.id){
                      $window.location.href = '/#/erroPermissao'
                    } else{
                      $window.location.href = '/api';
                    }
                }

              return $q.reject(response);
            }
        };
    });

'use strict';
/**
 * Para interceptar as tentativas de requisições depois da sessão expirar no servidor
 */
angular.module('acessos')
    .factory('authExpiredInterceptor', function ($rootScope, $q, $injector, localStorageService) {
        return {
            responseError: function (response) {
 
                if (response.status == 401 && response.data.path !== undefined && response.data.path.indexOf("/api/login") == -1) {
                    //
                }
                return $q.reject(response);
            }
        };
    });
'use strict';
/**
 * Interceptor para recuperar as alertas enviadas pelo servidor em cabeçalhos http
 */
angular.module('acessos')
    .factory('alertInterceptor', function ($q) {
        return {
            response: function(response) {
                var alertKey = response.headers('X-acessos-alert');
                if (angular.isString(alertKey)) {
                    // Tratar alertas
                }
                return response;
            }
        };
    });
(function () {
    'use strict';

    angular.module('acessos').service('Usuario', Usuario);

    function Usuario($resource) {
        return {
            resource: $resource('/api/usuarios/:_id', {_id: '@_id'}, { 'update': { method:'PUT' }}),
            public: $resource('/api/usuarios/public/:_id', {_id: '@_id'}, { 'update': { method:'PUT' }}),
            listar_usuarios: $resource('/api/usuarios/public/listar-usuarios'),
            cpf: $resource('/api/usuarios/public/recuperar-por-cpf/:cpf', {cpf: '@cpf'}),
            tipos_usuario: $resource('/api/usuarios/tipos-usuario/'),
            nome_cpf: $resource('/api/usuarios/pesquisar-por-cpf-ou-nome/:param', {param: '@param'}),
            nome_cpf_ativos: $resource('/api/usuarios/pesquisar-ativos-por-cpf-ou-nome/:param', {param: '@param'}),
            listar_usuarios_ativos_dados_basicos: $resource('/api/usuarios/usuarios-lightweight'),
            ativar_desativar: $resource('/api/usuarios/ativar-desativar/:_id/:strAtivo',
                {_id: '@_id', strAtivo: '@strAtivo'},
                { 'update': { method:'PUT' }}),
            movimentar_usuario: $resource('/api/usuarios/movimentar-usuario'),
            cadastrar_usuario_aprovacao: $resource('/api/usuarios/public/cadastrar-usuario-aprovacao'),
        }
    }

})();

(function () {
    'use strict';

    angular.module('acessos').controller('UsuarioController', UsuarioController);

    function UsuarioController($scope, $rootScope, $mdDialog, $state, $location, $window, Usuario, Unidade, SituacaoSolicitacao, SolicitacaoAtivacaoUsuario, Acesso,Upload, $filter, $mdToast, $stateParams, $q, Dominio, Sistema, Modulo, Perfil) {

        var vm = this;
        vm.form = {
          modulos: [],
          usuario : {}
        };
        vm.usuario = {};
        vm.acessosAssociadosObj = [];
        vm.unidades = [];
        vm.solicitacoes = [];
        vm.acessosAssociados = [];
        vm.situacoesSolicitacao = [];
        vm.bloquearEnviarFinalizacao = false;
        vm.formModulo = {};
        vm.filtroNomeOrgao = '';
        vm.jurisdicoes = [];

        var queryDefault = {
            order: 'nome',
            limit: 20,
            page:1
        };

        vm.query = angular.copy(queryDefault);
        vm.query.inicio = new Date();
        vm.query.inicio.setMonth(vm.query.inicio.getMonth() - 1);
        vm.query.fim = new Date();
        vm.opcoesAtivoInativo = [{'key': "Ativo", 'value': true}, {'key': "Inativo", 'value': false}];
        vm.opcoesInternoExterno = [{'key': "Interno", 'value': true}, {'key': "Externo", 'value': false}];

        vm.queryConsultaPerfil = angular.copy(queryDefault);

        vm.notificaConsultaLimitada = function () {
          angular.forEach($rootScope.usuarioLogado.acessos, function(acesso){
            if(acesso.permissoes.indexOf("ACESSOS.CONSULTAR_USUARIO") === -1){
              if(acesso.permissoes.indexOf("ACESSOS.CONSULTAR_USUARIO_MODULO_UNIDADE") != -1){
                $mdToast.show($mdToast.simple().content("Acesso limitado ao módulo " + acesso.nomeModulo + " do sistema " + acesso.nomeSistema + " na unidade " + acesso.organizacao.nome).position('top right').hideDelay(8000));
              } else if(acesso.permissoes.indexOf("ACESSOS.CONSULTAR_USUARIO_MODULO_UNID_SUP") != -1){
                $mdToast.show($mdToast.simple().content("Acesso limitado ao módulo " + acesso.nomeModulo + " do sistema " + acesso.nomeSistema + " nas Unidade abaixo da " + acesso.organizacao.nome).position('top right').hideDelay(8000));
              } else if(acesso.permissoes.indexOf("ACESSOS.CONSULTAR_USUARIO_MODULO") != -1){
                $mdToast.show($mdToast.simple().content("Acesso limitado ao módulo " + acesso.nomeModulo + " do sistema " + acesso.nomeSistema).position('top right').hideDelay(8000));
              }
            }
          });
        }

        vm.inicializarConsulta = function() {
            if($stateParams.query && $stateParams.query.pesquisar){
                vm.query = $stateParams.query;
                vm.consultarUsuario();
            }
            vm.notificaConsultaLimitada();
        };

        vm.inicializarConsultaUsuarioUnidade = function() {
          vm.form.orgaoSuperior = $rootScope.unidadeConsultaPerfil;
          if(vm.form.orgaoSuperior && vm.form.orgaoSuperior.id) {
            vm.recuperarJurisdicoesUnidade();
            vm.consultarPerfilUsuario();
          }
        };

        vm.consultar = function () {
            vm.query.dataInicio = vm.query.inicio ? $filter('date')(vm.query.inicio, 'MM/dd/yyyy') : null;
            vm.query.dataFim = vm.query.fim ? $filter('date')(vm.query.fim, 'MM/dd/yyyy') : null;
            vm.promise = SolicitacaoAtivacaoUsuario.resource.query(vm.query, function(data){
                if (data.length > 0){
                  vm.solicitacoes = data;
                } else {
                  $mdToast.show($mdToast.simple().content("A consulta não retornou resultado.").position('top right'));

                }
            });
        };

        vm.consultarUsuario = function () {
          vm.notificaConsultaLimitada();

          Usuario.resource.query(vm.query, function(result){
                vm.usuarios = result;
            });
        };

        vm.consultarPerfilUsuario = function () {
          if (!vm.form.orgaoSuperior){
            $mdToast.show($mdToast.simple().content("Órgão UGE - Órgão Superior ou Entidade é obrigatório").position('top right'));
          } else {
            $rootScope.unidadeConsultaPerfil = vm.form.orgaoSuperior;
            vm.notificaConsultaLimitada();
            Acesso.consultar_relatorio_perfil_usuario.query(vm.queryConsultaPerfil, {param: vm.form.orgaoSuperior.id}, function (result) {
                vm.relatorioPerfilUsuarios = result;
            });
          }
        }

        vm.recuperarJurisdicoesUnidade= function () {
          if(vm.form.orgaoSuperior && vm.form.orgaoSuperior.id) {
            Unidade.resource.get({_id: vm.form.orgaoSuperior.id}, function (data) {
              vm.jurisdicoes = data.jurisdicoes;
            });
          } else {
            vm.jurisdicoes = '';
          }
        };

        vm.pesquisarOrgao = function() {
          var query = angular.copy(queryDefault);
          query.nome = vm.filtroNomeOrgao;
          query.textoPesquisa = vm.filtroNomeOrgao;
          query.isUnidadeUsuarioLogado = true;

          return Unidade.listar_nome_sigla_completa_por_texto.get(query).$promise.then(function (data) {
            var deferred = $q.defer();
            deferred.resolve(data.content);
            return deferred.promise;
          });
        };

        vm.revogarPerfilAcessoAssociado = function(id){
          var confirm = $mdDialog.confirm()
            .title('Revogar Acesso')
            .textContent('Deseja confirmar a revogação desse perfil ?')
            .ariaLabel('Revogar Acesso')
            .targetEvent(event)
            .ok('Avançar')
            .cancel('Retornar');

          $mdDialog.show(confirm).then(function() {
            Acesso.revogar_acesso.update({_id: id}, function(){
              $mdToast.show($mdToast.simple().content("Acesso revogado").position('top right'));
              vm.consultarPerfilUsuario();
            });
          });
        };

        vm.voltar = function(){
          $window.history.back();
        };

        vm.salvar = function () {

            if(!vm.form.nome){
                $mdToast.show($mdToast.simple().content("Nome Obrigatório").position('top right'));
            }else if(!vm.form.cpf) {
              $mdToast.show($mdToast.simple().content("CPF Obrigatório").position('top right'));
            }else if(!vm.form.unidadeExecutoraPadrao) {
                $mdToast.show($mdToast.simple().content("Unidade Executora Padrão Obrigatório").position('top right'));
            }else if(!vm.form.email){
                $mdToast.show($mdToast.simple().content("E-mail Obrigatório").position('top right'));
            }else if(!vm.form.confirmacaoEmail){
                $mdToast.show($mdToast.simple().content("Confirmação e-mail Obrigatório").position('top right'));
            }else if(vm.form.email !== vm.form.confirmacaoEmail){
                $mdToast.show($mdToast.simple().content("Os e-mails informados não coincidem").position('top right'));
            }else{

              Usuario.resource.save(vm.form, function(result){
                        $mdToast.show($mdToast.simple().content("Usuário cadastrado com Sucesso").position('top right'));
                        vm.limpar();
                        vm.voltar();
                    }, function(result){
                      $mdToast.show($mdToast.simple().content(result.message).position('top right'));
                    });

            }
        };

        vm.alterar = function () {
            Usuario.resource.update({_id: $location.search().token}, vm.form, function () {
                $mdToast.show($mdToast.simple().content("Usuario alterado com sucesso").position('top right'));
                $state.go('home');
            });
        };

        vm.finalizar = function(event) {
            var alerta = $mdDialog.alert()
                .clickOutsideToClose(false)
                .title('Confirmação de Finalização do Cadastro')
                .textContent('Cadastro finalizado com sucesso. Solicite agora acesso aos sistemas.')
                .ariaLabel('Cadastro finalizado com sucesso. Solicite agora acesso aos sistemas.')
                .targetEvent(event)
                .ok('Fechar');

            if($scope.form.$invalid){
              $mdToast.show($mdToast.simple().content("Preencha os campos obrigatórios").position('top right'));
            } else if(vm.form.usuario.confirmarSenha !== vm.form.usuario.senha){
                $mdToast.show($mdToast.simple().content("As senhas informadas não coincidem").position('top right'));
            } else if(vm.form.usuario.email !== vm.form.usuario.confirmacaoEmail){
                $mdToast.show($mdToast.simple().content("Os e-mails informados não coincidem").position('top right'));
            } else {
                $mdDialog.show(alerta).then(function () {
                    Usuario.resource.save(vm.form.usuario, function () {
                        $mdToast.show($mdToast.simple().content("Usuario salvo com sucesso").position('top right'));
                        $state.go('home');
                    });
                });
            }
        };

        vm.recuperarUsuarioDetalhar = function() {
            Usuario.resource.get({_id: $stateParams.usuarioId}, function (data) {
                vm.form = data;
                if(vm.form.interno == true){
                    vm.form.interno = 'Interno';
                }else{
                    vm.form.interno = 'Externo';
                }

                if(vm.form.ativo == true){
                    vm.form.ativo = 'Ativo';
                }else{
                    vm.form.ativo = 'Inativo';
                }
            });
        };

        vm.recuperarUsuarioEditar = function() {
            Usuario.resource.get({_id: $stateParams.usuarioId}, function (data) {
              vm.form = data;
              vm.form.confirmarSenha = data.senha;
            });
        };

        vm.carregarUnidades = function() {
            Unidade.consultar_unidade.get({limit: 100000}).$promise.then(function(result) {
              vm.unidades = result.content;
            });
        };

        vm.limparConsultar = function() {
            vm.query = angular.copy(queryDefault);
            $rootScope.unidadeConsultaPerfil = undefined;
            if($stateParams.query){
              $state.go('consultarUsuario', {query: undefined});
            } else{
              $state.reload();
            }
        };

        vm.limparFinalizacaoForm = function () {
            vm.form = {
              modulos: [],
              usuario : {}
            };
            vm.finalizacaoCadastroForm.$setPristine();
            vm.finalizacaoCadastroForm.$setUntouched();
            vm.recuperarSolicitacaoFinalizarCadastroUsuario();
        };

        vm.limpar = function () {
            $state.reload();
        };

        vm.limparEdicao = function () {
            vm.limpar();
        };

        vm.carregarTiposUsuario = function (){
            Usuario.tipos_usuario.query().$promise.then(function(result) {
                vm.tiposUsuario = result;
            });
        };

        vm.pesquisarUnidadeFiltro = function() {
            vm.unidadesSelecionadas = [];
            vm.jurisdicoesSelecionadas = [];
            vm.query.textoPesquisa = vm.query.unidadeExecutoraPadrao;

          return Unidade.resource.get(vm.query).$promise.then( function(data){
            var deferred = $q.defer();
            deferred.resolve(data.content);
            return deferred.promise;
          });
        };

        vm.ativarInativar = function (usuario) {
            var alterouEstadoAtivo = false;
            var confirm = $mdDialog.confirm()
                .title('Ativar/Inativar Usuário')
                .ariaLabel('Confirmação Ativar/Inativar Grupo de Unidade')
                .ok('Avançar')
                .cancel('Retornar');

            $mdDialog.show(confirm).then(function() {
                Usuario.ativar_desativar.update({_id: usuario.id, strAtivo: usuario.ativo}, function () {
                    $mdToast.show($mdToast.simple().content("Ativar/Inativar Usuário Realizado com Sucesso").position('top right'));
                    alterouEstadoAtivo = true;
                });
            }, function(){
                vm.usuarios[vm.usuarios.indexOf(usuario)].usuario.ativo = !vm.usuarios[vm.usuarios.indexOf(usuario)].usuario.ativo;
            });

        };

        vm.detalhar = function (id) {
            $state.go('detalharUsuario', { usuarioId: id, query: vm.query });
        };

        vm.editar = function (id) {
            $state.go('editarUsuario', { usuarioId: id, query: vm.query });
        };

        vm.criarNovoUsuario = function(){
            $state.go('cadastrarUsuario');
        };

        vm.voltar = function(){
            if($stateParams.query){
                $stateParams.query.pesquisar = true;
            }
            $window.history.back()
        };

        vm.addAcesso = function (id) {
            $state.go('concederAcesso', { usuarioId: id, query: vm.query });
        };

        vm.salvarEdicao = function () {

          if(vm.form.telefoneTrabalho == null){
            $mdToast.show($mdToast.simple().content("Informe o telefone de trabalho").position('top right'));
          }  else if (!vm.form.interno && ( !vm.form.confirmarSenha || !vm.form.senha)) {
            $mdToast.show($mdToast.simple().content("Informe a senha e confirmação de senha.").position('top right'));
          }else if(vm.form.interno === false && vm.form.email !== vm.form.confirmacaoEmail){
            $mdToast.show($mdToast.simple().content("Os e-mails informados não coincidem").position('top right'));
          }else if(vm.form.interno === false && vm.form.confirmarSenha !== vm.form.senha){
            $mdToast.show($mdToast.simple().content("As senhas informadas não coincidem").position('top right'));
          } else {
            if (vm.foto && vm.foto[0] != null) {
              vm.salvarDocumento(vm.foto[0]).then(function (result) {
                vm.form.foto = result;
                vm.editaUsuario();
              });
            } else {
              vm.editaUsuario();
            }
          }
        };

        vm.editaUsuario = function (){
          Usuario.resource.update({_id : vm.form.id}, vm.form, function (result) {
            $mdToast.show($mdToast.simple().content("Usuário editado com sucesso.").position('top right'));
            if($state.current.name == "editarUsuario"){
              $state.go('consultarUsuario');
            }
          }, function(error){
            $mdToast.show($mdToast.simple().content(error.data.message).position('top right'));
          });
        };

        vm.excluir = function (event, id) {
            var confirm = $mdDialog.confirm()
                .title('Excluir Usuário')
                .textContent('Ao remover esse usuário todas as permissões, perfis e acessos vinculados a ele serão excluídos.\n Deseja proseguir?')
                .ariaLabel('Confirmação de Exclusão do Usuário')
                .targetEvent(event)
                .ok('Avançar')
                .cancel('Retornar');

            $mdDialog.show(confirm).then(function() {
                Usuario.resource.delete({_id: id}, function(){
                    $mdToast.show($mdToast.simple().content("Usuário removido com sucesso.").position('top right'));
                    vm.consultarUsuario();
                });
            });
        };

        vm.listarPerfisAssociados = function(){
            Acesso.listar_acessos_completos.query({idUsuario : $stateParams.usuarioId}, function(data){
                vm.acessosAssociados = data;
            });
        };

        vm.revogarAcessoAssociado = function(id){
            var confirm = $mdDialog.confirm()
                .title('Revogar Acesso')
                .textContent('Deseja confirmar a revogação desse perfil ?')
                .ariaLabel('Revogar Acesso')
                .targetEvent(event)
                .ok('Avançar')
                .cancel('Retornar');

            $mdDialog.show(confirm).then(function() {
                Acesso.revogar_acesso.update({_id: id}, function(){
                    $mdToast.show($mdToast.simple().content("Acesso revogado").position('top right'));
                    vm.listarPerfisAssociados();
                },function(result){
                    $mdToast.show($mdToast.simple().content(result.data.message).position('top right'));
                });
            });
        };

        vm.salvarDocumento = function(documento){

            if(documento) {
                return Upload.upload({
                    url: '/api/documentos',
                    data: {
                        tipo: documento.lfFile.type,
                        nome: documento.lfFile.name,
                        tamanho: documento.lfFile.size,
                        dado: documento.lfFile
                    }
                }).then(function (resp) {
                    return resp.data;
                }, function (resp) {
                    $mdToast.show($mdToast.simple().content("Houve um erro ao salvar o documento").position('top right'));
                });
            }

            return null;
        };

        vm.carregarSituacaoSolicitacao = function(result) {
            return SituacaoSolicitacao.query().$promise.then(function (data) {
                vm.situacoesSolicitacao = data;
            });
        };

        vm.tratar = function(id){
            SolicitacaoAtivacaoUsuario.tratar_solicitacao.save({_id: id}, function(data){
                $mdToast.show($mdToast.simple().content("Solicitação foi aceita com sucesso.").position('top right'));
                $state.reload();
            });
        };

        vm.recusar = function(id){
            SolicitacaoAtivacaoUsuario.recusar_solicitacao.save({_id: id}, function(data){
                $mdToast.show($mdToast.simple().content("Solicitação foi rejeitada.").position('top right'));
                $state.reload();
            });
        };

        vm.recuperarSolicitacaoFinalizarCadastro = function(){
            SolicitacaoAtivacaoUsuario.recuperar_solicitacao_finalizar_cadastro.get({_chave: $stateParams.chave}, function(result){
                vm.usuario = result;
            }, function (responseError) {
                $mdToast.show($mdToast.simple().content(responseError.data.message).position('top right'));
                vm.bloquearEnviarFinalizacao = true;
                // $state.go('home');
            });
        };


      vm.recuperarSolicitacaoFinalizarCadastroUsuario = function(){
        vm.form.chaveFinalizacao = $stateParams.chave;
        SolicitacaoAtivacaoUsuario.recuperar_solicitacao_finalizar_cadastro.get({_chave: $stateParams.chave},
          function(result){
              vm.form.usuario.nome = result.nome;
              vm.form.usuario.cpf = result.cpf;
              vm.form.usuario.email = result.email;
              vm.form.usuario.confirmarEmail = result.email;
          },
          function (erro) {
            if(erro.data.status == 400)
            $mdToast.show($mdToast.simple().content("Operação não permitida").position('top right'));
            $state.go('home');
          }
        );
        vm.carregarUnidades();
      };


        vm.movimentarUsuario = function(id){
          $state.go('movimentarUsuario', { usuarioId: id, query: vm.query });
        };

      vm.recuperarUsuarioMovimentar = function() {
        Usuario.resource.get({_id: $stateParams.usuarioId}, function (data) {
          vm.usuario = data;
          vm.movimentarUsuarioDto = {
            usuario: vm.usuario,
            replicarPermissoes: false,
            revogarPermissoes: false
          };

        });
      };

      vm.recuperarOrigens = function(){
        Dominio.origem.query().$promise.then(function (result) {
          vm.origens = result;
        });
      };

      vm.upperCase = function(param){
        vm.form.usuario[param] = vm.form.usuario[param].toUpperCase();
      };

      vm.gravarMovimentacaoUsuario = function(){
        if(vm.movimentarUsuarioDto.usuario && vm.movimentarUsuarioDto.unidadeExecutora){
          Usuario.movimentar_usuario.save(vm.movimentarUsuarioDto, function (retorno) {
            $mdToast.show($mdToast.simple().content("Movimentação realizada com sucesso.").position('top right'));
            vm.voltar();
          })
        }else{
          $mdToast.show($mdToast.simple().content("Preencha os campos obrigatórios").position('top right'));
        }

      };

      vm.carregarUnidadePorNome = function (nome) {
        vm.query.textoPesquisa = nome;
        vm.query.origem = vm.origem;
        return Unidade.listar_nome_sigla_completa_por_texto.get(vm.query).$promise.then(function (data) {
          var deferred = $q.defer();
          deferred.resolve(data.content);
          return deferred.promise;
        });
      };

      vm.enviarCadastroUsuario = function () {
        if(vm.finalizacaoCadastroForm.$invalid ){
          vm.finalizacaoCadastroForm.$setSubmitted();
          $mdToast.show($mdToast.simple().content("Campo(s) obrigatório(s) não preenchido(s)").position('top right'));
        }else if(vm.acessosAssociadosObj.length === 0 ){
          $mdToast.show($mdToast.simple().content("É necessário solicitar ao menos um perfil.").position('top right'));
        }else{
          Usuario.cadastrar_usuario_aprovacao.save({chaveFinalizacao: vm.form.chaveFinalizacao, usuario: vm.form.usuario, acessos: vm.acessosAssociadosObj}, function(data){
            $mdToast.show($mdToast.simple().content("Seu cadastro foi finalizado com sucesso!").position('top right'));
            $state.go('cadastroRealizado');
          });
        }
      };


      vm.consultarSistemas = function () {
        vm.promise = Sistema.consultar_sistemas.query(vm.query, consultarSucessoSistema).$promise;
      };

      var consultarSucessoSistema = function (data) {
        vm.sistemas = data;
      };

      vm.carregarModulos = function () {
        vm.query.idSistema = vm.form.sistema ? vm.form.sistema : null;
        Modulo.consultar_modulos.query(vm.query).$promise.then(function (result) {
          vm.modulos = result;
          vm.form.modulo = vm.modulos.length == 1 ? vm.modulos[0] : null;
        });
      };

      vm.consultarPerfis = function () {
        if(!vm.perfis || vm.perfis.length === 0 ||
          (vm.form.modulo && vm.form.modulo.id !== vm.query.idModulo)) {
          vm.query.idModulo = vm.form.modulo ? vm.form.modulo.id : null;
          Perfil.consultar_perfis.query(vm.query).$promise.then(function (result) {
            vm.perfis = result;
          });
        }
      };

      vm.validarConcederAcessoUsuario = function(){
        if(vm.form.dataExpiracao && !$scope.form.dataExpiracao.$valid && !vm.nuncaExpira){
          $mdToast.show($mdToast.simple().content("Preencha a data de expiração corretamente.").position('top right'));
        }else if(!vm.form.unidadeExecutora) {
          $mdToast.show($mdToast.simple().content("Informe a UG Executora.").position('top right'));
        } else if(!vm.form.modulo){
          $mdToast.show($mdToast.simple().content("Informe o módulo.").position('top right'));
        } else if(!vm.form.perfisSelecionados || vm.form.perfisSelecionados.length === 0){
          $mdToast.show($mdToast.simple().content("Informe o perfil.").position('top right'));
        } else if (!vm.nuncaExpira && !vm.form.dataExpiracao) {
          $mdToast.show($mdToast.simple().content('Informe a data de expiração ou desmarque a checkbox "O acesso nunca expira"').position('top right'));
        } else {
          vm.concederAcesso();
        }
      };

      vm.removerAcesso = function($index){
        vm.acessosAssociadosObj.splice($index, 1);
      };

      vm.concederAcesso = function(){
        vm.form.perfisSelecionados.forEach(function(perfil){
          var acesso = {
            modulo: vm.form.modulo,
            organizacao: vm.form.unidadeExecutora,
            validade: vm.nuncaExpira ? null : vm.form.dataExpiracao,
            observacao: vm.form.justificativa,
            perfil: perfil
          };
          vm.acessosAssociadosObj.push(acesso);
        });
      };

    }

})();

(function () {
    'use strict';

    angular.module('acessos').factory('Unidade', Unidade);

    function Unidade($resource) {
        return {
            resource: $resource('/api/unidades/:_id', {_id: '@_id'}, {'update': {method: 'PUT'}}),
            consultar_unidade: $resource('/api/unidades/public/:_id', {_id: '@_id'}, {'update': {method: 'PUT'}}),
            associar_jurisdicoes: $resource('/api/unidades/associar-jurisdicoes'),
            unidades_usuario: $resource('/api/unidades/buscar-unidades-usuario/'),
            listar_nome_sigla_completa_por_texto: $resource('/api/unidades/public/listar-nome-sigla-completa-por-texto'),
            ativar_desativar: $resource('/api/unidades/ativar-desativar/:_id/:strAtivo',
                {_id: '@_id', strAtivo: '@strAtivo'},
                { 'update': { method:'PUT' }})
        };
    };

})();

(function () {
  'use strict';

  angular.module('acessos').controller('UnidadeController', UnidadeController);

  function UnidadeController(Unidade, Orgao, Organizacao, TipoAdministracao, $mdToast, $mdDialog, $stateParams, $state, $scope) {

    var vm = this;
    vm.unidades = [];
    vm.selecionado = [];
    vm.form = {};
    vm.tiposAdministracao = {};

    vm.unidadesSelecionadas = [];
    vm.filtroNomeOrgao = '';
    vm.opcoesAtivoInativo = [{'key': "Ativo", 'value': true}, {'key': "Inativo", 'value': false}];

    var queryDefault = {
      order: 'nome',
      limit: 20,
      strAtivo: true,
      page:1
    };

    vm.query = angular.copy(queryDefault);
    vm.queryAtiva = {};

    vm.consultarUnidade = function(){
      $state.go('consultarUnidade');
    }

    vm.consultar = function () {
      vm.queryAtiva = angular.copy(vm.query);
      vm.queryAtiva.page = 1;
      vm.carregarPagina();
    };

    vm.carregarPagina = function(){

      if(vm.form.organizacaoSuperior) {
        vm.queryAtiva.idOrganizacaoSuperior = vm.form.organizacaoSuperior.id;
        vm.queryAtiva.organizacaoSuperior = vm.form.organizacaoSuperior;
      } else {
        delete vm.queryAtiva.idOrganizacaoSuperior;
        delete vm.queryAtiva.organizacaoSuperior;
      }

      if(vm.query.nome) {
        vm.queryAtiva.textoPesquisa = vm.query.nome;
        vm.queryAtiva.nome = vm.query.nome;
      } else {
        delete vm.queryAtiva.textoPesquisa;
        delete vm.queryAtiva.nome;
      }

      Unidade.resource.get(vm.queryAtiva, function(data){
        vm.totalElements = data.totalElements;
        vm.unidades = data.content;
      }, function(error){
        $mdToast.show($mdToast.simple().content("Nenhum registro encontrado.").position('top right'));
      });
    };

    vm.salvar = function () {
      Unidade.resource.save(vm.form, function () {
        $mdToast.show($mdToast.simple().content("Unidade salva com sucesso.").position('top right'));
        $state.go('consultarUnidade');
      });


    };

    vm.salvarEdicao = function () {
      Unidade.resource.update({_id: $stateParams.unidadeId}, vm.form, function () {
        $mdToast.show($mdToast.simple().content("Unidade salva com sicesso.").position('top right'));
        $state.go('consultarUnidade');
      });
    };

    vm.editar = function (id) {
      vm.queryAtiva.pesquisar = false;
      $state.go('editarUnidade', { unidadeId: id, query: vm.queryAtiva });
    };

    vm.detalhar = function (id) {
      vm.queryAtiva.pesquisar = false;
      $state.go('detalharUnidade', { unidadeId: id, query: vm.queryAtiva });
    };

    vm.excluir = function (event, id) {
      var confirm = $mdDialog.confirm()
        .title('Excluir Unidade')
        .textContent('Deseja realmente excluir essa unidade?')
        .ariaLabel('Excluir Unidade')
        .targetEvent(event)
        .ok('Avançar')
        .cancel('Retornar');

      $mdDialog.show(confirm).then(function() {
        Unidade.resource.delete({_id: id}, function(){
          $mdToast.show($mdToast.simple().content("Unidade excluída").position('top right'));
          vm.consultar();
        });
      });
    };

    vm.recuperarUnidade= function () {
      if($stateParams.unidadeId) {
        Unidade.resource.get({_id: $stateParams.unidadeId}, function (data) {
          vm.form = data;
        });
      }
    };

    vm.recuperarUnidadeDetalhar= function () {
      if($stateParams.unidadeId) {
        Unidade.resource.get({_id: $stateParams.unidadeId}, function (data) {
          vm.form = data;

          if(vm.form.ativo == true){
            vm.form.ativo = 'Ativo';
          }else{
            vm.form.ativo = 'Inativo';
          }
        });
      }
    };

    vm.limparConsultar = function () {
      vm.query = angular.copy(queryDefault);
      if($stateParams.query){
        $state.go('consultarUnidade', {query: undefined});
      } else{
        $state.reload();
      }
    };

    vm.limpar = function () {
      vm.query = angular.copy(queryDefault);
      $state.reload();
    };

    vm.carregarOrgaos = function () {
      vm.unidadesSelecionadas = [];
      Orgao.resource.query().$promise.then(function (result) {
        vm.orgaos = result;
      });
    };

    vm.pesquisarOrgao = function() {
      var query = angular.copy(queryDefault);
      query.strAtivo = null;
      query.nome = vm.filtroNomeOrgao;
      query.textoPesquisa = vm.filtroNomeOrgao;
      return Organizacao.listar_orgaos_entidades.query(query).$promise;
    };

    vm.consultarTipoAdministracao = function() {
      return TipoAdministracao.query({param: vm.filtroTipoAdministracao}).$promise.then(function (data) {
        vm.tiposAdministracao = data;
      });
    };

    vm.desabilitarGravar = function(){
      if(!$scope.unidadeForm.$valid || !vm.form.nome || !vm.form.codigoUg){
        return true;
      }
      else{
        return false;
      }
    };

    vm.criarNovaUnidade = function(){
      $state.go("cadastrarUnidade");
    };

    vm.voltar = function(){
      if($stateParams.query){
        $stateParams.query.pesquisar = true;
      }
      $state.go("consultarUnidade", {query: $stateParams.query});
    };

    vm.ativarInativar = function (unidade) {
      var confirm = $mdDialog.confirm()
        .title('Ativar/Inativar Unidade Executora')
        .textContent('Ativar/inativar Unidade Executora.\n Deseja proseguir?')
        .ariaLabel('Confirmação Ativar/Inativar Unidade Executora')
        .targetEvent(event)
        .ok('Avançar')
        .cancel('Retornar');

      $mdDialog.show(confirm).then(function() {
        Unidade.ativar_desativar.update({_id: unidade.id, strAtivo: unidade.ativo}, function () {
          $mdToast.show($mdToast.simple().content("Ativar/Inativar Unidade Executora Realizado com Sucesso").position('top right'));
        });
      }, function(){
        vm.unidades[vm.unidades.indexOf(unidade)].ativo = !vm.unidades[vm.unidades.indexOf(unidade)].ativo;
      });
    };

    vm.inicializarConsulta = function(){
      if($stateParams.query && $stateParams.query.pesquisar){
        vm.query = $stateParams.query;
        vm.form.organizacaoSuperior = $stateParams.query.organizacaoSuperior;

        vm.consultar();
      }
    };

  }
})();

(function () {
    'use strict';
    angular.module('acessos').service('Uf', Uf);

    function Uf($resource) {
        return $resource('/api/ufs/');
    }
})();
(function () {
    'use strict';
    angular.module('acessos').service('TipoAdministracao', TipoAdministracao);

    function TipoAdministracao($resource) {
        return $resource('/api/public/tipos-administracao/:_id', {_id: '@_id'});
    }
})();

(function () {
    'use strict';
    angular.module('acessos').service('SolicitacaoAtivacaoUsuario', SolicitacaoAtivacaoUsuario);

    function SolicitacaoAtivacaoUsuario($resource) {
        return {
            resource: $resource('/api/solicitacoes-ativacao-usuario/'),
            public: $resource('/api/solicitacoes-ativacao-usuario/public'),
            salvar_solicitacao: $resource('/api/solicitacoes-ativacao-usuario/public/salvar-solicitacao'),
            tratar_solicitacao: $resource('/api/solicitacoes-ativacao-usuario/tratar-solicitacoes/:_id', {_id: '@_id'}),
            recusar_solicitacao: $resource('/api/solicitacoes-ativacao-usuario/recusar-solicitacoes/:_id', {_id: '@_id'}),
            reenviar_email_solicitacao: $resource('/api/solicitacoes-ativacao-usuario/public/reenviar-email-solicitacao/:_id', {_id: '@_id'}),
            recuperar_solicitacao_finalizar_cadastro: $resource('/api/solicitacoes-ativacao-usuario/public/recuperar-solicitacao-finalizar-cadastro/:_chave', {_chave: '@_chave'})
        };
    }
})();

(function () {
  'use strict';

  angular.module('acessos').controller('SolicitacaoUsuarioController', SolicitacaoUsuarioController);

  function SolicitacaoUsuarioController($mdToast, $mdDialog, $stateParams, $state, $scope, Usuario, SolicitacaoAtivacaoUsuario) {

    var vm = this;
    vm.form = {
      usuario: {}
    };

    vm.recuperarNome = function () {
      if(vm.form.solicitacaoAtivacaoUsuario.cpf && $scope.form.cpf.$valid) {
        Usuario.cpf.get({cpf: vm.form.solicitacaoAtivacaoUsuario.cpf},
          function (data) {
            vm.form.solicitacaoAtivacaoUsuario.nome = data.nome;
            vm.nomeRecuperado = true;
          },
          function (erro) {
            if(erro.data.status == 400) {
              dialogCpfInvalido(erro.data.message);
            }
            vm.nomeRecuperado = false;
          }
        );
      }
    };

    var dialogCpfInvalido = function (msg) {
      var alerta = $mdDialog.alert()
        .clickOutsideToClose(false)
        .title('Erro ao recuperar usuário.')
        .textContent(msg)
        .ariaLabel(msg)
        .ok('Fechar');

      $mdDialog.show(alerta);
    };

    vm.reenviarEmail = function(){
      SolicitacaoAtivacaoUsuario.reenviar_email_solicitacao.get({_id: $stateParams.id}, function(data){
        $mdDialog.show(alertDialog("E-mail reenviado com sucesso."));
      });
    };

    vm.limpar = function () {
      $state.reload();
    };

    vm.enviar = function (event) {
      var usuario = {
        "nome" :  vm.form.solicitacaoAtivacaoUsuario.nome,
        "email" : vm.form.solicitacaoAtivacaoUsuario.email,
        "cpf" : vm.form.solicitacaoAtivacaoUsuario.cpf,
        "papeisUsuarioSolicitacao": [4]
      };

      var solicitacao = {
        "data": new Date(),
        "situacao": 0,
        "solicitante": usuario
      };

      var solicitacaoAtivacao = {
        cpfUsuario: usuario.cpf
      };

      if(validarConfirmacaoEmail() === true) {
        Usuario.public.query({cpf: usuario.cpf}, function (data) {
          if (data.length > 0) {
            if (data[0].ativo) {
              vm.usuarioEditarDados = data[0];
              vm.dialogEditarUsuarioAtivo();
            } else {
              var mensagem = data[0].interno ?
                "CPF já está cadastrado porém usuário desativado! Procure a central de serviços ou envie email para: spunet-gestao@economia.gov.br" :
                "CPF já está cadastrado porém usuário desativado! Procure o Responsável Legal e/ou Administrador de sua unidade ou envie email para: spunet-gestao@economia.gov.br";
              $mdDialog.show(alertDialog(mensagem));
            }
          } else {
            SolicitacaoAtivacaoUsuario.public.query(solicitacaoAtivacao, function (data) {
              if (data.length > 0) {
                $mdDialog.show(alertDialog("Já possui uma solicitação para o usuário informado. Aguarde a analise da solicitação ou envie email para: spunet-gestao@economia.gov.br"));
              } else {
                vm.form.solicitacaoAtivacaoUsuario.solicitacao = solicitacao;
                vm.form.solicitacaoAtivacaoUsuario.usuario = usuario;
                SolicitacaoAtivacaoUsuario.salvar_solicitacao.save(vm.form, function (data) {
                  $mdDialog.show(alertDialog("Solicitação criada com sucesso."));
                  $state.go('solicitarUsuario', {id: data.id});
                }, function (result){
                  $mdDialog.show(alertDialog(result.data.message));
                  vm.resetCaptcha();
                });
              }
            });
          }
        });
      }
    };

    var validarConfirmacaoEmail = function () {
      if (vm.form.solicitacaoAtivacaoUsuario.email !== vm.form.solicitacaoAtivacaoUsuario.confirmacaoEmail) {
        $mdToast.show($mdToast.simple().content("Confirmação de e-mail inválida").position('top right'));
        return false;
      }
      return resolvaCaptcha();
    };

    var resolvaCaptcha = function () {
      if($scope.form.$invalid || vm.form.captchaResponse == null) {
        $mdToast.show($mdToast.simple().content("Preencha os campos obrigatórios").position('top right'));
        if(vm.form.captchaResponse == null) {
          $mdDialog.show(alertDialog("Resolva o CAPTCHA"));
        }
        return false;
      }
      return true;
    };

    var alertDialog = function(mensagem){
      return $mdDialog.alert()
        .clickOutsideToClose(false)
        .title('Solicitação de Ativação Usuário')
        .textContent(mensagem)
        .ariaLabel(mensagem)
        .ok('Fechar');
    };

    vm.dialogEditarUsuarioAtivo = function(){
      var confirm = $mdDialog.confirm()
        .title('Solicitação de Ativação Usuário')
        .textContent('Usuário já está cadastrado e ativo. Deseja editar o usuário?')
        .ariaLabel('Solicitação de Ativação Usuário')
        .ok('Sim')
        .cancel('Não');

      $mdDialog.show(confirm).then(function() {
        $state.go('editarUsuario', {usuarioId: vm.usuarioEditarDados.id});
      });
    };
  }

})();

(function () {
  'use strict';
  angular.module('acessos').service('SolicitacaoAtivacaoOrgaoModulo', SolicitacaoAtivacaoOrgaoModulo);

  function SolicitacaoAtivacaoOrgaoModulo($resource) {
      return {
          resource: $resource('/api/solicitacoes-ativacao-orgao-modulo/:_id', {_id: '@_id'}),
          salvar_modulos_solicitacao: $resource('/api/solicitacoes-ativacao-orgao-modulo/salvar-modulo-solicitacao'),
          recuperar_modulos_solicitacao : $resource('/api/solicitacoes-ativacao-orgao-modulo/solicitacao-ativacao-orgao/:idSolicitacaoAtivacaoOrgao',
          {idSolicitacaoAtivacaoOrgao: '@idSolicitacaoAtivacaoOrgao'},
          { 'get': { method:'GET' }})
      };
  }
})();

(function () {
    'use strict';
    angular.module('acessos').service('SolicitacaoAtivacaoOrgao', SolicitacaoAtivacaoOrgao);

    function SolicitacaoAtivacaoOrgao($resource) {
        return {
            resource: $resource('/api/solicitacoes-ativacao-orgao/:_id', {_id: '@_id'}),
            recuperar_formulario_padrao: $resource('/api/solicitacoes-ativacao-orgao/public/formulario-padrao'),
            salvar_solicitacao: $resource('/api/solicitacoes-ativacao-orgao/public/salvar-solicitacao'),
            tratar_solicitacao: $resource('/api/solicitacoes-ativacao-orgao/tratar-solicitacao/:_id',
                  {_id: '@_id'}, { 'update': { method:'PUT' }})
        };
    }
})();

(function () {
    'use strict';
    angular.module('acessos').service('SolicitacaoAcesso', SolicitacaoAcesso);

    function SolicitacaoAcesso($resource) {
        return{
            resource: $resource('/api/solicitacoes-acesso/:_id', {_id: '@_id'}),
            pendentes_logado: $resource('/api/solicitacoes-acesso/pendentes-logado'),
            reenviar_solicitacao: $resource('/api/solicitacoes-acesso/reenviar-notificacao-pendente/:_id', {_id: '@_id'}),
            tratar_solicitacao: $resource('/api/solicitacoes-acesso/tratar-solicitacao/:_id',
            {_id: '@_id'}, { 'update': { method:'PUT' }})
        }};
    })();

    (function () {
        'use strict';
        angular.module('acessos').service('SituacaoSolicitacao', SituacaoSolicitacao);

        function SituacaoSolicitacao($resource) {
            return $resource('/api/situacoes-solicitacao/:_id', {_id: '@_id'});
        }
    })();

(function () {
    'use strict';

    angular.module('acessos').factory('SituacaoSolicitacao', SituacaoSolicitacao);

    function SituacaoSolicitacao($resource) {
        return $resource('/api/situacoes-solicitacao/');
    };

})();
(function () {
    'use strict';

    angular.module('acessos').service('Sistema', Sistema);

    function Sistema($resource) {
        return {
            resource: $resource('/api/sistemas/:_id', {_id: '@_id'},{ 'update': { method:'PUT' }}),
            consultar_sistemas: $resource('/api/sistemas/public/:_id', {_id: '@_id'},{ 'update': { method:'PUT' }}),
            desassociar_modulos: $resource('/api/sistemas/desassociar-modulos/:_id', {_id: '@_id'}),
            email_contato: $resource('/api/sistemas/public/email-contato',{responseType: 'text'})
        };
    };

})();

(function () {
    'use strict';

    angular.module('acessos').controller('SistemaController', SistemaController);

    function SistemaController(Sistema, $filter, $mdToast, $mdDialog, $stateParams, $state, $scope, Upload, Modulo, Dominio) {

        var vm = this;
        vm.comboSistemas = [];
        vm.sistemas = [];
        vm.comboOrigens = [];
        vm.selecionado = [];
        vm.sigla = '';
        vm.form = {
            interno: false,
            modulos: []
        };

        vm.formModulo = {};

        var queryDefault = {
            order: 'nome',
            limit: 20,
            page:1
        };

        vm.query = angular.copy(queryDefault);

        var consultarSucesso = function (data) {

            if(data.length == 0){
                $mdToast.show($mdToast.simple().content("A consulta não retornou resultado.").position('top right'));
                vm.sistemas = [];
            } else{
                vm.sistemas = data;
            }
        };

        vm.consultarSistema = function(){
            $state.go('consultarSistema');
        }

        vm.consultar = function () {
            vm.promise = Sistema.resource.query(vm.query, consultarSucesso).$promise;
        };

        vm.salvarDocumento = function(documento){

            if(documento) {
                return Upload.upload({
                    url: '/api/documentos',
                    data: {
                        tipo: documento.lfFile.type,
                        nome: documento.lfFile.name,
                        tamanho: documento.lfFile.size,
                        dado: documento.lfFile
                    }
                }).then(function (resp) {
                    return resp.data;
                }, function (resp) {
                    $mdToast.show($mdToast.simple().content("Houve um erro ao salvar o documento").position('top right'));
                });
            }
            return null;
        };

        vm.salvar = function () {
            if (vm.form.modulos.length == 0){
                $mdToast.show($mdToast.simple().content("É necessário cadastrar ao menos um módulo.").position('top right'));
            } else if (vm.files[0] != null) {
                vm.salvarDocumento(vm.files[0]).then(function (result) {
                    Sistema.resource.save({
                        nome: vm.form.nome,
                        descricao: vm.form.descricao,
                        esquema: vm.form.esquema,
                        interno: vm.form.interno,
                        sigla: vm.form.sigla,
                        codigoSistema: vm.form.codigoSistema,
                        modulos: vm.form.modulos,
                        origem: vm.form.origem,
                        logo: result
                    }, function(resp){
                        $mdToast.show($mdToast.simple().content("Sistema salvo com sucesso").position('top right'));
                        $state.go('consultarSistema');
                    }, function(error){
                        $mdToast.show($mdToast.simple().content(error.data.message).position('top right'));
                    });
                });
            }else{
                Sistema.resource.save({
                    nome: vm.form.nome,
                    descricao: vm.form.descricao,
                    esquema: vm.form.esquema,
                    interno: vm.form.interno,
                    sigla: vm.form.sigla,
                    codigoSistema: vm.form.codigoSistema,
                    modulos: vm.form.modulos,
                    origem: vm.form.origem
                }, function(resp){
                    $mdToast.show($mdToast.simple().content("Sistema salvo com sucesso").position('top right'));
                    $state.go('consultarSistema');
                }, function(error){
                    $mdToast.show($mdToast.simple().content(error.data.message).position('top right'));
                });
            }
        };

        vm.salvarEdicao = function () {

            if (vm.form.modulos.length == 0){
                $mdToast.show($mdToast.simple().content("É necessário cadastrar ao menos um módulo.").position('top right'));
            } else if (vm.files[0] != null) {
                vm.salvarDocumento(vm.files[0]).then(function (result) {
                    Sistema.resource.update({_id:vm.form.id,
                        nome: vm.form.nome,
                        descricao: vm.form.descricao,
                        esquema: vm.form.esquema,
                        interno: vm.form.interno,
                        sigla: vm.form.sigla,
                        codigoSistema: vm.form.codigoSistema,
                        modulos: vm.form.modulos,
                        origem: vm.form.origem,
                        logo: result
                    }, function (resp) {
                        $mdToast.show($mdToast.simple().content("Sistema alterado com sucesso").position('top right'));
                        $state.go('consultarSistema');
                    }, function (error) {
                        $mdToast.show($mdToast.simple().content(error.data.message).position('top right'));
                    });
                });
            }else{
                Sistema.resource.update({
                    _id:vm.form.id,
                    nome: vm.form.nome,
                    descricao: vm.form.descricao,
                    esquema: vm.form.esquema,
                    interno: vm.form.interno,
                    sigla: vm.form.sigla,
                    codigoSistema: vm.form.codigoSistema,
                    modulos: vm.form.modulos,
                    origem: vm.form.origem
                }, function (resp) {
                    $mdToast.show($mdToast.simple().content("Sistema alterado com sucesso").position('top right'));
                    $state.go('consultarSistema');
                }, function (error) {
                    $mdToast.show($mdToast.simple().content(error.data.message).position('top right'));
                });
            }
        };

        vm.criarNovoSistema = function(){
            $state.go('cadastrarSistema');
        };

        vm.voltar = function(){
          if($stateParams.query){
            $stateParams.query.pesquisar = true;
          }
          $state.go("consultarSistema", {query: $stateParams.query});
        };

        vm.editar = function (id) {
          vm.query.pesquisar = false;
          $state.go('editarSistema', { sistemaId: id, query: vm.query });
        };

        vm.detalhar = function (id) {
          vm.query.pesquisar = false;
          $state.go('detalharSistema', { sistemaId: id, query: vm.query });
        };

        vm.excluir = function (event, id) {
            var confirm = $mdDialog.confirm()
                .title('Excluir Sistema')
                .textContent('Ao remover esse sistema todas as permissões, perfis, módulos e acessos vinculados a ele serão excluídos.\n Deseja prosseguir?')
                .ariaLabel('Confirmação de Exclusão do Sistema')
                .targetEvent(event)
                .ok('Avançar')
                .cancel('Retornar');

            $mdDialog.show(confirm).then(function() {
                Sistema.resource.delete({_id: id}, function(){
                    $mdToast.show($mdToast.simple().content("Sistema excluído").position('top right'));
                    vm.consultar();
                });
            });
        };

        vm.carregarSistemas = function () {
            Sistema.resource.query().$promise.then(function (result) {
                vm.comboSistemas = result;
            });
        };

        vm.carregarOrigens = function () {
          Dominio.origem.query().$promise.then(function (result) {
              vm.comboOrigens = result;
          });
        };

        vm.carregarOrigens();

        vm.recuperarSistema = function () {
            if($stateParams.sistemaId) {
                Sistema.resource.get({_id: $stateParams.sistemaId}, function (data) {
                    vm.form = data;
                    vm.sigla = data.sigla;

                    if (!data.logo){
                        $mdToast.show($mdToast.simple().content("O sistema não possui logo").position('top right'));
                    }

                });
            }
        };

        vm.limpar = function () {
            $state.reload();
        };

        vm.limparConsultar = function () {
            if($stateParams.query){
              $state.go('consultarSistema', {query: undefined});
            } else{
              $state.reload();
            }
        };

        vm.desabilitarGravar = function() {
            return $scope.formSistema.$invalid;
        };

        vm.cadastrarModulo = function(){

          if(vm.formModulo.sigla && vm.formModulo.nome && vm.formModulo.codigoModulo && vm.formModulo.url){

            var parametroDuplicado = $filter('filter')(vm.form.modulos,{
              codigoModulo: vm.formModulo.codigoModulo
            }, true);

            if(parametroDuplicado.length == 0){

              Modulo.verificar_modulo_unico.query({"codigoModulo" : vm.formModulo.codigoModulo, "sigla" : vm.formModulo.sigla}, function(data){
                if(data.length > 0){
                  $mdToast.show($mdToast.simple().content("O código e/ou sigla já foram utilizados anteriormente para outro módulo.").position('top right'));
                } else {
                  vm.formModulo.excluido = false;
                  vm.form.modulos.push(vm.formModulo);
                  vm.formModulo = {};
                }
              });
            }
            else if (parametroDuplicado[0].excluido == true){
              parametroDuplicado[0].excluido = false;
            }
            else {
              $mdToast.show($mdToast.simple().content("Módulo já cadastrado.").position('top right'));
            }
          } else{
            $mdToast.show($mdToast.simple().content("Preencha as informações do módulo.").position('top right'));
          }
        };

        vm.excluirModulo = function(modulo){
            if(vm.form.modulos.length > 1 || !modulo.id) {
                var confirm = $mdDialog.confirm()
                    .title('Excluir módulo')
                    .textContent('Ao excluir esse módulo todas permissões, perfis, itens de menu e acessos vinculados a ele serão impactados.\n Deseja proseguir?')
                    .ariaLabel('Confirmação exclusão de módulo')
                    .targetEvent(event)
                    .ok('Avançar')
                    .cancel('Retornar');

                $mdDialog.show(confirm).then(function () {
                  var idx = vm.form.modulos.indexOf(modulo);
                    if (typeof modulo.id != 'undefined') {
                        Sistema.desassociar_modulos.save({_id: modulo.id}, function () {
                            $mdToast.show($mdToast.simple().content("Módulo desassociado com sucesso.").position('top right'));
                        }, function (error) {
                            vm.form.modulos.splice(idx, 0, modulo);
                            $mdToast.show($mdToast.simple().content(error.data.message).position('top right'));
                        });
                    }
                    vm.form.modulos.splice(vm.form.modulos.indexOf(modulo), 1);
                });
            }else{
                $mdToast.show($mdToast.simple().content("É preciso ter ao menos um módulo. Inclua um módulo antes de excluir esse módulo.").position('top right'));
            }

        };

        vm.inicializarConsulta = function(){
          if($stateParams.query && $stateParams.query.pesquisar){
            vm.carregarSistemas();
            vm.query = $stateParams.query;

            vm.consultar();
          }
        };

    };

})();

(function () {
    'use strict';

    angular.module('acessos').controller('SamlController', SamlController);

    function SamlController($http, $location) {
        var vm = this;
        vm.credenciais = {};

        vm.recuperarUsuario = function () {
            var queryString = $location.search();
            $http({
                method: 'GET',
                url: '/api/saml/SSO/alias/acessoslocal',
                params: ''
            })
                .then(function (response) {
                    console.log(response);
                });
        };
    }
})();
(function () {
    'use strict';
    angular.module('acessos').service('Poder', Poder);

    function Poder($resource) {
        return $resource('/api/public/poderes/');
    }
})();

(function () {
    'use strict';

    angular.module('acessos').factory('Permissao', Permissao);

    function Permissao($resource) {
        return $resource('/api/permissoes/:_id', {_id: '@_id'}, { 'update': { method:'PUT' }});
    };

})();

(function () {
    'use strict';

    angular.module('acessos').factory('PermissaoNaoVinculada', Permissao);

    function Permissao($resource) {
        return $resource('/api/permissoes/perfil-nao-vinculado/:_id', {_id: '@_id'}, { 'update': { method:'PUT' }, 'get': {method:'GET', isArray:true}});
    };

})();
(function () {
    'use strict';

    angular.module('acessos').controller('PermissaoController', PermissaoController);

    function PermissaoController(Sistema, Permissao, Modulo, AcaoHttp, $mdToast, $mdDialog, $stateParams, $state, $scope) {

        var vm = this;
        vm.sistemas = [];
        vm.modulos = [];
        vm.permissoes = [];
        vm.acoesHttp = [];
        vm.selecionado = [];
        vm.form = {
            exigeCertificadoDigital: false,
            permissaoSistema: false,
            acoes: []
        };

        var queryDefault = {
            order: 'nome',
            limit: 20,
            page:1
        };

        vm.query = angular.copy(queryDefault);

        var consultarSucesso = function (data) {
            if(data.length == 0){
                $mdToast.show($mdToast.simple().content("A consulta não retornou resultados.").position('top right'));
                vm.permissoes = [];
            } else {
                vm.permissoes = data;
            }
        }

        vm.consultar = function () {
            vm.promise = Permissao.query(vm.query, consultarSucesso).$promise;
        };

        vm.salvar = function () {
            vm.verificarPermissaoSistema();
            vm.form.codigoModulo = vm.form.modulo.codigoModulo;
            Permissao.save(vm.form, function () {
                $mdToast.show($mdToast.simple().content("Permissão salva").position('top right'));
                $state.go('consultarPermissao');
            }, function(result){                
                $mdToast.show($mdToast.simple().content(result.data.message).position('top right'));                          
            });
        };

        vm.salvarEdicao = function () {
            vm.verificarPermissaoSistema();
            Permissao.update(
              {_id: vm.form.id}, vm.form, function () {
              $mdToast.show($mdToast.simple().content("Permissão salva").position('top right'));
              $state.go('consultarPermissao');
            }, function(result){                
                $mdToast.show($mdToast.simple().content(result.data.message).position('top right'));                          
            });
        };

        vm.criarNovaPermissao = function(){
            $state.go('cadastrarPermissao');
        };

        // Garante que a permissão só possuirá valores 'true' ou 'false'
        vm.verificarPermissaoSistema = function() {
            if(vm.form.permissaoSistema != true) {
                vm.form.permissaoSistema = false;
            }
        }

        vm.voltar = function(){
            if($stateParams.query){
              $stateParams.query.pesquisar = true;
            }
            $state.go("consultarPermissao", {query: $stateParams.query});
        };

        vm.editar = function (id) {
            vm.query.pesquisar = false;
            $state.go('editarPermissao', { permissaoId: id, query: vm.query });
        };

        vm.detalhar = function (id) {
            vm.query.pesquisar = false;
            $state.go('detalharPermissao', { permissaoId: id, query: vm.query });
        };

        vm.excluir = function (event, id, nomeSistema) {
            var confirm = $mdDialog.confirm()
                .title('Excluir Permissão')
                .textContent('Ao remover essa permissão as funcionalidades do Sistema '+ nomeSistema +' não funcionarão.\n Deseja proseguir?')
                .ariaLabel('Excluir Permissão')
                .targetEvent(event)
                .ok('Avançar')
                .cancel('Retornar');

            $mdDialog.show(confirm).then(function() {
                Permissao.delete({_id: id}, function(){
                    $mdToast.show($mdToast.simple().content("Permissão excluída").position('top right'));
                    vm.consultar();
                });
            });
        };

        vm.carregarSistemas = function () {
            Sistema.resource.query().$promise.then(function (result) {
                vm.sistemas = result;
            });
        };

        vm.carregarModulos = function () {
            Modulo.resource.query(vm.query).$promise.then(function (result) {
                vm.modulos = result;
            });
        };

        vm.carregarAcoesHttp = function() {
            AcaoHttp.query().$promise.then(function(result){
                vm.acoesHttp = result;
            });
        };

        vm.recuperarPermissao = function () {
            if($stateParams.permissaoId) {
                vm.titulo = 'Editar';
                Permissao.get({_id: $stateParams.permissaoId}, function (data) {
                    vm.form = data;
                });
            }
        };

        vm.limpar = function () {
            $state.reload();
        };

        vm.limparConsultar = function () {
          if($stateParams.query){
            $state.go('consultarPermissao', {query: undefined});
          } else{
            $state.reload();
          }
        };

        vm.toggle = function (acao, lista) {
            var idx = lista.indexOf(acao);
            if (idx > -1) {
                lista.splice(idx, 1);
            }
            else {
                lista.push(acao);
            }
        };

        vm.marcarAcao = function (acao, lista) {
            return lista.indexOf(acao) > -1;
        };

      vm.inicializarConsulta = function(){
        if($stateParams.query && $stateParams.query.pesquisar){
          vm.carregarSistemas();
          vm.carregarModulos();
          vm.query = $stateParams.query;

          vm.consultar();
        }
      };

    }

})();

(function () {
    'use strict';

    angular.module('acessos').factory('Perfil', Perfil);

    function Perfil($resource) {
        return {
            resource: $resource('/api/perfis/:_id', {_id: '@_id'}, { 'update': { method:'PUT' }}),
            consultar_perfis: $resource('/api/perfis/public/:_id', {_id: '@_id'}, { 'update': { method:'PUT' }})
        };
    };

})();

(function () {
  'use strict';

  angular.module('acessos').controller('PerfilController', PerfilController);

  function PerfilController(Perfil, Modulo, Sistema, Permissao, $mdToast, $mdDialog, $stateParams, $state, $scope) {


    var vm = this;
    vm.perfis = [];
    vm.selecionado = [];
    $scope.ordenacaoAtual = 'nome';
    $scope.direcaoOrdenacao = false;

    vm.form = {
      perfilSistema: false,
      permissoes: [],
      moduloFiltro: {}
    };

    var queryDefault = {
      order: 'nome',
      limit: 20,
      page: 1
    };

    var queryDefaultFiltro = {
      order: 'nome',
      limit: 20,
      page: 1
    };

    vm.sistemas = [];
    vm.modulos = [];
    vm.sistemas_filtro_permissoes = [];
    vm.modulos_filtro_permissoes = [];
    vm.permissoes = [];

    vm.query = angular.copy(queryDefault);
    vm.queryFiltro = angular.copy(queryDefaultFiltro);

    var consultarSucesso = function (data) {
      vm.perfis = data;
    };

    vm.inicializarConsulta = function () {
      if ($stateParams.query && $stateParams.query.pesquisar) {
        vm.carregarSistemas();
        vm.carregarModulos();
        vm.query = $stateParams.query;
        vm.consultar();
      }
    };

    vm.inicializarConsultaFiltro = function () {
      if ($stateParams.queryFiltro) {
        vm.carregarSistemasFiltro();
        vm.carregarModulosFiltro();
        vm.queryFiltro = $stateParams.queryFiltro;
        vm.consultarFiltro();
      }
    };

    vm.carregarSistemasFiltro = function () {
      Sistema.resource.query(vm.queryFiltro).$promise.then(function (result) {
        vm.sistemas_filtro_permissoes = result;
      });
    };

    vm.carregarModulosFiltro = function () {
      Modulo.resource.query(vm.queryFiltro).$promise.then(function (result) {
        vm.modulos_filtro_permissoes = result;
      });
    };

    vm.consultar = function () {
      vm.promise = Perfil.resource.query(vm.query, consultarSucesso).$promise;
    };
    vm.consultarFiltro = function () {
      vm.promise = Perfil.resource.query(vm.queryFiltro, consultarSucesso).$promise;
    };


    vm.salvar = function () {
      Perfil.resource.save(vm.form, function (responseSuccess) {
        $mdToast.show($mdToast.simple().content("Perfil salvo").position('top right'));
        $state.go('consultarPerfil');
      }, function (responseError) {
        $mdToast.show($mdToast.simple().content(responseError.data.message).position('top right'));
      });
    };

    vm.salvarEdicao = function () {
      Perfil.resource.update({_id: $stateParams.perfilId}, vm.form, function (responseSuccess) {
        $mdToast.show($mdToast.simple().content("Perfil salvo").position('top right'));
        $state.go('consultarPerfil');
      }, function (responseError) {
        $mdToast.show($mdToast.simple().content(responseError.data.message).position('top right'));
      });
    };

    vm.criarNovoPerfil = function () {
      $state.go('cadastrarPerfil');
    };

    vm.voltar = function () {
      if ($stateParams.query) {
        $stateParams.query.pesquisar = true;
      }
      $state.go('consultarPerfil', {query: $stateParams.query});
    };

    vm.editar = function (id) {
      $state.go('editarPerfil', {perfilId: id, query: vm.query});
    };

    vm.detalhar = function (id) {
      $state.go('detalharPerfil', {perfilId: id, query: vm.query});
    };

    vm.concederAcessoEmLote = function (idPerfil) {
      $state.go('concederAcessoEmLote', {idPerfil: idPerfil});
    };

    vm.excluir = function (event, id) {
      var confirm = $mdDialog.confirm()
        .title('Excluir Perfil')
        .textContent('Ao remover o perfil todas as permissões e acessos vinculados a ele serão desvinculados.\n Deseja continuar?')
        .ariaLabel('Excluir Perfil')
        .targetEvent(event)
        .ok('Avançar')
        .cancel('Retornar');

      $mdDialog.show(confirm).then(function () {
        Perfil.resource.delete({_id: id}, function () {
          $mdToast.show($mdToast.simple().content("Perfil excluído").position('top right'));
          vm.consultar();
        });
      });
    };

    vm.recuperarPerfil = function () {
      if ($stateParams.perfilId) {
        Perfil.resource.get({_id: $stateParams.perfilId}, function (data) {
          vm.form = data;
          // md-table com md-row-select exige que o ng-model seja sempre um array.
          // Sem isso, o Material chama .isSelected()/.every() sobre um valor
          // nao-array e quebra o $digest (TypeError: e.isSelected is not a function).
          if (!angular.isArray(vm.form.permissoes)) {
            vm.form.permissoes = [];
          }
          vm.form.idModulo = vm.form.modulo.id;
          vm.carregarPermissoes();
        });
      }
    };

    vm.limpar = function () {
      $state.reload();
    };

    vm.limparConsultar = function () {
      vm.query = angular.copy(queryDefault);
      if ($stateParams.query) {
        $state.go('consultarPerfil', {query: undefined});
      } else {
        $state.reload();
      }
    };

    vm.carregarSistemas = function () {
      Sistema.resource.query(vm.query).$promise.then(function (result) {
        vm.sistemas = result;
      });
    };

    vm.carregarModulos = function () {
      Modulo.resource.query(vm.query).$promise.then(function (result) {
        vm.modulos = result;
      });
    };

    vm.carregarPermissoes = function () {
      // moduloFiltro e o modulo escolhido no select de filtro da tela.
      // No carregamento inicial (edicao) ele ainda nao foi escolhido pelo
      // usuario, entao caimos no modulo do proprio perfil (vm.form.modulo).
      var modulo = vm.form.moduloFiltro && vm.form.moduloFiltro.id
        ? vm.form.moduloFiltro
        : vm.form.modulo;

      if (!modulo || !modulo.id) {
        return;
      }

      vm.queryFiltro.idModulo = modulo.id;
      vm.queryFiltro.idSistema = modulo.sistema ? modulo.sistema.id : undefined;

      Permissao.query(vm.queryFiltro).$promise.then(function (result) {
        vm.permissoes = result;
        sincronizarSelecao();
      });
    };

    // As permissoes ja vinculadas ao perfil (vm.form.permissoes) vem de uma
    // chamada diferente da listagem exibida na tabela (vm.permissoes). Como sao
    // instancias de objeto distintas, o md-table nao marca os checkboxes.
    //
    // Para a tabela reconhecer a selecao, as permissoes que aparecem na listagem
    // atual precisam ser a MESMA instancia presente em vm.permissoes. Ao mesmo
    // tempo, precisamos preservar as permissoes ja vinculadas que pertencem a
    // outros modulos/sistemas (nao visiveis na listagem filtrada atual), para
    // nao perde-las ao gravar.
    var sincronizarSelecao = function () {
      if (!angular.isArray(vm.form.permissoes) || !angular.isArray(vm.permissoes)) {
        return;
      }

      var idsVinculados = vm.form.permissoes.map(function (p) {
        return p.id;
      });

      var idsNaListagem = vm.permissoes.map(function (p) {
        return p.id;
      });

      // Permissoes vinculadas que NAO estao na listagem atual (outros modulos):
      // mantem as instancias originais para nao perder a selecao ao gravar.
      var vinculadasForaDaListagem = vm.form.permissoes.filter(function (p) {
        return idsNaListagem.indexOf(p.id) === -1;
      });

      // Permissoes vinculadas que estao na listagem atual: usa a instancia da
      // listagem (mesma referencia que o md-table renderiza nas linhas).
      var vinculadasNaListagem = vm.permissoes.filter(function (p) {
        return idsVinculados.indexOf(p.id) > -1;
      });

      vm.form.permissoes = vinculadasForaDaListagem.concat(vinculadasNaListagem);
    };



  }

})();

(function () {
    'use strict';

    angular.module('acessos').factory('Orgao', Orgao);

    function Orgao($resource) {
        return {
            resource: $resource('/api/orgaos/:_id', {_id: '@_id'}, { 'update': { method:'PUT' }}),
            ativar_desativar: $resource('/api/orgaos/ativar-desativar/:_id/:strAtivo',
                {_id: '@_id', strAtivo: '@strAtivo'}, { 'update': { method:'PUT' }})
        };
    };

})();
(function () {
  'use strict';

  angular.module('acessos').controller('OrgaoController', OrgaoController);

  function OrgaoController(Orgao, Usuario, TipoAdministracao, Poder, EsferaPoder, SolicitacaoAtivacaoOrgao, SolicitacaoAtivacaoOrgaoModulo, Organizacao, Entidade, SituacaoSolicitacao, Sistema, Modulo, Perfil, Upload, Unidade, $filter, $timeout, $q,  $mdToast, $mdDialog, $stateParams, $state, $scope, $rootScope, CAPTCHAKEY, $window, $element) {

    var vm = this;
    vm.opcoesAtivoInativo = [{'key': "Ativo", 'value': true}, {'key': "Inativo", 'value': false}];
    vm.orgaos = [];
    vm.selecionado = [];
    vm.form = {};
    vm.formResponsavel = {};
    vm.formAdministrador = {};
    vm.formAvaliacaoSolicitacao = {
      data: new Date(),
      modulos: []
    };
    vm.usuarios = [];
    vm.responseCaptcha = "";

    //Autocomplete da pesquisa de Solicitante, Administradores e Responsável
    vm.filtroSolicitante = '';
    vm.solicitantesSelecionados = [];
    vm.showFormCadastroSolicitante = false;

    vm.filtroAdministrador = '';
    vm.administradoresSelecionados = [];
    vm.showFormCadastroAdministrador = false;

    vm.filtroResponsavel = '';
    vm.responsaveisSelecionados = [];
    vm.showFormCadastroResponsavel = false;
    vm.responsavelSelecionadoAuxiliar = [];

    vm.situacoesSolicitacao = [];

    vm.esferasPoder = [];

    vm.filtroTipoAdministracao = '';
    vm.tiposAdministracao = [];
    vm.tipoAdministracao;

    vm.filtroPoder = '';
    vm.poderes = [];
    vm.poder;

    vm.filtroNomeOrgao = '';
    vm.formularioPadrao = {};

    vm.formCadastroEntidade = {};
    vm.showFormCadastroEntidade = false;

    vm.form.exigeCertificadoDigital = false;

    vm.tipoAdministracaoPrivada = 15;
    vm.tipoAdministracaoSemFinsLucrativos = 16;

    var enumPapelAdministradorOrgao = 0,
      enumPapelResponsavelOrgao = 1,
      enumPapelResponsavelImoveis = 2,
      enumPapelUsuario = 3,
      enumPapelSolicitante = 4;

    var enumSituacaoPendente = 0;

    //vm.reCaptcha = CAPTCHAKEY;

    vm.form.dataPublicacaoAtoNomeacaoResponsavel = new Date();
    vm.form.dataAtoNomeacaoResponsavel = new Date();

    vm.sistemas = [];
    vm.modulos = [];
    vm.perfis = [];
    vm.opcoesDecisao = [{'key': "De acordo", 'value': true}, {'key': "Recusar", 'value': false}];

    var queryDefault = {
      order: 'nome',
      limit: 20,
      page: 1
    };

    vm.query = angular.copy(queryDefault);
    vm.query.inicio = new Date();
    vm.query.inicio.setMonth(vm.query.inicio.getMonth() - 1);
    vm.query.fim = new Date();

    var consultarSucesso = function (data) {
      vm.orgaos = data;
      if (vm.orgaos.length === 0) {
        $mdToast.show($mdToast.simple().content("A consulta não retornou resultado.").position('top right'));
      }
    };

    vm.inicializarConsulta = function () {
      if($stateParams.query && $stateParams.query.pesquisar){
        vm.query = $stateParams.query;
        vm.consultar();
      }
    };

    vm.inicializarConsultaSolicitAtivOrgao = function(){
      if($stateParams.query && $stateParams.query.pesquisar){
        vm.query = $stateParams.query;

        vm.consultarSolicitacaoAtivacao();
      }
    };

    vm.consultarOrgao = function(){
      $state.go('consultarOrgao');
    }

    vm.voltarConsultarSolicitAtivacaoOrgao = function() {
      if($stateParams.query){
        $stateParams.query.pesquisar = true;
      }
      $state.go('consultarSolicitAtivacaoOrgao', { query: $stateParams.query });
    }

    vm.voltarConsultarOrgao = function() {
      if($stateParams.query){
        $stateParams.query.pesquisar = true;
      }
      $state.go('consultarOrgao', { query: $stateParams.query });
    }

    vm.consultarPerfil = function(){
      $state.go('consultarPerfil');
    }

    vm.consultar = function () {
      vm.query.textoPesquisa = vm.query.nome;
      vm.promise = Organizacao.listar_orgaos_entidades.query(vm.query, consultarSucesso).$promise;
    };

    vm.salvar = function () {
      if(vm.form.tipoAdministracao.id === vm.tipoAdministracaoPrivada
        || vm.form.tipoAdministracao.id === vm.tipoAdministracaoSemFinsLucrativos){
        Entidade.resource.save(vm.form, function () {
          $mdToast.show($mdToast.simple().content("Órgão UGE - Órgão Superior​ ou Entidade salvo").position('top right'));
          $state.go('consultarOrgao');
        });
      }else {
        Orgao.resource.save(vm.form, function () {
          $mdToast.show($mdToast.simple().content("Órgão UGE - Órgão Superior​ ou Entidade salvo").position('top right'));
          $state.go('consultarOrgao');
        });
      }
    };

    vm.salvarEntidade = function () {
      vm.form.organizacao = angular.copy(vm.formCadastroEntidade);
      vm.form.tipoEntidade = $filter('filter')(vm.tiposAdministracao,{
        id: vm.query.tipoAdministracaoId
      })[0];
      //vm.filtroNomeOrgao = vm.formCadastroEntidade.nome;
      vm.formCadastroEntidade={};
      vm.fecharFormCadastroEntidade();
    };

    vm.salvarEdicao = function () {
      vm.form.ativo = stringToSituacaoAtivo(vm.form.ativo);
      Orgao.resource.update({_id: $stateParams.orgaoId}, vm.form, function () {
        $mdToast.show($mdToast.simple().content("Órgão UGE - Órgão Superior​ ou Entidade salvo").position('top right'));
        $state.go('consultarOrgao');
      });
    };

    vm.editar = function (id) {
      $state.go('editarOrgao', {orgaoId: id, query: vm.query});
    };

    vm.detalhar = function (id) {
      $state.go('detalharOrgao', {orgaoId: id, query: vm.query});
    };

    vm.excluir = function (event, id) {
      var confirm = $mdDialog.confirm()
        .title('Excluir Órgão')
        .textContent('Deseja realmente excluir esse órgão?')
        .ariaLabel('Excluir Órgão')
        .targetEvent(event)
        .ok('Avançar')
        .cancel('Retornar');

      $mdDialog.show(confirm).then(function () {
        Orgao.resource.delete({_id: id}, function () {
          $mdToast.show($mdToast.simple().content("Órgão excluído").position('top right'));
          vm.consultar();
        });
      });
    };

    vm.recuperarOrgao = function () {
      if ($stateParams.orgaoId) {
        Orgao.resource.get({_id: $stateParams.orgaoId}, function (data) {
          vm.form = data;
          vm.form.ativo = situacaoAtivoToString(data.ativo);
        });
      }
    };

    vm.validarSolicitacaoAtivacaoOrgao = function(){
      if(!vm.solicitantesSelecionados[0]) {
        $mdToast.show($mdToast.simple().content("Informe o solicitante.").position('top right'));
      } else if(!vm.form.organizacao){
        $mdToast.show($mdToast.simple().content("Informe o Órgão Superior ou Entidade.").position('top right'));
      } else if (vm.formularioAutorizacao.length == 0){
        $mdToast.show($mdToast.simple().content("Insira o formulário de autorização.").position('top right'));
      } else if (vm.responsaveisSelecionados.length === 0) {
        $mdToast.show($mdToast.simple().content("Informe o responsável legal").position('top right'));
      } else if (vm.documentoComprobatorioResponsavel.length == 0){
        $mdToast.show($mdToast.simple().content("Insira o documento comprobatório do Responsável Legal.").position('top right'));
      } else if (vm.documentoPessoalResponsavel.length == 0){
        $mdToast.show($mdToast.simple().content("Insira a cópia de RG e CPF do Responsável Legal.").position('top right'));
      } else if (vm.administradoresSelecionados.length < 2) {
        $mdToast.show($mdToast.simple().content("Informe pelo menos dois administradores").position('top right'));
      } else if (!vm.form.telefone){
        $mdToast.show($mdToast.simple().content("Informe o telefone").position('top right'));
      } else if (!vm.form.emailInstitucional){
        $mdToast.show($mdToast.simple().content("Informe o e-mail").position('top right'));
      } else if (!vm.form.emailInstitucionalConfirmacao){
        $mdToast.show($mdToast.simple().content("Informe a confirmaçao do e-mail").position('top right'));
        //} else if (!vcRecaptchaService || vm.responseCaptcha == "") {
        //    $mdToast.show($mdToast.simple().content("Preencha o re-captcha.").position('top right'));
      } else if (vm.formAvaliacaoSolicitacao.modulos.length < 1) {
        $mdToast.show($mdToast.simple().content("Informe pelo menos um sistema/módulo").position('top right'));
      }else {
        vm.salvarSolicitacaoAtivacaoOrgao();
      }
    };

    vm.salvarSolicitacaoAtivacaoOrgao = function () {

      var usuariosSolicitacao = [];

      var solicitante = {
        "idUsuario": vm.solicitantesSelecionados[0].id ? vm.solicitantesSelecionados[0].id : null,
        "nome": vm.solicitantesSelecionados[0].nome,
        "email": vm.solicitantesSelecionados[0].email,
        "cpf": vm.solicitantesSelecionados[0].cpf,
        "papeisUsuarioSolicitacao": [enumPapelSolicitante]
      };

      if (solicitante.nome == vm.responsaveisSelecionados[0].nome && solicitante.cpf == vm.responsaveisSelecionados[0].cpf) {
        solicitante.papeisUsuarioSolicitacao.push(enumPapelAdministradorOrgao);
        solicitante.papeisUsuarioSolicitacao.push(enumPapelResponsavelOrgao);
      }
      else {
        var responsavelOrgao = {
          "idUsuario": vm.responsaveisSelecionados[0].id ? vm.responsaveisSelecionados[0].id : null,
          "nome": vm.responsaveisSelecionados[0].nome,
          "email": vm.responsaveisSelecionados[0].email,
          "cpf": vm.responsaveisSelecionados[0].cpf,
          "papeisUsuarioSolicitacao": [enumPapelAdministradorOrgao, enumPapelResponsavelOrgao]
        };
      }

      for (var i = 0; i < vm.administradoresSelecionados.length; i++) {
        if (solicitante.nome == vm.administradoresSelecionados[i].nome && solicitante.cpf == vm.administradoresSelecionados[i].cpf) {
          if (vm.administradoresSelecionados[i].responsavelImovel) solicitante.papeisUsuarioSolicitacao.push(enumPapelResponsavelImoveis);

          if (solicitante.papeisUsuarioSolicitacao.indexOf(enumPapelAdministradorOrgao) > -1) {
            continue;
          }
          else {
            solicitante.papeisUsuarioSolicitacao.push(enumPapelAdministradorOrgao);
          }
        }
        else if (responsavelOrgao && responsavelOrgao.nome == vm.administradoresSelecionados[i].nome && responsavelOrgao.cpf == vm.administradoresSelecionados[i].cpf) {
          if (vm.administradoresSelecionados[i].responsavelImovel) responsavelOrgao.papeisUsuarioSolicitacao.push(enumPapelResponsavelImoveis);
          continue;
        }
        else {
          var usuario = {
            "idUsuario": vm.administradoresSelecionados[i].id,
            "nome": vm.administradoresSelecionados[i].nome,
            "email": vm.administradoresSelecionados[i].email,
            "cpf": vm.administradoresSelecionados[i].cpf,
            "papeisUsuarioSolicitacao": [enumPapelAdministradorOrgao]
          }

          if (vm.administradoresSelecionados[i].responsavelImovel) usuario.papeisUsuarioSolicitacao.push(enumPapelResponsavelImoveis);
          usuariosSolicitacao.push(usuario);
        }
      }

      usuariosSolicitacao.push(solicitante);
      if (responsavelOrgao) usuariosSolicitacao.push(responsavelOrgao);

      vm.form.solicitacao = {
        "data": new Date(),
        "situacao": enumSituacaoPendente,
        "solicitante": solicitante
      };
      vm.form.usuariosSolicitacao = usuariosSolicitacao;

      vm.salvarDocumento(vm.formularioAutorizacao[0]).then(function (result) {

        vm.form.formularioAutorizacao = result;

        vm.salvarDocumento(vm.documentoComprobatorioResponsavel[0]).then(function (result2) {

          vm.form.documentoComprobatorioResponsavel = result2;

          vm.salvarDocumento(vm.documentoPessoalResponsavel[0]).then(function (result3) {

            vm.form.documentoPessoalResponsavel = result3;

            if(typeof vm.form.organizacao.id === null || typeof vm.form.organizacao.id === 'undefined'){
              vm.form.nomeEntidade = vm.form.organizacao.nome;
              vm.form.cnpjEntidade = vm.form.organizacao.cnpj;
              vm.form.codUgEntidade = vm.form.organizacao.codigoUg;
            }

            vm.form.modulos = vm.formAvaliacaoSolicitacao.modulos;

            SolicitacaoAtivacaoOrgao.salvar_solicitacao.save(vm.form, function () {
              $mdToast.show($mdToast.simple().content("Pedido de ativação enviado com sucesso").position('top right'));
              $state.reload();
            }, function(error) {
              $mdToast.show($mdToast.simple().content(error.data.message).position('top right'));
            });

          });
        });

      });

    };

    vm.carregarSituacaoSolicitacao = function(result) {
      return SituacaoSolicitacao.query().$promise.then(function (data) {
        vm.situacoesSolicitacao = data;
      });
    };

    vm.consultarSolicitacaoAtivacao = function(){
      vm.query.dataInicio = vm.query.inicio ? $filter('date')(vm.query.inicio, 'MM/dd/yyyy') : null;
      vm.query.dataFim = vm.query.fim ? $filter('date')(vm.query.fim, 'MM/dd/yyyy') : null;
      return SolicitacaoAtivacaoOrgao.resource.query(vm.query, function (data) {
        if(data.length > 0){
          vm.solicitacoes = data;
        } else{
          $mdToast.show($mdToast.simple().content("A consulta não retornou resultado.").position('top right'));
        }
      });
    };

    vm.fecharFormCadastroEntidade = function () {
      vm.formCadastroOrgaoEntidade = {};
      vm.showFormCadastroEntidade = false;
    };

    vm.desabilitarSalvarEntidade = function() {
      if (vm.formCadastroEntidade) {
        return !vm.formCadastroEntidade.nome || !vm.formCadastroEntidade.cnpj || $scope.solicitarAtivacaoOrgaoForm.cnpjOrgaoEntidade.$invalid  || !vm.formCadastroEntidade.codigoUg ? true : false;
      } else {
        return true;
      }
    };

    vm.pesquisarOrgao = function() {
      vm.query.textoPesquisa = vm.filtroNomeOrgao;
      return Organizacao.listar_orgaos_entidades.query(vm.query).$promise;
    };

    vm.visualizarSolicitAtivacaoOrgao = function(id){
      $state.go('tratarSolicitAtivacaoOrgao', { solicitacaoAtivacaoOrgaoId: id, query: vm.query });
    };

    vm.cadastrar = function(){
      $state.go('cadastrarOrgao');
    };

    vm.detalharSolicitAtivacaoOrgao = function(id){
      $state.go('detalharSolicitAtivacaoOrgao', { solicitacaoAtivacaoOrgaoId: id,  query: vm.query });
    };

    vm.recuperarSolicitAtivacaoOrgao = function(){
      if($stateParams.solicitacaoAtivacaoOrgaoId) {
        SolicitacaoAtivacaoOrgao.resource.get({_id: $stateParams.solicitacaoAtivacaoOrgaoId}, function (data) {
          vm.form = data;
          vm.form.administradores = [];
          vm.form.responsavelImoveis = [];
          vm.form.avaliacao = vm.form.solicitacao.avaliacoes[0];

          angular.forEach(vm.form.usuariosSolicitacao, function(usuarioSolicitacao){
            var papel;
            for(var i = 0; i <= usuarioSolicitacao.papeisUsuarioSolicitacao.length; i++){
              papel =  usuarioSolicitacao.papeisUsuarioSolicitacao[i];
              if(papel == 'SOLICITANTE') {
                vm.form.solicitante = usuarioSolicitacao;
              }
              else if(papel == 'RESPONSAVEL_ORGAO'){
                vm.form.responsavelOrgao = usuarioSolicitacao;
              }
              else if(papel == 'RESPONSAVEL_IMOVEIS'){
                vm.form.responsavelImoveis.push(usuarioSolicitacao);
              }
              if(papel == 'ADMINISTRADOR_ORGAO'){
                vm.form.administradores.push(usuarioSolicitacao);
              }
            }
          });
        });
        consultarModuloSolicitacaoAtivacaoOrgao($stateParams.solicitacaoAtivacaoOrgaoId);
      }
    };

    vm.tratarSolicitacaoAtivacaoOrgao = function() {
      if(typeof vm.formAvaliacaoSolicitacao.aprovada == 'undefined' || vm.formAvaliacaoSolicitacao.aprovada == null) {
        $mdToast.show($mdToast.simple().content('Informe uma nova situação para solicitação: "Autorizada" ou "Negada"').position('top right'));
      } else if (vm.formAvaliacaoSolicitacao.aprovada == true && vm.formAvaliacaoSolicitacao.modulos.length == 0) {
        $mdToast.show($mdToast.simple().content("É necessário informar ao menos um módulo.").position('top right'));
      } else if(vm.formAvaliacaoSolicitacao.aprovada == false & !vm.formAvaliacaoSolicitacao.observacao){
        $mdToast.show($mdToast.simple().content('É necessário informar o motivo da recusa da solicitação').position('top right'));
      } else {
        vm.formAvaliacaoSolicitacao.solicitacao = vm.form.solicitacao;
        vm.formAvaliacaoSolicitacao.situacao =  vm.form.solicitacao.situacao;
        SolicitacaoAtivacaoOrgao.tratar_solicitacao.update({_id: vm.form.id},vm.formAvaliacaoSolicitacao, function(result){
          $mdToast.show($mdToast.simple().content("Pedido tratado com sucesso!").position('top right'));
          $state.go('consultarSolicitAtivacaoOrgao');
        }, function(error){
          $mdToast.show($mdToast.simple().content(error.data.message).position('top right'));
        });
      }

    };
    vm.validarModuloAutorizado = function(){
      if(!vm.form.modulo){
        $mdToast.show($mdToast.simple().content("informe o módulo.").position('top right'));
      } else {
        vm.ativarModuloAutorizado();
      }
    };

    vm.ativarModuloAutorizado = function() {
      var moduloSolicitacaoDuplicado;
      var moduloTemp;
      for(var i = 0; i < vm.formAvaliacaoSolicitacao.modulos.length; i++){
        moduloTemp = vm.formAvaliacaoSolicitacao.modulos[i];
        if(vm.form.modulo.id == moduloTemp.id){
          moduloSolicitacaoDuplicado = true;
        }
      }

      if (!moduloSolicitacaoDuplicado) {
        SolicitacaoAtivacaoOrgaoModulo.salvar_modulos_solicitacao.save({solicitacaoAtivacaoOrgao: vm.form, modulo: vm.form.modulo}, function () {
          $mdToast.show($mdToast.simple().content("Módulo associado com sucesso.").position('top right'));
          vm.formAvaliacaoSolicitacao.modulos.push(vm.form.modulo);
          $state.reload();
        }, function(error) {
          $mdToast.show($mdToast.simple().content(error.data.message).position('top right'));
        });
      } else {
        $mdToast.show($mdToast.simple().content("Módulo já autorizado.").position('top right'));
      }
    };

    vm.validarModuloAutorizadoSolicitacao = function(){
      if(!vm.form.modulo){
        $mdToast.show($mdToast.simple().content("informe o módulo.").position('top right'));
      } else {
        vm.ativarModuloAutorizadoSolicitacao();
      }
    };

    vm.ativarModuloAutorizadoSolicitacao = function() {
      var moduloSolicitacaoDuplicado;
      var moduloTemp;
      for(var i = 0; i < vm.formAvaliacaoSolicitacao.modulos.length; i++){
        moduloTemp = vm.formAvaliacaoSolicitacao.modulos[i];
        if(vm.form.modulo.id == moduloTemp.id){
          moduloSolicitacaoDuplicado = true;
        }
      }

      if (!moduloSolicitacaoDuplicado) {
          vm.formAvaliacaoSolicitacao.modulos.push(vm.form.modulo);
          vm.form.modulo = {};
      } else {
        $mdToast.show($mdToast.simple().content("Módulo já autorizado.").position('top right'));
      }
    };

    vm.removerModuloAutorizado = function(index){

      var confirm = $mdDialog.confirm()
        .title('Excluir Módulo')
        .textContent('Ao remover o Módulo não será adicionada permissão nele.\n Deseja continuar?')
        .ariaLabel('Excluir Módulo')
        .targetEvent(event)
        .ok('Avançar')
        .cancel('Retornar');

      $mdDialog.show(confirm).then(function () {
        SolicitacaoAtivacaoOrgaoModulo.resource.delete({_id: index.id}, function () {
          $mdToast.show($mdToast.simple().content("Módulo excluído").position('top right'));
          consultarModuloSolicitacaoAtivacaoOrgao($stateParams.solicitacaoAtivacaoOrgaoId);
        });
      });
    };

    var consultarModuloSolicitacaoAtivacaoOrgao = function(idSolicitacaoAtivacaoOrgao) {
      SolicitacaoAtivacaoOrgaoModulo.recuperar_modulos_solicitacao.query({idSolicitacaoAtivacaoOrgao: idSolicitacaoAtivacaoOrgao}, function (result) {
        if(result.length > 0) {
          vm.formAvaliacaoSolicitacao.modulos = result;
        }
      });
    }

    vm.removerModuloAutorizadoSolicitacao = function(index){
        vm.formAvaliacaoSolicitacao.modulos.splice(index,1);
    };

    //######################################## ESFERA PODER ########################################

    var consultarEsferasPoderSucesso = function (data) {
      vm.esferasPoder = data;
    };

    vm.consultarEsferasPoder = function () {
      vm.promise = EsferaPoder.query(vm.query, consultarEsferasPoderSucesso).$promise;
    };

    //##################################### USUÁRIO #####################################

    vm.carregarUsuario = function () {
      return Usuario.listar_usuarios.query({param: vm.filtroAdministrador}).$promise.then( function(result){
        vm.usuarios = result;
      });
    };

    function filtrarSolicitante(usuario) {
      var filtro = angular.lowercase(vm.filtroSolicitante);
      var nome = angular.lowercase(usuario.nome);

      if (nome.indexOf(filtro) >= 0 || usuario.cpf.indexOf(vm.filtroSolicitante) >= 0){
        return true;
      }
    };

    vm.pesquisarSolicitante = function(){
      vm.solicitantesSelecionados = [];
      var results = vm.filtroSolicitante ? vm.usuarios.filter( filtrarSolicitante ) : [];
      var deferred = $q.defer();
      $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
      return deferred.promise;
    };

    vm.desabilitarSalvarSolicitante = function() {
      if (vm.formSolicitante) {
        return !vm.formSolicitante.nome || !vm.formSolicitante.cpf || $scope.solicitarAtivacaoOrgaoForm.cpfSolicitante.$invalid  || !vm.formSolicitante.email || $scope.solicitarAtivacaoOrgaoForm.emailSolicitante.$invalid ? true : false;
      } else {
        return true;
      }
    };

    vm.salvarSolicitante = function() {
      var parametroDuplicado = $filter('filter')(vm.usuarios,{
        nome: vm.formSolicitante.nome,
        cpf: vm.formSolicitante.cpf,
      }).length;

      if(parametroDuplicado == 0){
        vm.solicitacao.solicitante = vm.formSolicitante;
        vm.usuarios.push(vm.formSolicitante);
        vm.fecharFormSolicitante();
        vm.formSolicitante = {};
      }else{
        $mdToast.show($mdToast.simple().content("Usuário já cadastrado.").position('top right'));
      }

    };

    vm.fecharFormSolicitante = function () {
      vm.formResponsavel = {};
      vm.showFormCadastroSolicitante = false;
    };

    function filtrarResponsavel(responsavel) {
      var filtro = angular.lowercase(vm.filtroResponsavel);
      var nome = angular.lowercase(responsavel.nome);

      if (nome.indexOf(filtro) >= 0 || responsavel.cpf.indexOf(vm.filtroResponsavel) >= 0){
        return true;
      }
    };

    vm.pesquisarResponsavel = function(){
      vm.responsaveisSelecionados = [];
      vm.removerResponsavelAdministrador();
      var results = vm.filtroResponsavel ? vm.usuarios.filter( filtrarResponsavel ) : [];
      var deferred = $q.defer();
      $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
      return deferred.promise;
    };

    vm.desabilitarSalvarResponsavel = function() {
      if (vm.formResponsavel) {
        return !vm.formResponsavel.nome || !vm.formResponsavel.cpf || $scope.solicitarAtivacaoOrgaoForm.cpfResponsavel.$invalid  || !vm.formResponsavel.email || $scope.solicitarAtivacaoOrgaoForm.emailResponsavel.$invalid ? true : false;
      } else {
        return true;
      }
    };

    vm.adicionarResponsavelAdministrador = function (responsavel) {
      if (vm.administradoresSelecionados.indexOf(responsavel[0]) == -1){
        vm.administradoresSelecionados.push(responsavel[0]);
        vm.responsavelSelecionadoAuxiliar = responsavel[0];
      }

    };

    vm.removerResponsavelAdministrador = function () {
      var index = vm.administradoresSelecionados.indexOf(vm.responsavelSelecionadoAuxiliar);

      if(index > -1){
        vm.administradoresSelecionados.splice(index, 1);
      }

    };

    vm.salvarResponsavel = function () {
      var parametroDuplicado = $filter('filter')(vm.usuarios,{
        nome: vm.formResponsavel.nome,
        cpf: vm.formResponsavel.cpf,
      }).length;

      if(parametroDuplicado == 0){
        vm.usuarios.push(vm.formResponsavel);
        vm.responsaveisSelecionados = [];
        vm.removerResponsavelAdministrador();
        vm.responsaveisSelecionados.push(vm.formResponsavel);
        vm.adicionarResponsavelAdministrador(vm.responsaveisSelecionados);
        vm.filtroResponsavel = [];
        vm.formResponsavel={};
        vm.fecharFormResponsavel();
      }else{
        $mdToast.show($mdToast.simple().content("Usuário já cadastrado.").position('top right'));
      }
    };

    vm.fecharFormResponsavel = function () {
      vm.formResponsavel = {};
      vm.showFormCadastroResponsavel = false;
    };

    function filtrarAdministrador(administrador) {
      var filtro = angular.lowercase(vm.filtroAdministrador);
      var nome = angular.lowercase(administrador.nome);

      if (nome.indexOf(filtro) >= 0 || administrador.cpf.indexOf(vm.filtroAdministrador) >= 0){
        return true;
      }
    };

    vm.pesquisarAdministrador = function(){
      var results = vm.filtroAdministrador ? vm.usuarios.filter( filtrarAdministrador ) : [];
      var deferred = $q.defer();
      $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
      return deferred.promise;
    };

    vm.desabilitarSalvarAdministrador = function() {      
      if (vm.formAdministrador) {
        return !vm.formAdministrador.nome 
               || !vm.formAdministrador.cpf 
               || $scope.solicitarAtivacaoOrgaoForm.cpfAdministrador.$invalid  
               || !vm.formAdministrador.email 
               || $scope.solicitarAtivacaoOrgaoForm.emailAdministrador.$invalid 
               ? true : false;
      } else {
        return true;
      }
    };

    vm.salvarAdministrador = function () {
      var parametroDuplicado = $filter('filter')(vm.usuarios,{
        nome: vm.formAdministrador.nome,
        cpf: vm.formAdministrador.cpf,
      }).length;

      if(parametroDuplicado == 0){

        vm.usuarios.push(vm.formAdministrador);
        vm.administradoresSelecionados.push(vm.formAdministrador);
        vm.filtroAdministrador = [];
        vm.formAdministrador={};
        vm.fecharFormAdministrador();

      }else{
        $mdToast.show($mdToast.simple().content("Usuário já cadastrado.").position('top right'));
      }
    };

    vm.fecharFormAdministrador = function () {
      vm.formAdministrador = {};
      vm.showFormCadastroAdministrador = false;
    };

    vm.removerAdministradorResponsavel = function (){

      var index = vm.administradoresSelecionados.indexOf(vm.responsaveisSelecionados[0]);

      if(index === -1){
        vm.responsaveisSelecionados = [];
      }
    };

    vm.recuperaGestorAvaliador = function(){
      if($rootScope.usuarioLogado && $rootScope.usuarioLogado.id) {
        vm.formAvaliacaoSolicitacao.avaliador = $rootScope.usuarioLogado;
      } else{
        $state.go('home');
      }
    };

    //#################################### TIPO-ADMINISTRACAO #########################################

    vm.consultarTipoAdministracao = function(result) {
      return TipoAdministracao.query({param: vm.filtroTipoAdministracao}).$promise.then(function (data) {
        vm.tiposAdministracao = data;
      });
    };

    vm.recuperarTipoAdministracao = function (id) {
      if (id) {
        TipoAdministracao.get({_id: id}, function (data) {
          unidade.tipoAdministracao = data;
        });
      }
    };

    //#################################### PODER #########################################

    vm.consultarPoder = function (result) {
      return Poder.query({param: vm.filtroPoder}).$promise.then(function (data) {
        vm.poderes = data;
      });
    };

    //#################################### PEDIDO_ATIVACAO #########################################

    vm.salvarDocumento = function(documento){

      if(documento) {
        return Upload.upload({
          url: '/api/documentos/public/salvar-documento',
          data: {
            tipo: documento.lfFile.type,
            nome: documento.lfFile.name,
            tamanho: documento.lfFile.size,
            dado: documento.lfFile
          }
        }).then(function (resp) {
          return resp.data;
        }, function (resp) {
          $mdToast.show($mdToast.simple().content("Houve um erro ao salvar o documento").position('top right'));
        });
      }

      return null;
    };

    //##################################### SISTEMA #####################################

    vm.consultarSistemas = function(){
      vm.promise = Sistema.resource.query(vm.query, function(result){
        vm.sistemas = result;
      }).$promise;
    };

    vm.consultarSistemasPublic = function(){
      vm.promise = Sistema.consultar_sistemas.query(vm.query, function(result){
        vm.sistemas = result;
      }).$promise;
    };

    //##################################### MODULO #####################################
    vm.carregarModulos = function () {
      Modulo.resource.query(vm.query).$promise.then(function (result) {
        vm.modulos = result;
      });
    };

    vm.carregarModulosPublic = function () {
      Modulo.consultar_modulos.query(vm.query).$promise.then(function (result) {
        vm.modulos = result;
      });
    };

    //##################################### MODULO #####################################
    vm.consultarPerfis = function () {
      vm.query.idModulo = vm.form.modulo ? vm.form.modulo.id : null;
      Perfil.resource.query(vm.query).$promise.then(function (result) {
        vm.perfis = result;
      });
    };

    //###################################################################################

    vm.transformChip = function (chip) {
      // Se o parametro for um objeto, ele já é um chip
      if (angular.isObject(chip)) {
        return chip;
      }
      // Senão, cria um novo chip
      return {name: chip, type: 'new'}
    };

    function situacaoAtivoToString(boolean) {
      return boolean ? 'Ativo' : 'Inativo';
    };

    function stringToSituacaoAtivo(string) {
      var ativo = "Ativo";
      var compare = ativo.localeCompare(string);
      return compare == 0 ? true : false;
    };

    vm.limpar = function () {
        vm.query = angular.copy(queryDefault);
        $state.reload();
    };

    vm.limparConsultar = function () {
        vm.query = angular.copy(queryDefault);
        if($stateParams.query){
            $state.go('consultarOrgao', {query: undefined});
        } else{
            $state.reload();
        }
    };

    vm.limparConsultaSolicitAtivOrgao = function () {
      vm.query = angular.copy(queryDefault);
      if($stateParams.query){
        $state.go('consultarSolicitAtivacaoOrgao', {query: undefined});
      } else{
        $state.reload();
      }
    };

    vm.ativarInativar = function (orgao) {
      var confirm = $mdDialog.confirm()
        .title('Ativar/Inativar Órgão')
        .textContent('Ao ativar/inativar esse Órgao todas unidades vinculadas a ele serão impactadas.\n Deseja proseguir?')
        .ariaLabel('Confirmação Ativar/Inativar Órgão')
        .targetEvent(event)
        .ok('Avançar')
        .cancel('Retornar');

      $mdDialog.show(confirm).then(function () {
        Orgao.ativar_desativar.update({_id: orgao.id, strAtivo: orgao.ativo}, function () {
          $mdToast.show($mdToast.simple().content("Ativar/Inativar Órgão realizado com sucesso").position('top right'));
          vm.promise = Orgao.resource.query(vm.query, consultarSucesso).$promise;
        });
      }, function(){
        vm.orgaos[vm.orgaos.indexOf(orgao)].ativo = !vm.orgaos[vm.orgaos.indexOf(orgao)].ativo;
      });
    };

    vm.mostrarBtnAdicionarEntidade = function(){
      return vm.query.tipoAdministracaoId && (vm.query.tipoAdministracaoId === vm.tipoAdministracaoPrivada
      || vm.query.tipoAdministracaoId === vm.tipoAdministracaoSemFinsLucrativos) ? true : false;
    };

    vm.isTipoAdministracaoEspecialSolicitarAtivacaoOrgao = function () {

      if (vm.form.organizacao != null && typeof vm.form.organizacao.id !== 'undefined'){
        if (!vm.form.organizacao || vm.form.organizacao.tipoAdministracao.id === vm.tipoAdministracaoPrivada ||
          vm.form.organizacao.tipoAdministracao.id === vm.tipoAdministracaoSemFinsLucrativos ||
          !vm.form.organizacao.tipoAdministracao.id) {
          return true;
        } else {
          return false;
        }
      }
    };

    vm.isTipoAdministracaoEspecialDesabilitar = function () {
      if(vm.query.tipoAdministracaoId === vm.tipoAdministracaoPrivada
        || vm.query.tipoAdministracaoId === vm.tipoAdministracaoSemFinsLucrativos){
        vm.query.esferaId = '';
        vm.query.poderId = '';
        return true;
      }else{
        return false;
      }
    };

    vm.apresentarAjuda = function (mensagem){
      $mdToast.show($mdToast.simple().content(mensagem).position('top right'));
    };

    vm.carregarUnidadePorNome = function () {
      var query = angular.copy(queryDefault);
      query.nome = vm.filtroNomeOrgao;
      query.textoPesquisa = vm.filtroNomeOrgao;

      return Unidade.listar_nome_sigla_completa_por_texto.get(query).$promise.then(function (data) {
        var deferred = $q.defer();
        deferred.resolve(data.content);
        return deferred.promise;
      });
    };

    vm.recuperarFormularioPadrao = function () {
      SolicitacaoAtivacaoOrgao.recuperar_formulario_padrao.get().$promise.then(function (data) {
        vm.formularioPadrao = data;
      });
    };

    vm.downloadFormularioPadrao = function () {
        var objData = vm.formularioPadrao.dado;
        var filename = 'formulario_padrao.pdf';
        var contentType= 'application/pdf';
        createDownloadFile(objData, filename, contentType);
    };

    function base64ToArrayBuffer(base64) {
      var binary_string = $window.atob(base64);
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      return bytes.buffer;
    }

    function createDownloadFile(fileData, filename, dataContentType) {
      var blob = new Blob([base64ToArrayBuffer(fileData)], {'type': dataContentType});
      var _navigator = $window.navigator;
      var _userAgent = _navigator.userAgent;
      if (_navigator.msSaveOrOpenBlob) {
        //IE 11+
        _navigator.msSaveOrOpenBlob(blob, filename);
      }
      else if (_userAgent.match("CriOS")) {
        //Chrome iOS
        var reader = new FileReader();
        reader.onloadend = function() {
          $window.open(reader.result);
        };
        reader.readAsDataURL(blob);
      }
      else {
        var address = $window.URL.createObjectURL(blob);

        //Chrome, Edge, others
        var downloadLink = $element.find("a");
        if (!downloadLink[0]) {
          downloadLink = angular.element('<a>');
        }

        downloadLink.attr("download", filename);
        downloadLink.attr("href", address);
        if (vm.newWindow) {
          downloadLink.attr("target", '_blank');
        }

        $element.append(downloadLink);
        downloadLink.ready(function() {
          downloadLink[0].click();
          $timeout(function() {
            downloadLink.detach();
          }, 1000);
        });
      }
    }
  }

})();

(function () {
    'use strict';

    angular.module('acessos').factory('Entidade', Entidade);

    function Entidade($resource) {
        return {
            resource: $resource('/api/entidades/:_id', {_id: '@_id'}, { 'update': { method:'PUT' }})
        };
    };

})();

(function () {
    'use strict';

    angular.module('acessos').factory('Organizacao', Organizacao);

    function Organizacao($resource) {
        return {
            resource: $resource('/api/organizacoes/:_id', {_id: '@_id'}, { 'update': { method:'PUT' }}),
            listar_orgaos_entidades: $resource('/api/organizacoes/public/listar-orgaos-entidades')
        };
    };

})();

(function () {
    'use strict';

    angular.module('acessos').factory('Modulo', Modulo);

    function Modulo($resource) {
        return{
            resource: $resource('/api/modulos/:_id', {_id: '@_id'}),
            consultar_modulos: $resource('/api/modulos/public/:_id', {_id: '@_id'}),
            verificar_modulo_unico: $resource('/api/modulos/verificar-modulo-unico')
        }
    };

})();

(function () {
    'use strict';

    angular.module('acessos').service('ItemMenuCadastro', ItemMenuCadastro);

    function ItemMenuCadastro($resource) {
        return {
            resource : $resource('/api/item-menu-cadastro/:_id', {_id: '@_id'}),
            recuperar_menu_usuario : $resource('/api/item-menu-cadastro/buscar-menu/id-usuario/:idUsuario/id-sistema/:idSistema',
              {idUsuario: '@idUsuario', idSistema: '@idSistema'}),
            reposicionar_item_menu: $resource('/api/item-menu-cadastro/reposicionar-item-menu/id-item-menu/:idItemMenu/id-novo-item-menu-superior/:idNovoItemMenuSuperior/nova-posicao/:novaPosicao',
              {idItemMenu: '@idItemMenu', idNovoItemMenuSuperior: '@idNovoItemMenuSuperior', novaPosicao: '@novaPosicao'},
              { 'update': { method:'PUT' }}),
            listar_menu : $resource('/api/item-menu-cadastro/listar-menu/:idModulo',
            {idModulo: '@idModulo'}),
            reativar: $resource('/api/item-menu-cadastro/reativar/:id', {id: '@id'}, { 'update': { method:'PUT' }})
        };
    }
})();

(function () {
    'use strict';

    angular.module('acessos').service('ItemMenu', ItemMenu);

    function ItemMenu($resource) {
        return {
            resource : $resource('/api/item-menu/:_id', {_id: '@_id'}),
            recuperar_menu_usuario : $resource('/api/item-menu/buscar-menu/id-usuario/:idUsuario/id-sistema/:idSistema',
              {idUsuario: '@idUsuario', idSistema: '@idSistema'}),
            reposicionar_item_menu: $resource('/api/item-menu/reposicionar-item-menu/id-item-menu/:idItemMenu/id-novo-item-menu-superior/:idNovoItemMenuSuperior/nova-posicao/:novaPosicao',
              {idItemMenu: '@idItemMenu', idNovoItemMenuSuperior: '@idNovoItemMenuSuperior', novaPosicao: '@novaPosicao'},
              { 'update': { method:'PUT' }}),
            listar_menu : $resource('/api/item-menu/listar-menu/:idModulo',
            {idModulo: '@idModulo'})
        };
    }
})();

(function () {
    'use strict';

    angular.module('acessos').controller('ItemMenuController', ItemMenuController);

    function ItemMenuController(Sistema, Modulo, ItemMenuCadastro, Permissao, $mdToast, $stateParams, $state, $scope, Upload, $mdDialog, $window) {

        var vm = this;
        vm.comboSistemas = [];
        vm.sistemas = [];
        vm.selecionado = [];
        vm.form = {
            permissoes: []
        };
        vm.permissoes = [];
        vm.scope = {};
        vm.menuNos = [];
        vm.permissoesMenu = [];
        $scope.form = {
            permissoes: []
        };

        $scope.data = [{
            'id': 0,
            'descricaoResumida': 'Menu',
            'nodrop': true,
            'nos': []
        }];

      $scope.treeOptions = {
        beforeDrop: function (e) {
          if(e.source.nodeScope.$modelValue.id != 0 && e.dest.nodesScope.$parent.$modelValue){

            var idItemMenu = e.source.nodeScope.$modelValue.id,
              novaPosicao = e.dest.index + 1,
              idNovoItemMenuSuperior = e.dest.nodesScope.$parent.$modelValue.id;

            //var confirm = $mdDialog.confirm()
            //  .title('Item Menu')
            //  .textContent('Você tem certeza que deseja re-ordernar o item de menu?')
            //  .ariaLabel('Ordernar Menu')
            //  .targetEvent(event)
            //  .ok('Confirmar')
            //  .cancel('Retornar');

            //$mdDialog.show(confirm).then(function() {
            ItemMenuCadastro.reposicionar_item_menu.update({
              idItemMenu: idItemMenu,
              idNovoItemMenuSuperior: idNovoItemMenuSuperior,
              novaPosicao: novaPosicao
            }, function () {
              $mdToast.show($mdToast.simple().content("Item menu alterado com sucesso.").position('top right'));
              //vm.consultar();
              //});
              //});

            });
          }
          else{
            $mdToast.show($mdToast.simple().content("Ação não permitida.").position('top right'));
            $state.reload();
          }
        }
      };

        var queryDefault = {
            order: 'nome',
            limit: 5,
            page:1
        };

        var menuCarregado = 0;

        vm.query = angular.copy(queryDefault);

        var consultarSucesso = function (data) {
            vm.modulos = data;
        }

        vm.inicializarConsulta = function() {
            if($stateParams.query && $stateParams.query.pesquisar){
              vm.carregarSistemas();
              vm.carregarModulos();
              vm.query = $stateParams.query;
              vm.consultar();
            }
        }

        vm.consultar = function () {
            vm.consulta = {};
            vm.consulta.idSistema = vm.query.id;
            vm.consulta.id = vm.query.idModulo;
            vm.promise = Modulo.resource.query(vm.consulta, consultarSucesso).$promise;
        };

        vm.editar = function (id) {
            $state.go('cadastrarItemMenu', { moduloId: id, query: vm.query });
        };

        vm.carregarSistemas = function () {
            Sistema.resource.query().$promise.then(function (result) {
                vm.comboSistemas = result;
            });
            vm.query.idModulo = '';
        };

        vm.carregarModulos = function () {
            vm.consulta = {};
            vm.consulta.idSistema = vm.query.id;

            Modulo.resource.query(vm.consulta).$promise.then(function (result) {
                vm.comboModulos = result;
            });
        };

        vm.limpar = function(){
            vm.query = angular.copy(queryDefault);
            if($stateParams.query){
                $state.go('consultarItemMenu', {query: undefined});
            } else{
                $state.reload();
            }
        };

        vm.voltarConsultarMenu = function() {
            if($stateParams.query){
              $stateParams.query.pesquisar = true;
            }
            $state.go('consultarItemMenu', {query: $stateParams.query});
        };

        vm.voltar = function(){
            $state.go('cadastrarItemMenu', {moduloId : $stateParams.moduloId});
        };

        vm.recuperarSistema = function (scope) {
          if (menuCarregado == 0) {
            if ($stateParams.moduloId) {
              Modulo.resource.get({_id: $stateParams.moduloId}, function (data) {
                vm.form = data;
              });

              ItemMenuCadastro.listar_menu.query({idModulo: $stateParams.moduloId}, function (data) {
                var nodeData = scope.$modelValue;
                nodeData.nos = data;
                menuCarregado++;

                var preparaMenu = function (itens) {

                  angular.forEach(itens, function (item) {

                    if (!item.nos) {
                      item.nos = [];
                    }

                    if (item.nos && item.nos.length > 0) {
                      preparaMenu(item.nos);
                    }
                  });
                };
                preparaMenu(nodeData.nos);
              });
            }
          }
        };

        vm.recuperarItemMenu = function(){
            ItemMenuCadastro.resource.get({_id: $stateParams.itemMenuId}, function (data) {
                vm.form = data;
                vm.form.idItemMenuSuperior = data.idItemMenuSuperior;
                vm.carregarPermissoes();
            });
        };

        vm.carregarPermissoes = function () {
            if($stateParams.moduloId) {
                vm.query.idModulo = $stateParams.moduloId;
            }else {
                vm.query.idModulo = vm.form.modulo.id;
            }
            Permissao.query(vm.query).$promise.then(function (result){
                vm.permissoes = result;
            });
        };

        $scope.removerItem = function (scope) {

          var confirm = $mdDialog.confirm()
            .title('Excluir Item de Menu')
            .textContent('Ao remover o item de menu, todos os itens de menu vinculados a este também serão excluídos.\n Deseja continuar?')
            .ariaLabel('Excluir Item de Menu')
            .targetEvent(event)
            .ok('Avançar')
            .cancel('Retornar');

          $mdDialog.show(confirm).then(function() {
            ItemMenuCadastro.resource.delete({_id: scope.$modelValue.id}, function(){
              $mdToast.show($mdToast.simple().content("Item menu excluido com sucesso").position('top right'));
            }, function(){
              $mdToast.show($mdToast.simple().content("Erro ao tentar excluir o item de menu.").position('top right'));
            });

            scope.remove();
            $window.location.reload();
          });
        };

        $scope.reativarItem = function(scope) {
          var confirm = $mdDialog.confirm()
            .title('Reativar Item de Menu')
            .textContent('Ao reativar o item de menu, todos os itens de menu vinculados a este também serão ativados.\n Deseja continuar?')
            .ariaLabel('Reativar Item de Menu')
            .targetEvent(event)
            .ok('Avançar')
            .cancel('Retornar');

          $mdDialog.show(confirm).then(function() {
            ItemMenuCadastro.reativar.update({id: scope.$modelValue.id}, function(){
              $mdToast.show($mdToast.simple().content("Item menu excluido com sucesso").position('top right'));
            }, function(){
              $mdToast.show($mdToast.simple().content("Erro ao tentar excluir o item de menu.").position('top right'));
            });

            scope.remove();
            $window.location.reload();
          });
        }

        $scope.toggle = function (scope) {
            scope.toggle();
        };

        $scope.newSubItem = function (scope) {
            vm.menuNos = scope.$parent.$modelValue;
            vm.criarItemMenu($stateParams.moduloId, scope.$parent.$modelValue.id)
        };

        $scope.editSubItem = function (scope) {
            vm.editarItemMenu(scope.$modelValue.id, $stateParams.moduloId)
        };

        vm.criarItemMenu = function(idModulo, idItemSuperior){
            $state.go('criarItemMenu', {moduloId: idModulo, itemSuperiorId: idItemSuperior});
        };

        vm.editarItemMenu = function(idItemMenu, idModulo){
            $state.go('editarItemMenu', {itemMenuId: idItemMenu, moduloId: idModulo});
        };

        vm.salvarDocumento = function(documento){
            if(documento) {
                return Upload.upload({
                    url: '/api/documentos',
                    data: {
                        tipo: documento.lfFile.type,
                        nome: documento.lfFile.name,
                        tamanho: documento.lfFile.size,
                        dado: documento.lfFile
                    }
                }).then(function (resp) {
                    return resp.data;
                }, function (resp) {
                    $mdToast.show($mdToast.simple().content("Houve um erro ao salvar o documento").position('top right'));
                });
            }
            return null;
        };

        vm.salvar = function (subitem, icone) {
            if (typeof subitem != 'undefined') {
                if (typeof subitem.descricaoDetalhada === 'undefined') {
                    $mdToast.show($mdToast.simple().content("Descricao detalhada obrigatoria").position('top right'));
                } else if (typeof subitem.descricaoResumida === 'undefined') {
                    $mdToast.show($mdToast.simple().content("Descricao resumida obrigatoria").position('top right'));
                } else if (typeof subitem.codigoIdentificador === 'undefined') {
                    $mdToast.show($mdToast.simple().content("Código identificador obrigatorio").position('top right'));
                } else {
                    if(typeof subitem.codigoIdentificador === 'undefined'){subitem.codigoIdentificador = null;}
                    if(typeof subitem.url === 'undefined'){subitem.url = null;}
                    if(typeof subitem.templateUrl === 'undefined'){subitem.templateUrl = null;}
                    if(typeof subitem.controller === 'undefined'){subitem.controller = null;}
                    if(typeof subitem.apelidoController === 'undefined'){subitem.apelidoController = null;}

                    var idItemMenuSuperior = {};
                    if(typeof $stateParams.itemSuperiorId !== "undefined"){
                        idItemMenuSuperior = $stateParams.itemSuperiorId;
                    }else{
                        idItemMenuSuperior = subitem.idItemMenuSuperior;
                    }

                    ItemMenuCadastro.resource.query({"codigoIdentificador": subitem.codigoIdentificador}).$promise.then(function (result) {
                        if (icone[0] != null) {
                            vm.salvarDocumento(icone[0]).then(function (result) {
                                var itemMenu = {
                                    id: subitem.id,
                                    idModulo: $stateParams.moduloId,
                                    idItemMenuSuperior: idItemMenuSuperior,
                                    descricaoDetalhada: subitem.descricaoDetalhada,
                                    descricaoResumida: subitem.descricaoResumida,
                                    codigoIdentificador: subitem.codigoIdentificador,
                                    url: subitem.url,
                                    templateUrl: subitem.templateUrl,
                                    controller: subitem.controller,
                                    apelidoController: subitem.apelidoController,
                                    permissoes: subitem.permissoes,
                                    icone: result
                                };
                              ItemMenuCadastro.resource.save(itemMenu, function(resp){
                                    $mdToast.show($mdToast.simple().content("Item menu salvo com sucesso").position('top right'));
                                    $state.go('cadastrarItemMenu', {moduloId: $stateParams.moduloId});
                                }, function(error){
                                    $mdToast.show($mdToast.simple().content(error.data.message).position('top right'));
                                });
                            });
                        }else{
                            var itemMenu = {
                                id: subitem.id,
                                idModulo: $stateParams.moduloId,
                                idItemMenuSuperior: idItemMenuSuperior,
                                descricaoDetalhada: subitem.descricaoDetalhada,
                                descricaoResumida: subitem.descricaoResumida,
                                codigoIdentificador: subitem.codigoIdentificador,
                                url: subitem.url,
                                templateUrl: subitem.templateUrl,
                                controller: subitem.controller,
                                apelidoController: subitem.apelidoController,
                                permissoes: subitem.permissoes,
                            };
                            ItemMenuCadastro.resource.save(itemMenu, function(resp){
                                $mdToast.show($mdToast.simple().content("Item menu salvo com sucesso").position('top right'));
                                $state.go('cadastrarItemMenu', {moduloId: $stateParams.moduloId});
                            }, function(error){
                                $mdToast.show($mdToast.simple().content(error.data.message).position('top right'));
                            });
                        }
                    });
                }
            }else{
                $mdToast.show($mdToast.simple().content("Preencha os dados do item de menu para salvar").position('top right'));
            };
        };

        vm.getToolbarColor = function(node) {
          if(node.excluido === true) {
            return '#ffe9ef';
          }
        };
    }
})();

(function () {
    'use strict';

    angular.module('acessos').controller('LoginController', LoginController);

    function LoginController($mdToast, $rootScope, $http, $state) {
        var vm = this;
        vm.credenciais = {};

        vm.login = function() {
            var data = 'username=' + vm.credenciais.usuario + '&password=' + vm.credenciais.senha;
            $http({
                data: data,
                method: 'POST',
                url: '/api/login',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }).then(function successCallback(response) {
                $rootScope.authenticado = true;
                $state.go('home');
                $mdToast.show($mdToast.simple().content("Usuário autenticado com sucesso").position('top right'));
            }, handleError);
        };

        function handleError(response) {
            $mdToast.show($mdToast.simple().content('Usuário ou senha inválidos').position('top right'))
        }

    };
})();
(function () {
	'use strict';

	angular.module('acessos').factory('HomeService', HomeService);

	function HomeService(){}

})();
(function () {
	'use strict';

	angular.module('acessos').controller('HomeController', HomeController);

	function HomeController($rootScope, Sistema) {
			var vm = this;

			vm.cl = 'init';
			vm.selectedIndex = 0;
			vm.emailContato = '';

			vm.onTabSelected = function(tab) {
					vm.cl='clicked';
					vm.selectedIndex = tab;
			}

      Sistema.email_contato.get().$promise.then(function (rst) {
						vm.emailContato = rst.email;
			});

			vm.isLogado = function() {
				return $rootScope.usuarioLogado && $rootScope.usuarioLogado.id && vm.cl == 'init' ? 1: vm.selectedIndex;
			}

	}

})();

/**
 * Created by guilhermemorum on 14/06/17.
 */
(function () {
  'use strict';

  angular.module('acessos').factory('HistoricoUnidadePadrao', HistoricoUnidadePadrao);

  function HistoricoUnidadePadrao($resource) {
    return {
      historico_usuario: $resource('/api/historico-unidades/buscar-por-usuario-id/:id', {id: "@id"})
    };
  }

})();

(function () {
  'use strict';

  angular.module('acessos').service('HistoricoAcoes', HistoricoAcoes);

  function HistoricoAcoes($resource) {
    return {
      filtrar_historico: $resource('/api/historico-acoes/filtrar-historico-acoes',
        {param: '@param'},
        {'filtrar' : { method: 'GET' }})
    }
  }

})();

(function () {
  'use strict';

  angular.module('acessos').controller('HistoricoAcoesController', HistoricoAcoesController);

  function HistoricoAcoesController($filter, $mdToast, Dominio, Sistema, HistoricoAcoes) {

    var vm = this;
    vm.historico = {};
    vm.logs = [];

    Sistema.resource.query(vm.query).$promise.then(function (result) {
      vm.sistemas = result;
    });

    Dominio.tiposLog.query().$promise.then(function (result) {
      vm.tiposLog = result;
    });

    vm.tabelaHistorico = {
      totalElementos: 0
    };
    vm.historico.dataInicio = vm.historico.dataFim = new Date();
    vm.historico.numeroPagina = 1;
    vm.historico.maximoPorPagina = 5;

    vm.filtrar = function () {

      if (vm.formHistoricoUsuario.$valid) {
        vm.historico.dataInicio = vm.historico.dataInicio ? $filter('date')(vm.historico.dataInicio, 'MM/dd/yyyy') : null;
        vm.historico.dataFim = vm.historico.dataFim ? $filter('date')(vm.historico.dataFim, 'MM/dd/yyyy') : null;
        HistoricoAcoes.filtrar_historico.filtrar(vm.historico).$promise.then (function (data) {
          if (data.content.length > 0) {
            vm.tabelaHistorico.totalElementos = data.totalElements;
            vm.logs = data.content;
          } else {
            vm.logs = [];
            vm.tabelaHistorico.totalElementos = 0;
            $mdToast.show($mdToast.simple().content("Nenhum registro encontrado.").position('top right'));
          }
        })
      } else {
        $mdToast.show($mdToast.simple().content("Preencha os campos obrigatórios").position('top right'));
      }

    };

  }

})();

(function () {
    'use strict';

    angular.module('acessos').factory('GrupoUnidade', GrupoUnidade);

    function GrupoUnidade($resource) {
        return {
            resource: $resource('/api/grupos-unidades/:_id', {_id: '@_id'}, { 'update': { method:'PUT' }}),
            ativar_desativar: $resource('/api/grupos-unidades/ativar-desativar/:_id/:strAtivo',
                {_id: '@_id', strAtivo: '@strAtivo'},
                { 'update': { method:'PUT' }})
        };
    };
})();

(function(){
  angular.module('acessos')
    .factory('GrupoUnidadeFactory', Factory);

  Factory.$inject = [];

  function Factory(){

    var grupoUnidadeFiltro = {
      orgaoNome: '',
      nome: '',
      unidadeNome: '',
      pesquisar: false
    };

    return{
      adicionarAtributosPesquisa: adicionarAtributosPesquisa,
      recuperarAtributosPesquisa: recuperarAtributosPesquisa,
      resetarAtributosPesquisa: resetarAtributosPesquisa,
      setPesquisarFalse: setPesquisarFalse,
    }

    function adicionarAtributosPesquisa(grupoPesquisa){
      grupoUnidadeFiltro = grupoPesquisa;
      grupoUnidadeFiltro.pesquisar = true;
    }

    function recuperarAtributosPesquisa(){
      return grupoUnidadeFiltro;
    }

    function resetarAtributosPesquisa(){
      grupoUnidadeFiltro = {
        orgaoNome: '',
        nome: '',
        unidadeNome: '',
        pesquisar: false
      }
    }

    function setPesquisarFalse(){
      grupoUnidadeFiltro.pesquisar = false;
    }

  }
})();

(function () {
  'use strict';

  angular.module('acessos').controller('GrupoUnidadeController', GrupoUnidadeController);

  function GrupoUnidadeController(GrupoUnidade, Acesso, Orgao, Unidade, Usuario, Sistema, Uf, Organizacao, Modulo, GrupoUnidadeFactory, $mdToast, $mdDialog, $stateParams, $state, $q) {

    var vm = this;
    vm.gruposUnidades = [];
    vm.grupoUnidade = {};
    vm.opcoesAtivoInativo = [{'key': "Ativo", 'value': true}, {'key': "Inativo", 'value': false}];
    vm.orgaos = [];
    vm.selecionado = [];
    vm.form = {};
    vm.formUsuario = {};
    vm.formUnidade = {};

    //Autocomplete da pesquisa de unidades
    vm.filtroNomeUnidade = [];
    vm.unidades = [];
    vm.unidadeSelecionada = {};
    vm.unidadesSelecionadas = [];
    vm.showFormCadastroUnidade = false;

    vm.filtroAdministrador = '';
    vm.administradorSelecionado = {};
    vm.administradoresSelecionados = [];
    vm.showFormCadastroUsuario = false;

    vm.filtroNomeOrgao = '';
    vm.sistemas = [];
    vm.modulos = [];

    vm.perfil = [];
    vm.jurisdicoes = [];
    vm.jurisdicoesSelecionadas = [];

    var perfilAdministradorUnidade = 4;

    var queryDefault = {
      order: 'nome',
      limit: 20,
      page:1
    };

    vm.query = angular.copy(queryDefault);

    vm.inicializarConsulta = function(){
      if($stateParams.query && $stateParams.query.pesquisar){
        vm.query = $stateParams.query;
        vm.form.orgao = $stateParams.query.orgao;

        vm.consultar();
      }
    };

    //##################################### GRUPO UNIDADE #####################################

    var consultarSucesso = function (data) {
      vm.gruposUnidades = data;
      if(vm.gruposUnidades.length === 0){
        $mdToast.show($mdToast.simple().content("A consulta não retornou resultado").position('top right'));
      }
    };

    vm.consultarGrupoUnidade = function(){
      $state.go('consultarGrupoUnidade');
    }


    vm.consultar = function () {
      if(vm.form.orgao) {
        vm.query.orgao = vm.form.orgao;
        vm.query.nomeOrgao = vm.form.orgao.nome;
      } else {
        delete vm.query.orgao;
        delete vm.query.nomeOrgao;
      }

      vm.promise = GrupoUnidade.resource.query(vm.query, consultarSucesso).$promise;

    };

    vm.detalhar = function (id) {
      vm.query.pesquisar = false;
      $state.go('detalharGrupoUnidade', { grupoUnidadeId: id, query: vm.query });
    };

    vm.recuperarGrupoUnidade= function () {
      if($stateParams.grupoUnidadeId) {
        GrupoUnidade.resource.get({_id: $stateParams.grupoUnidadeId}, function (data) {
          vm.form = data;
          vm.form.ativo = situacaoAtivoToString(data.ativo);
          vm.unidadesSelecionadas =  vm.form.unidadeExecutoras;
          vm.administradoresSelecionados = vm.form.administradores;
          if(!vm.unidadesSelecionadas || vm.unidadesSelecionadas.length === 0){
            $mdToast.show($mdToast.simple().content("O Grupo Não Possui Unidades Cadastradas").position('top right'));
          }
        });
      }
    };

    vm.salvar = function () {
      vm.form.unidadeExecutoras = vm.unidadesSelecionadas;
      vm.form.administradores = vm.administradoresSelecionados;
      vm.form.ativo = true;
      vm.form.excluido = false;

      if (vm.form.administradores && vm.form.administradores.length >= 2) {
        GrupoUnidade.resource.update(vm.form, function () {
          $mdToast.show($mdToast.simple().content("Grupo de Unidades salvo").position('top right'));
          $state.go('consultarGrupoUnidade');
        }, function(){
          $mdToast.show($mdToast.simple().content("As unidades devem pertencer ao mesmo órgão superior.").position('top right'));
        });
      } else {
        $mdToast.show($mdToast.simple().content("Deve haver no mínimo 2 usuários administradores").position('top right'));
      }
    };

    vm.salvarEdicao = function () {
      vm.form.ativo = stringToSituacaoAtivo(vm.form.ativo);
      vm.form.unidades = vm.unidadesSelecionadas;
      vm.form.administradores = vm.administradoresSelecionados;

      if (vm.form.administradores && vm.form.administradores.length >= 2) {
        GrupoUnidade.resource.update({_id: $stateParams.grupoUnidadeId}, vm.form, function () {
          $mdToast.show($mdToast.simple().content("Grupo de Unidades salvo").position('top right'));
          $state.go('consultarGrupoUnidade');
        }, function(){
          $mdToast.show($mdToast.simple().content("As unidades devem pertencer ao mesmo órgão superior.").position('top right'));
        });
      } else {
        $mdToast.show($mdToast.simple().content("Deve haver no mínimo 2 usuários administradores").position('top right'));
      }
    };

    vm.editar = function (id) {
      vm.query.pesquisar = false;
      $state.go('editarGrupoUnidade', { grupoUnidadeId: id, query: vm.query });
    };

    vm.ativarInativar = function (grupoUnidade) {
      var confirm = $mdDialog.confirm()
        .title('Ativar/Inativar Grupo de Unidade')
        .textContent('Ao ativar/inativar esse Grupo de Unidade Executora todas unidades vinculadas a ele serão impactadas.\n Deseja proseguir?')
        .ariaLabel('Confirmação Ativar/Inativar Grupo de Unidade')
        .targetEvent(event)
        .ok('Avançar')
        .cancel('Retornar');

      $mdDialog.show(confirm).then(function() {
        GrupoUnidade.ativar_desativar.update({_id: grupoUnidade.id, strAtivo: grupoUnidade.ativo}, function () {
          $mdToast.show($mdToast.simple().content("Ativar/Inativar Grupo de Unidade Realizado com Sucesso").position('top right'));
        });
      }, function(){
        vm.gruposUnidades[vm.gruposUnidades.indexOf(grupoUnidade)].ativo = !vm.gruposUnidades[vm.gruposUnidades.indexOf(grupoUnidade)].ativo;
      });
    };

    vm.consultarGrupoUnidadePorOrgao = function(){
      vm.promise = GrupoUnidade.resource.query(vm.query, consultarSucesso).$promise;
      vm.grupoUnidade = [];
      vm.unidadesSelecionadas = [];
    };

    vm.criarNovoGrupo = function(){
      $state.go("cadastrarGrupoUnidade");
    };

    vm.voltar = function(){
      if($stateParams.query){
        $stateParams.query.pesquisar = true;
      }
      $state.go("consultarGrupoUnidade", {query: $stateParams.query});
    };

    //##################################### ÓRGÃO #####################################

    vm.carregarOrgaos = function () {
      vm.query.idGrupoUnidade='';
      vm.unidadesSelecionadas = [];
      vm.jurisdicoesSelecionadas = [];

      Orgao.resource.query().$promise.then(function (result) {
        vm.orgaos = result;
      });
    };

    vm.pesquisarOrgao = function() {
      var query = angular.copy(queryDefault);
      query.nome = vm.filtroNomeOrgao;
      query.textoPesquisa = vm.filtroNomeOrgao;

      return Unidade.listar_nome_sigla_completa_por_texto.get(query).$promise.then(function (data) {
        var deferred = $q.defer();
        deferred.resolve(data.content);
        return deferred.promise;
      });
    };

    //##################################### UNIDADE #####################################

    vm.recuperarUnidade= function () {
      if($stateParams.unidadeId) {
        Unidade.resource.get({_id: $stateParams.unidadeId}, function (data) {
          vm.form = data;
        });
      }
    };

    vm.recuperaUnidadeSelecionada= function () {

      Unidade.resource.get({_id: vm.unidadesSelecionadas[0].id}, function (data) {
        vm.jurisdicoesSelecionadas = data.jurisdicoes;
        var jurisdicoesTemp = [];

        for(var indexJurisdicoes in vm.jurisdicoes) {
          for (var indexSelecionadas in vm.jurisdicoesSelecionadas) {
            if (vm.jurisdicoes[indexJurisdicoes].id == vm.jurisdicoesSelecionadas[indexSelecionadas].id) {
              jurisdicoesTemp.push(vm.jurisdicoes[indexJurisdicoes]);
            }
          }
        }

        vm.jurisdicoesSelecionadas = jurisdicoesTemp;
      });
    };

    vm.pesquisarUnidade = function(result) {
      var query = angular.copy(queryDefault);
      query.nome = vm.filtroNomeUnidade;
      vm.query.idOrganizacaoSuperior = vm.form.orgaoSuperior.id;

      return Unidade.resource.get(vm.query).$promise.then( function(data){
        var deferred = $q.defer();
        deferred.resolve(data.content);
        return deferred.promise;
      });
    };

    vm.pesquisarUnidadeFiltro = function() {
      vm.unidadesSelecionadas = [];
      vm.jurisdicoesSelecionadas = [];
      vm.query.textoPesquisa = vm.query.nome;
      vm.query.origem = null;
      vm.query.idOrganizacaoSuperior = vm.form.orgaoSuperior ? vm.form.orgaoSuperior.id : null;

      return Unidade.listar_nome_sigla_completa_por_texto.get(vm.query).$promise.then(function (data) {
        var deferred = $q.defer();
        deferred.resolve(data.content);
        return deferred.promise;
      });

    };

    vm.pesquisarUnidadeGrupoUnidadeFiltro = function() {
      vm.query.idOrganizacaoSuperior = vm.form.orgaoSuperior.id;
      var unidade =  Unidade.resource.query(vm.query).$promise;
      return unidade;
    };


    vm.pesquisarUnidadeOrgao = function() {
      var query = angular.copy(queryDefault);
      query.idOrgao = vm.form.orgaoSuperior.id;
      return Unidade.resource.query(query).$promise;
    };

    vm.pesquisarUnidadeOrgaoFiltro = function() {
      vm.query.idOrganizacaoSuperior = vm.form.orgaoSuperior.id;
      vm.query.textoPesquisa = vm.filtroNomeUnidade;

      return Unidade.resource.get(vm.query).$promise.then( function(data){
        var deferred = $q.defer();
        deferred.resolve(data.content);
        return deferred.promise;
      });
    };


    vm.criarFiltroUnidade = function(unidade){
      var unidadePesquisa = angular.lowercase(vm.filtroNomeUnidade);
      var unidadeNome =  angular.lowercase(unidade.nome);
      return (unidadeNome.indexOf(unidadePesquisa) === 0);
    };

    vm.salvarUnidade = function () {
      vm.grupoUnidade = JSON.parse(vm.form.grupoUnidade);
      if (vm.formUnidade.nome) {
        vm.formUnidade.grupoUnidade = vm.grupoUnidade;
        var unidadeInserida = Unidade.save(vm.formUnidade, function () {
          $mdToast.show($mdToast.simple().content("Unidade salva").position('top right'));
        });
        vm.fecharFormUnidade();
        vm.unidadesSelecionadas.push(unidadeInserida);
        vm.filtroNomeUnidade = [];
      }
    };

    vm.fecharFormUnidade = function() {
      vm.formUnidade = {};
      vm.showFormCadastroUnidade = false;
    };

    vm.desabilitarAssociacao = function(){
      return vm.unidadesSelecionadas.length > 0 && vm.form.sistema ? false : true;
    };

    //##################################### USUÁRIO #####################################

    vm.pesquisarAdministrador = function(result) {
      return Usuario.nome_cpf.query({param: vm.filtroAdministrador}).$promise;
    };

    vm.salvarUsuario = function () {
      if (vm.formUsuario.nome && vm.formUsuario.cpf && vm.formUsuario.email) {
        var usuarioInserido = Usuario.resource.save(vm.formUsuario, function () {
          $mdToast.show($mdToast.simple().content("Usuário salvo").position('top right'));
        });
        vm.fecharFormUsuario();
        vm.administradoresSelecionados.push(usuarioInserido);
        vm.filtroAdministrador = [];
      }
    };

    vm.fecharFormUsuario = function() {
      vm.formUsuario = {};
      vm.showFormCadastroUsuario = false;
    }

    //##################################### UNIDADE-SISTEMA-USUARIO #####################################

    vm.consultarUsuarioAssociados = function(){
      vm.administradoresSelecionados = [];
      if(vm.form.sistema && vm.unidadesSelecionadas.length > 0){
        Acesso.buscar_usuarios_associados_sistema.query({idSistema: vm.form.sistema.id, idUnidade: vm.unidadesSelecionadas[0].id}, function (data) {
          vm.administradoresSelecionados = data;
          vm.administradoresSelecionadosAuxiliar = angular.copy(vm.administradoresSelecionados);
        });
      }
    };

    vm.associarUnidadeSistemaUsuario = function (){
      if (!vm.form.modulo){
        $mdToast.show($mdToast.simple().content("É necessário selecionar o módulo.").position('top right'));
      } else if (!vm.administradoresSelecionados && vm.administradoresSelecionados.length < 2) {
        $mdToast.show($mdToast.simple().content("Deve haver no mínimo 2 usuários administradores").position('top right'));
      } else{
        Sistema.resource.get({_id:  vm.form.sistema.id}, function (data) {
          var sistema = data;

          vm.form.usuarios = vm.administradoresSelecionados;
          vm.form.orgaoSuperior = {
            id : vm.unidadesSelecionadas[0].id
          };

          for(var i = 0; i < vm.form.usuarios.length; i++){

            var objetoAcesso = {
              perfil: {id: perfilAdministradorUnidade },
              organizacao: vm.form.orgaoSuperior,
              usuario: vm.form.usuarios[i],
              modulo : vm.form.modulo,
              idSistema: sistema.id
            }
            Acesso.conceder_acessos_administradores_sistema_unidade.save(objetoAcesso, function () {
              $mdToast.show($mdToast.simple().content("Administradores de sistema da unidade salvo").position('top right'));
            });
          }
          $state.reload();
          vm.carregarOrgaos()
        });
      }
    };

    vm.adicionarAdministradoresSelecionadoAuxiliar = function(){
      vm.administradoresSelecionadosAuxiliar = angular.copy(vm.administradoresSelecionados);
    };

    vm.desassociarUnidadeSistemaUsuario = function (index){

      if (vm.administradoresSelecionados && vm.administradoresSelecionados.length >= 2) {

        vm.form.orgaoSuperior = {};
        vm.form.orgaoSuperior.id = vm.unidadesSelecionadas[0].id;

        Acesso.buscar_acesso_administrador_sistema_unidade.query({idSistema: vm.form.sistema.id,
          idUnidade: vm.unidadesSelecionadas[0].id,
          idUsuario: vm.administradoresSelecionadosAuxiliar[index].id}, function(data){
          var acessosUsuario = data;

          for(var i = 0; i < acessosUsuario.length; i++){
            Acesso.resource.delete({_id: acessosUsuario[i].id}, function() {
              $mdToast.show($mdToast.simple().content("Acesso de administrador desassociado").position('top right'));
            });
          }
        });
      }else {
        $mdToast.show($mdToast.simple().content("Deve haver no mínimo 2 usuários administradores. Insira outro administrador antes de excluir.").position('top right'));
        vm.administradoresSelecionados = angular.copy(vm.administradoresSelecionadosAuxiliar);
      }
    };

    //##################################### SISTEMA #####################################

    var consultarSucessoSistema = function (data) {
      vm.sistemas = data;
    };

    vm.consultarSistemas = function () {
      vm.promise = Sistema.resource.query(vm.query, consultarSucessoSistema).$promise;
    };

    //##################################### MODULO #####################################

    vm.carregarModulos = function () {
      vm.query.idSistema = vm.form.sistema ? vm.form.sistema.id : null;
      Modulo.resource.query(vm.query).$promise.then(function (result) {
        vm.modulos = result;
        vm.form.modulo = vm.modulos.length == 1 ? vm.modulos[0] : null;
      });
    };
    //##################################### JURISDIÇÃO #####################################

    var consultarSucessoJurisdicao = function (data) {
      vm.jurisdicoes = data;
    }

    vm.consultarJurisdicoes = function () {
      vm.promise = Uf.query(vm.query, consultarSucessoJurisdicao).$promise;
    };

    vm.alterarJurisdicao = function (item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      }
      else {
        list.push(item);
      }
    };
    vm.isExistenteJurisdicao = function (item, list) {
      return list.indexOf(item) > -1;
    };
    vm.isIndeterminadoJurisdicao = function() {
      return (vm.jurisdicoesSelecionadas.length !== 0 &&
      vm.jurisdicoesSelecionadas.length !== vm.jurisdicoes.length);
    };
    vm.isSelecionadoJurisdicao = function() {
      return vm.jurisdicoesSelecionadas.length === vm.jurisdicoes.length;
    };
    vm.alterarTodosJurisdicao = function() {
      if (vm.jurisdicoesSelecionadas.length === vm.jurisdicoes.length) {
        vm.jurisdicoesSelecionadas = [];
      } else if (vm.jurisdicoesSelecionadas.length === 0 || vm.jurisdicoesSelecionadas.length > 0) {
        vm.jurisdicoesSelecionadas = vm.jurisdicoes.slice(0);
      }
    };
    vm.isJurisdicaoSelecionada = function() {
      return vm.jurisdicoesSelecionadas.length > 0 ? false : true;
    };

    vm.associarJurisdicaoUnidade = function () {
      if(vm.unidadesSelecionadas[0]) {
        vm.unidadesSelecionadas[0].jurisdicoes = vm.jurisdicoesSelecionadas;
      }

      if(vm.unidadesSelecionadas.length > 0) {
        Unidade.associar_jurisdicoes.save({id: vm.unidadesSelecionadas[0].id, jurisdicoes: vm.unidadesSelecionadas[0].jurisdicoes},
          function () {
            $mdToast.show($mdToast.simple().content("Jurisdições Atribuidas com Sucesso").position('top right'));
            $state.reload();
            vm.consultarJurisdicoes();
            vm.carregarOrgaos();
          });
      }else{
        $mdToast.show($mdToast.simple().content("Informe a Unidade").position('top right'));
      }

    };

    //######################################################################################

    function situacaoAtivoToString(boolean){
      return boolean ? 'Ativo' : 'Inativo';
    };

    function stringToSituacaoAtivo(string){
      var ativo = "Ativo";
      var compare = ativo.localeCompare(string);

      if(compare == 0 || string == true){
        return true;
      }else{
        return false;
      }
    };

    vm.limpar = function () {
      GrupoUnidadeFactory.resetarAtributosPesquisa();
      $state.reload();
    };

    vm.limparConsultar = function () {
      if($stateParams.query){
        $state.go('consultarGrupoUnidade', {query: undefined});
      } else{
        $state.reload();
      }
    };

    vm.transformChip = function (chip) {
      // Se o parametro for um objeto, ele já é um chip
      if (angular.isObject(chip)) {
        return chip;
      }
      // Senão, cria um novo chip
      return { name: chip, type: 'new' }
    };
  }
})();

(function () {
    'use strict';
    angular.module('acessos').service('EsferaPoder', EsferaPoder);

    function EsferaPoder($resource) {
        return $resource('/api/public/esferas-poder/');
    }
})();

(function () {
  'use strict';

  angular.module('acessos').service('Dominio', Dominio);

  function Dominio($resource) {
      return {
        origem: $resource('/api/dominio/origens/'),
        tiposLog: $resource('/api/dominio/tipos-log/')
      }
  };

})();

angular.module('acessos').run(function ($rootScope, $location, $window, $http, $state, $mdToast, ENV, VERSION) {

        $rootScope.ENV = ENV;
        $rootScope.VERSION = VERSION;

        //Colocar aqui o código de inicialização depois de integrado com sistema de segurança
        $http.get('/api/cliente/public/usuario-logado-v2').then(function (result) {

          $rootScope.usuarioLogado = result.data;
        }, function (erro) {
          if ($rootScope.usuarioLogado && $rootScope.usuarioLogado.id) {
            $mdToast.show($mdToast.simple().content("Erro ao tentar recuperar o usuário logado.").position('top right'));
          }
        });

        $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams) {
            $rootScope.toState = toState;
            $rootScope.toStateParams = toStateParams;
        });

        $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
            var titleKey = 'acessos' ;
            if (toState.name != 'login' && $rootScope.previousStateName) {
                $rootScope.previousStateName = fromState.name;
                $rootScope.previousStateParams = fromParams;
            }
            if (toState.data && toState.data.pageTitle) {
                titleKey = toState.data.pageTitle;
            }
            $window.document.title = titleKey;
        });

        $rootScope.back = function() {
            if ($rootScope.previousStateName === 'activate' || $state.get($rootScope.previousStateName) === null) {
                $state.go('home');
            } else {
                $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
            }
        };

        $rootScope.$on("$stateChangeError", function (evt, current, previous, rejection) {
          if($rootScope.usuarioLogado && $rootScope.usuarioLogado.id){
            $state.go("erroPermissao");
          } else{
            $window.location.href = '/api';
          }
        });
    });

((function () {
    'use strict';

    angular.module('acessos').config(function ($stateProvider, $urlRouterProvider) {

      $urlRouterProvider.otherwise("/");

      var permissaoVinculadaAoUsuario = function(permissaoTela){
        var permissaoEncontrada = false;
        angular.forEach($rootScope.usuarioLogado.acessos, function(acesso){
          if(acesso.permissoes.indexOf(permissaoTela) != -1){
            permissaoEncontrada = true;
          }
        });
        return permissaoEncontrada;
      };


      var verificarPermissaoParaPagina = function (permissao) {
        return ["$state", "$q", "$timeout", "$http", "$rootScope", "$mdToast", "$interval", function($state, $q, $timeout, $http, $rootScope, $mdToast, $interval) {
          var defer = $q.defer();

          var permissaoVinculadaAoUsuario = function(permissaoTela){
            var permissaoEncontrada = false;
            var arrayPermissoes = permissaoTela.split(",");
            angular.forEach($rootScope.usuarioLogado.acessos, function(acesso){
              var permissoesAcesso = acesso.permissoes;
              angular.forEach(arrayPermissoes, function(permissao){
                if(permissoesAcesso.indexOf(permissao.trim()) != -1){
                  permissaoEncontrada = true;
                }
              });
            });
            return permissaoEncontrada;
          };

          if($rootScope.usuarioLogado && $rootScope.usuarioLogado.id) {
            if(!permissao){
              defer.resolve();
            } else{
              if($rootScope.usuarioLogado.acessos && permissaoVinculadaAoUsuario(permissao)){
                defer.resolve();
              } else{
                defer.reject("usuario-sem-permissao");
              }
            }
          } else{

            if(!permissao){
              defer.resolve();
            } else{
              var intervalPromise2 = $interval(function () {

                if($rootScope.usuarioLogado){

                    if($rootScope.usuarioLogado && $rootScope.usuarioLogado.id) {
                      if(!permissao){
                        defer.resolve();
                      } else{
                        if($rootScope.usuarioLogado.acessos && permissaoVinculadaAoUsuario(permissao)){
                          defer.resolve();
                        } else{
                          defer.reject("usuario-sem-permissao");
                        }
                      }
                    } else {
                      defer.reject("usuario-nao-logado");
                    }

                    $interval.cancel(intervalPromise2);
                }
              },1000);

            }
          }

          return defer.promise;
        }];
      };


      var states = [{
        state: 'consultarSistema',
        url: "/consultarSistema",
        templateUrl: "scripts/sistema/views/consultar-sistema.tmpl.html",
        controller: 'SistemaController as sistemaCtrl',
        params: { query: null },
        permissao: 'ACESSOS.CONSULTAR_SISTEMA'
      },{
        state:'cadastrarSistema',
        url: '/cadastrarSistema',
        templateUrl: 'scripts/sistema/views/cadastrar-sistema.tmpl.html',
        controller: 'SistemaController as sistemaCtrl',
        permissao: 'ACESSOS.CADASTRAR_SISTEMA'
      },{

        state: 'editarSistema',
        url: '/editarSistema/:sistemaId',
        templateUrl: 'scripts/sistema/views/editar-sistema.tmpl.html',
        controller: 'SistemaController as sistemaCtrl',
        params: { query: null },
        permissao: 'ACESSOS.ALTERAR_SISTEMA'
      },{

        state:'detalharSistema',
        url: '/detalharSistema/:sistemaId',
        templateUrl: 'scripts/sistema/views/detalhar-sistema.tmpl.html',
        controller: 'SistemaController as sistemaCtrl',
        params: { query: null },
        permissao: 'ACESSOS.CONSULTAR_SISTEMA'
      },{

        state:'consultarPermissao',
        url: "/consultarPermissao",
        templateUrl: "scripts/permissao/views/consultar-permissao.tmpl.html",
        controller: 'PermissaoController as permissaoCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_PERMISSAO"
      },{

        state:'cadastrarPermissao',
        url: '/cadastrarPermissao',
        templateUrl: 'scripts/permissao/views/cadastrar-permissao.tmpl.html',
        controller: 'PermissaoController as permissaoCtrl',
        permissao: "ACESSOS.CADASTRAR_PERMISSAO"
      },{

        state:'editarPermissao',
        url: '/editarPermissao/:permissaoId',
        templateUrl: 'scripts/permissao/views/editar-permissao.tmpl.html',
        controller: 'PermissaoController as permissaoCtrl',
        params: { query: null },
        permissao: "ACESSOS.ALTERAR_PERMISSAO"
      },{

        state:'detalharPermissao',
        url: '/detalharPermissao/:permissaoId',
        templateUrl: 'scripts/permissao/views/detalhar-permissao.tmpl.html',
        controller: 'PermissaoController as permissaoCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_PERMISSAO"
      },{

        state:'consultarPerfil',
        url: "/consultarPerfil",
        templateUrl: "scripts/perfil/views/consultar-perfil.tmpl.html",
        controller: 'PerfilController as perfilCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_PERFIL"
      },{

        state:'cadastrarPerfil',
        url: '/cadastrarPerfil',
        templateUrl: 'scripts/perfil/views/cadastrar-perfil.tmpl.html',
        controller: 'PerfilController as perfilCtrl',
        permissao: "ACESSOS.CADASTRAR_PERFIL"
      },{

        state:'editarPerfil',
        url: '/editarPerfil/:perfilId',
        templateUrl: 'scripts/perfil/views/editar-perfil.tmpl.html',
        controller: 'PerfilController as perfilCtrl',
        params: { query: null },
        permissao: "ACESSOS.ALTERAR_PERFIL"
      },{

        state:'detalharPerfil',
        url: '/detalharPerfil/:perfilId',
        templateUrl: 'scripts/perfil/views/detalhar-perfil.tmpl.html',
        controller: 'PerfilController as perfilCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_PERFIL"
      },{

        state:'consultarItemMenu',
        url: "/consultarItemMenu",
        templateUrl: "scripts/menu/views/consultar-item-menu.tmpl.html",
        controller: 'ItemMenuController as itemMenuCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_MENU"
      },{
        state:'cadastrarItemMenu',
        url: "/cadastrarItemMenu/:moduloId",
        templateUrl: "scripts/menu/views/cadastrar-item-menu.tmpl.html",
        controller: 'ItemMenuController as itemMenuCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_MENU"
      },{
        state:'criarItemMenu',
        url: "/criarItemMenu/id-modulo/:moduloId/id-item-superior/:itemSuperiorId",
        templateUrl: "scripts/menu/views/criar-item-menu.tmpl.html",
        controller: 'ItemMenuController as itemMenuCtrl',
        permissao: "ACESSOS.CADASTRAR_MENU"
      },{
        state:'editarItemMenu',
        url: "/editarItemMenu/id-item-menu/:itemMenuId/id-modulo/:moduloId",
        templateUrl: "scripts/menu/views/editar-item-menu.tmpl.html",
        controller: 'ItemMenuController as itemMenuCtrl',
        permissao: "ACESSOS.ALTERAR_MENU"
      },{
        state:'cadastrarUsuario',
        url: "/cadastrarUsuario",
        templateUrl: "scripts/usuario/views/cadastrar-usuario.tmpl.html",
        controller: 'UsuarioController as usuarioCtrl',
        permissao: "ACESSOS.CADASTRAR_USUARIO"
      },{

        state:'consultarUsuario',
        url: "/consultarUsuario",
        templateUrl: "scripts/usuario/views/consultar-usuario.tmpl.html",
        controller: 'UsuarioController as usuarioCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_USUARIO, ACESSOS.CONSULTAR_USUARIO_MODULO, ACESSOS.CONSULTAR_USUARIO_MODULO_UNIDADE, ACESSOS.CONSULTAR_USUARIO_MODULO_UNID_SUP"
      },{

        state:'detalharUsuario',
        url: "/detalharUsuario/:usuarioId",
        templateUrl: "scripts/usuario/views/detalhar-usuario.tmpl.html",
        controller: 'UsuarioController as usuarioCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_USUARIO, ACESSOS.CONSULTAR_USUARIO_MODULO, ACESSOS.CONSULTAR_USUARIO_MODULO_UNIDADE, ACESSOS.CONSULTAR_USUARIO_MODULO_UNID_SUP"
      },{

        state:'editarUsuario',
        url: "/editarUsuario/:usuarioId",
        templateUrl: "scripts/usuario/views/editar-usuario.tmpl.html",
        controller: 'UsuarioController as usuarioCtrl',
        params: { query: null },
        permissao: "ACESSOS.ALTERAR_USUARIO"
      },{

        state:'movimentarUsuario',
        url: "/movimentarUsuario/:usuarioId",
        templateUrl: "scripts/usuario/views/movimentar-usuario.tmpl.html",
        controller: 'UsuarioController as usuarioCtrl',
        params: { query: null },
        permissao: "ACESSOS.MOVIMENTAR_USUARIO"
      },{

        state:'solicitarAtivacaoUsuario',
        url: "/solicitarAtivacaoUsuario",
        templateUrl: "scripts/solicitacao_ativacao_usuario/solicitacao-ativacao-usuario.tmpl.html",
        controller: 'SolicitacaoUsuarioController as solicitacaoUsuarioCtrl'
      },{
        state:'consultaPerfilUsuario',
        url: "/consultaPerfilUsuario",
        templateUrl: "scripts/usuario/views/consulta-perfil-usuario.tmpl.html",
        controller: 'UsuarioController as usuarioCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_PERFIL_USUARIO_UNIDADE"
      },{

        state:'consultarSolicitAtivacaoUsuario',
        url: "/consultarSolicitAtivacaoUsuario",
        templateUrl: "scripts/usuario/views/consultar-solicit-ativacao-usuario.tmpl.html",
        controller: 'UsuarioController as usuarioCtrl',
        permissao: "ACESSOS.CONSULTAR_SOLICIT_ATIVACAO_USUARIO"
      },{

        state:'finalizarCadastro',
        url: "/finalizarCadastro/:chave",
        templateUrl: "scripts/usuario/views/finalizacao-cadastro.tmpl.html",
        controller: 'UsuarioController as usuarioCtrl'
      },{

        state:'alterarCadastro',
        url: "/alterarCadastro/:usuarioId",
        templateUrl: "scripts/usuario/views/alteracao-cadastro.tmpl.html",
        controller: 'UsuarioController as usuarioCtrl',
        permissao: "ACESSOS.ALTERAR_DADOS_PESSOAIS"
      },{

        state:'home',
        url: '/',
        templateUrl: "scripts/home/views/home.tmpl.html",
        controller: 'HomeController as homeCtrl'
      },{


        state:'solicitarAcesso',
        url: "/solicitarAcesso",
        templateUrl: "scripts/acesso/views/solicitacao-acesso.tmpl.html",
        controller: 'AcessoController as acessoCtrl',
        permissao: "ACESSOS.SOLICITAR_ACESSO"
      },{

        state:'concederAcesso',
        url: "/concederAcesso/:usuarioId",
        templateUrl: "scripts/acesso/views/conceder-acesso.tmpl.html",
        controller: 'AcessoController as acessoCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONCEDER_ACESSO"
      },{

        state:'consultarSolicitacaoAcesso',
        url: "/consultarSolicitacaoAcesso",
        templateUrl: "scripts/acesso/views/consultar-solicitacao-acesso.tmpl.html",
        controller: "AcessoController as acessoCtrl",
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_SOLICIT_ACESSO, ACESSOS.CONSULTAR_SOLICIT_ACESSO_SISTEMA, ACESSOS.CONSULTAR_SOLICIT_ACESSO_MODULO, ACESSOS.CONSULTAR_SOLICIT_ACESSO_MODULO_UNIDADE, ACESSOS.CONSULTAR_SOLICIT_ACESSO_MODULO_UNID_SUP"
      },{

        state:'detalharSolicitacaoAcesso',
        url: "/detalharSolicitacaoAcesso/:solicitacaoAcessoId",
        templateUrl: "scripts/acesso/views/detalhar-solicitacao-acesso.tmpl.html",
        controller: "AcessoController as acessoCtrl",
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_SOLICIT_ACESSO, ACESSOS.CONSULTAR_SOLICIT_ACESSO_SISTEMA, ACESSOS.CONSULTAR_SOLICIT_ACESSO_MODULO, ACESSOS.CONSULTAR_SOLICIT_ACESSO_MODULO_UNIDADE, ACESSOS.CONSULTAR_SOLICIT_ACESSO_MODULO_UNID_SUP"
      },{

        state:'tratarSolicitacaoAcesso',
        url: "/tratarSolicitacaoAcesso/:solicitacaoAcessoId",
        templateUrl: "scripts/acesso/views/tratar-solicitacao-acesso.tmpl.html",
        controller: "AcessoController as acessoCtrl",
        permissao: "ACESSOS.TRATAR_SOLICIT_ACESSO, ACESSOS.TRATAR_SOLICIT_ACESSO_SISTEMA, ACESSOS.TRATAR_SOLICIT_ACESSO_MODULO, ACESSOS.TRATAR_SOLICIT_ACESSO_MODULO_UNIDADE, ACESSOS.TRATAR_SOLICIT_ACESSO_MODULO_UNID_SUP"
      },{

        state:'consultarGrupoUnidade',
        url: "/consultarGrupoUnidade",
        templateUrl: "scripts/grupo_unidade/views/consultar-grupo-unidade.tmpl.html",
        controller: 'GrupoUnidadeController as grupoUnidadeCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_GRUPO_UNIDADE"
      },{

        state:'cadastrarGrupoUnidade',
        url: "/cadastrarGrupoUnidade",
        templateUrl: "scripts/grupo_unidade/views/cadastrar-grupo-unidade.tmpl.html",
        controller: 'GrupoUnidadeController as grupoUnidadeCtrl',
        permissao: "ACESSOS.CADASTRAR_GRUPO_UNIDADE"
      },{

        state:'detalharGrupoUnidade',
        url: "/detalharGrupoUnidade/:grupoUnidadeId",
        templateUrl: "scripts/grupo_unidade/views/detalhar-grupo-unidade.tmpl.html",
        controller: 'GrupoUnidadeController as grupoUnidadeCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_GRUPO_UNIDADE"
      },{

        state:'editarGrupoUnidade',
        url: '/editarGrupoUnidade/:grupoUnidadeId',
        templateUrl: 'scripts/grupo_unidade/views/editar-grupo-unidade.tmpl.html',
        controller: 'GrupoUnidadeController as grupoUnidadeCtrl',
        params: { query: null },
        permissao: "ACESSOS.ALTERAR_GRUPO_UNIDADE"
      },{

        state:'consultarOrgao',
        url: '/consultarOrgao/:orgaoId',
        templateUrl: 'scripts/orgao/views/consultar-orgao.tmpl.html',
        controller: 'OrgaoController as orgaoCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_ORGAO"
      },{

        state:'cadastrarOrgao',
        url: '/cadastrarOrgao',
        templateUrl: 'scripts/orgao/views/cadastrar-orgao.tmpl.html',
        controller: 'OrgaoController as orgaoCtrl',
        permissao: "ACESSOS.CADASTRAR_ORGAO"
      },{

        state:'editarOrgao',
        url: '/alterarOrgao/:orgaoId',
        templateUrl: 'scripts/orgao/views/editar-orgao.tmpl.html',
        controller: 'OrgaoController as orgaoCtrl',
        params: { query: null },
        permissao: "ACESSOS.ALTERAR_ORGAO"
      },{

        state:'detalharOrgao',
        url: '/detalharOrgao/:orgaoId',
        templateUrl: 'scripts/orgao/views/detalhar-orgao.tmpl.html',
        controller: 'OrgaoController as orgaoCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_ORGAO"
      },{

        state:'solicitarAtivacaoOrgao',
        url: '/solicitarAtivacaoOrgao',
        templateUrl: 'scripts/orgao/views/solicitar-ativacao-orgao.tmpl.html',
        controller: 'OrgaoController as orgaoCtrl'
      },{

        state:'consultarSolicitAtivacaoOrgao',
        url: '/consultarSolicitAtivacaoOrgao',
        templateUrl: 'scripts/orgao/views/consultar-solicit-ativacao-orgao.tmpl.html',
        controller: 'OrgaoController as orgaoCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_SOLICITACAO_ATIVACAO_ORGAO"
      },{

        state:'detalharSolicitAtivacaoOrgao',
        url: '/detalharSolicitAtivacaoOrgao/:solicitacaoAtivacaoOrgaoId',
        templateUrl: 'scripts/orgao/views/detalhar-solicit-ativacao-orgao.tmpl.html',
        controller: 'OrgaoController as orgaoCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_SOLICITACAO_ATIVACAO_ORGAO"
      },{

        state:'tratarSolicitAtivacaoOrgao',
        url: '/tratarSolicitAtivacaoOrgao/:solicitacaoAtivacaoOrgaoId',
        templateUrl: 'scripts/orgao/views/tratar-solicit-ativacao-orgao.tmpl.html',
        controller: 'OrgaoController as orgaoCtrl',
        params: { query: null },
        permissao: "ACESSOS.TRATAR_SOLICIT_ATIVACAO_ORGAO"
      },{

        state:'associarUnidade',
        url: "/associarUnidade",
        templateUrl: "scripts/unidade/views/associar-unidade.tmpl.html",
        controller: 'GrupoUnidadeController as grupoUnidadeCtrl',
        permissao: "ACESSOS.ASSOCIAR_ADMINISTRADORES_UNID_EXEC"
      },{

        state:'associarJurisdicao',
        url: "/associarJurisdicao",
        templateUrl: "scripts/unidade/views/associar-jurisdicao.tmpl.html",
        controller: 'GrupoUnidadeController as grupoUnidadeCtrl',
        permissao: "ACESSOS.ASSOCIAR_JURISDICOES_UNID_EXEC"
      },{

        state:'cadastrarUnidade',
        url: "/cadastrarUnidade",
        templateUrl: "scripts/unidade/views/cadastrar-unidade.tmpl.html",
        controller: 'UnidadeController as unidadeCtrl',
        permissao: "ACESSOS.CADASTRAR_UNIDADE"
      },{

        state:'consultarUnidade',
        url: "/consultarUnidade",
        templateUrl: "scripts/unidade/views/consultar-unidade.tmpl.html",
        controller: 'UnidadeController as unidadeCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_UNIDADE"
      },{

        state:'detalharUnidade',
        url: "/detalharUnidade/:unidadeId",
        templateUrl: "scripts/unidade/views/detalhar-unidade.tmpl.html",
        controller: 'UnidadeController as unidadeCtrl',
        params: { query: null },
        permissao: "ACESSOS.CONSULTAR_UNIDADE"
      },{

        state:'editarUnidade',
        url: "/editarUnidade/:unidadeId",
        templateUrl: "scripts/unidade/views/editar-unidade.tmpl.html",
        controller: 'UnidadeController as unidadeCtrl',
        params: { query: null },
        permissao: "ACESSOS.ALTERAR_UNIDADE"
      },{
        state:'concederAcessoEmLote',
        url: "/concederAcessoEmLote/:idPerfil",
        templateUrl: "scripts/acesso/views/conceder-acesso-em-lote.tmpl.html",
        controller: 'PerfilAcessoController as perfilAcessoCtrl',
        permissao: "ACESSOS.CONCEDER_ACESSO"
      },
      {
        state:'historicoAcoes',
        url: "/historico",
        templateUrl: "scripts/historico_acoes/views/historico-acoes.tmpl.html",
        controller: 'HistoricoAcoesController as historicoAcoesCtrl',
        permissao: "ACESSOS.CONSULTAR_HISTORICO_ACOES"
      },
      {
        state:'solicitarUsuario',
        url: "/solicitarUsuario/:id",
        templateUrl: "scripts/solicitacao_ativacao_usuario/solicitacao-realizada.tmpl.html",
        controller: 'SolicitacaoUsuarioController as solicitacaoUsuarioCtrl'
      },
      {
        state:'usuarioSemCadastro',
        url: "/usuarioSemCadastro",
        templateUrl: "scripts/usuario/views/usuario-sem-cadastro.tmpl.html",
      },
      {
        state:'erro',
        url: "/erro",
        templateUrl: "scripts/usuario/views/usuario-erro-ldap.tmpl.html",
      },
      {
        state:'cadastroRealizado',
        url: "/cadastroRealizado",
        templateUrl: "scripts/usuario/views/cadastro-realizado.tmpl.html"
      }
      ];

      angular.forEach(states, function (state) {

            $stateProvider
                .state(state.state, {
                    url: state.url,
                    templateUrl: state.templateUrl,
                    controller: state.controller,
                    params: state.params,
                    resolve: {
                      verificarPermissaoParaPagina : verificarPermissaoParaPagina(state.permissao)
                    }
                });
        });

      $stateProvider
        .state('erroPermissao', {
          url: '/erroPermissao',
          templateUrl: 'scripts/home/views/erro-permissao.tmpl.html',
          controller: 'HomeController as homeCtrl'
      });

      $stateProvider
        .state('erroInativo', {
          url: '/erroInativo',
          templateUrl: 'scripts/home/views/erro-inativo.tmpl.html',
          controller: 'HomeController as homeCtrl'
      });

      $stateProvider
        .state('logout', {
          url: '/logout',
          templateUrl: 'logout.html',
          controller: 'HomeController as homeCtrl',
          resolve: {
            verificarPermissaoParaPagina : verificarPermissaoParaPagina()
          }
        });

    });

})());

'use strict';
angular.module('acessos').controller('MenuController', function($mdSidenav,$scope, $location, ItemMenu) {
            var self = this;

      $scope.getToolbarColor = function() {
        var env = window.__env.ENV;
        switch(env) {
          case 'des':
            return '#ffff00';
          case 'ext':
            return '#0f4098';
          case 'test':
            return '#2eb82e';
          case 'hom':
            return '#000000';
          default:
            return '#0f4098';
        }
      };



  self.toggleMenu= function() {
                    $mdSidenav('left').toggle();
            };

            //var sections = [];
            //
            //self.carregarMenu = function(idModulo){
            //    ItemMenu.query({ idModulo:idModulo }, function (data) {
            //
            //        var section = {
            //            name: 'Acessos',
            //            type: 'heading',
            //            children: []
            //        };
            //
            //        angular.forEach(data, function(itemTemp){
            //            var itemPai = {
            //                name: itemTemp.descricaoResumida,
            //                type: 'toggle',
            //                pages:[]
            //            };
            //
            //            if(itemTemp.nos){
            //                angular.forEach(itemTemp.nos, function(itemTemp){
            //                    var itemFilho = {
            //                        name: itemTemp.descricaoResumida,
            //                        state: itemTemp.url,
            //                        type: 'link'
            //                    };
            //
            //                    itemPai.pages.push(itemFilho);
            //                });
            //            }
            //
            //            section.children.push(itemPai);
            //        });
            //
            //        sections.push(section);
            //    });
            //};

            //var sections = [];
            //sections.push({
            //        name: 'Segurança',
            //        type: 'heading',
            //        children: [
            //            {
            //                name: 'Acessos',
            //                type: 'toggle',
            //                pages: [{
            //                    name: 'Consultar Solicitação',
            //                    state: 'consultarSolicitacaoAcesso',
            //                    type: 'link'
            //                }, {
            //                    name: 'Solicitar Acesso',
            //                    state: 'solicitarAcesso',
            //                    type: 'link'
            //                }]
            //            },{
            //                name: 'Sistema',
            //                type: 'toggle',
            //                pages: [{
            //                    name: 'Consultar Sistema',
            //                    state: 'consultarSistema',
            //                    type: 'link'
            //                },{
            //                    name: 'Cadastrar Sistema',
            //                    state: 'cadastrarSistema',
            //                    type: 'link'
            //                }]
            //            },{
            //                name: 'Perfil',
            //                type: 'toggle',
            //                pages: [{
            //                    name: 'Consultar Perfil',
            //                    state: 'consultarPerfil',
            //                    type: 'link'
            //                },{
            //                    name: 'Cadastrar Perfil',
            //                    state: 'cadastrarPerfil',
            //                    type: 'link'
            //                }]
            //            },{
            //                name: 'Permissão',
            //                type: 'toggle',
            //                pages: [{
            //                    name: 'Consultar Permissão',
            //                    state: 'consultarPermissao',
            //                    type: 'link'
            //                },{
            //                    name: 'Cadastrar Permissão',
            //                    state: 'cadastrarPermissao',
            //                    type: 'link'
            //                }]
            //            },{
            //                name: 'Menu',
            //                type: 'toggle',
            //                pages: [{
            //                    name: 'Consultar Itens de Menu',
            //                    state: 'consultarItemMenu',
            //                    type: 'link'
            //                }]
            //            },{
            //                name: 'Usuario',
            //                type: 'toggle',
            //                pages: [{
            //                    name: 'Solicitar Ativação ',
            //                    state: 'solicitarAtivacaoUsuario',
            //                    type: 'link'
            //                }]
            //            }, {
            //                name: 'Órgão',
            //                type: 'toggle',
            //                pages: [{
            //                    name: 'Gerenciar Órgãos',
            //                    state: 'consultarOrgao',
            //                    type: 'link'
            //                },{
            //                    name: 'Solicitar Ativação',
            //                    state: 'solicitarAtivacaoOrgao',
            //                    type: 'link'
            //                }]
            //            },{
            //                name: 'Unidade',
            //                type: 'toggle',
            //                pages: [{
            //                    name: 'Associar Unidades Executoras',
            //                    state: 'associarUnidade',
            //                    type: 'link'
            //                },{
            //                    name: 'Associar Jurisdição',
            //                    state: 'associarJurisdicao',
            //                    type: 'link'
            //                }]
            //            },{
            //                name: 'Grupo Unidade',
            //                type: 'toggle',
            //                pages: [{
            //                    name: 'Gerenciar Grupo de Unidade',
            //                    state: 'consultarGrupoUnidade',
            //                    type: 'link'
            //                },{
            //                    name: 'Criar Grupo de Unidade',
            //                    state: 'cadastrarGrupoUnidade',
            //                    type: 'link'
            //                }]
            //            }
            //        ]});
            //sections.push({
            //        name: 'License',
            //        url:  'license',
            //        type: 'link',
            //        // Add a hidden section so that the title in the toolbar is properly set
            //        hidden: true
            //});
            //
            //var menu = {
            //        sections: sections,
            //
            //        selectSection: function(section) {
            //                self.openedSection = section;
            //        },
            //        toggleSelectSection: function(section) {
            //                self.openedSection = (self.openedSection === section ? null : section);
            //        },
            //        isSectionSelected: function(section) {
            //                return self.openedSection === section;
            //        },
            //
            //        selectPage: function(section, page) {
            //                self.currentSection = section;
            //                self.currentPage = page;
            //        },
            //        isPageSelected: function(page) {
            //                return self.currentPage === page;
            //        }
            //};
            //self.menu = menu;

            // Methods used by menuLink and menuToggle directives
            //self.isOpen = isOpen;
            //self.isSelected = isSelected;
            //self.toggleOpen = toggleOpen;
            //self.autoFocusContent = false;
            //
            //function isSelected(page) {
            //        return menu.isPageSelected(page);
            //}
            //
            //function isSectionSelected(section) {
            //        var selected = false;
            //        var openedSection = menu.openedSection;
            //        if(openedSection === section){
            //                selected = true;
            //        }
            //        else if(section.children) {
            //                section.children.forEach(function(childSection) {
            //                        if(childSection === openedSection){
            //                                selected = true;
            //                        }
            //                });
            //        }
            //        return selected;
            //}
            //
            //function isOpen(section) {
            //        return menu.isSectionSelected(section);
            //}
            //
            //function toggleOpen(section) {
            //        menu.toggleSelectSection(section);
            //}

    }).controller('GlobalController', function() {});

"use strict";
/**
 * Para trocar os valores das variáveis de ambiente modifique o arquivo de exemplo environment/env.js e o adicione
 * no diretório /environment do sistema operacional.
 */

var ENV;
var VERSION;
var CAPTCHAKEY;

ENV = !!ENV ? ENV : window.__env.ENV;
VERSION = !!VERSION ? VERSION : window.__env.VERSION;
CAPTCHAKEY = !!CAPTCHAKEY ? CAPTCHAKEY : window.__env.CAPTCHAKEY;

angular.module("acessos")
.constant("ENV", ENV)
.constant("VERSION", VERSION)
.constant("CAPTCHAKEY", CAPTCHAKEY);

(function () {
    'use strict';

    var URL_AVATAR_ICONS = 'assets/img/icons/avatars.svg';
    var URL_ICON_MENU = 'assets/img/icons/menu.svg';
    var URL_ICON_SHARE = 'assets/img/icons/share.svg';
    var URL_ICON_PERSON = 'assets/img/icons/ic_person_48px.svg';
    var URL_LOGOUT = 'assets/img/icons/ic_power_settings_new_48px.svg';

    angular.module('acessos')

        .config(function ($httpProvider, $locationProvider,  httpRequestInterceptorCacheBusterProvider) {
            $httpProvider.defaults.xsrfCookieName = 'CSRF-TOKEN';
            $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';
            //Cache everything except rest api requests

            httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);
            $httpProvider.interceptors.push('errorHandlerInterceptor');
            $httpProvider.interceptors.push('authExpiredInterceptor');
            $httpProvider.interceptors.push('alertInterceptor');
        })

        .config(['$urlMatcherFactoryProvider', function($urlMatcherFactory) {
            $urlMatcherFactory.type('boolean', {
                name : 'boolean',
                decode: function(val) { return val == true ? true : val == "true" ? true : false },
                encode: function(val) { return val ? 1 : 0; },
                equals: function(a, b) { return this.is(a) && a === b; },
                is: function(val) { return [true,false,0,1].indexOf(val) >= 0 },
                pattern: /bool|true|0|1/
            });

        }])

        .config(function($mdThemingProvider){
            $mdThemingProvider.theme("success-toast");
            $mdThemingProvider.theme('default')
                .primaryPalette('blue');

        })

        .config(function($compileProvider) {
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|file|ftp|blob):|data:image\//);
        })

        .config(function($mdDateLocaleProvider) {

            var myShortMonths = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
            $mdDateLocaleProvider.months = ['janeiro', 'feveiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
            $mdDateLocaleProvider.shortMonths = myShortMonths;
            $mdDateLocaleProvider.days = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'qunita-feira', 'sexta-feira', 'sábado'];
            $mdDateLocaleProvider.shortDays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'];
            $mdDateLocaleProvider.firstDayOfWeek = 1;
            $mdDateLocaleProvider.monthHeaderFormatter = function(date) {
                return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
            };
            $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
                return 'Semana ' + weekNumber;
            };
            $mdDateLocaleProvider.msgCalendar = 'Calendário';
            $mdDateLocaleProvider.msgOpenCalendar = 'Abrir o calendário';
            $mdDateLocaleProvider.formatDate = function(date) {
                return moment(date).format('DD/MM/YYYY');
            };
            $mdDateLocaleProvider.parseDate = function (dateString) {
              if (dateString == null || dateString.length === 0) {
                return null;
              }
              var m = moment(dateString, 'DD/MM/YYYY', true);
              return m.isValid() ? m.toDate() : new Date(NaN);
            };
        })

        .config(function($mdIconProvider) {
            $mdIconProvider
                .defaultIconSet(URL_AVATAR_ICONS, 128)
                .icon('menu', URL_ICON_MENU, 24)
                .icon('share', URL_ICON_SHARE, 24)
                .icon('person', URL_LOGOUT, 48)
                .icon('person', URL_ICON_PERSON, 48);
        });

})();

/**
 * Created by guilherme.lima on 07/06/17.
 */
(function(){
  'use strict';

  angular.module('acessos').controller('PerfilAcessoController', PerfilAcessoController);

  function PerfilAcessoController(Perfil,$stateParams){
    var vm = this;
    vm.perfil = {};

    vm.init = function(){
      if($stateParams.idPerfil) {
        Perfil.resource.get({_id: $stateParams.idPerfil}, function (data) {
          vm.perfil = data;
        });
      }
    };
    vm.init()

  }
})();

(function () {
    'use strict';

    angular.module('acessos').factory('Acesso', Acesso);

    function Acesso($resource) {
        return {
            resource: $resource('/api/acessos/:_id', {_id: '@_id'}, { 'update': { method:'PUT' }}),
            buscar_usuarios_associados_sistema: $resource('/api/acessos/buscar-usuarios-associados-sistema/:idSistema/:idUnidade', {idSistema: '@idSistema', idUnidade: '@idUnidade'}),
            buscar_acessos_administradores_sistema_unidade: $resource('/api/acessos/buscar-acessos-administradores-sistema-unidade/:idSistema/:idUnidade', {idSistema: '@idSistema', idUnidade: '@idUnidade'}),
            buscar_acesso_administrador_sistema_unidade: $resource('/api/acessos/buscar-acesso-administrador-modulo-unidade/:idSistema/:idUnidade/:idUsuario', {idSistema: '@idSistema', idUnidade: '@idUnidade', idUsuario: '@idUsuario'}),
            conceder_acessos_administradores_sistema_unidade: $resource('/api/acessos/concede-acessos-administradores-sistema-unidade/'),
            listar_acessos_completos: $resource('/api/acessos/listar-acessos-completos/'),
            revogar_acesso: $resource('/api/acessos/revogar-acesso/:_id', {_id: '@_id'}, { 'update': { method:'PUT' }}),
            listar_acessos_ativos: $resource('/api/acessos/listar-acessos-ativos/:_id',{_id: '@_id'}),
            listar_acessos_vencidos_inativos: $resource('/api/acessos/listar-acessos-vencidos-inativos/:_id',{_id: '@_id'}),
            listar_acessos_ativos_por_perfil: $resource('/api/acessos/listar-acessos-ativos-perfil/:_id',{_id: '@_id'}),
            salvar_em_lote: $resource('/api/acessos/acessos-em-lote'),
            verificar_existente_por_perfis: $resource('/api/acessos/verifica-acesso-existente-por-perfis/'),
            salvar_por_perfis: $resource('/api/acessos/salvar-por-perfis/'),
            consultar_relatorio_perfil_usuario: $resource('/api/acessos/listar-acessos-ativos-unidade/:param', {param: '@param'}, { 'get': {method:'GET', isArray:true}})
        };
    }

})();

(function () {
  'use strict';

  angular.module('acessos').controller('AcessoController', AcessoController);

  function AcessoController(SolicitacaoAcesso, Acesso, Organizacao, GrupoUnidade, Unidade, Sistema, Modulo, Perfil, Usuario, SituacaoSolicitacao, $mdToast, $mdDialog, $stateParams, $state, $scope, $filter, $rootScope, $q, $element, $location, $anchorScroll, $timeout) {

    var vm = this;
    vm.solicitacoes = [];
    vm.selecionado = [];
    vm.situacoes = [];
    vm.form = {};

    vm.filtroNomeOrgao = '';
    vm.grupoUnidade = {};
    vm.unidadesExecutoras = [];
    vm.unidadesSelecionadas = [];
    vm.sistemas = [];
    vm.modulos = [];
    vm.perfis = [];
    vm.acessosAssociados = [];
    vm.acessosSolicitacao = [];
    vm.acessosSolicitacaoPersistidos = [];
    vm.nuncaExpira = true;
    var enumSituacaoPendente = 0;
    var enumPapelSolicitante = 4;

    vm.usuarioSolicitacao = $rootScope.usuarioLogado;

    vm.acessosAssociados = [];
    vm.acessosSolicitacao = [];

    vm.sistemas = [];
    vm.modulos = [];
    vm.sistemas_filtro_permissoes = [];
    vm.modulos_filtro_permissoes = [];

    vm.form.dataExpiracao = new Date();

    vm.searchTerm;

    vm.opcoesDecisao = [{'key': "De acordo", 'value': true}, {'key': "Recusar", 'value': false}];
    vm.formAvaliacaoSolicitacao = {
      data: new Date()
    };


    var queryDefault = {
      order: 'nome',
      limit: 20,
      page:1
    };

    vm.query = angular.copy(queryDefault);
    vm.query.inicio = new Date();
    vm.query.inicio.setMonth(vm.query.inicio.getMonth() - 1);
    vm.query.fim = new Date();

    vm.inicializarConsulta = function() {
      if($stateParams.query && $stateParams.query.pesquisar){
        vm.query = $stateParams.query;
        vm.consultar();
      }
      vm.carregarSituacoes();
      vm.carregarSistemasFiltro();
      vm.carregarModulosFiltro();

      var consultaLimitada = false;
      angular.forEach($rootScope.usuarioLogado.acessos, function(acesso){
        if(acesso.permissoes.indexOf("ACESSOS.CONSULTAR_SOLICIT_ACESSO") != -1){
        } else if(acesso.permissoes.indexOf("ACESSOS.CONSULTAR_SOLICIT_ACESSO_MODULO_UNIDADE") != -1){
          $mdToast.show($mdToast.simple().content("Acesso limitado ao módulo " + acesso.nomeModulo + " do sistema " + acesso.nomeSistema + " na unidade " + acesso.organizacao.nome).position('top right').hideDelay(8000));
        } else if(acesso.permissoes.indexOf("ACESSOS.CONSULTAR_SOLICIT_ACESSO_MODULO_UNID_SUP") != -1){
          $mdToast.show($mdToast.simple().content("Acesso limitado ao módulo " + acesso.nomeModulo + " do sistema " + acesso.nomeSistema + " nas Unidade abaixo da " + acesso.organizacao.nome).position('top right').hideDelay(8000));
        } else if(acesso.permissoes.indexOf("ACESSOS.CONSULTAR_SOLICIT_ACESSO_MODULO") != -1){
          $mdToast.show($mdToast.simple().content("Acesso limitado ao módulo " + acesso.nomeModulo + " do sistema " + acesso.nomeSistema).position('top right').hideDelay(8000));
        } else if(acesso.permissoes.indexOf("ACESSOS.CONSULTAR_SOLICIT_ACESSO_SISTEMA") != -1){
          $mdToast.show($mdToast.simple().content("Acesso limitado ao sistema " + acesso.nomeSistema).position('top right').hideDelay(8000));
        }
      });
    }

    vm.consultar = function () {
      vm.query.dataInicio = vm.query.inicio ? $filter('date')(vm.query.inicio, 'MM/dd/yyyy') : null;
      vm.query.dataFim = vm.query.fim ? $filter('date')(vm.query.fim, 'MM/dd/yyyy') : null;

      if(vm.modulo) {
        vm.query.idModulo = vm.modulo.id;
      }

      if(vm.unidadeExecutora) {
        vm.query.idUnidadeExecutora = vm.unidadeExecutora.id;
      }

      vm.promise = SolicitacaoAcesso.resource.query(vm.query, function(data){
        vm.solicitacoes = data;
        if(vm.solicitacoes.length == 0){
          $mdToast.show($mdToast.simple().content("A consulta não retornou resultado.").position('top right'));
        }
      });
    };

    vm.voltarConsultarUsuario = function(){
      if($stateParams.query){
        $stateParams.query.pesquisar = true;
      }
      $state.go('consultarUsuario', { query: $stateParams.query });
    };

    vm.voltarConsultarSolicit = function(){
      if($stateParams.query){
        $stateParams.query.pesquisar = true;
      }
      $state.go('consultarSolicitacaoAcesso',{ query: $stateParams.query });
    };

    vm.limpar = function () {
      $state.reload();
    };

    vm.limparConsultar = function () {
      vm.query = angular.copy(queryDefault);
      if($stateParams.query){
        $state.go('consultarSolicitacaoAcesso', {query: undefined});
      } else{
        $state.reload();
      }
    };

    vm.limparEdicao = function () {
      vm.recuperarSolicitacaoAcesso();
      $state.reload();
    };

    vm.salvarEdicao = function () {
      SolicitacaoAcesso.resource.update({_id: $stateParams.solicitacaoAcessoId}, vm.form, function () {
        $mdToast.show($mdToast.simple().content("Pedido tratado com sucesso").position('top right'));
      });
      $state.go('consultarSolicitacaoAcesso');
    };

    vm.tratar = function (id) {
      $state.go('tratarSolicitacaoAcesso', { solicitacaoAcessoId: id });
    };

    vm.recuperarSolicitacaoAcesso = function () {
      if($stateParams.solicitacaoAcessoId) {
        SolicitacaoAcesso.resource.get({_id: $stateParams.solicitacaoAcessoId}, function (data) {
          vm.form = data;
          vm.form.avaliacao = vm.form.solicitacao.avaliacoes[0];
        });
      }
    };

    vm.carregarSituacoes = function() {
      SituacaoSolicitacao.query(function(data) {
        vm.situacoes = data;
      })
    };

    vm.recuperarUnidadeSolicitacaoAcesso = function(){
      Unidade.resource.get({_id: $rootScope.usuarioLogado.idOrganizacao}, function(data){
        vm.unidade = data;
      });
    };

    vm.carregarUnidadePorNome = function (nome) {
        vm.query.textoPesquisa = nome;
        vm.query.origem = vm.form.modulo.sistema.origem;
        return Unidade.listar_nome_sigla_completa_por_texto.get(vm.query).$promise.then(function (data) {
          var deferred = $q.defer();
          deferred.resolve(data.content);
          return deferred.promise;
        });
        vm.query = angular.copy(queryDefault);
    };

    vm.listarPerfisAssociados = function(){
      if(!vm.usuarioSolicitacao){
        $state.go('home');
      }
      Acesso.listar_acessos_ativos.query({_id : vm.usuarioSolicitacao.id}, function(data){
          vm.acessosAssociados = data;
      });
    };

    vm.pesquisarOrgao = function() {
      var query = angular.copy(queryDefault);
      query.nome = vm.filtroNomeOrgao;
      query.textoPesquisa = vm.filtroNomeOrgao;
      vm.unidadesSelecionadas = [];
      return Organizacao.listar_orgaos_entidades.query(query).$promise;
    };

    vm.consultarGrupoUnidadePorOrgao = function(){
      vm.promise = GrupoUnidade.resource.query(vm.query, consultarSucesso).$promise;
      vm.grupoUnidade = [];
      vm.unidadesSelecionadas = [];
    };

    var consultarSucesso = function (data) {
      vm.gruposUnidades = data;
      if(vm.gruposUnidades.length === 0){
        $mdToast.show($mdToast.simple().content("A consulta nao retornou resultado").position('top right'));
      }
    };

    vm.pesquisarUnidadeFiltro = function() {
      vm.unidadesSelecionadas = [];
      vm.query.textoPesquisa = vm.query.nome;
      vm.query.idOrganizacaoSuperior = vm.form.orgaoSuperior ? vm.form.orgaoSuperior.id : null;

      return Unidade.resource.get(vm.query).$promise.then( function(data){
        var deferred = $q.defer();
        deferred.resolve(data.content);
        return deferred.promise;
      });

    };

    vm.consultarSistemas = function () {
      vm.promise = Sistema.resource.query(vm.query, consultarSucessoSistema).$promise;
    };

    var consultarSucessoSistema = function (data) {
      vm.sistemas = data;
    };

    vm.carregarModulos = function () {
      vm.query.idSistema = vm.form.sistema ? vm.form.sistema : null;
      Modulo.resource.query(vm.query).$promise.then(function (result) {
        vm.modulos = result;
        vm.form.modulo = vm.modulos.length == 1 ? vm.modulos[0] : null;
      });
    };

    vm.consultarPerfis = function () {
      if(!vm.perfis || vm.perfis.length === 0 ||
        (vm.form.modulo && vm.form.modulo.id !== vm.query.idModulo)) {
        vm.query.idModulo = vm.form.modulo ? vm.form.modulo.id : null;
        Perfil.resource.query(vm.query).$promise.then(function (result) {
          vm.perfis = result;
        });
      }
    };

    vm.consultarPerfisPublicos = function () {
      if(!vm.perfis || vm.perfis.length === 0 ||
        (vm.form.modulo && vm.form.modulo.id !== vm.query.idModulo)) {
        vm.query.idModulo = vm.form.modulo ? vm.form.modulo.id : null;
        Perfil.consultar_perfis.query(vm.query).$promise.then(function (result) {
          vm.perfis = result;
        });
      }
    };

    vm.buscarUnidadeCompleta = function(){
      Unidade.resource.get({_id: vm.unidadesSelecionadas[0].id}, function(data){
        vm.unidadesSelecionadas[0].jurisdicoes = data.jurisdicoes;
      });
    };

    vm.validarSolicitacaoAcesso = function(){
      if(vm.form.dataExpiracao && !$scope.formAcesso.dataExpiracao.$valid && !vm.nuncaExpira){
        $mdToast.show($mdToast.simple().content("Preencha a data de expiração corretamente.").position('top right'));
      }else if(!vm.form.unidadeExecutora) {
        $mdToast.show($mdToast.simple().content("Informe a Unidade.").position('top right'));
      } else if(!vm.form.modulo){
        $mdToast.show($mdToast.simple().content("informe o módulo.").position('top right'));
      } else if(!vm.form.perfisSelecionados){
        $mdToast.show($mdToast.simple().content("informe no mínimo um perfil.").position('top right'));
      } else if (!vm.form.justificativa) {
        $mdToast.show($mdToast.simple().content("Informe a justificativa.").position('top right'));
      } else if (!vm.nuncaExpira && !vm.form.dataExpiracao) {
        $mdToast.show($mdToast.simple().content('Informe a data de expiração ou desmarque a checkbox "O acesso nunca expira"').position('top right'));
      } else {
        vm.salvar();
      }
    };

    vm.salvar = function() {

      vm.form.perfisSelecionados.forEach(function(perfilLoop){
        var acessoSolicitacaoDuplicado = $filter('filter')(vm.acessosSolicitacao,{
          idUnidadeExecutora: vm.form.unidadeExecutora.id,
          idModulo: vm.form.modulo.id,
          idPerfil: perfilLoop.id
        });

        if(acessoSolicitacaoDuplicado.length == 0){

          Acesso.resource.query({
            idPerfil: perfilLoop.id,
            idModulo: vm.form.modulo.id,
            //idUnidadeExecutora: vm.unidadesSelecionadas[0].id,
            idUnidadeExecutora: vm.form.unidadeExecutora.id,
            idUsuario: vm.usuarioSolicitacao.id,
            ativo: true,
            valido: true
          }, function(data){

            if(data.length > 0 )
              $mdToast.show($mdToast.simple().content("O usuário já está associado a este perfil '"+perfilLoop.nome+"'.").position('top right'));
            else{

              SolicitacaoAcesso.resource.query({
                idPerfil: perfilLoop.id,
                idModulo: vm.form.modulo.id,
                //idUnidadeExecutora: vm.unidadesSelecionadas[0].id,
                idUnidadeExecutora: vm.form.unidadeExecutora.id,
                idUsuario: vm.usuarioSolicitacao.id,
                situacaoSolicitacao: 'PENDENTE'
              }, function(data){

                if(data.length > 0 )
                  $mdToast.show($mdToast.simple().content("Já existe uma solicitação para este acesso.").position('top right'));
                else{
                  var acessoObject = {
                    perfil: perfilLoop,
                    //unidadeExecutora: vm.unidadesSelecionadas[0],
                    unidadeExecutora: vm.form.unidadeExecutora,
                    //jurisdicoes: vm.unidadesSelecionadas[0].jurisdicoes,
                    jurisdicoes: vm.form.unidadeExecutora.jurisdicoes,
                    validade: !vm.nuncaExpira ? vm.form.dataExpiracao : null,
                    justificativa: vm.form.justificativa,
                    modulo: vm.form.modulo,
                    idPerfil: perfilLoop.id,
                    idModulo: vm.form.modulo.id,
                    //idUnidadeExecutora: vm.unidadesSelecionadas[0].id
                    idUnidadeExecutora: vm.form.unidadeExecutora.id
                  };

                  vm.acessosSolicitacao.push(acessoObject);
                  $timeout(function() {
                    $location.hash('btnEnviarSolicitacao');
                    $anchorScroll();
                  }, 2000);
                }
              });
            }
          });

        } else{
          $mdToast.show($mdToast.simple().content("Algumas das solicitações já estão na lista.").position('top right'));
        }

      });

    };

    vm.revogarAcessoAssociado = function(id){
      var confirm = $mdDialog.confirm()
        .title('Revogar Acesso')
        .textContent('Deseja confirmar a revogação desse perfil ?')
        .ariaLabel('Revogar Acesso')
        .targetEvent(event)
        .ok('Avançar')
        .cancel('Retornar');

      $mdDialog.show(confirm).then(function() {
        Acesso.revogar_acesso.update({_id: id}, function(){
          $mdToast.show($mdToast.simple().content("Acesso revogado").position('top right'));

          if($stateParams.usuarioId){
            vm.listarPerfisAssociadosUsuario();
          } else{
            vm.listarPerfisAssociados();
          }

        });
      });
    };

    vm.revogarAcesso = function(index){
      vm.acessosSolicitacao.splice(index,1);
    };

    vm.gravar = function() {

      for (var i = 0; i < vm.acessosSolicitacao.length; i++) {
        var persistir = {};
        persistir = {
          perfil: vm.acessosSolicitacao[i].perfil,
          unidadeExecutora: vm.acessosSolicitacao[i].unidadeExecutora,
          dataExpiracao: vm.acessosSolicitacao[i].validade ? vm.acessosSolicitacao[i].validade : null,
          modulo: vm.acessosSolicitacao[i].modulo,
          solicitacao: {
            "data": new Date(),
            "situacao": enumSituacaoPendente,
            "justificativa": vm.acessosSolicitacao[i].justificativa,
            "solicitante": {
              idUsuario: vm.usuarioSolicitacao.id,
              nome: vm.usuarioSolicitacao.nome,
              email: vm.usuarioSolicitacao.email,
              cpf: vm.usuarioSolicitacao.cpf,
              papeisUsuarioSolicitacao: [enumPapelSolicitante]
            }
          }
        };

        SolicitacaoAcesso.resource.save(persistir, function (data) {
          vm.acessosSolicitacaoPersistidos.push(data);

          if(vm.acessosSolicitacaoPersistidos.length == vm.acessosSolicitacao.length){
            $mdDialog.show({
              scope: $scope,
              preserveScope: true,
              templateUrl: 'scripts/acesso/views/confirmacao-dialog.tmpl.html',
              clickOutsideToClose: true,
              controller: function DialogController($scope, $mdDialog) {
                $scope.closeDialog = function () {
                  $mdDialog.hide();
                  $mdToast.show($mdToast.simple().content("Solicitação criada com sucesso!").position('top right').hideDelay(6000));
                  $state.reload();
                }
              }
            });
          }
        }, function(error){
          $mdToast.show($mdToast.simple().content(error.data.message).position('top right').hideDelay(3000));
        });
      }

    };

    vm.transformChip = function (chip) {
      // Se o parametro for um objeto, ele já é um chip
      if (angular.isObject(chip)) {
        return chip;
      }
      // Senão, cria um novo chip
      return { name: chip, type: 'new' }
    };

    vm.recuperaUsuario = function() {
      Usuario.resource.get({_id: $stateParams.usuarioId}, function (data) {
        vm.form.usuario = data;
        vm.listarPerfisAssociadosUsuario();
      });
    };

    vm.recuperaGestorAvaliador = function(){
      if($rootScope.usuarioLogado && $rootScope.usuarioLogado.id) {
        vm.formAvaliacaoSolicitacao.avaliador = $rootScope.usuarioLogado;
      } else{
        $state.go('home');
      }
    };

    vm.listarPerfisAssociadosUsuario = function(){
      Acesso.listar_acessos_ativos.query({_id : $stateParams.usuarioId}, function(data){
        vm.acessosAssociados = data;
      });
    };

    vm.validarConcederAcesso = function(){
      //if(!vm.unidadesSelecionadas[0]) {
      if(!vm.unidade) {
        $mdToast.show($mdToast.simple().content("Informe a UG Executora.").position('top right'));
      } else if(!vm.form.modulo){
        $mdToast.show($mdToast.simple().content("informe o módulo.").position('top right'));
      } else if(!vm.form.perfil){
        $mdToast.show($mdToast.simple().content("informe o perfil.").position('top right'));
      } else if (!vm.nuncaExpira && !vm.form.dataExpiracao) {
        $mdToast.show($mdToast.simple().content('Informe a data de expiração ou desmarque a checkbox "O acesso nunca expira"').position('top right'));
      } else {
        vm.concederAcesso();
      }
    };

    vm.validarConcederAcessoUsuario = function(){
      if(vm.form.dataExpiracao && !$scope.formAcesso.dataExpiracao.$valid && !vm.nuncaExpira){
        $mdToast.show($mdToast.simple().content("Preencha a data de expiração corretamente.").position('top right'));
      }else if(!vm.form.unidadeExecutora) {
        $mdToast.show($mdToast.simple().content("Informe a UG Executora.").position('top right'));
      } else if(!vm.form.modulo){
        $mdToast.show($mdToast.simple().content("Informe o módulo.").position('top right'));
      } else if(!vm.form.perfisSelecionados || vm.form.perfisSelecionados.length === 0){
        $mdToast.show($mdToast.simple().content("Informe o perfil.").position('top right'));
      } else if (!vm.nuncaExpira && !vm.form.dataExpiracao) {
        $mdToast.show($mdToast.simple().content('Informe a data de expiração ou desmarque a checkbox "O acesso nunca expira"').position('top right'));
      } else {
        vm.concederAcesso();
      }
    };

    vm.concederAcesso = function(){
      Acesso.verificar_existente_por_perfis
        .query({
          idModulo: vm.form.modulo.id,
          idUnidadeExecutora: vm.form.unidadeExecutora.id,
          idUsuario: $stateParams.usuarioId,
          perfilIdList: vm.form.perfisSelecionados
        }, function(data){
        if(data.length > 0 ) {
          $mdToast.show($mdToast.simple().content("O usuário já está associado a este perfil.").position('top right'));
        }else {
          var acesso = {
            modulo: vm.form.modulo,
            organizacao: vm.form.unidadeExecutora,
            usuario: vm.form.usuario,
            validade: vm.nuncaExpira ? null : vm.form.dataExpiracao,
            observacao: vm.form.justificativa,
            perfilIdList: vm.form.perfisSelecionados
          };
          Acesso.salvar_por_perfis.save(acesso, function(){
            $mdToast.show($mdToast.simple().content("Acesso concedido").position('top right'));
            $state.reload();
          });
        }
      });
    };

    vm.irParaTratarSolicitacaoAcesso = function(id){
      $state.go('tratarSolicitAtivacaoOrgao', { solicitacaoAtivacaoOrgaoId: id });
    };

    vm.tratarSolicitacaoAcesso = function() {
      if(typeof vm.formAvaliacaoSolicitacao.aprovada == 'undefined' || vm.formAvaliacaoSolicitacao.aprovada == null) {
        $mdToast.show($mdToast.simple().content('Informe uma nova situação para solicitação: "Autorizada" ou "Negada"').position('top right'));
      } else if(vm.formAvaliacaoSolicitacao.aprovada == false & !vm.formAvaliacaoSolicitacao.observacao){
        $mdToast.show($mdToast.simple().content('É necessário informar o motivo da recusa da solicitação').position('top right'));
      } else {
        vm.formAvaliacaoSolicitacao.solicitacao = vm.form.solicitacao;
        vm.formAvaliacaoSolicitacao.situacao =  vm.form.solicitacao.situacao;
        vm.formAvaliacaoSolicitacao.dataExpiracao = vm.form.dataExpiracao;

        SolicitacaoAcesso.tratar_solicitacao.update({_id: vm.form.id},vm.formAvaliacaoSolicitacao, function(result){
          $mdToast.show($mdToast.simple().content("Pedido tratado com sucesso!").position('top right'));
          $state.go('consultarSolicitacaoAcesso');
        }, function(error){
          $mdToast.show($mdToast.simple().content(error.data.message).position('top right'));
        });
      }

    };

    vm.excluirSolicitacaoAcesso = function(id){
      //$state.go('tratarSolicitAtivacaoOrgao', { solicitacaoAtivacaoOrgaoId: id });
    };

    vm.clearSearchTerm = function() {
      vm.searchTerm = '';
    };

    $element.find('input').on('keydown', function(ev) {
      ev.stopPropagation();
    });

    vm.carregarUnidadePorNome = function (nome) {
      var query = angular.copy(queryDefault);
          query.nome = nome;
          query.textoPesquisa = nome;
          query.isUnidadeUsuarioLogado = true;

          return Unidade.listar_nome_sigla_completa_por_texto.get(query).$promise.then(function (data) {
            var deferred = $q.defer();
            deferred.resolve(data.content);
            return deferred.promise;
          });
    };

    vm.carregarSistemasFiltro = function () {
      Sistema.resource.query(vm.queryFiltro).$promise.then(function (result) {
        vm.sistemas_filtro_permissoes = result;
      });
    };

    vm.carregarModulosFiltro = function () {
      Modulo.resource.query(vm.queryFiltro).$promise.then(function (result) {
        vm.modulos_filtro_permissoes = result;
      });
    };

    vm.carregarSistemas = function () {
      Sistema.resource.query(vm.query).$promise.then(function (result) {
        vm.sistemas = result;
      });
    };

    vm.carregarModulos = function () {
      var query = angular.copy(queryDefault);
      query.idSistema = vm.idSistema;
      Modulo.resource.query(query).$promise.then(function (result) {
        vm.modulos = result;
      });
    };
  }

})();

(function () {
    'use strict';

    angular.module('acessos').factory('AcaoHttp', AcaoHttp);

    function AcaoHttp($resource) {
        return $resource('/api/acoes-http/');
    };

})();
(function () {
    'use strict';

    angular.module('acessos').factory('Documento', Documento);

    function Documento($resource) {
        return $resource('/api/documentos/:_id', {_id: '@_id'}, { 'update': { method:'PUT' }});
    };

})();
angular.module("acessos").run(["$templateCache", function($templateCache) {$templateCache.put("scripts/solicitacao_ativacao_usuario/solicitacao-ativacao-usuario.tmpl.html","<div class=padding-right-pagina><div class=md-title-com-borda>Solicitação de Ativação Usuário</div><div layout=column layout-align=center><form name=form novalidate><div layout=row><md-input-container flex=30><label>CPF</label><input name=cpf ng-model=solicitacaoUsuarioCtrl.form.solicitacaoAtivacaoUsuario.cpf ng-blur=solicitacaoUsuarioCtrl.recuperarNome() ui-br-cpf-mask required><div ng-messages=form.cpf.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=cpf><small>CPF inválido</small></div></div></md-input-container><md-input-container flex=70><label>Nome</label><input name=nome required ng-disabled=solicitacaoUsuarioCtrl.nomeRecuperado ng-model=solicitacaoUsuarioCtrl.form.solicitacaoAtivacaoUsuario.nome></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Email</label><input type=email name=email ng-model=solicitacaoUsuarioCtrl.form.solicitacaoAtivacaoUsuario.email required><div ng-messages=form.email.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=email><small>Email inválido</small></div></div></md-input-container><md-input-container class=md-block flex=50><label>Confirmar Email</label><input type=email name=cemail ng-model=solicitacaoUsuarioCtrl.form.solicitacaoAtivacaoUsuario.confirmacaoEmail required><div ng-messages=form.cemail.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=email>Email inválido</div></div><div ng-show=\"form.cemail.$dirty && solicitacaoUsuarioCtrl.form.email != solicitacaoUsuarioCtrl.form.confirmacaoEmail\"><small>A confirmação de email não coincide</small></div></md-input-container></div><div layout-margin=5 layout=row flex=100 layout-align=end><captcha ng-model=solicitacaoUsuarioCtrl.form.captchaResponse reset-captcha=solicitacaoUsuarioCtrl.resetCaptcha></captcha></div><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button class=md-raised ng-click=solicitacaoUsuarioCtrl.limpar()>Limpar</md-button><md-button type=submit class=md-raised ng-click=solicitacaoUsuarioCtrl.enviar($event)>Enviar</md-button></div></form></div></div>");
$templateCache.put("scripts/solicitacao_ativacao_usuario/solicitacao-realizada.tmpl.html","<div class=padding-right-pagina><div class=md-title-com-borda>Solicitação de Cadastro de Usuário</div><h2 style=\"margin-top: 50px; text-align: center\">Seu Cadastro foi realizado com sucesso!</h2><h3 style=\"text-align: center; line-height: 200%; margin-top: 50px\">Encaminhamos uma mensagem de confirmação para o e-mail informado no cadastro. Se Você já se cadastrou mas não recebeu a mensagem de confirmação, <a href=\"\" ng-click=solicitacaoUsuarioCtrl.reenviarEmail()>clique aqui</a> para reenviar o e-mail. Dica: se a mensagem não chegar na caixa de entrada, verifique a caixa de Spam ou envie um email para: spunet-gestao@economia.gov.br</h3></div>");
$templateCache.put("scripts/acesso/views/conceder-acesso-em-lote.tmpl.html","<div><h1 class=md-title>Concessão de acesso em lote</h1><md-divider></md-divider><dados-perfil ng-if=perfilAcessoCtrl.perfil.id perfil=perfilAcessoCtrl.perfil></dados-perfil><concessao-acesso-em-lote ng-if=perfilAcessoCtrl.perfil.id perfil=perfilAcessoCtrl.perfil></concessao-acesso-em-lote></div>");
$templateCache.put("scripts/acesso/views/conceder-acesso.tmpl.html","<div layout-xs=column ng-init=acessoCtrl.recuperaUsuario();><md-content flex><h1 class=md-title>Conceder Acesso</h1><md-divider></md-divider><form name=formAcesso novalidate><br><br><section><h1 class=md-title>Dados do Usuário</h1><md-divider></md-divider><section><br><section layout=row layout-align=center><span>{{ acessoCtrl.form.usuario.cpf}} - {{acessoCtrl.form.usuario.nome}}</span></section></section><br><br><h1 class=md-title ng-show=\"acessoCtrl.acessosAssociados.length > 0\">Perfis associados</h1><md-divider ng-show=\"acessoCtrl.acessosAssociados.length > 0\"></md-divider><section ng-show=\"acessoCtrl.acessosAssociados.length > 0\"><br><br><section><md-card><md-table-container><table md-table><thead md-head><tr md-row><th md-column style=\"text-align: center\"><span>Sistema</span></th><th md-column style=\"text-align: center\"><span>Módulo</span></th><th md-column style=\"text-align: center\"><span>Perfil</span></th><th md-column style=\"text-align: center\"><span>Unidade</span></th><th md-column style=\"text-align: center\"><span>Jurisdição</span></th><th md-column style=\"text-align: center\"><span>Validade</span></th><th md-column style=\"text-align: center\"><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"acesso in acessoCtrl.acessosAssociados\"><td md-cell style=\"text-align: center\">{{acesso.modulo.sistema.nome}}</td><td md-cell style=\"text-align: center\">{{acesso.modulo.nome}}</td><td md-cell style=\"text-align: center\">{{acesso.perfil.nome}}</td><td md-cell style=\"text-align: center\">{{acesso.unidadeExecutora.nome}}</td><td md-cell style=\"text-align: center\"><span ng-repeat=\"jurisdicao in acesso.unidadeExecutora.jurisdicoes\"><span ng-if=!$last>{{jurisdicao.sigla}} /</span> <span ng-if=$last>{{jurisdicao.sigla}}</span></span></td><td md-cell style=\"text-align: center\">{{acesso.validadeDate ? acesso.validadeDate : acesso.validade | date : \"dd/MM/yyyy\"}}</td><td md-cell style=\"text-align: center\"><ng-md-icon icon=delete style=fill:#788489 size=22 alt=Excluir ng-click=acessoCtrl.revogarAcessoAssociado(acesso.id) ng-if=\"acesso.status == \'Ativo\'\"><md-tooltip>Excluir</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container></md-card><br><br><historico-acesso ng-if=acessoCtrl.form.usuario.id meus-acessos=false id-usuario=acessoCtrl.form.usuario.id atualizar-historico={{acessoCtrl.acessosAssociados}}></historico-acesso></section></section><br><br><h3 class=texto-secundario>Novo Perfil</h3><div flex=100><div layout=row><md-input-container flex=50><label>Sistema:</label><md-select name=sistema ng-model=acessoCtrl.form.sistema md-on-open=\"acessoCtrl.consultarSistemas(); acessoCtrl.form.perfil = \'\';\" md-on-close=acessoCtrl.carregarModulos();><md-option ng-repeat=\"sistema in acessoCtrl.sistemas\" ng-value={{sistema.id}}>{{sistema.nome}}</md-option></md-select></md-input-container><md-input-container class=md-block flex=50 ng-show=\"acessoCtrl.form.sistema && acessoCtrl.modulos.length > 1\"><label>Módulo</label><md-select name=modulo ng-model=acessoCtrl.form.modulo md-on-open=\"acessoCtrl.carregarModulos(); acessoCtrl.form.perfil = \'\';\" ng-change=acessoCtrl.carregarPermissoes()><md-option ng-repeat=\"modulo in acessoCtrl.modulos\" ng-value={{modulo}}>{{modulo.nome}}</md-option></md-select></md-input-container></div><div layout=row><md-input-container flex=100 flex-xs=100><label>Unidade<ng-md-icon icon=help style=fill:#788489 size=26 alt=Ajuda></ng-md-icon><md-tooltip>Este campo pode ser utilizado para associar uma unidade/UG Executora/departamento/setor/órgão a um usuário ou perfil dentro do sistema acessos</md-tooltip></label><md-autocomplete ng-model=acessoCtrl.form.unidadeExecutora md-selected-item=acessoCtrl.form.unidadeExecutora md-search-text=textoBusca md-items=\"unidade in acessoCtrl.carregarUnidadePorNome(textoBusca)\" md-item-text=unidade.nome md-no-cache=true md-input-minlength=3 md-delay=700 ng-disabled=!acessoCtrl.form.modulo><md-item-template><span md-highlight-text=textoBusca md-highlight-flags=gi>{{unidade.nome}} - {{unidade.siglaCompleta}}</span></md-item-template><md-not-found>Unidade não encontrada. É necessário cadastrá-la e ativá-la antes de realizar a solicitação.</md-not-found></md-autocomplete></md-input-container><div flex=50 ng-show=\"acessoCtrl.unidadesSelecionadas[0].jurisdicoes.length > 0\" layout=\"center center\">Jurisdição: <span ng-repeat=\"jurisdicao in acessoCtrl.unidadesSelecionadas[0].jurisdicoes\"><span ng-if=!$last>{{jurisdicao.sigla}} /</span> <span ng-if=$last>{{jurisdicao.sigla}}</span></span></div></div><div layout=row><md-input-container class=md-block flex=50 flex-xs=100><label>Perfil:</label><md-select ng-model=acessoCtrl.form.perfisSelecionados md-on-close=acessoCtrl.clearSearchTerm() data-md-container-class=selectHeader multiple md-on-open=acessoCtrl.consultarPerfis()><md-select-header class=select-header><input ng-model=acessoCtrl.searchTerm type=search placeholder=\"Pesquisar perfis...\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=Perfil:><md-option ng-value=perfil.id ng-repeat=\"perfil in acessoCtrl.perfis | filter: {nome: acessoCtrl.searchTerm} track by perfil.nome | orderBy : \'nome\'\">{{perfil.nome}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=md-block flex=50 flex-xs=100><label>Justificativa</label><textarea name=justificativa ng-model=acessoCtrl.form.justificativa md-maxlength=150></textarea><div ng-messages=formAcesso.justificativa.$error><div ng-message=md-maxlength>O campo deve ter no máximo 150 caracteres</div></div></md-input-container></div><div layout=row><div layout=row flex=20 flex-xs=100 layout-align=\"center center\"><md-checkbox ng-model=acessoCtrl.nuncaExpira style=margin:0>O acesso nunca expira</md-checkbox></div><div layout=row layout-align=\"center center\" ng-show=!acessoCtrl.nuncaExpira><span>Data Expiração:</span><md-datepicker name=dataExpiracao ng-model=acessoCtrl.form.dataExpiracao md-placeholder=\"Data expiração\" ng-disabled=acessoCtrl.nuncaExpira ng-required=!acessoCtrl.nuncaExpira></md-datepicker><div ng-messages=formAcesso.dataExpiracao.$error><div ng-message=required><small>Campo obrigatório</small></div></div></div></div><br><div layout=row layout-align=end><md-button id=voltar_Button class=md-raised ng-click=acessoCtrl.voltarConsultarUsuario()>Voltar</md-button><md-button class=md-raised ng-click=acessoCtrl.limpar()>Limpar</md-button><md-button id=concederAcesso_Button type=submit class=md-raised ng-click=acessoCtrl.validarConcederAcessoUsuario()>Associar</md-button></div></div></section></form></md-content></div>");
$templateCache.put("scripts/acesso/views/confirmacao-dialog.tmpl.html","<md-dialog aria-label=\"Mensagem de Confirmação\" ng-cloak flex=50><form><md-toolbar><div class=md-toolbar-tools><h2>Mensagem de Confirmação</h2><span flex></span></div></md-toolbar><md-dialog-content><div class=md-dialog-content><label>Solicitação de Associação de Perfil/Unidade enviado com sucesso</label><md-table-container><table md-table><thead md-head><tr md-row><th md-column style=\"text-align: center\"><span>Nro Pedido</span></th><th md-column style=\"text-align: center\"><span>Sistema</span></th><th md-column style=\"text-align: center\"><span>Perfil</span></th><th md-column style=\"text-align: center\"><span>Unidade</span></th><th md-column style=\"text-align: center\"><span>Jurisdição</span></th><th md-column style=\"text-align: center\"><span>Validade</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"acesso in acessoCtrl.acessosSolicitacaoPersistidos\"><td md-cell style=\"text-align: center\">{{acesso.id}}</td><td md-cell style=\"text-align: center\">{{acesso.modulo.sistema.nome}}</td><td md-cell style=\"text-align: center\">{{acesso.perfil.nome}}</td><td md-cell style=\"text-align: center\">{{acesso.unidadeExecutora.nome}}</td><td md-cell style=\"text-align: center\"><span ng-repeat=\"jurisdicao in acesso.unidadeExecutora.jurisdicoes\"><span ng-if=!$last>{{jurisdicao.sigla}} /</span> <span ng-if=$last>{{jurisdicao.sigla}}</span></span></td><td md-cell style=\"text-align: center\" ng-if=acesso.dataExpiracao>{{acesso.dataExpiracao | date : \"dd/MM/yyyy\" }}</td><td md-cell style=\"text-align: center\" ng-if=!acesso.dataExpiracao>Nunca Expira</td></tr></tbody></table></md-table-container></div></md-dialog-content><md-dialog-actions layout=row><md-button style=margin-right:20px ng-click=closeDialog()>OK</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("scripts/acesso/views/consultar-solicitacao-acesso.tmpl.html","<div class=padding-right-pagina ng-init=acessoCtrl.inicializarConsulta();><div class=md-title>Consultar Solicitações de Acesso</div><div layout=column><form name=solicitacaoAcessoForm class=caixa-consulta><div layout=row><md-input-container flex=50 class=padding-right-input><label>CPF do usuário</label><input ng-model=acessoCtrl.query.cpfUsuario ui-br-cpf-mask></md-input-container><md-input-container flex=50><label>Nome do usuário</label><input ng-model=acessoCtrl.query.nomeUsuario></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Situação</label><md-select ng-model=acessoCtrl.query.situacaoSolicitacao md-on-open=\"\"><md-option ng-repeat=\"opcao in acessoCtrl.situacoes\" value={{opcao}}>{{opcao}}</md-option></md-select></md-input-container><md-input-container flex=50 class=\"md-icon-float md-block\"><label>Unidade</label><md-autocomplete ng-model=acessoCtrl.unidadeExecutora md-selected-item=acessoCtrl.unidadeExecutora md-search-text=textoBusca md-items=\"unidade in acessoCtrl.carregarUnidadePorNome(textoBusca)\" md-item-text=unidade.nome md-no-cache=true md-input-minlength=3 md-delay=700 required><md-item-template><span md-highlight-text=textoBusca md-highlight-flags=gi>{{unidade.nome}} - {{unidade.siglaCompleta}}</span></md-item-template><md-not-found>Unidade não encontrada.</md-not-found></md-autocomplete></md-input-container></div><div layout=row><md-input-container flex=50><label>Sistema</label><md-select name=sistema ng-model=acessoCtrl.idSistema md-on-open=acessoCtrl.carregarSistemas()><md-option ng-repeat=\"sistema in acessoCtrl.sistemas\" value={{sistema.id}}>{{sistema.nome}}</md-option></md-select></md-input-container><md-input-container flex=50><label>Módulo</label><md-select name=modulo ng-model=acessoCtrl.modulo md-on-open=acessoCtrl.carregarModulos()><md-option ng-repeat=\"modulo in acessoCtrl.modulos\" ng-value={{modulo}}>{{modulo.nome}}</md-option></md-select></md-input-container></div><div layout=row><div layout=row flex=50 layout-align=\"start center\"><span class=espaco-label-data>Data de Inicio:</span><md-datepicker ng-model=acessoCtrl.query.inicio md-placeholder=Inicio></md-datepicker></div><div layout=row flex=50 layout-align=\"start center\"><span class=espaco-label-data>Data Final:</span><md-datepicker ng-model=acessoCtrl.query.fim md-placeholder=Fim></md-datepicker></div></div></form></div><div layout=row layout-align=end class=margin-top><md-button type=reset class=md-raised ng-click=acessoCtrl.limparConsultar()>Limpar</md-button><md-button type=submit class=md-raised ng-click=acessoCtrl.consultar()>Consultar</md-button></div></div><div><md-table-container><table md-table ng-model=acessoCtrl.selecionado md-progress=promise><thead md-head><tr md-row><th md-column><span>CPF</span></th><th md-column><span>Usuário</span></th><th md-column><span>Unidade</span></th><th md-column><span>Módulo</span></th><th md-column><span>Perfil</span></th><th md-column><span>Data solicitação</span></th><th md-column><span>Situação</span></th><th md-column><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"solicitacaoAcesso in acessoCtrl.solicitacoes |\n                            orderBy: acessoCtrl.query.order | limitTo: acessoCtrl.query.limit :\n                            (acessoCtrl.query.page -1) * acessoCtrl.query.limit\"><td md-cell>{{solicitacaoAcesso.solicitacao.solicitante.cpf}}</td><td md-cell>{{solicitacaoAcesso.solicitacao.solicitante.nome}}</td><td md-cell>{{solicitacaoAcesso.unidadeExecutora.nome}}</td><td md-cell>{{solicitacaoAcesso.modulo.nome}}</td><td md-cell>{{solicitacaoAcesso.perfil.nome}}</td><td md-cell ng-if=solicitacaoAcesso.solicitacao.data>{{solicitacaoAcesso.solicitacao.data | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td md-cell ng-if=!solicitacaoAcesso.solicitacao.data>Nunca Expira</td><td md-cell>{{solicitacaoAcesso.solicitacao.situacao}}</td><td md-cell><ng-md-icon icon=search style=fill:#788489 size=22 alt=Detalhar ui-sref=\"detalharSolicitacaoAcesso({solicitacaoAcessoId : solicitacaoAcesso.id, query: acessoCtrl.query})\"><md-tooltip>Detalhar</md-tooltip></ng-md-icon><ng-md-icon icon=create style=fill:#788489 size=22 alt=Tratar ui-sref=\"tratarSolicitacaoAcesso({solicitacaoAcessoId : solicitacaoAcesso.id})\" ng-show=\"solicitacaoAcesso.solicitacao.situacao == \'PENDENTE\'\"><md-tooltip>Tratar</md-tooltip></ng-md-icon><!--<ng-md-icon icon=\"create\" style=\"fill:#788489\" size=\"22\" alt=\"Tratar\"--><!--ng-show=\"solicitacao.situacao.descricao != \'Autorizado\'\">--><!--<md-tooltip>Tratar</md-tooltip>--><!--</ng-md-icon>--></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"acessoCtrl.solicitacoes.length > 0\" md-limit=acessoCtrl.query.limit md-limit-options=\"[20, 50, 100]\" md-page=acessoCtrl.query.page md-total={{acessoCtrl.solicitacoes.length}} md-on-paginate=acessoCtrl.consultar md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></div>");
$templateCache.put("scripts/acesso/views/detalhar-solicitacao-acesso.tmpl.html","<div class=padding-right-pagina ng-init=acessoCtrl.recuperarSolicitacaoAcesso();><h1 class=md-title-com-borda>Tratar Pedido de Solicitação de Acesso</h1><form name=detalharSolicitacaoAcessoForm><div flex=90 flex-offset=5 style=\"margin-top: 2%\"><div class=texto-secundario>Dados da Solicitação</div><md-divider></md-divider><div flex-offset=5><div><p>Usuário: {{ acessoCtrl.form.solicitacao.solicitante.cpf}} - {{ acessoCtrl.form.solicitacao.solicitante.nome}}</p><p>Data da Solicitação: {{ acessoCtrl.form.solicitacao.data | date : \"dd/MM/yyyy H:mm\"}}</p><p ng-if=acessoCtrl.form.dataExpiracao>Data de Expiração: {{ acessoCtrl.form.dataExpiracao | date : \"dd/MM/yyyy\"}}</p><p ng-if=!acessoCtrl.form.dataExpiracao>Data de Expiração: Nunca Expira</p><p>Situação: {{ acessoCtrl.form.solicitacao.situacao }}</p><p>Justificativa: {{ acessoCtrl.form.solicitacao.justificativa }}</p><p>Nome do Módulo: {{ acessoCtrl.form.modulo.nome }}</p><p>Nome do Perfil: {{ acessoCtrl.form.perfil.nome }}</p><p>Unidade: {{ acessoCtrl.form.unidadeExecutora.nome}}</p></div></div></div><div flex=90 flex-offset=5 style=\"margin-top: 3%\" ng-show=acessoCtrl.form.avaliacao><h1 class=md-title-com-borda>Manifestação do Gestor</h1><section flex=90 flex-offset=5><section><p>Usuário: {{ acessoCtrl.form.avaliacao.avaliador.cpf}} - {{ acessoCtrl.form.avaliacao.avaliador.nome}}</p><p>Data: {{ acessoCtrl.form.avaliacao.data | date : \'dd/MM/yyyy\' }}</p><p>Decisão: {{ acessoCtrl.form.avaliacao.situacao}}</p><p ng-show=\"acessoCtrl.form.avaliacao.situacao == \'NEGADA\'\">Manifestação do Gestor: {{ acessoCtrl.form.avaliacao.observacao}}</p></section></section></div><br><div layout=row layout-align=center><!--<md-button class=\"md-raised\" ui-sref=\"consultarSolicitacaoAcesso\">--><md-button class=md-raised ng-click=acessoCtrl.voltarConsultarSolicit()>Voltar</md-button></div></form></div>");
$templateCache.put("scripts/acesso/views/solicitacao-acesso.tmpl.html","<div class=padding-right-pagina ng-init=\"acessoCtrl.listarPerfisAssociados(); acessoCtrl.recuperarUnidadeSolicitacaoAcesso()\"><div class=md-title-com-borda>Solicitação/Revogação de Acesso</div><form name=formAcesso novalidate><span class=texto-secundario>Dados do Usuário</span><div layout=column layout-align=start layout-margin=10><div><span class=texto-cinza>CPF:</span> {{ acessoCtrl.usuarioSolicitacao.cpf}}</div><div><span class=texto-cinza>Nome:</span> {{acessoCtrl.usuarioSolicitacao.nome}}</div></div><div class=texto-secundario>Perfis associados</div><div ng-show=\"acessoCtrl.acessosAssociados.length > 0\"><div><md-table-container><table md-table><thead md-head><tr md-row><th md-column class=alinhamento-coluna-table><span>Sistema</span></th><th md-column class=alinhamento-coluna-table><span>Módulo</span></th><th md-column class=alinhamento-coluna-table><span>Perfil</span></th><th md-column class=alinhamento-coluna-table><span>Unidade</span></th><th md-column class=alinhamento-coluna-table><span>Jurisdição</span></th><th md-column class=alinhamento-coluna-table><span>Validade</span></th><th md-column class=alinhamento-coluna-table><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"acesso in acessoCtrl.acessosAssociados\"><td md-cell class=alinhamento-coluna-table>{{acesso.modulo.sistema.nome}}</td><td md-cell class=alinhamento-coluna-table>{{acesso.modulo.nome}}</td><td md-cell class=alinhamento-coluna-table>{{acesso.perfil.nome}}</td><td md-cell class=alinhamento-coluna-table>{{acesso.unidadeExecutora.nome}}</td><td md-cell class=alinhamento-coluna-table><span ng-repeat=\"jurisdicao in acesso.unidadeExecutora.jurisdicoes\"><span ng-if=!$last>{{jurisdicao.sigla}} /</span> <span ng-if=$last>{{jurisdicao.sigla}}</span></span></td><td md-cell class=alinhamento-coluna-table>{{acesso.validadeDate ? acesso.validadeDate : acesso.validade | date : \"dd/MM/yyyy\"}}</td><td md-cell class=alinhamento-coluna-table><ng-md-icon icon=delete style=fill:#788489 size=22 alt=Excluir ng-click=acessoCtrl.revogarAcessoAssociado(acesso.id) ng-if=\"acesso.status == \'Ativo\' && acesso.perfil.nome !== \'Usuário Autenticado\'\"><md-tooltip>Excluir</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container></div><br><br><historico-acesso ng-if=acessoCtrl.usuarioSolicitacao.id meus-acessos=true id-usuario=acessoCtrl.usuarioSolicitacao.id atualizar-historico={{acessoCtrl.acessosAssociados}}></historico-acesso></div><h3 class=texto-secundario>Solicitar Novo Perfil</h3><div flex=100><div><!--<div layout=\"row\" layout-align=\"center\">--><!--<fieldset flex=\"70\">--><!--<legend class=\"demo-legend\">Filtros</legend>--><!--<section layout=\"row\" layout-align=\"center\">--><!--<section class=\"md-block\" flex=\"65\">--><!--<label>Órgão UGE - Órgão Superior​ ou Entidade:</label>--><!--<md-autocomplete--><!--ng-model=\"acessoCtrl.form.orgaoSuperior\"--><!--placeholder=\"Informe um órgão/entidade\"--><!--md-selected-item=\"acessoCtrl.form.orgaoSuperior\"--><!--md-search-text=\"acessoCtrl.filtroNomeOrgao\"--><!--md-items=\"item in acessoCtrl.pesquisarOrgao()\"--><!--md-item-text=\"item.codigoUg + \' - \' + item.nome\"--><!--md-no-cache=\"true\">--><!--<span md-highlight-text=\"acessoCtrl.filtroNomeOrgao\">{{item.codigoUg}} - {{item.nome}}</span>--><!--<md-not-found>--><!--Não encontrado.--><!--</md-not-found>--><!--</md-autocomplete>--><!--<div ng-messages=\"acessoCtrl.orgaos.$error\">--><!--<div ng-message=\"required\"><small>Campo obrigatório</small></div>--><!--</div>--><!--</section>--><!--</section>--><!--<div layout=\"row\" layout-align=\"center center\">--><!--<md-input-container class=\"md-block\" flex=\"50\">--><!--<label>Grupo Unidade:</label>--><!--<md-select name=\"grupoUnidade\"--><!--ng-model=\"acessoCtrl.query.grupoUnidade\"--><!--md-on-open=\"acessoCtrl.consultarGrupoUnidadePorOrgao()\"--><!--ng-disabled=\"!acessoCtrl.form.orgaoSuperior || acessoCtrl.query.semGrupoUnidade\">--><!--<md-option ng-repeat=\"grupo in acessoCtrl.gruposUnidades\" ng-value=\"grupo\">--><!--{{grupo.nome}}--><!--</md-option>--><!--</md-select>--><!--</md-input-container>--><!--<div class=\"md-block\" flex=\"15\">--><!--<md-checkbox ng-model=\"acessoCtrl.query.semGrupoUnidade\" aria-label=\"Sem grupo\"  ng-disabled=\"!acessoCtrl.form.orgaoSuperior\" ng-change=\"acessoCtrl.query.idGrupoUnidade=\'\'\">--><!--Sem grupo--><!--</md-checkbox>--><!--</div>--><!--</div>--><!--</fieldset>--><!--</div>--></div><div layout=row><md-input-container flex=50><label>Sistema:</label><md-select name=sistema ng-model=acessoCtrl.form.sistema md-on-open=\"acessoCtrl.consultarSistemas(); acessoCtrl.form.perfil = \'\';\" md-on-close=acessoCtrl.carregarModulos()><md-option ng-repeat=\"sistema in acessoCtrl.sistemas\" ng-value={{sistema.id}}>{{sistema.nome}}</md-option></md-select></md-input-container><md-input-container class=md-block flex=50 ng-show=\"acessoCtrl.form.sistema && acessoCtrl.modulos.length > 1\"><label>Módulo</label><md-select name=modulo ng-model=acessoCtrl.form.modulo md-on-open=\"acessoCtrl.carregarModulos(); acessoCtrl.form.perfil = \'\';acessoCtrl.form.perfisSelecionados = \'\';\" ng-change=acessoCtrl.carregarPermissoes()><md-option ng-repeat=\"modulo in acessoCtrl.modulos\" ng-value={{modulo}}>{{modulo.nome}}</md-option></md-select></md-input-container></div><div layout=row><md-input-container flex=100 flex-xs=100><label>Unidade<ng-md-icon icon=help style=fill:#788489 size=26 alt=Ajuda></ng-md-icon><md-tooltip>Este campo pode ser utilizado para associar uma unidade/UG Executora/departamento/setor/órgão a um usuário ou perfil dentro do sistema acessos</md-tooltip></label><md-autocomplete ng-model=acessoCtrl.form.unidadeExecutora md-selected-item=acessoCtrl.form.unidadeExecutora md-search-text=ugExecutora md-items=\"ug in acessoCtrl.carregarUnidadePorNome(ugExecutora)\" md-item-text=ug.nome md-no-cache=true md-input-minlength=3 md-delay=700 ng-disabled=!acessoCtrl.form.modulo><span md-highlight-text=ugExecutora md-highlight-flags=gi>{{ug.nome}} - {{ug.siglaCompleta}}</span><md-not-found>Unidade não encontrada. É necessário cadastrá-la e ativá-la antes de realizar a solicitação.</md-not-found></md-autocomplete></md-input-container><!--<md-input-container flex=\"50\" flex-xs=\"100\">--><!--<label>UG Executora: </label>--><!--<md-chips ng-model=\"acessoCtrl.unidade\"--><!--md-transform-chip=\"acessoCtrl.transformChip($chip)\"--><!--md-require-match=\"true\"--><!--md-on-add=\"acessoCtrl.buscarUnidadeCompleta()\" flex=\"100\">--><!--<md-autocomplete md-input-name=\"unidadeExecutora\" flex=\"100\"--><!--placeholder=\"Informe o nome ou código\"--><!--md-min-length=\"3\"--><!--md-selected-item=\"acessoCtrl.unidadeSelecionada.id\"--><!--md-search-text=\"acessoCtrl.query.nome\"--><!--md-items=\"item in acessoCtrl.pesquisarUnidadeFiltro()\"--><!--md-item-text=\"item.codigoUg + \' - \' + item.nome\"--><!--md-no-cache=\"true\">--><!--<span md-highlight-text=\"acessoCtrl.query.nome\">{{item.codigoUg}} - {{item.nome}}</span>--><!--<md-not-found ng-show=\"acessoCtrl.query.nome.length \">--><!--&lt;!&ndash;<md-button ng-click=\"acessoCtrl.showFormCadastroUnidade=true\">cadastrar unidade</md-button>&ndash;&gt;--><!--Unidade não encontrada. É necessário cadastrá-la e ativá-la antes de realizar a--><!--solicitação.--><!--</md-not-found>--><!--</md-autocomplete>--><!--<md-chip-template>--><!--<span>--><!--<strong>{{$chip.nome}}</strong>--><!--</span>--><!--</md-chip-template>--><!--</md-chips>--><!--</md-input-container>--><div flex=50 ng-show=\"acessoCtrl.unidadesSelecionadas[0].jurisdicoes.length > 0\" layout=\"center center\">Jurisdição: <span ng-repeat=\"jurisdicao in acessoCtrl.unidadesSelecionadas[0].jurisdicoes\"><span ng-if=!$last>{{jurisdicao.sigla}} /</span> <span ng-if=$last>{{jurisdicao.sigla}}</span></span></div></div><div layout=row><!-- md-input-container class=\"md-block\" flex=\"50\" flex-xs=\"100\">\n                    <label>Perfil:</label>\n                    <md-select name=\"perfil\"\n                               ng-model=\"acessoCtrl.form.perfil\"\n                               md-on-open=\"acessoCtrl.consultarPerfis()\">\n                        <md-option ng-repeat=\"perfil in acessoCtrl.perfis\"\n                                   ng-value=\"{{perfil}}\">\n                            {{perfil.nome}}\n                        </md-option>\n                    </md-select>\n                </md-input-container --><md-input-container class=md-block flex=50 flex-xs=100><label>Perfil:</label><md-select ng-model=acessoCtrl.form.perfisSelecionados data-md-container-class=selectHeader ng-disabled=!acessoCtrl.form.modulo multiple md-on-open=acessoCtrl.consultarPerfisPublicos() required><md-optgroup label=Perfil:><md-option ng-value=perfil ng-repeat=\"perfil in acessoCtrl.perfis | filter: {nome: acessoCtrl.searchTerm} track by perfil.id | orderBy : \'nome\'\">{{perfil.nome}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=md-block flex=50 flex-xs=100><label>Justificativa</label><textarea name=justificativa ng-model=acessoCtrl.form.justificativa md-maxlength=150></textarea><div ng-messages=formAcesso.justificativa.$error><div ng-message=md-maxlength>O campo deve ter no máximo 150 caracteres</div></div></md-input-container></div><div layout=row><div layout=row flex=20 flex-xs=100 layout-align=\"center center\"><md-checkbox ng-model=acessoCtrl.nuncaExpira style=margin:0>O acesso nunca expira</md-checkbox></div><div layout=row layout-align=\"center center\" ng-show=!acessoCtrl.nuncaExpira><span>Data Expiração:</span><md-datepicker name=dataExpiracao ng-model=acessoCtrl.form.dataExpiracao md-placeholder=\"Data expiração\" ng-disabled=acessoCtrl.nuncaExpira ng-required=!acessoCtrl.nuncaExpira></md-datepicker><div ng-messages=formAcesso.dataExpiracao.$error><div ng-message=required><small>Campo obrigatório</small></div></div></div></div><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button class=md-raised ng-click=acessoCtrl.limpar()>Limpar</md-button><md-button class=md-raised ng-click=acessoCtrl.validarSolicitacaoAcesso()>Associar</md-button></div></div><md-table-container ng-show=\"acessoCtrl.acessosSolicitacao.length > 0\"><table md-table><thead md-head><tr md-row><th md-column class=alinhamento-coluna-table><span>Sistema</span></th><th md-column class=alinhamento-coluna-table><span>Perfil</span></th><th md-column class=alinhamento-coluna-table><span>Unidade</span></th><th md-column class=alinhamento-coluna-table><span>Jurisdição</span></th><th md-column class=alinhamento-coluna-table><span>Validade</span></th><th md-column class=alinhamento-coluna-table><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"acesso in acessoCtrl.acessosSolicitacao\"><td md-cell class=alinhamento-coluna-table>{{acesso.modulo.sistema.nome}}</td><td md-cell class=alinhamento-coluna-table>{{acesso.perfil.nome}}</td><td md-cell class=alinhamento-coluna-table>{{acesso.unidadeExecutora.nome}}</td><td md-cell class=alinhamento-coluna-table><span ng-repeat=\"jurisdicao in acesso.unidadeExecutora.jurisdicoes\"><span ng-if=!$last>{{jurisdicao.sigla}} /</span> <span ng-if=$last>{{jurisdicao.sigla}}</span></span></td><td md-cell class=alinhamento-coluna-table ng-if=acesso.validade>{{acesso.validade | date : \"dd/MM/yyyy\" }}</td><td md-cell class=alinhamento-coluna-table ng-if=!acesso.validade>Nunca Expira</td><td md-cell class=alinhamento-coluna-table><ng-md-icon icon=delete style=fill:#788489 size=22 alt=Excluir ng-click=acessoCtrl.revogarAcesso($index)><md-tooltip>Excluir</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container><div layout=row layout-align=center ng-show=\"acessoCtrl.acessosSolicitacao.length > 0\"><md-button id=btnEnviarSolicitacao type=submit class=md-raised ng-disabled=formPerfil.$invalid ng-click=acessoCtrl.gravar()>Enviar Solicitação(ões)</md-button></div></form></div>");
$templateCache.put("scripts/acesso/views/tratar-solicitacao-acesso.tmpl.html","<div class=padding-right-pagina ng-init=\"acessoCtrl.recuperarSolicitacaoAcesso(); acessoCtrl.recuperaGestorAvaliador();\"><h1 class=md-title-com-borda>Tratar Pedido de Solicitação de Acesso</h1><form name=tratarSolicitacaoAcessoForm><div flex=90 flex-offset=5 style=\"margin-top: 2%\"><div class=texto-secundario>Dados da Solicitação</div><md-divider></md-divider><div flex-offset=5><div><p>Usuário: {{ acessoCtrl.form.solicitacao.solicitante.cpf}} - {{ acessoCtrl.form.solicitacao.solicitante.nome}}</p><p>Data da Solicitação: {{ acessoCtrl.form.solicitacao.data | date : \"dd/MM/yyyy\"}}</p><p ng-if=acessoCtrl.form.dataExpiracao>Data de Expiração: {{ acessoCtrl.form.dataExpiracao | date : \"dd/MM/yyyy\"}}</p><p ng-if=!acessoCtrl.form.dataExpiracao>Data de Expiração: Nunca Expira</p><p>Situação: {{ acessoCtrl.form.solicitacao.situacao }}</p><p>Justificativa: {{ acessoCtrl.form.solicitacao.justificativa }}</p><p>Nome do Módulo: {{ acessoCtrl.form.modulo.nome }}</p><p>Nome do Perfil: {{ acessoCtrl.form.perfil.nome }}</p><p>Unidade: {{ acessoCtrl.form.unidadeExecutora.nome}}</p></div></div></div><div flex=90 flex-offset=5 style=\"margin-top: 3%\"><div class=texto-secundario>Manifestação do Gestor</div><md-divider></md-divider><div><p>Usuário: {{ acessoCtrl.formAvaliacaoSolicitacao.avaliador.cpf}} - {{ acessoCtrl.formAvaliacaoSolicitacao.avaliador.nome}}</p><p>Data: {{ acessoCtrl.formAvaliacaoSolicitacao.data | date : \'dd/MM/yyyy\' }}</p><div layout=row layout-align=left><md-input-container class=md-block flex=45><label>Decisao</label><md-select ng-model=acessoCtrl.formAvaliacaoSolicitacao.aprovada><md-option ng-repeat=\"opcao in acessoCtrl.opcoesDecisao\" ng-value=\"{{ opcao.value }}\">{{opcao.key}}</md-option></md-select></md-input-container></div><div layout=row layout-align=left ng-show=\"acessoCtrl.formAvaliacaoSolicitacao.aprovada == false\"><md-input-container class=md-block flex=45><label>Manifestação do Gestor</label><textarea name=observacao ng-model=acessoCtrl.formAvaliacaoSolicitacao.observacao ng-required=\"acessoCtrl.formAvaliacaoSolicitacao.aprovada == false\" md-maxlength=150></textarea><div ng-messages=solicitarAtivacaoOrgaoForm.observacao.$error><div ng-message=md-maxlength>O campo deve ter no máximo 150 caracteres</div></div></md-input-container></div></div></div><br><div layout=row layout-align=center><md-button class=md-raised ui-sref=consultarSolicitacaoAcesso>Voltar</md-button><md-button type=submit class=\"md-primary md-raised\" ng-click=acessoCtrl.tratarSolicitacaoAcesso()>Responder</md-button></div></form></div>");
$templateCache.put("scripts/app/views/main.view.tmpl.html","<div flex layout=column ng-controller=\"MenuController as ul\"><!-- Barra de navageção --><md-toolbar layout=row class=md-whiteframe-z3 style=\"padding-top: 13px; padding-left: 10px; background-color: #3e67b1\"><!-- hide-gt-sm --><md-button class=menu ng-click=ul.toggleMenu() aria-label=\"Menu da Aplicação\"><ng-md-icon icon=menu style=fill:#fff size=38></ng-md-icon></md-button><div hide-xs layout=column><!--<img src=\"assets/img/logo-spu.png\" style=\"margin-top: 13px;\" />--><div style=\"color: white; font-size: 28px\">AcessosMP</div><div style=\"color: white; font-size: 15px\">SPU - Secretaria de Patrimônio da União.</div></div><span flex></span><div layout=row style=\"margin-right: 50px\"><md-button class=\"md-icon-button launch\" ui-sref=home><ng-md-icon icon=home style=fill:#fff alt=Home size=30><md-tooltip md-direction=bottom>Home</md-tooltip></ng-md-icon></md-button><md-button class=\"md-icon-button launch\" ui-sref=\"alterarCadastro({usuarioId : usuarioLogado.id})\" ng-if=\"usuarioLogado.id != null\"><ng-md-icon icon=account_circle style=fill:#fff alt=\"Conta do usuário\" size=30><md-tooltip md-direction=bottom>{{usuarioLogado.nome}}</md-tooltip></ng-md-icon></md-button><md-button class=\"md-icon-button launch\" ui-sref=solicitarAcesso ng-if=\"usuarioLogado.id != null\"><ng-md-icon icon=vpn_key style=fill:#fff alt=\"Meus Acesso\" size=30><md-tooltip md-direction=bottom>Meus Acessos</md-tooltip></ng-md-icon></md-button><md-button class=\"md-icon-button launch\" href=/api/saml/logout ng-if=\"usuarioLogado.id != null\"><ng-md-icon icon=do_not_disturb style=fill:#fff alt=Logout size=30><md-tooltip md-direction=bottom>Logout</md-tooltip></ng-md-icon></md-button><md-button class=botao-govbr href=/api ng-if=\"usuarioLogado.id == null\"><span class=texto-govbr>Entrar com&nbsp</span> <img class=img-govbr src=../../../assets/img/govbr-logo-large.png alt=gov.br></md-button></div></md-toolbar><md-toolbar layout=row class=md-whiteframe-z3 ng-style=\"{\'background-color\': getToolbarColor()}\" style=\"min-height: 25px !important\"><!--<div style=\"float: left;\">\n          <p style=\"color: #fff; font-size: 10px; margin-left: 40px; margin-top: 6px;\">Você está aqui: Home > Caminho > Caminho</p>\n      </div>\n      <div style=\"right: 16px; position: absolute;\">\n          <p style=\"color: #fff; font-size: 10px; margin-right: 40px; margin-top: 6px;\">Sua sessão expira em 00:40:00</p>\n      </div>--></md-toolbar><!-- Container Menu e Conteúdo --><div flex layout=row><!-- Menu --><menu></menu><!-- Conteúdo Principal --><md-content id=conteudo flex layout=column><!-- TODO: usar o GlobalController no view state --><div ng-controller=\"GlobalController as vm\"><div ui-view layout-padding flex=noshrink></div></div></md-content></div><footer class=footer>SPU - Secretaria de Patrimônio da União | Esplanada dos Ministérios - Bloco C e K - Brasília-DF - Versão: _</footer></div>");
$templateCache.put("scripts/directives/captcha/captcha.html","<div id=captcha-container></div>");
$templateCache.put("scripts/directives/concessao_acesso_em_lote/concessaoAcessoEmLote.html","<form name=formAcessoEmLote><div class=md-padding ng-cloak><div><div layout=column flex=100><md-input-container flex=100 flex-xs=100><label>Unidade<ng-md-icon icon=help style=fill:#788489 size=26 alt=Ajuda></ng-md-icon><md-tooltip>Este campo pode ser utilizado para associar uma unidade/UG Executora/departamento/setor/órgão a um usuário ou perfil dentro do sistema acessos</md-tooltip></label><md-autocomplete ng-model=acessoLoteDto.unidadeExecutora md-selected-item=acessoLoteDto.unidadeExecutora md-search-text=ugExecutora md-items=\"ug in carregarUnidadePorNome(ugExecutora)\" md-item-text=ug.nome md-no-cache=true md-input-minlength=3 md-delay=700><span md-highlight-text=ugExecutora md-highlight-flags=gi>{{ug.nome}} - {{ug.siglaCompleta}}</span><md-not-found>Unidade não encontrada.</md-not-found></md-autocomplete></md-input-container><md-input-container flex=50><label>Usuário:</label><md-chips ng-model=acessoLoteDto.usuariosSelecionados md-require-match=true required><md-autocomplete placeholder=\"Pesquisar usuário\" md-search-text=filtroUsuario md-items=\"usuario in pesquisarUsuario(filtroUsuario)\" md-item-text=usuario.nome md-selected-item=usuario md-no-cache=true md-input-minlength=3 md-delay=700 md-min-length=3><span md-highlight-text=filtroUsuario>{{usuario.nome}}</span></md-autocomplete><md-chip-template><span><strong>{{$chip.nome}}</strong></span></md-chip-template></md-chips></md-input-container><md-input-container class=md-block flex=50 flex-xs=100><label>Justificativa</label><textarea name=justificativa ng-model=acessoLoteDto.justificativa md-maxlength=150></textarea></md-input-container></div><div layout=row><div layout=row flex=20 flex-xs=100><md-checkbox ng-model=nuncaExpira style=margin:0>O acesso nunca expira</md-checkbox></div><div layout=row layout-align=\"center center\" ng-if=!nuncaExpira><span>Data de Expiração:</span><md-datepicker name=dataExpiracao ng-model=dataExpiracao md-placeholder=\"Data de Validade\" ng-disabled=nuncaExpira ng-change=setDataValidade(this) ng-required=!nuncaExpira></md-datepicker></div></div><br></div><div layout=row><md-button id=concederAcesso_Button type=submit class=md-raised ng-click=associarAcessos()>Associar</md-button><md-button id=voltar_Button class=md-raised ng-click=voltarConsultarPerfil()>Voltar</md-button></div><br><br><div ng-if=\"acessosAssociados.length > 0\"><h1 class=md-subhead style=\"color: gray; font-weight: bold\">Usuários associados</h1><md-divider></md-divider></div><div layout=row ng-if=\"acessosAssociados.length > 0\"><section style=\"width: 100%\"><md-card><md-table-container><table md-table><thead md-head><tr md-row><th md-column style=\"text-align: center\"><span>Usuário</span></th><th md-column style=\"text-align: center\"><span>Unidade</span></th><th md-column style=\"text-align: center\"><span>Validade</span></th><th md-column style=\"text-align: center\"><span>Ação</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"acesso in acessosAssociados |\n                            orderBy: query.order | limitTo: query.limit :\n                            (query.page -1) * query.limit\"><td md-cell style=\"text-align: center\">{{acesso.usuario.nome}}</td><td md-cell style=\"text-align: center\">{{acesso.unidadeExecutora.nome}}</td><td md-cell style=\"text-align: center\">{{acesso.validadeDate ? acesso.validadeDate : \"Nunca expira\" | date : \"dd/MM/yyyy\"}}</td><td md-cell style=\"text-align: center\"><ng-md-icon icon=delete style=fill:#788489 size=22 ng-click=revogarAcessoAssociado(acesso.id) alt=Excluir><md-tooltip>Excluir</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=query.limit md-limit-options=\"[20, 50, 100]\" md-page=query.page md-total={{acessosAssociados.length}} md-on-paginate=consultar md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></md-card></section></div></div></form>");
$templateCache.put("scripts/directives/dados_perfil/dadosPerfil.html","<div class=md-padding ng-cloak><div class=dados-perfil><p><span>Nome do Perfil: </span>{{perfil.nome}}</p><p><span>Descrição: </span>{{perfil.descricao}}</p><p><span>Sistema: </span>{{perfil.modulo.sistema.nome}}</p><p><span>Módulo: </span>{{perfil.modulo.nome}}</p></div></div>");
$templateCache.put("scripts/directives/historico_acesso/historicoAcesso.html","<v-accordion class=vAccordion--default ng-if=\"acessosVencidosInativos.length > 0 || acessosPendentes.length > 0\"><v-pane ng-if=\"acessosPendentes.length > 0\" expanded><v-pane-header class=historico-pane-header>Acessos Pendentes</v-pane-header><v-pane-content><md-card><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span>Sistema</span></th><th md-column><span>Módulo</span></th><th md-column><span>Perfil</span></th><th md-column><span>Unidade</span></th><th md-column><span>Data solicitação</span></th><th md-column><span>Situação</span></th><th md-column><span>Aprovadores</span></th><th md-column><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id-pendentes md-auto-select ng-repeat=\"solicitacaoAcesso in acessosPendentes\"><td md-cell>{{solicitacaoAcesso.modulo.sistema.nome}}</td><td md-cell>{{solicitacaoAcesso.modulo.nome}}</td><td md-cell>{{solicitacaoAcesso.perfil.nome}}</td><td md-cell>{{solicitacaoAcesso.unidadeExecutora.nome}}</td><td md-cell ng-if=solicitacaoAcesso.solicitacao.data>{{solicitacaoAcesso.solicitacao.data | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td md-cell ng-if=!solicitacaoAcesso.solicitacao.data>Nunca Expira</td><td md-cell>{{solicitacaoAcesso.solicitacao.situacao}}</td><td md-cell><md-button ng-click=\"solicitacaoAcesso.mostrarAprovadores = !solicitacaoAcesso.mostrarAprovadores\" ng-show=\"solicitacaoAcesso.aprovadores.length > 1\"><ng-md-icon icon=keyboard_arrow_down style=fill:#788489 size=22><md-tooltip>Ver lista de pessoas aptas a aprovar seu pedido</md-tooltip></ng-md-icon>Ver lista</md-button><table md-table><tbody md-body><tr md-row ng-repeat=\"aprovadores in solicitacaoAcesso.aprovadores\" ng-show=\"solicitacaoAcesso.mostrarAprovadores || solicitacaoAcesso.aprovadores.length < 2\"><td md-cell>{{aprovadores.email}}</td><td md-cell>{{aprovadores.telefoneTrabalho}}</td><br></tr></tbody></table></td><td md-cell><ng-md-icon ng-if=\"solicitacaoAcesso.solicitacao.situacao == \'PENDENTE\'\" icon=email style=fill:#788489 size=22 alt=\"Reenviar Solicitação\" ng-click=reenviarSolicitacao(solicitacaoAcesso.id)><md-tooltip>Reenviar Solicitação</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container></md-card></v-pane-content></v-pane><v-pane ng-if=\"acessosRecusados.length > 0\"><v-pane-header class=historico-pane-header>Acessos Recusados</v-pane-header><v-pane-content><md-card><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span>Sistema</span></th><th md-column><span>Módulo</span></th><th md-column><span>Perfil</span></th><th md-column><span>Unidade</span></th><th md-column><span>Data solicitação</span></th><th md-column><span>Situação</span></th><th md-column><span>Observação</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id-pendentes md-auto-select ng-repeat=\"solicitacaoAcesso in acessosRecusados\"><td md-cell>{{solicitacaoAcesso.modulo.sistema.nome}}</td><td md-cell>{{solicitacaoAcesso.modulo.nome}}</td><td md-cell>{{solicitacaoAcesso.perfil.nome}}</td><td md-cell>{{solicitacaoAcesso.unidadeExecutora.nome}}</td><td md-cell ng-if=solicitacaoAcesso.solicitacao.data>{{solicitacaoAcesso.solicitacao.data | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td md-cell ng-if=!solicitacaoAcesso.solicitacao.data>Nunca Expira</td><td md-cell>{{solicitacaoAcesso.solicitacao.situacao}}</td><td md-cell><span ng-if=\"solicitacaoAcesso.solicitacao.situacao == \'NEGADA\'\">{{solicitacaoAcesso.solicitacao.avaliacoes[0].observacao}} ({{solicitacaoAcesso.solicitacao.avaliacoes[0].avaliador.nome}})</span></td></tr></tbody></table></md-table-container></md-card></v-pane-content></v-pane><v-pane><v-pane-header class=historico-pane-header>Histórico de Acessos</v-pane-header><v-pane-content><md-card><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span>Sistema</span></th><th md-column><span>Módulo</span></th><th md-column><span>Perfil</span></th><th md-column><span>Unidade</span></th><th md-column><span>Jurisdição</span></th><th md-column><span>Status</span></th><th md-column><span>Período</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"acesso in acessosVencidosInativos\"><td md-cell>{{acesso.modulo.sistema.nome}}</td><td md-cell>{{acesso.modulo.nome}}</td><td md-cell>{{acesso.perfil.nome}}</td><td md-cell>{{acesso.unidadeExecutora.nome}}</td><td md-cell><span ng-repeat=\"jurisdicao in acesso.unidadeExecutora.jurisdicoes\"><span ng-if=!$last>{{jurisdicao.sigla}} /</span> <span ng-if=$last>{{jurisdicao.sigla}}</span></span></td><td md-cell>{{acesso.status}}</td><td md-cell ng-if=acesso.validadeDate>{{acesso.dataConcessao | date : \"dd/MM/yyyy HH:mm\"}} à {{acesso.validadeDate | date : \"dd/MM/yyyy HH:mm\"}}</td><td md-cell ng-if=\"acesso.validadeDate == undefined\">-</td></tr></tbody></table></md-table-container></md-card></v-pane-content></v-pane></v-accordion>");
$templateCache.put("scripts/directives/historico_unidade_padrao/historicoUnidadePadrao.html","<v-accordion class=vAccordion--default ng-if=\"historicoUsuario.length > 0\"><v-pane><v-pane-header class=historico-pane-header>Histórico de Unidades Padrão</v-pane-header><v-pane-content><md-card><md-table-container><table md-table><thead md-head><tr md-row><th md-column style=\"text-align: center\"><span>Unidade Anterior</span></th><th md-column style=\"text-align: center\"><span>Unidade Concedida</span></th><th md-column style=\"text-align: center\"><span>Data de Concessão</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"historico in historicoUsuario | orderBy: \'dataConcessao\':true\"><td md-cell style=\"text-align: center\">{{historico.unidadeExecutoraAnterior.nome}}</td><td md-cell style=\"text-align: center\">{{historico.unidadeExecutoraConcedida.nome}}</td><td md-cell style=\"text-align: center\">{{historico.dataConcessao | date: \'dd/MM/yyyy\'}}</td></tr></tbody></table></md-table-container></md-card></v-pane-content></v-pane></v-accordion>");
$templateCache.put("scripts/directives/solicitar_acesso/solicitarAcesso.html","<form novalidate isolate-form name=formSolicitarAcesso><fieldset class=fieldset><h4 class=md-title>Selecione abaixo os acessos desejados</h4><md-divider></md-divider><div layout=row layout-align=center><md-input-container class=md-block flex=100><label>Sistema:</label><md-select name=sistema ng-model=formSistema.sistema md-on-open=\"consultarSistemas(); formSistema.perfil = \'\';\" md-on-close=carregarModulos(); required><md-option ng-repeat=\"sistema in sistemas\" ng-value={{sistema.id}}>{{sistema.nome}}</md-option></md-select></md-input-container><md-input-container class=md-block flex=50 ng-show=\"formSistema.sistema && modulos.length > 1\"><label>Módulo</label><md-select name=modulo ng-model=formSistema.modulo md-on-open=\"carregarModulos(); formSistema.perfil = \'\';\"><md-option ng-repeat=\"modulo in modulos\" ng-value={{modulo}}>{{modulo.nome}}</md-option></md-select></md-input-container></div><div layout=row layout-align=center><md-input-container flex=100 flex-xs=100><label>Unidade<ng-md-icon icon=help style=fill:#788489 size=26 alt=Ajuda></ng-md-icon><md-tooltip>Este campo pode ser utilizado para associar uma unidade/UG Executora/departamento/setor/órgão a um usuário ou perfil dentro do sistema acessos</md-tooltip></label><md-autocomplete ng-model=formSistema.unidadeExecutora md-selected-item=formSistema.unidadeExecutora md-search-text=ugExecutora md-items=\"ug in carregarUnidadePorNome(ugExecutora)\" md-item-text=ug.nome md-no-cache=true md-input-minlength=3 md-delay=700 ng-disabled=!formSistema.modulo required><span md-highlight-text=ugExecutora md-highlight-flags=gi>{{ug.nome}} - {{ug.siglaCompleta}}</span><md-not-found>Unidade não encontrada. É necessário cadastrá-la e ativá-la antes de realizar a solicitação.</md-not-found></md-autocomplete></md-input-container><div flex=50 ng-show=\"usuarioCtrl.unidadesSelecionadas[0].jurisdicoes.length > 0\" layout=\"center center\">Jurisdição: <span ng-repeat=\"jurisdicao in usuarioCtrl.unidadesSelecionadas[0].jurisdicoes\"><span ng-if=!$last>{{jurisdicao.sigla}} /</span> <span ng-if=$last>{{jurisdicao.sigla}}</span></span></div></div><div layout=row><md-input-container class=md-block flex=50 flex-xs=100><label>Perfil:</label><md-select ng-model=formSistema.perfisSelecionados md-on-close=usuarioCtrl.clearSearchTerm() data-md-container-class=selectHeader multiple md-on-open=consultarPerfis() required><md-select-header class=select-header><input ng-model=usuarioCtrl.searchTerm type=search placeholder=\"Pesquisar perfis...\" class=\"header-searchbox md-text\"></md-select-header><md-optgroup label=Perfil:><md-option ng-value=perfil ng-repeat=\"perfil in perfis | filter: {nome: acessoCtrl.searchTerm} track by perfil.nome | orderBy : \'nome\'\">{{perfil.nome}}</md-option></md-optgroup></md-select></md-input-container><md-input-container class=md-block flex=50 flex-xs=100><label>Justificativa</label><textarea name=justificativa ng-model=formSistema.justificativa md-maxlength=150 required>\n        </textarea><div ng-messages=form.justificativa.$error><div ng-message=md-maxlength>O campo deve ter no máximo 150 caracteres</div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><md-checkbox ng-model=formSistema.nuncaExpira style=margin:0>O acesso nunca expira</md-checkbox></md-input-container><md-input-container class=md-block flex=50 ng-show=!formSistema.nuncaExpira><span>Data Expiração:</span><md-datepicker name=dataExpiracao ng-model=formSistema.dataExpiracao md-placeholder=\"Data expiração\" ng-disabled=formSistema.nuncaExpira ng-required=!formSistema.nuncaExpira></md-datepicker></md-input-container></div><br><div layout=row layout-align=end><md-button class=md-raised ng-click=limparForm()>Limpar</md-button><md-button id=concederAcesso_Button type=submit class=md-raised ng-click=validarConcederAcessoUsuario()>Associar</md-button></div><div class=table-margin-top ng-show=\"model.length > 0\"><md-table-container><table md-table><thead md-head><tr md-row><th md-column class=alinhamento-coluna-table><span>Sistema</span></th><th md-column class=alinhamento-coluna-table><span>Módulo</span></th><th md-column class=alinhamento-coluna-table><span>Perfil</span></th><th md-column class=alinhamento-coluna-table><span>Unidade</span></th><th md-column class=alinhamento-coluna-table><span>Justificativa</span></th><th md-column class=alinhamento-coluna-table><span>Validade</span></th><th md-column class=alinhamento-coluna-table><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"acesso in model track by $index\"><td md-cell class=alinhamento-coluna-table>{{acesso.modulo.sistema.nome}}</td><td md-cell class=alinhamento-coluna-table>{{acesso.modulo.nome}}</td><td md-cell class=alinhamento-coluna-table>{{acesso.perfil.nome}}</td><td md-cell class=alinhamento-coluna-table>{{acesso.organizacao.nome}}</td><td md-cell class=alinhamento-coluna-table>{{acesso.observacao}}</td><td md-cell class=alinhamento-coluna-table>{{acesso.validadeDate ? acesso.validadeDate : acesso.validade | date : \"dd/MM/yyyy\"}}</td><td md-cell class=alinhamento-coluna-table><ng-md-icon icon=delete style=fill:#788489 size=22 alt=Excluir ng-click=removerAcesso($index)><md-tooltip>Excluir</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container><br><br><historico-acesso ng-if=usuarioCtrl.usuarioSolicitacao.id meus-acessos=true id-usuario=acessoCtrl.usuarioSolicitacao.id atualizar-historico={{usuarioCtrl.acessosAssociados}}></historico-acesso></div></fieldset><br><br><br></form>");
$templateCache.put("scripts/grupo_unidade/views/cadastrar-associar-unidade.tmpl.html","<!--<div layout-xs=\"column\">--><!--<md-content flex>--><!--<h1 class=\"md-title\">Associar Unidades Executoras</h1>--><!--<md-divider></md-divider>--><!--<form name=\"unidadeForm\" novalidate>--><!--<div layout=\"row\" layout-align=\"center\">--><!--<md-input-container class=\"md-block\" flex=\"45\">--><!--<label>Órgão UGE - Órgão Superior​ ou Entidade</label>--><!--<md-select name=\"orgao\" ng-model=\"grupoUnidadeCtrl.query.idOrgao\" md-on-open=\"grupoUnidadeCtrl.carregarOrgaos(); grupoUnidadeCtrl.form.grupoUnidade=\'\'\" required>--><!--<md-option ng-repeat=\"orgao in grupoUnidadeCtrl.orgaos\" value=\"{{orgao.id}}\">--><!--{{orgao.nome}}--><!--</md-option>--><!--</md-select>--><!--<div ng-messages=\"unidadeForm.orgao.$error\">--><!--<div ng-message=\"required\"><small>Campo obrigatório</small></div>--><!--</div>--><!--</md-input-container>--><!--</div>--><!--<div layout=\"row\" layout-align=\"center\" ng-show=\"grupoUnidadeCtrl.query.idOrgao\">--><!--<md-input-container class=\"md-block\" flex=\"45\">--><!--<label>Grupo Unidade:</label>--><!--<md-select name=\"grupoUnidade\" ng-model=\"grupoUnidadeCtrl.form.grupoUnidade\" md-on-open=\"grupoUnidadeCtrl.consultarGrupoUnidadePorOrgao()\" required>--><!--<md-option ng-repeat=\"grupo in grupoUnidadeCtrl.gruposUnidades\" value=\"{{grupo}}\">--><!--{{grupo.nome}}--><!--</md-option>--><!--</md-select>--><!--<div ng-messages=\"unidadeForm.grupoUnidade.$error\">--><!--<div ng-message=\"required\"><small>Campo obrigatório</small></div>--><!--</div>--><!--</md-input-container>--><!--</div>--><!--<div layout=\"row\" layout-align=\"center\" ng-show=\"grupoUnidadeCtrl.form.grupoUnidade\">--><!--<md-input-container class=\"md-block\" flex=\"45\" >--><!--<label>UG Executora </label>--><!--<md-chips ng-model=\"grupoUnidadeCtrl.unidadesSelecionadas\"--><!--md-transform-chip=\"grupoUnidadeCtrl.transformChip($chip)\"--><!--md-require-match=\"true\" required>--><!--<md-autocomplete--><!--placeholder=\"Informe uma Unidade\"--><!--md-selected-item=\"grupoUnidadeCtrl.unidadeSelecionada.id\"--><!--md-search-text=\"grupoUnidadeCtrl.filtroNomeUnidade\"--><!--md-items=\"item in grupoUnidadeCtrl.pesquisarUnidadeFiltro(grupoUnidadeCtrl.filtroNomeUnidade)\"--><!--md-item-text=\"item.nome\"--><!--md-no-cache=\"true\">--><!--<span md-highlight-text=\"grupoUnidadeCtrl.filtroNomeUnidade\">{{item.nome}}</span>--><!--<md-not-found>--><!--<md-button ng-click=\"grupoUnidadeCtrl.showFormCadastroUnidade=true\">cadastrar UG Executora</md-button>--><!--</md-not-found>--><!--</md-autocomplete>--><!--<md-chip-template>--><!--<span>--><!--<strong>{{$chip.nome}}</strong>--><!--</span>--><!--</md-chip-template>--><!--</md-chips>--><!--</md-input-container>--><!--</div>--><!--<div ng-show=\"grupoUnidadeCtrl.showFormCadastroUnidade\" layout=\"row\" layout-align=\"center\">--><!--<md-content flex=\"45\" style=\"border: solid #34aa53 1px;\" class=\"md-primary.md-hue-2\">--><!--<section layout=\"row\">--><!--<md-input-container class=\"md-block\">--><!--<label>Nome: </label>--><!--<input name=\"nome\" ng-model=\"grupoUnidadeCtrl.formUnidade.nome\" required=\"grupoUnidadeCtrl.showFormCadastroUnidade\">--><!--<div ng-messages=\"unidadeForm.nome.$error\">--><!--<div ng-message=\"required\"><small>Campo obrigatório</small></div>--><!--</div>--><!--</md-input-container>--><!--</section>--><!--<section layout=\"row\" layout-align=\"center\">--><!--<md-button class=\"md-primary md-raised\" ng-click=\"grupoUnidadeCtrl.salvarUnidade()\">--><!--Salvar usuário--><!--</md-button>--><!--<md-button class=\"md-raised\" ng-click=\"grupoUnidadeCtrl.fecharFormUnidade()\">--><!--Cancelar--><!--</md-button>--><!--</section>--><!--</md-content>--><!--</div>--><!--<md-divider></md-divider>--><!--<h1 class=\"md-title\">Administradores das Unidades Executoras</h1>--><!--<div layout=\"row\" layout-align=\"center\">--><!--<md-input-container class=\"md-block\" flex=\"45\">--><!--<label>Sistema:</label>--><!--<md-select name=\"sistema\" ng-model=\"grupoUnidadeCtrl.form.sistema\" md-on-open=\"grupoUnidadeCtrl.consultarSistemas()\" required>--><!--<md-option ng-repeat=\"sistema in grupoUnidadeCtrl.sistemas\" value=\"{{sistema}}\">--><!--{{sistema.nome}}--><!--</md-option>--><!--</md-select>--><!--<div ng-messages=\"unidadeForm.sistema.$error\">--><!--<div ng-message=\"required\"><small>Campo obrigatório</small></div>--><!--</div>--><!--</md-input-container>--><!--</div>--><!--<div layout=\"row\" layout-align=\"center\">--><!--<md-input-container class=\"md-block\" flex=\"45\" >--><!--<label>Nome ou CPF: </label>--><!--<md-chips ng-model=\"grupoUnidadeCtrl.administradoresSelecionados\"--><!--md-transform-chip=\"grupoUnidadeCtrl.transformChip($chip)\"--><!--md-require-match=\"true\" required>--><!--<md-autocomplete--><!--placeholder=\"Informe o nome ou CPF\"--><!--md-selected-item=\"grupoUnidadeCtrl.administradorSelecionado.id\"--><!--md-search-text=\"grupoUnidadeCtrl.filtroAdministrador\"--><!--md-items=\"item in grupoUnidadeCtrl.pesquisarAdministrador()\"--><!--md-item-text=\"item.nome\"--><!--md-no-cache=\"true\">--><!--<span md-highlight-text=\"grupoUnidadeCtrl.filtroAdministrador\">{{item.nome}}</span>--><!--<md-not-found>--><!--<md-button ng-click=\"grupoUnidadeCtrl.showFormCadastroUsuario=true\">cadastrar usuário</md-button>--><!--</md-not-found>--><!--</md-autocomplete>--><!--<md-chip-template>--><!--<span>--><!--<strong>{{$chip.nome}}</strong>--><!--</span>--><!--</md-chip-template>--><!--</md-chips>--><!--</md-input-container>--><!--</div>--><!--<div ng-show=\"grupoUnidadeCtrl.showFormCadastroUsuario\" layout=\"row\" layout-align=\"center\">--><!--<md-content flex=\"45\" style=\"border: solid #34aa53 1px;\" class=\"md-primary.md-hue-2\">--><!--<section layout=\"row\">--><!--<md-input-container class=\"md-block\">--><!--<label>Nome: </label>--><!--<input name=\"nome\" ng-model=\"grupoUnidadeCtrl.formUsuario.nome\" required=\"grupoUnidadeCtrl.showFormCadastroUsuario\">--><!--<div ng-messages=\"unidadeForm.nome.$error\">--><!--<div ng-message=\"required\"><small>Campo obrigatório</small></div>--><!--</div>--><!--</md-input-container>--><!--<md-input-container class=\"md-block\">--><!--<label>CPF: </label>--><!--<input name=\"cpf\" ng-model=\"grupoUnidadeCtrl.formUsuario.cpf\"  ui-br-cpf-mask required=\"grupoUnidadeCtrl.showFormCadastroUsuario\">--><!--<div ng-messages=\"unidadeForm.cpf.$error\">--><!--<div ng-message=\"required\"><small>Campo obrigatório</small></div>--><!--<div ng-message=\"cpf\"><small>CPF inválido</small></div>--><!--</div>--><!--</md-input-container>--><!--<md-input-container class=\"md-block\">--><!--<label>E-mail: </label>--><!--<input type=\"email\" name=\"email\" ng-model=\"grupoUnidadeCtrl.formUsuario.email\" required=\"grupoUnidadeCtrl.showFormCadastroUsuario\">--><!--<div ng-messages=\"unidadeForm.email.$error\">--><!--<div ng-message=\"required\"><small>Campo obrigatório</small></div>--><!--<div ng-message=\"email\"><small>Email inválido</small></div>--><!--</div>--><!--</md-input-container>--><!--</section>--><!--<section layout=\"row\" layout-align=\"center\">--><!--<md-button class=\"md-primary md-raised\" ng-click=\"grupoUnidadeCtrl.salvarUsuario()\">--><!--Salvar usuário--><!--</md-button>--><!--<md-button class=\"md-raised\" ng-click=\"grupoUnidadeCtrl.fecharFormUsuario()\">--><!--Cancelar--><!--</md-button>--><!--</section>--><!--</md-content>--><!--</div>--><!--<div layout=\"row\" layout-align=\"center\">--><!--<md-button type=\"submit\" class=\"md-primary md-raised\" ng-click=\"grupoUnidadeCtrl.associarUnidades()\">Associar</md-button>--><!--</div>--><!--<md-table-container>--><!--<table md-table ng-model=\"grupoUnidadeCtrl.selecionado\" md-progress=\"promise\">--><!--<thead md-head md-order=\"grupoUnidadeCtrl.query.order\" ng-if=\"grupoUnidadeCtrl.associacoes.length > 0\">--><!--<tr md-row>--><!--<th md-column md-order-by=\"sistema\"><span>Sistema</span></th>--><!--<th md-column md-order-by=\"usuario\"><span>Usuário</span></th>--><!--<th md-column md-order-by=\"unidade\"><span>UG Executora</span></th>--><!--<th md-column ><span>Ações</span></th>--><!--</tr>--><!--</thead>--><!--<tbody md-body>--><!--<tr md-row md-select-id=\"id\" md-auto-select ng-repeat=\"associacao in grupoUnidadeCtrl.associacoes | orderBy: grupoUnidadeCtrl.query.order | limitTo: grupoUnidadeCtrl.query.limit : (grupoUnidadeCtrl.query.page -1) * grupoUnidadeCtrl.query.limit\">--><!--<td md-cell>{{associacao.sistema.nome}}</td>--><!--<td md-cell>{{associacao.usuario.cpf + \' - \' + associacao.usuario.nome}}</td>--><!--<td md-cell> {{associacao.unidade.nome}} </td>--><!--<td md-cell>--><!--<ng-md-icon icon=\"delete\" style=\"fill:#788489\" size=\"22\" alt=\"Desassociar\" ng-click=\"grupoUnidadeCtrl.desassociar()\">--><!--<md-tooltip>Desassociar</md-tooltip>--><!--</ng-md-icon>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</md-table-container>--><!--<md-table-pagination ng-if=\"grupoUnidadeCtrl.associacoes.length > 0\"--><!--md-limit=\"grupoUnidadeCtrl.query.limit\"--><!--md-limit-options=\"[5, 10, 15]\"--><!--md-page=\"grupoUnidadeCtrl.query.page\"--><!--md-total=\"{{grupoUnidadeCtrl.associacoes.length}}\"--><!--md-on-paginate=\"grupoUnidadeCtrl.associar\"--><!--md-page-select>--><!--</md-table-pagination>--><!--<div layout=\"row\" layout-align=\"center\">--><!--<md-button type=\"submit\" class=\"md-primary md-raised\" ng-click=\"grupoUnidadeCtrl.salvar()\">Gravar</md-button>--><!--<md-button class=\"md-raised\" ng-click=\"grupoUnidadeCtrl.limpar();\">Limpar</md-button>--><!--</div>--><!--</form>--><!--</md-content>--> <!--</div>-->");
$templateCache.put("scripts/grupo_unidade/views/cadastrar-grupo-unidade.tmpl.html","<div class=padding-right-pagina ng-init=grupoUnidadeCtrl.carregarOrgaos()><div class=md-title-com-borda>Cadastrar Grupo de Unidade Executora</div><form name=grupoUnidadeForm novalidate><div layout=row><div class=md-block flex=100><label>Órgão UGE - Órgão Superior ou Entidade:</label><md-autocomplete ng-model=grupoUnidadeCtrl.form.orgaoSuperior placeholder=\"Informe um órgão/entidade\" md-selected-item=grupoUnidadeCtrl.form.orgaoSuperior md-search-text=grupoUnidadeCtrl.filtroNomeOrgao md-items=\"item in grupoUnidadeCtrl.pesquisarOrgao()\" md-item-text=\"item.codigoUg + \' - \' + item.nome\" md-no-cache=true md-input-minlength=3 md-delay=700 md-input-id=orgaoSuperior><span md-highlight-text=grupoUnidadeCtrl.filtroNomeOrgao>{{item.codigoUg}} - {{item.nome}}</span><md-not-found>Não encontrado.</md-not-found></md-autocomplete><div ng-messages=grupoUnidadeForm.orgaos.$error><div ng-message=required><small>Campo obrigatório</small></div></div></div></div><div layout=row><md-input-container class=md-block flex=100><label>Nome Unidade Executora:</label><md-chips name=unidades ng-model=grupoUnidadeCtrl.unidadesSelecionadas md-transform-chip=grupoUnidadeCtrl.transformChip($chip) md-require-match=true required><md-autocomplete placeholder=\"Informe uma unidade\" secondary-placeholder=\"+1 unidade\" md-selected-item=grupoUnidadeCtrl.unidadeSelecionada.id md-search-text=grupoUnidadeCtrl.filtroNomeUnidade md-items=\"item in grupoUnidadeCtrl.pesquisarUnidadeOrgaoFiltro()\" md-item-text=item.nome md-no-cache=true md-input-minlength=3 md-delay=700 md-input-id=unidadeSelecionada ng-disabled=!grupoUnidadeCtrl.form.orgaoSuperior><span md-highlight-text=grupoUnidadeCtrl.filtroNomeUnidade>{{item.nome}}</span><md-not-found>Não encontrado.</md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip.nome}}</strong></span></md-chip-template></md-chips><div ng-messages=grupoUnidadeForm.unidades.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=100><label>Nome do grupo:</label><input name=nome ng-model=grupoUnidadeCtrl.form.nome required><div ng-messages=grupoUnidadeForm.nome.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=100><label>Administradores do Grupo de Unidades:</label><md-chips ng-model=grupoUnidadeCtrl.administradoresSelecionados md-transform-chip=grupoUnidadeCtrl.transformChip($chip) md-require-match=true id=administradoresSelecionados required><md-autocomplete placeholder=\"Informe o nome ou CPF\" md-selected-item=grupoUnidadeCtrl.administradorSelecionado.id md-search-text=grupoUnidadeCtrl.filtroAdministrador md-items=\"item in grupoUnidadeCtrl.pesquisarAdministrador()\" md-item-text=\"item.codigoUg + \' - \' + item.nome\" md-input-id=administradoresSelecionados md-no-cache=true md-input-minlength=3 md-delay=700><span md-highlight-text=grupoUnidadeCtrl.filtroAdministrador>{{item.codigoUg}} - {{item.nome}}</span><md-not-found><md-button ng-click=\"grupoUnidadeCtrl.showFormCadastroUsuario=true\">cadastrar usuário</md-button></md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip.nome}}</strong></span></md-chip-template></md-chips></md-input-container></div><div ng-show=grupoUnidadeCtrl.showFormCadastroUsuario><div class=border-tabela flex=100 layout=column><div layout=row><md-input-container class=md-block flex=30><label>CPF:</label><input name=cpf ng-model=grupoUnidadeCtrl.formUsuario.cpf ui-br-cpf-mask required><div ng-messages=grupoUnidadeForm.cpf.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=cpf><small>CPF inválido</small></div></div></md-input-container><md-input-container class=md-block flex=70><label>Nome:</label><input name=nome ng-model=grupoUnidadeCtrl.formUsuario.nome required><div ng-messages=grupoUnidadeForm.nome.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div><md-input-container class=md-block flex=33><label>E-mail:</label><input type=email name=email ng-model=grupoUnidadeCtrl.formUsuario.email required><div ng-messages=grupoUnidadeForm.email.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=email><small>Email inválido</small></div></div></md-input-container></div><div layout=row layout-align=end><md-button class=md-raised ng-click=grupoUnidadeCtrl.fecharFormUsuario()>Cancelar</md-button><md-button class=md-raised ng-click=grupoUnidadeCtrl.salvarUsuario()>Gravar</md-button></div></div></div></form><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button class=md-raised ng-click=grupoUnidadeCtrl.voltar()>Voltar</md-button><md-button class=md-raised ng-click=grupoUnidadeCtrl.limpar()>Limpar</md-button><md-button id=salvarGrupoUnidade_Button type=submit class=md-raised ng-disabled=\"grupoUnidadeCtrl.unidadesSelecionadas.length === 0\" ng-click=grupoUnidadeCtrl.salvar()>Gravar</md-button></div></div>");
$templateCache.put("scripts/grupo_unidade/views/consultar-grupo-unidade.tmpl.html","<div class=padding-right-pagina ng-init=grupoUnidadeCtrl.inicializarConsulta();><h1 class=md-title>Consultar Grupos de Unidades Executora</h1><div layout=column layout-align=center><form name=grupoUnidadeForm class=caixa-consulta><label>Órgão Superior ou Entidade:</label><md-autocomplete ng-model=grupoUnidadeCtrl.form.orgao.nome placeholder=\"Informe um órgão/entidade\" md-selected-item=grupoUnidadeCtrl.form.orgao md-search-text=grupoUnidadeCtrl.filtroNomeOrgao md-items=\"item in grupoUnidadeCtrl.pesquisarOrgao()\" md-item-text=\"item.codigoUg + \' - \' + item.nome\" md-no-cache=true md-input-minlength=3 md-delay=700><span md-highlight-text=grupoUnidadeCtrl.filtroNomeOrgao>{{item.codigoUg}} - {{item.nome}}</span><md-not-found>Não encontrado.</md-not-found></md-autocomplete><div ng-messages=grupoUnidadeForm.orgaos.$error><div ng-message=required><small>Campo obrigatório</small></div></div><md-input-container class=md-block><label>Nome do Grupo</label><input ng-model=grupoUnidadeCtrl.query.nome></md-input-container><md-input-container class=md-block><label>Nome Unidade Executora</label><input ng-model=grupoUnidadeCtrl.query.nomeUnidade></md-input-container><md-input-container class=md-block><label>Situação</label><md-select ng-model=grupoUnidadeCtrl.query.strAtivo><md-option ng-repeat=\"opcao in grupoUnidadeCtrl.opcoesAtivoInativo\" value={{opcao.value}}>{{opcao.key}}</md-option></md-select></md-input-container></form><div layout=row layout-align=end class=margin-top><md-button type=reset class=md-raised ng-click=grupoUnidadeCtrl.limparConsultar()>Limpar</md-button><md-button id=consultarGrupoUnidade_Button type=submit class=md-raised ng-click=grupoUnidadeCtrl.consultar()>Consultar</md-button><md-button type=submit class=md-raised ng-click=grupoUnidadeCtrl.criarNovoGrupo()>Novo</md-button></div></div><md-table-container><table md-table ng-model=grupoUnidadeCtrl.selecionado md-progress=promise><thead md-head md-order=grupoUnidadeCtrl.query.order md-on-reorder=grupoUnidadeCtrl.consultar ng-if=\"grupoUnidadeCtrl.gruposUnidades.length > 0\"><tr md-row><th md-column md-order-by=orgao><span>Órgão UGE - Órgão Superior​ ou Entidade</span></th><th md-column md-order-by=nome><span>Nome do Grupo</span></th><th md-column md-order-by=ativo><span>Ativo</span></th><th md-column><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"grupoUnidade in grupoUnidadeCtrl.gruposUnidades | orderBy: grupoUnidadeCtrl.query.order | limitTo: grupoUnidadeCtrl.query.limit : (grupoUnidadeCtrl.query.page -1) * grupoUnidadeCtrl.query.limit\"><td md-cell>{{grupoUnidade.orgaoSuperior.nome}}</td><td md-cell>{{grupoUnidade.nome}}</td><td md-cell><md-switch id=ativarInativarGrupoUnidade_Button ng-model=grupoUnidade.ativo ng-change=grupoUnidadeCtrl.ativarInativar(grupoUnidade)>{{grupoUnidade.ativo && \"Ativo\" || \"Inativo\"}}</md-switch></td><td md-cell><ng-md-icon id=detalharGrupoUnidade_Button icon=search style=fill:#788489 size=22 alt=Detalhar ng-click=grupoUnidadeCtrl.detalhar(grupoUnidade.id)><md-tooltip>Detalhar</md-tooltip></ng-md-icon><ng-md-icon id=alterarGrupoUnidade_Button icon=create style=fill:#788489 size=22 alt=Editar ng-click=grupoUnidadeCtrl.editar(grupoUnidade.id)><md-tooltip>Editar</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"grupoUnidadeCtrl.gruposUnidades.length > 0\" md-limit=grupoUnidadeCtrl.query.limit md-limit-options=\"[20, 50, 100]\" md-page=grupoUnidadeCtrl.query.page md-total={{grupoUnidadeCtrl.gruposUnidades.length}} md-on-paginate=grupoUnidadeCtrl.consultar md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></div>");
$templateCache.put("scripts/grupo_unidade/views/detalhar-grupo-unidade.tmpl.html","<div class=padding-right-pagina ng-init=grupoUnidadeCtrl.recuperarGrupoUnidade()><div class=md-title-com-borda>Detalhar Grupo de Unidade Executora</div><form name=grupoUnidadeForm novalidate><div layout-gt-sm=row><md-input-container class=md-block flex=45><label>Órgão UGE - Órgão Superior​ ou Entidade</label><input name=orgao ng-model=grupoUnidadeCtrl.form.orgaoSuperior.nome disabled></md-input-container></div><div layout-gt-sm=row><md-input-container class=md-block flex=50><label>Nome do Grupo</label><input name=nome ng-model=grupoUnidadeCtrl.form.nome disabled></md-input-container><md-input-container class=md-block flex=50><label>Situação</label><input name=situacao ng-model=grupoUnidadeCtrl.form.ativo disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex=50 ng-show=\"grupoUnidadeCtrl.form.administradores.length > 0\">Administradores<md-chips name=administradores ng-model=grupoUnidadeCtrl.form.administradores md-transform-chip=grupoUnidadeCtrl.transformChip($chip) readonly><md-chip-template><span><strong>{{$chip.nome}}</strong></span></md-chip-template></md-chips></md-input-container><md-input-container class=md-block flex=50 ng-show=\"grupoUnidadeCtrl.form.unidadeExecutoras.length > 0\">UG Executora<md-chips name=administradores ng-model=grupoUnidadeCtrl.form.unidadeExecutoras md-transform-chip=grupoUnidadeCtrl.transformChip($chip) readonly><md-chip-template><span><strong>{{$chip.nome}}</strong></span></md-chip-template></md-chips></md-input-container></div></form><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button id=voltar_Button class=md-raised ng-click=grupoUnidadeCtrl.voltar()>Voltar</md-button></div></div>");
$templateCache.put("scripts/grupo_unidade/views/editar-grupo-unidade.tmpl.html","<div class=padding-right-pagina ng-init=\"grupoUnidadeCtrl.carregarOrgaos(); grupoUnidadeCtrl.recuperarGrupoUnidade(); grupoUnidadeCtrl.recuperaUnidadesSelecionadas();\"><h1 class=md-title-com-borda>Editar Grupo de Unidade Executora</h1><form name=grupoUnidadeForm novalidate><div layout=row><md-input-container class=md-block flex=100><label>Órgão UGE - Órgão Superior​ ou Entidade</label><md-select name=orgao ng-model=grupoUnidadeCtrl.form.orgaoSuperior ng-model-options=\"{trackBy: \'$value.id\'}\" required><md-option ng-repeat=\"orgao in grupoUnidadeCtrl.orgaos\" ng-value=orgao>{{orgao.nome}}</md-option></md-select><div ng-messages=grupoUnidadeForm.orgao.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=100><label>Nome do grupo:</label><input name=nome ng-model=grupoUnidadeCtrl.form.nome required><div ng-messages=grupoUnidadeForm.nome.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=100><label>UG Executora:</label><md-chips name=unidades ng-model=grupoUnidadeCtrl.unidadesSelecionadas md-transform-chip=grupoUnidadeCtrl.transformChip($chip) md-require-match=true required><md-autocomplete placeholder=\"Informe uma unidade\" secondary-placeholder=\"+1 unidade\" md-selected-item=grupoUnidadeCtrl.unidadeSelecionada.id md-search-text=grupoUnidadeCtrl.filtroNomeUnidade md-items=\"item in grupoUnidadeCtrl.pesquisarUnidade()\" md-item-text=item.nome md-no-cache=true md-input-minlength=3 md-delay=700><span md-highlight-text=grupoUnidadeCtrl.filtroNomeUnidade>{{item.nome}}</span><md-not-found>Não encontrado.</md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip.nome}}</strong></span></md-chip-template></md-chips><div ng-messages=grupoUnidadeForm.unidades.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=100><label>Administradores do Grupo de Unidades:</label><md-chips ng-model=grupoUnidadeCtrl.form.administradores md-transform-chip=grupoUnidadeCtrl.transformChip($chip) md-require-match=true required><md-autocomplete placeholder=\"Informe o nome ou CPF\" md-selected-item=grupoUnidadeCtrl.administradorSelecionado.id md-search-text=grupoUnidadeCtrl.filtroAdministrador md-items=\"item in grupoUnidadeCtrl.pesquisarAdministrador()\" md-item-text=item.nome md-no-cache=true md-input-minlength=3 md-delay=700><span md-highlight-text=grupoUnidadeCtrl.filtroAdministrador>{{item.nome}}</span><md-not-found><md-button ng-click=\"grupoUnidadeCtrl.showFormCadastroUsuario=true\">cadastrar usuário</md-button></md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip.nome}}</strong></span></md-chip-template></md-chips></md-input-container></div><div ng-show=grupoUnidadeCtrl.showFormCadastroUsuario layout=row><md-content flex=45 style=\"border: solid #34aa53 1px\" class=md-primary.md-hue-2><section layout=row><md-input-container class=md-block><label>Nome:</label><input name=nome ng-model=grupoUnidadeCtrl.formUsuario.nome required><div ng-messages=grupoUnidadeForm.nome.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block><label>CPF:</label><input name=cpf ng-model=grupoUnidadeCtrl.formUsuario.cpf ui-br-cpf-mask required><div ng-messages=grupoUnidadeForm.cpf.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=cpf><small>CPF inválido</small></div></div></md-input-container><md-input-container class=md-block><label>E-mail:</label><div ng-messages=grupoUnidadeForm.email.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=email><small>Email inválido</small></div></div></md-input-container></section><section layout=row layout-align=center><md-button class=\"md-primary md-raised\" ng-click=grupoUnidadeCtrl.salvarUsuario()>Salvar usuário</md-button><md-button class=md-raised ng-click=grupoUnidadeCtrl.fecharFormUsuario()>Cancelar</md-button></section></md-content></div></form><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button id=voltar_Button class=md-raised ng-click=grupoUnidadeCtrl.voltar()>Voltar</md-button><md-button class=md-raised ng-click=grupoUnidadeCtrl.limpar();>Limpar</md-button><md-button id=salvarEdicao_Button type=submit class=md-raised ng-click=grupoUnidadeCtrl.salvarEdicao()>Gravar</md-button></div></div>");
$templateCache.put("scripts/historico_acoes/views/historico-acoes.tmpl.html","<div class=padding-right-pagina><h1 class=md-title>Histórico</h1><div layout=column layout-align=center><form name=historicoAcoesCtrl.formHistoricoUsuario class=caixa-consulta novalidate><div layout=row><md-input-container flex=50><label>Sistema</label><md-select name=sistema ng-model=historicoAcoesCtrl.historico.sistema required><md-option ng-repeat=\"sistema in historicoAcoesCtrl.sistemas\" value={{sistema.id}}>{{sistema.nome}}</md-option></md-select></md-input-container><md-input-container flex=50><label>Tipo de Log</label><md-select name=tipoLog ng-model=historicoAcoesCtrl.historico.tipoLog><md-option ng-repeat=\"tipo in historicoAcoesCtrl.tiposLog\" value={{tipo.name}}>{{tipo.descricao}}</md-option></md-select></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Busca pelo nome do responsável da ação</label><input name=nome ng-model=historicoAcoesCtrl.historico.nomeExecutor></md-input-container><md-input-container class=md-block flex=50><label>Busca por texto</label><input name=mensagem ng-model=historicoAcoesCtrl.historico.mensagem></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Busca pelo CPF</label><input name=cpf maxlength=11 ng-model=historicoAcoesCtrl.historico.cpfExecutor></md-input-container></div><div layout=row><div layout=row flex=50 layout-align=\"start center\"><span class=espaco-label-data>Data de Início:</span><md-datepicker ng-model=historicoAcoesCtrl.historico.dataInicio md-placeholder=\"Data Início\"></md-datepicker></div><div layout=row flex=50 layout-align=\"start center\"><span class=espaco-label-data>Data Final:</span><md-datepicker ng-model=historicoAcoesCtrl.historico.dataFim md-placeholder=\"Data Fim\"></md-datepicker></div></div><div layout=row layout-align=\"end center\"><md-button type=submit class=md-raised ng-click=historicoAcoesCtrl.filtrar()>Filtrar</md-button></div></form></div><md-content><md-table-container><table md-table><thead md-head><tr md-row><th md-column style=\"text-align: center\"><span>Tipo de Log</span></th><th md-column style=\"text-align: center; padding-right: 0px\"><span>Código do Evento</span></th><th md-column style=\"text-align: center; padding: 15px\"><span>Nível</span></th><th md-column style=\"text-align: center; padding: 10px\"><span>CPF/Executor</span></th><th md-column style=\"text-align: center; padding: 5px\"><span>Data/Hora</span></th><th md-column style=\"text-align: center\"><span>Info. Origem</span></th><th md-column style=\"text-align: center\"><span>Mensagem</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"log in historicoAcoesCtrl.logs\"><td md-cell style=\"text-align: center\">{{log.tipoLog.descricao || \'-\'}}</td><td md-cell style=\"text-align: center; padding-right: 0px\">{{log.codigoEvento || \'-\' }}</td><td md-cell style=\"text-align: center; padding: 15px\">{{log.nivel.descricao || \'-\' }}</td><td md-cell style=\"text-align: center;padding: 10px\">{{log.cpfExecutor}} - {{log.nomeExecutor}}</td><td md-cell style=\"text-align: center; padding: 5px\">{{log.dataRegistroEvento | date : \"dd/MM/yyyy HH:mm:ss\"}}</td><td md-cell style=\"text-align: center\">{{log.infoOrigem || \'-\' }}</td><td md-cell style=\"text-align: center\">{{log.mensagem || \'-\' }}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=historicoAcoesCtrl.historico.maximoPorPagina md-limit-options=\"[5, 10, 15]\" md-page=historicoAcoesCtrl.historico.numeroPagina md-total={{historicoAcoesCtrl.tabelaHistorico.totalElementos}} md-on-paginate=historicoAcoesCtrl.filtrar md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></md-content><md-divider></md-divider></div>");
$templateCache.put("scripts/home/views/erro-inativo.tmpl.html","<div layout=column ng-cloak flex=100><md-content><div layout=row layout-xs=row layout-align=\"center center\"><p>Ops!!!</p></div><div layout=row layout-xs=row layout-align=\"center center\"><img src=assets/img/negado.jpg></div><div layout=row layout-xs=row layout-align=\"center center\"><div layout=row layout-xs=row layout-align=\"center center\" class=\"layout-xs-row layout-align-center-center layout-row\"><p>Seu usuário esta inativo no Acessos<br><br>Caso necessário, entre em contato para solicitar a reativação de seu cadastro.</p></div></div></md-content></div>");
$templateCache.put("scripts/home/views/erro-permissao.tmpl.html","<div layout=column ng-cloak flex=100><md-content><div layout=row layout-xs=row layout-align=\"center center\"><p>Ops!!! Você não tem acesso a essa funcionalidade!</p></div><div layout=row layout-xs=row layout-align=\"center center\"><img src=assets/img/negado.jpg></div><div layout=row layout-xs=row layout-align=\"center center\"><div layout=row layout-xs=row layout-align=\"center center\" class=\"layout-xs-row layout-align-center-center layout-row\"><p>Porém já esta cadastrado no Acessos!<br><br>Se desejar, efetue o <b>login</b> no canto superior direito e solicite seu acesso pelo menu <b>Acessos-&gt;Solicitar Acesso</b>.</p></div></div></md-content></div>");
$templateCache.put("scripts/home/views/home.tmpl.html","<div layout=column ng-cloak flex=100><md-content><div ng-cloak><md-content><md-tabs md-dynamic-height md-border-bottom md-selected=homeCtrl.isLogado()><md-tab ng-click=homeCtrl.onTabSelected(0)><md-tab-label>Por onde começar?</md-tab-label><md-tab-body><md-content class=md-padding><h3 class=md-displayy-1><i class=\"material-icons .material-icons.md-36\">open_in_new</i> Bem-vindo! este é o <strong>Acessos-MP</strong>.</h3><div layout=row><div flex><p>Um Portal Moderno que unifica alguns serviços de Gestão de Acesso e Identidade.</p><p>Direcionado aos Gestores e Usuários de sistemas do Ministério do Planejamento.</p><p>Permite controlar e atribuir as devidas permissões e responsabilidades em módulos, menus e funcionalidades aos usuários dos Sistemas que estejam integrados a ele!</p></div><!--div flex>\n										<img class=\"img_logo\" src=\"scripts/home/views/ministerio_planejamento-spu.png\" alt=\"SPU - Secretaria de Patrimônio da União.\" style=\"width:700px;height:300px;\">\n									</div --></div><h1 class=md-display-1><i class=\"material-icons .material-icons.md-36\">person</i> Meu primeiro Acesso</h1><p>O primeiro passo é preencher o formulário de solicitação de acesso a um dos sistemas do SPU - Secretaria de Patrimônio da União. através do botão abaixo ou através do menu principal<md-button class=menu ng-click=ul.toggleMenu() aria-label=\"Menu da Aplicação\" style=min-width:30px;margin:0px;padding:0px><ng-md-icon icon=menu style=fill:#ff6600 size=38></ng-md-icon></md-button>em \'Páginas Públicas -> Solicitar Ativação Usuário\'.</p><p>Neste momento você já deve indicar o Sistema no qual deseja obter o acesso, sua solicitação será direcionada aos Gestores do Sistema para que seja feita a aprovação.</p><p>Em caso de sucesso você receberá as informações de acesso no email cadastrado.</p><md-button class=\"md-raised md-warn\" href=/#/solicitarAtivacaoUsuario style=background-color:#ff6600><md-icon><i class=\"material-icons .material-icons.md-36\">person_add</i></md-icon>Solicitar Cadastro e Primeiro Acesso</md-button></md-content></md-tab-body></md-tab><md-tab ng-click=homeCtrl.onTabSelected(1)><md-tab-label>Já tenho cadastro</md-tab-label><md-tab-body><md-content class=md-padding><h1 class=md-display-1>Já tenho cadastro</h1><p>Neste caso, faça a autenticação utilizando o menu de login no topo direito da página, em seguida os demais menus e funcionalidades estarão disponíveis pelo menu principal<md-button class=menu ng-click=ul.toggleMenu() aria-label=\"Menu da Aplicação\" style=min-width:30px;margin:0px;padding:0px><ng-md-icon icon=menu style=fill:#ff6600 size=38></ng-md-icon></md-button>no topo a esquerda.</p><h3>Esqueci a senha / Desejo alterar a senha</h3><p>Neste caso, faça logout e vá na tela de login clicando no menu no topo direito da página, e logo abaixo dos campos de usuário e senha, os link\'s de \'Alterar Senha\' e \'Esqueci a senha\' estarão disponíveis.</p><h1 class=md-display-1><i class=\"material-icons .material-icons.md-36\">verified_user</i> Meus Acessos</h1><div layout=column><p>Para visualizar os Acessos que tem, ver os pedidos de acessos <b>pendentes</b> e solicitar novos perfis.<br>Acesse o menu<md-button class=\"md-icon-button launch\" href=/api style=min-width:30px;margin:0px;padding:0px><ng-md-icon icon=vpn_key style=fill:#ff6600 alt=Login size=30><md-tooltip md-direction=bottom>Login</md-tooltip></ng-md-icon></md-button>no topo direito da página ou navegue no menu principal -> “Acessos” -> “Solicitar Acessos” e preencha o formulário indicando o sistema, módulo e unidade que deseja acessar.</p></div></md-content></md-tab-body></md-tab><md-tab ng-click=homeCtrl.onTabSelected(2)><md-tab-label>Preciso de ajuda</md-tab-label><md-tab-body><md-content class=md-padding><h3>Para outras dúvidas ou problemas por favor entre em<md-button class=\"md-raised md-warn\" ng-click=\"shwEml = !shwEml\">Contato</md-button><p ng-show=shwEml><label><ng-md-icon icon=email style=fill:#ff6600 size=24></ng-md-icon>{{ shwEml ? homeCtrl.emailContato: \'\'}}</label></p></h3></md-content></md-tab-body></md-tab></md-tabs></md-content></div><div style=\"position: relative; padding: 50px; display: flex; justify-content: center; align-items: center\"><img class=img_logo src=scripts/home/views/ministerio_planejamento-spu.png alt=\"SPU - Secretaria de Patrimônio da União.\" style=\"max-width: 100%; max-height: 100%\"></div></md-content></div>");
$templateCache.put("scripts/login/views/login.tmpl.html","<div layout-xs=column><md-content flex><h1 class=md-title>Login</h1><md-divider></md-divider><form name=formLogin autocomplete=off><div layout=row layout-align=center><md-input-container class=md-block flex=45><label>Usuário</label><input name=usuario ng-model=loginCtrl.credenciais.usuario required><div ng-messages=formLogin.nome.$error><div ng-message=required>Campo obrigatório!</div></div></md-input-container></div><div layout=row layout-align=center><md-input-container class=md-block flex=45><label>Senha</label><input type=password name=senha ng-model=loginCtrl.credenciais.senha required><div ng-messages=formLogin.senha.$error><div ng-message=required>Campo obrigatório!</div></div></md-input-container></div><div layout=row layout-align=center><md-button class=md-raised ng-click=loginCtrl.limpar();>Limpar</md-button><md-button type=submit class=\"md-primary md-raised\" ng-click=loginCtrl.login()>Login</md-button></div></form></md-content></div>");
$templateCache.put("scripts/menu/views/cadastrar-item-menu.tmpl.html","<!-- Nested node template --><style type=text/css>.btn {\n        margin-right: 8px;\n    }\n\n    .angular-ui-tree-handle {\n        background: #f8faff;\n        border: 1px solid #dae2ea;\n        color: #7c9eb2;\n        padding: 10px 10px;\n    }\n\n    .angular-ui-tree-handle:hover {\n        color: #438eb9;\n        background: #f4f6f7;\n        border-color: #dce2e8;\n    }\n\n    .angular-ui-tree-placeholder {\n        background: #f0f9ff;\n        border: 2px dashed #bed2db;\n        -webkit-box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        box-sizing: border-box;\n    }\n\n    tr.angular-ui-tree-empty {\n        height: 100px\n    }\n\n    .group-title {\n        background-color: #687074 !important;\n        color: #FFF !important;\n    }\n\n    /* --- Tree --- */\n    .tree-node {\n        border: 1px solid #dae2ea;\n        background: #f8faff;\n        color: #7c9eb2;\n    }\n\n    .nodrop {\n        background-color: #f2dede;\n    }\n\n    .tree-node-content {\n        margin: 10px;\n    }\n\n    .tree-handle {\n        padding: 10px;\n        background: #428bca;\n        color: #FFF;\n        margin-right: 10px;\n    }\n\n    .angular-ui-tree-handle:hover {\n    }\n\n    .angular-ui-tree-placeholder {\n        background: #f0f9ff;\n        border: 2px dashed #bed2db;\n        -webkit-box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        box-sizing: border-box;\n    }</style><script type=text/ng-template id=nodes_renderer.html><div ui-tree-handle class=\"tree-node tree-node-content\" style=\"height: 45px;\" ng-style=\"{\'background-color\': itemMenuCtrl.getToolbarColor(node)}\">\n        <ng-md-icon icon=\"keyboard_arrow_down\" style=\"fill:blue; float:left\" size=\"24\"\n                    ng-if=\"node.nos && node.nos.length > 0\"\n                    ng-class=\"{\'glyphicon-chevron-right\': collapsed,\'glyphicon-chevron-down\': !collapsed}\"\n                    data-nodrag ng-click=\"toggle(this)\">\n        </ng-md-icon>\n\n        <div style=\"float:left\">\n            <span ng-show=\"node.icone\">\n                <img ng-src=\"data:image/JPEG;base64,{{node.icone.dado}}\"  height=\"20\"> -\n            </span>\n            {{node.descricaoResumida}}\n        </div>\n\n        <div style=\"float: right\" ng-init=\"itemMenuCtrl.recuperarSistema(this)\">\n            <ng-md-icon ng-show=\"node.excluido === false\" icon=\"add\" data-nodrag style=\"fill:#788489\" size=\"22\" alt=\"Criar\"\n                        ng-click=\"newSubItem(this)\"></ng-md-icon>\n            <ng-md-icon ng-show=\"node.id != 0 && node.excluido === false\" icon=\"create\" style=\"fill:#788489\" size=\"22\" alt=\"Alterar\" data-nodrag\n                        ng-click=\"editSubItem(this)\"></ng-md-icon>\n            <ng-md-icon ng-show=\"node.id != 0 && node.excluido === false\" icon=\"delete\" data-nodrag style=\"fill:#788489\" size=\"22\" alt=\"Excluir\"\n                        ng-click=\"removerItem(this)\"></ng-md-icon>\n            <ng-md-icon ng-show=\"node.id != 0 && node.excluido === true\" icon=\"check\" data-nodrag style=\"fill:#788489\" size=\"22\" alt=\"Reativar\"\n                        ng-click=\"reativarItem(this)\"></ng-md-icon>\n        </div>\n\n    </div>\n    <ol ui-tree-nodes=\"\" ng-model=\"node.nos\" ng-class=\"{hidden: collapsed}\">\n        <li ng-repeat=\"node in node.nos\" ui-tree-node ng-include=\"\'nodes_renderer.html\'\">\n        </li>\n    </ol></script><div class=padding-right-pagina><div class=row><div class=md-title-com-borda><div>Gerenciar Itens de Menu</div></div><div class=texto-secundario><div>{{itemMenuCtrl.form.sistema.nome}} - {{itemMenuCtrl.form.nome}}</div></div></div><div class=row><div class=col-sm-6><div ui-tree=treeOptions id=tree-root><ol ui-tree-nodes ng-model=data><li ng-repeat=\"node in data\" ui-tree-node ng-include=\"\'nodes_renderer.html\'\"></li></ol></div></div></div><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button class=md-raised ng-click=itemMenuCtrl.voltarConsultarMenu()>Voltar</md-button><!--<md-button class=\"md-raised\" ui-sref=\"consultarItemMenu\">Voltar</md-button>--></div></div>");
$templateCache.put("scripts/menu/views/consultar-item-menu.tmpl.html","<div class=padding-right-pagina ng-init=itemMenuCtrl.inicializarConsulta();><h1 class=md-title>Consultar Itens de Menu</h1><div layout=column layout-align=center><form name=itemMenuForm class=caixa-consulta><div layout=row layout-align=center class=padding-right-input><md-input-container flex=50 class=padding-right-input><label>Sistema</label><md-select ng-model=itemMenuCtrl.query.id md-on-open=itemMenuCtrl.carregarSistemas()><md-option ng-repeat=\"sistema in itemMenuCtrl.comboSistemas\" value=\"{{ sistema.id }}\">{{sistema.nome}}</md-option></md-select></md-input-container><md-input-container flex=50><label>Módulo</label><md-select ng-model=itemMenuCtrl.query.idModulo md-on-open=itemMenuCtrl.carregarModulos() ng-disabled=!itemMenuCtrl.query.id><md-option ng-repeat=\"modulo in itemMenuCtrl.comboModulos\" value=\"{{ modulo.id }}\">{{modulo.nome}}</md-option></md-select></md-input-container></div></form><div layout=row layout-align=end class=margin-top><md-button type=reset class=md-raised ng-click=itemMenuCtrl.limpar()>Limpar</md-button><md-button type=submit class=md-raised ng-click=itemMenuCtrl.consultar()>Consultar</md-button></div></div><div><md-table-container><table md-table ng-model=itemMenuCtrl.selecionado md-progress=promise><thead md-head md-order=itemMenuCtrl.query.order md-on-reorder=itemMenuCtrl.consultar><tr md-row><th md-column md-order-by=nome><span>Sistema</span></th><th md-column><span>Módulo</span></th><th md-column><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"modulo in itemMenuCtrl.modulos\"><td md-cell>{{modulo.sistema.nome}}</td><td md-cell>{{modulo.nome}}</td><td md-cell><ng-md-icon icon=create style=fill:#788489 size=22 alt=Editar ng-click=itemMenuCtrl.editar(modulo.id)><md-tooltip>Alterar</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container><!--<md-table-pagination md-limit=\"permissaoCtrl.query.limit\"\n                             md-limit-options=\"[5, 10, 15]\"\n                             md-page=\"permissaoCtrl.query.page\"\n                             md-total=\"{{permissaoCtrl.permissoes.count}}\"\n                             md-on-paginate=\"permissaoCtrl.consultar\"\n                             md-page-select>\n        </md-table-pagination>--></div></div>");
$templateCache.put("scripts/menu/views/criar-item-menu.tmpl.html","<div class=padding-right-pagina ng-init=itemMenuCtrl.carregarPermissoes()><h1 class=md-title>Incluir Item de Menu</h1><form><md-dialog-content><div layout=row layout-align=center><md-input-container class=md-block flex=50><label>Descrição detalhada do Item de Menu (Hint)</label><input name=descricaoDetalhada ng-model=form.descricaoDetalhada required><div ng-messages=formSistema.descricaoDetalhada.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container><md-input-container class=md-block flex=50><label>Descrição Resumida</label><input name=descricaoResumida ng-model=form.descricaoResumida required><div ng-messages=formSistema.descricaoResumida.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><div layout=row layout-align=center><md-input-container class=md-block flex=50><label>State AngularJS</label><input name=codigoIdentificador ng-model=form.codigoIdentificador required><div ng-messages=formSistema.codigoIdentificador.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container><md-input-container class=md-block flex-gt-sm><label>Url AngularJS</label><input name=url ng-model=form.url></md-input-container></div><div layout=row layout-align=center><md-input-container class=md-block flex=100><label>Template Url AngularJS</label><input name=templateUrl ng-model=form.templateUrl></md-input-container></div><div layout=row layout-align=center><md-input-container class=md-block flex=50><label>Controller AngularJS</label><input name=controller ng-model=form.controller></md-input-container><md-input-container class=md-block flex=50><label>Apelido Controller AngularJS</label><input name=apelidoController ng-model=form.apelidoController></md-input-container></div><md-input-container class=md-block flex-gt-sm><lf-ng-md-file-input name=icone lf-files=form.icone lf-filesize=1MB lf-totalsize=1MB lf-mimetype=image/* lf-placeholder=\"Selecione o ícone\" lf-remove-label=Remover preview lf-browse-label=Procurar...></lf-ng-md-file-input><div ng-messages=formSistema.files.$error style=color:red><div ng-message=filesize>O arquivo excede o limite de 5MB</div><div ng-message=totalsize>A requisição excede o limite de 10MB</div><div ng-message=mimetype>O arquivo deve ser uma imagem</div></div></md-input-container></md-dialog-content><div layout=row><div flex=100 ng-show=\"itemMenuCtrl.permissoes.length > 0\"><md-table-container><table md-table md-row-select multiple ng-model=form.permissoes><thead md-head><tr md-row><th md-column><span>Código Sistêmico</span></th><th md-column><span>Nome da Permissão</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=permissao md-select-id=id ng-repeat=\"permissao in itemMenuCtrl.permissoes |\n                                orderBy: itemMenuCtrl.query.order | limitTo: itemMenuCtrl.query.limit :\n                                (itemMenuCtrl.query.page -1) * itemMenuCtrl.query.limit\"><td md-cell>{{permissao.codigoSistemico}}</td><td md-cell>{{permissao.nome}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=itemMenuCtrl.query.limit md-limit-options=\"[5, 10, 15]\" md-page=itemMenuCtrl.query.page md-total={{itemMenuCtrl.permissoes.length}} md-on-paginate=itemMenuCtrl.consultar md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></div></div><md-divider></md-divider><div layout=row layout-align=end><md-button ng-click=itemMenuCtrl.voltar() class=md-raised>Voltar</md-button><md-button ng-click=itemMenuCtrl.limpar() class=md-raised>Limpar</md-button><md-button class=md-raised ng-click=\"itemMenuCtrl.salvar(form, form.icone)\" style=margin-right:20px>Gravar</md-button></div></form></div>");
$templateCache.put("scripts/menu/views/editar-item-menu.tmpl.html","<div class=padding-right-pagina ng-init=itemMenuCtrl.recuperarItemMenu();><h1 class=md-title>Editar Item de Menu</h1><form><md-dialog-content><div layout=row layout-align=center><md-input-container class=md-block flex=50><label>Descrição detalhada do Item de Menu (Hint)</label><input name=descricaoDetalhada ng-model=itemMenuCtrl.form.descricaoDetalhada required><div ng-messages=formSistema.descricaoDetalhada.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container><md-input-container class=md-block flex=50><label>Descrição Resumida</label><input name=descricaoResumida ng-model=itemMenuCtrl.form.descricaoResumida required><div ng-messages=formSistema.descricaoResumida.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><div layout=row layout-align=center><md-input-container class=md-block flex=50><label>State AngularJS</label><input name=codigoIdentificador ng-model=itemMenuCtrl.form.codigoIdentificador required><div ng-messages=formSistema.codigoIdentificador.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container><md-input-container class=md-block flex-gt-sm><label>Url AngularJS</label><input name=url ng-model=itemMenuCtrl.form.url></md-input-container></div><div layout=row layout-align=center><md-input-container class=md-block flex=100><label>Template Url AngularJS</label><input name=templateUrl ng-model=itemMenuCtrl.form.templateUrl></md-input-container></div><div layout=row layout-align=center><md-input-container class=md-block flex=50><label>Controller AngularJS</label><input name=controller ng-model=itemMenuCtrl.form.controller></md-input-container><md-input-container class=md-block flex=50><label>Apelido Controller AngularJS</label><input name=apelidoController ng-model=itemMenuCtrl.form.apelidoController></md-input-container></div><md-input-container class=md-block flex-gt-sm><lf-ng-md-file-input name=icone lf-files=itemMenuCtrl.icone lf-filesize=1MB lf-totalsize=1MB lf-mimetype=image/* lf-placeholder=\"Selecione o ícone\" lf-remove-label=Remover preview lf-browse-label=Procurar...></lf-ng-md-file-input><div ng-messages=formSistema.files.$error style=color:red><div ng-message=filesize>O arquivo excede o limite de 5MB</div><div ng-message=totalsize>A requisição excede o limite de 10MB</div><div ng-message=mimetype>O arquivo deve ser uma imagem</div></div></md-input-container></md-dialog-content><div layout=row><div flex=100 ng-show=\"itemMenuCtrl.permissoes.length > 0\"><md-table-container><table md-table md-row-select multiple ng-model=itemMenuCtrl.form.permissoes><thead md-head><tr md-row><th md-column><span>Código Sistêmico</span></th><th md-column><span>Nome da Permissão</span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=permissao md-select-id=id ng-repeat=\"permissao in itemMenuCtrl.permissoes |\n                                orderBy: itemMenuCtrl.query.order | limitTo: itemMenuCtrl.query.limit :\n                                (itemMenuCtrl.query.page -1) * itemMenuCtrl.query.limit\"><td md-cell>{{permissao.codigoSistemico}}</td><td md-cell>{{permissao.nome}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=itemMenuCtrl.query.limit md-limit-options=\"[5, 10, 15]\" md-page=itemMenuCtrl.query.page md-total={{itemMenuCtrl.permissoes.length}} md-on-paginate=itemMenuCtrl.consultar md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></div></div><md-divider></md-divider><div layout=row layout-align=end><md-button ng-click=itemMenuCtrl.voltar() class=md-raised>Voltar</md-button><md-button class=md-raised ng-click=\"itemMenuCtrl.salvar(itemMenuCtrl.form, itemMenuCtrl.icone)\" style=margin-right:20px>Gravar</md-button></div></form></div>");
$templateCache.put("scripts/menu/views/item-menu-dialog.tmpl.html","<md-dialog aria-label=\"Incluir Item de Menu\" ng-cloak flex=50><form><md-toolbar><div class=md-toolbar-tools><h2>Incluir Item de Menu</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><md-icon md-svg-src=img/icons/ic_close_24px.svg aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=row layout-align=center><md-input-container class=md-block flex=50><label>Descrição detalhada do Item de Menu (Hint)</label><input name=descricaoDetalhada ng-model=form.descricaoDetalhada required><div ng-messages=formSistema.descricaoDetalhada.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container><md-input-container class=md-block flex=50><label>Descrição Resumida</label><input name=descricaoResumida ng-model=form.descricaoResumida required><div ng-messages=formSistema.descricaoResumida.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><div layout=row layout-align=center><md-input-container class=md-block flex=50><label>State AngularJS</label><input name=codigoIdentificador ng-model=form.codigoIdentificador required><div ng-messages=formSistema.codigoIdentificador.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container><md-input-container class=md-block flex-gt-sm><label>Url AngularJS</label><input name=url ng-model=form.url></md-input-container></div><div layout=row layout-align=center><md-input-container class=md-block flex=100><label>Template Url AngularJS</label><input name=templateUrl ng-model=form.templateUrl></md-input-container></div><div layout=row layout-align=center><md-input-container class=md-block flex=50><label>Controller AngularJS</label><input name=controller ng-model=form.controller></md-input-container><md-input-container class=md-block flex=50><label>Apelido Controller AngularJS</label><input name=apelidoController ng-model=form.apelidoController></md-input-container></div><md-input-container class=md-block flex-gt-sm><lf-ng-md-file-input name=files lf-files=files lf-filesize=1MB lf-totalsize=1MB lf-mimetype=image/* lf-placeholder=\"Selecione o ícone\" lf-remove-label=Remover preview lf-browse-label=Procurar...></lf-ng-md-file-input><div ng-messages=formSistema.files.$error style=color:red><div ng-message=filesize>O arquivo excede o limite de 5MB</div><div ng-message=totalsize>A requisição excede o limite de 10MB</div><div ng-message=mimetype>O arquivo deve ser uma imagem</div></div></md-input-container></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel()>Cancelar</md-button><md-button ng-click=salvar(form) style=margin-right:20px>Salvar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("scripts/menu-modulo/src/menu.tmpl.html","<!-- Menu --><!-- md-is-locked-open=\"$mdMedia(\'gt-sm\')\" --><md-sidenav class=\"site-sidenav md-fg-600 md-sidenav-left md-whiteframe-z2\" md-component-id=left layout=column flex><div style=\"background: #666; min-height: 40px; width: 100%\"><!--<div layout=\"row\" style=\"margin-top: 20px; margin-left: 25px;\">--><!--<input type=\"text\" style=\"border: none; box-shadow: none; width: 150px; padding: 10px; font-size: 14px;\"--><!--placeholder=\"Busca inteligente\"/>--><!--<ng-md-icon icon=\"search\" style=\"fill:#fff\" size=\"48\" alt=\"Pesquisar\" ></ng-md-icon>--><!--</div>--></div><div layout=column style=\"width: 100%\"><md-menu-bar role=menubar><md-menu md-position-mode style=\"margin: 0px; padding: 0px\" ng-repeat=\"item in menuAcessos\"><div><md-button ng-click=$mdOpenMenu() ng-show=\"item.nos != null\"><div layout=row flex>{{item.descricaoResumida}} <span flex></span> <span><i style=\"vertical-align: middle\" class=material-icons>chevron_right</i></span></div></md-button><md-button ui-sref={{item.codigoIdentificador}} ng-show=\"item.nos == null\"><div layout=row flex>{{item.descricaoResumida}}</div></md-button></div><md-menu-content ng-show=\"item.nos != null\"><md-menu-item><div layout=column><ul ng-repeat=\"subItemPai in item.nos\"><div ng-show=\"subItemPai.nos == null\"><li><md-button ui-sref={{subItemPai.codigoIdentificador}} ng-click=closeMenu()><h3>{{subItemPai.descricaoResumida}}</h3></md-button></li></div><div ng-show=\"subItemPai.nos != null\"><li><h3 style=\"color: #0066bb\">{{subItemPai.descricaoResumida}}</h3><ul class=listaitens><li class=itensmenu ng-repeat=\"subItemFilho in subItemPai.nos\"><md-button ui-sref=\"{{subItemFilho.codigoIdentificador  }}\" ng-click=closeMenu()>{{subItemFilho.descricaoResumida}}</md-button></li></ul></li></div></ul></div></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></md-sidenav>");
$templateCache.put("scripts/orgao/views/cadastrar-orgao.tmpl.html","<div class=padding-right-pagina ng-init=orgaoCtrl.carregarOrgaos()><div class=md-title-com-borda>Cadastrar Órgão Superior ou Entidade</div><form name=orgaoForm novalidate><div layout=row><md-input-container class=md-block flex=50><label>CNPJ:</label><input name=cnpj ng-model=orgaoCtrl.form.cnpj cpf-cnpj-mask></md-input-container><md-input-container class=md-block flex=50><label>Nome do Órgão Superior ou Entidade:</label><input name=nome ng-model=orgaoCtrl.form.nome required><div ng-messages=orgaoForm.nome.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Sigla:</label><input name=sigla ng-model=orgaoCtrl.form.sigla></md-input-container><md-input-container class=md-block flex=50><label>Código UG:</label><input name=codigoUg ng-model=orgaoCtrl.form.codigoUg></md-input-container></div><div layout=row><md-input-container flex=50><label>Tipo:</label><md-select name=tipoAdministracao ng-model=orgaoCtrl.form.tipoAdministracao md-on-open=orgaoCtrl.consultarTipoAdministracao() required><md-option ng-repeat=\"tipoAdministracao in orgaoCtrl.tiposAdministracao\" ng-value=tipoAdministracao>{{tipoAdministracao.descricao}}</md-option></md-select><div ng-messages=orgaoForm.tipoAdministracao.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=50><label>Esfera:</label><md-select name=esferaPoder ng-model=orgaoCtrl.form.esferaPoder md-on-open=orgaoCtrl.consultarEsferasPoder() ng-disabled=orgaoCtrl.isTipoAdministracaoEspecialDesabilitar()><md-option ng-repeat=\"esfera in orgaoCtrl.esferasPoder\" ng-value=esfera>{{esfera.descricao}}</md-option></md-select></md-input-container></div><div layout=row><md-input-container flex=50><label>Poder:</label><md-select name=poder ng-model=orgaoCtrl.form.poder md-on-open=orgaoCtrl.consultarPoder() ng-disabled=orgaoCtrl.isTipoAdministracaoEspecialDesabilitar()><md-option ng-repeat=\"poder in orgaoCtrl.poderes\" ng-value=poder>{{poder.descricao}}</md-option></md-select></md-input-container></div><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button class=md-raised ng-click=orgaoCtrl.consultarOrgao()>Voltar</md-button><md-button class=md-raised ng-click=orgaoCtrl.limpar()>Limpar</md-button><md-button type=submit class=md-raised ng-disabled=orgaoCtrl.desabilitarGravar() ng-click=orgaoCtrl.salvar()>Gravar</md-button></div></form></div>");
$templateCache.put("scripts/orgao/views/consultar-orgao.tmpl.html","<div class=padding-right-pagina ng-init=orgaoCtrl.inicializarConsulta();><h1 class=md-title>Consultar Órgão Superior ou Entidade</h1><div layout=column layout-align=center><form name=orgaoForm class=caixa-consulta><div layout=row><md-input-container class=md-block flex=50><label>CNPJ</label><input ng-model=orgaoCtrl.query.cnpj cpf-cnpj-mask></md-input-container><md-input-container class=md-block flex=50><label>Situação</label><md-select ng-model=orgaoCtrl.query.strAtivo><md-option ng-repeat=\"opcao in orgaoCtrl.opcoesAtivoInativo\" value=\"{{ opcao.value }}\">{{opcao.key}}</md-option></md-select></md-input-container></div><md-input-container class=md-block><label>Nome do Órgão Superior ou Entidade</label><input ng-model=orgaoCtrl.query.nome></md-input-container></form><div layout=row layout-align=end class=margin-top><md-button type=reset class=md-raised ng-click=orgaoCtrl.limparConsultar()>Limpar</md-button><md-button type=submit class=md-raised ng-click=orgaoCtrl.consultar()>Consultar</md-button><md-button type=submit class=md-raised ng-click=orgaoCtrl.cadastrar()>Novo</md-button></div></div><div><md-table-container><table md-table ng-model=orgaoCtrl.selecionado md-progress=promise><thead md-head md-order=orgaoCtrl.query.order><tr md-row><th md-column md-order-by=cnpj><span>CNPJ</span></th><th md-column md-order-by=orgao><span>Órgão UGE - Órgão Superior​ ou Entidade</span></th><th md-column md-order-by=orgao><span>Código da UGE</span></th><th md-column md-order-by=situacao><span>Situação</span></th><th md-column><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"orgao in orgaoCtrl.orgaos| orderBy: orgaoCtrl.query.order | limitTo: orgaoCtrl.query.limit : (orgaoCtrl.query.page -1) * orgaoCtrl.query.limit \"><td md-cell>{{orgao.cnpj}}</td><td md-cell>{{orgao.nome}}</td><td md-cell>{{orgao.codigoUg}}</td><td md-cell><md-switch ng-model=orgao.ativo ng-change=orgaoCtrl.ativarInativar(orgao)>{{orgao.ativo && \"Ativo\" || \"Inativo\"}}</md-switch></td><td md-cell><ng-md-icon icon=search style=fill:#788489 size=22 alt=Detalhar ng-click=orgaoCtrl.detalhar(orgao.id)><md-tooltip>Detalhar</md-tooltip></ng-md-icon><ng-md-icon icon=create style=fill:#788489 size=22 alt=Editar ng-click=orgaoCtrl.editar(orgao.id)><md-tooltip>Editar</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"orgaoCtrl.orgaos.length > 0\" md-limit=orgaoCtrl.query.limit md-limit-options=\"[20, 50, 100]\" md-page=orgaoCtrl.query.page md-total={{orgaoCtrl.orgaos.length}} md-on-paginate=orgaoCtrl.consultar md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></div></div>");
$templateCache.put("scripts/orgao/views/consultar-solicit-ativacao-orgao.tmpl.html","<div class=padding-right-pagina ng-init=\"orgaoCtrl.carregarSituacaoSolicitacao(); orgaoCtrl.inicializarConsultaSolicitAtivOrgao()\"><h1 class=md-title>Consultar/Tratar Solicitações de Ativação de Unidade Executora</h1><div layout=column layout-align=center><form name=solicitacaoAtivacaoOrgaoForm class=caixa-consulta><div layout=row><md-input-container flex=40 class=padding-right-input><label>CNPJ:</label><input name=cnpj ng-model=orgaoCtrl.query.cnpjEntidade cpf-cnpj-mask></md-input-container><md-input-container flex=60><label>Unidade Executora</label><input ng-model=orgaoCtrl.query.nomeEntidade></md-input-container></div><md-input-container class=md-block><label>Situação</label><md-select ng-model=orgaoCtrl.query.situacaoSolicitacao md-on-open=\"\"><md-option ng-repeat=\"opcao in orgaoCtrl.situacoesSolicitacao\" value={{opcao}}>{{opcao}}</md-option></md-select></md-input-container><div layout=row><div layout=row flex=50 layout-align=\"start center\"><span class=espaco-label-data>Data Inicio:</span><md-datepicker ng-model=orgaoCtrl.query.inicio md-placeholder=Inicio></md-datepicker></div><div layout=row flex=50 layout-align=\"start center\"><span class=espaco-label-data>Data Fim:</span><md-datepicker ng-model=orgaoCtrl.query.fim md-placeholder=Fim></md-datepicker></div></div></form><div layout=row layout-align=end class=margin-top><md-button type=reset class=md-raised ng-click=orgaoCtrl.limparConsultaSolicitAtivOrgao()>Limpar</md-button><md-button type=submit class=md-raised ng-click=orgaoCtrl.consultarSolicitacaoAtivacao()>Consultar</md-button></div></div><div><md-table-container><table md-table ng-model=orgaoCtrl.selecionado md-progress=promise><thead md-head ng-if=\"orgaoCtrl.solicitacoes.length > 0\"><tr md-row><th md-column><span>CNPJ</span></th><th md-column><span>Unidade Executora</span></th><th md-column><span>Data solicitação</span></th><th md-column><span>Situação</span></th><th md-column><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"solicitacaoAtivacao in orgaoCtrl.solicitacoes\"><td md-cell ng-if=solicitacaoAtivacao.organizacao>{{solicitacaoAtivacao.organizacao.cnpj}}</td><td md-cell ng-if=!solicitacaoAtivacao.organizacao>{{solicitacaoAtivacao.cnpjEntidade}}</td><td md-cell ng-if=solicitacaoAtivacao.organizacao>{{solicitacaoAtivacao.organizacao.nome}}</td><td md-cell ng-if=!solicitacaoAtivacao.organizacao>{{solicitacaoAtivacao.nomeEntidade}}</td><td md-cell>{{solicitacaoAtivacao.solicitacao.data | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td md-cell>{{solicitacaoAtivacao.solicitacao.situacao}}</td><td md-cell><ng-md-icon icon=search style=fill:#788489 size=22 alt=Detalhar ng-click=orgaoCtrl.detalharSolicitAtivacaoOrgao(solicitacaoAtivacao.id)><md-tooltip>Detalhar</md-tooltip></ng-md-icon><ng-md-icon icon=create style=fill:#788489 size=22 alt=Tratar ng-click=orgaoCtrl.visualizarSolicitAtivacaoOrgao(solicitacaoAtivacao.id) ng-show=\"solicitacaoAtivacao.solicitacao.situacao == \'PENDENTE\'\"><md-tooltip>Tratar</md-tooltip></ng-md-icon><ng-md-icon icon=delete style=fill:#788489 size=22 alt=Excluir ng-if=\"solicitacaoAtivacao.solicitacao.situacao == \'PENDENTE\' || solicitacaoAtivacao.solicitacao.situacao == \'NEGADA\'\" ng-click=orgaoCtrl.excluirSolicitacaoAtivacao(solicitacaoAtivacao.id)><md-tooltip>Excluir</md-tooltip></ng-md-icon><!--<ng-md-icon icon=\"create\" style=\"fill:#788489\" size=\"22\" alt=\"Tratar\"--><!--ng-click=\"acessoCtrl.tratar(solicitacao.id)\"--><!--ng-show=\"solicitacao.situacao.descricao != \'Autorizado\'\">--><!--<md-tooltip>Tratar</md-tooltip>--><!--</ng-md-icon>--></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"orgaoCtrl.solicitacoes.length > 0\" md-limit=orgaoCtrl.query.limit md-limit-options=\"[20, 50, 100]\" md-page=orgaoCtrl.query.page md-total={{orgaoCtrl.solicitacoes.length}} md-on-paginate=orgaoCtrl.consultar md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></div></div>");
$templateCache.put("scripts/orgao/views/detalhar-orgao.tmpl.html","<div class=padding-right-pagina ng-init=orgaoCtrl.recuperarOrgao()><div class=md-title-com-borda>Detalhar Órgão ou Entidade</div><form name=orgaoForm><div layout-gt-sm=row><md-input-container class=md-block flex=50><label>CNPJ</label><input name=nome ng-model=orgaoCtrl.form.cnpj disabled></md-input-container><md-input-container class=md-block flex=50><label>Nome do Órgão UGE - Órgão Superior​ ou Entidade</label><input name=orgao ng-model=orgaoCtrl.form.nome disabled></md-input-container></div><div layout-gt-sm=row><md-input-container class=md-block flex=50><label>Sigla:</label><input name=sigla ng-model=orgaoCtrl.form.sigla></md-input-container><md-input-container class=md-block flex=50><label>Código UG</label><input name=orgao ng-model=orgaoCtrl.form.codigoUg disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex-gt-sm><label>Tipo</label><input name=tipoAdministracao ng-model=orgaoCtrl.form.tipoAdministracao.descricao disabled></md-input-container><md-input-container class=md-block flex-gt-sm><label>Esfera Poder</label><input name=esferaPoder ng-model=orgaoCtrl.form.esferaPoder.descricao disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex-gt-sm><label>Poder</label><input name=poder ng-model=orgaoCtrl.form.poder.descricao disabled></md-input-container><md-input-container class=md-block flex-gt-sm><label>Situação</label><input name=situacao ng-model=orgaoCtrl.form.ativo disabled></md-input-container></div></form><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button class=md-raised ng-click=orgaoCtrl.voltarConsultarOrgao()>Voltar</md-button></div></div>");
$templateCache.put("scripts/orgao/views/detalhar-solicit-ativacao-orgao.tmpl.html","<div layout-xs=column ng-init=orgaoCtrl.recuperarSolicitAtivacaoOrgao();><h1 class=md-title-com-borda>Visualizar Pedido de Ativação de Unidade Executora</h1><form name=solicitarAtivacaoOrgaoForm><div flex=90 flex-offset=5><div class=texto-secundario>Solicitante</div><md-divider></md-divider><div flex-offset=5><div><p>CPF: {{ orgaoCtrl.form.solicitante.cpf}}</p><p>Nome: {{ orgaoCtrl.form.solicitante.nome}}</p><p>E-mail: {{ orgaoCtrl.form.solicitante.email}}</p></div></div></div><br><section flex=90 flex-offset=5><div class=texto-secundario>Dados da Unidade Executora</div><md-divider></md-divider><section flex-offset=5><div ng-if=orgaoCtrl.form.organizacao><p layout=row>Unidade Executora: {{orgaoCtrl.form.organizacao.nome}}</p><p layout=row>CNPJ: {{orgaoCtrl.form.organizacao.cnpj}}</p><p layout=row>Código UG(SIAFI): {{orgaoCtrl.form.organizacao.codigoUg}}</p><div layout=row><p flex=25>Tipo: {{orgaoCtrl.form.organizacao.tipoAdministracao.descricao}}</p><p flex=25>Esfera: {{orgaoCtrl.form.organizacao.esferaPoder.descricao}}</p><p flex=25>Poder: {{orgaoCtrl.form.organizacao.poder.descricao}}</p></div></div><div ng-if=!orgaoCtrl.form.organizacao><p layout=row>Entidade: {{orgaoCtrl.form.nomeEntidade}}</p><p layout=row>CNPJ: {{orgaoCtrl.form.cnpjEntidade}}</p><p layout=row>Código UG(SIAFI): {{orgaoCtrl.form.codUgEntidade}}</p><p layout=row>Tipo: {{orgaoCtrl.form.tipoEntidade.descricao}}</p></div><br>Localização da sede<div layout=row flex-offset=5><p flex=20>Endereço: xxxxxxxxxxxx</p><p flex=20>CEP: xx.xxx/xxx</p><p flex=20>Estado: xx</p><p flex=20>Município: YYYYY</p></div><div layout=row><p flex=20>Telefone: {{orgaoCtrl.form.telefone}}</p><p flex=20>E-mail: {{orgaoCtrl.form.emailInstitucional}}</p></div></section></section><br><section flex=90 flex-offset=5><div class=texto-secundario>Autorização</div><md-divider></md-divider><section flex-offset=5><br><section layout=row layout-align=\"left center\"><md-radio-group ng-model=orgaoCtrl.form.exigeCertificadoDigital layout=row><md-radio-button ng-value=true disabled>Com certificado</md-radio-button><br><md-radio-button ng-value=false disabled>Sem certificado</md-radio-button></md-radio-group></section><br><section><md-button class=\"md-primary md-raised\" ng-href=data:image/JPEG;base64,{{orgaoCtrl.form.formularioAutorizacao.dado}} download={{orgaoCtrl.form.formularioAutorizacao.nome}}>Visualizar Formulário de Autorização</md-button></section></section></section><section flex=90 flex-offset=5><div class=texto-secundario>Responsável Legal da Unidade Executora Requerente</div><md-divider></md-divider><section flex-offset=5><br><section layout=row><section><p>CPF: {{ orgaoCtrl.form.responsavelOrgao.cpf}}</p><p>Nome: {{ orgaoCtrl.form.responsavelOrgao.nome}}</p><p>E-mail: {{ orgaoCtrl.form.responsavelOrgao.email}}</p></section></section><br><div flex=50><md-button class=\"md-primary md-raised\" ng-href=data:image/JPEG;base64,{{orgaoCtrl.form.documentoComprobatorioResponsavel.dado}} download={{orgaoCtrl.form.documentoComprobatorioResponsavel.nome}}>Visualizar Documento comprobatório do Responsável Legal</md-button><br><md-button class=\"md-primary md-raised\" flex=100 ng-href=data:image/JPEG;base64,{{orgaoCtrl.form.documentoComprobatorioResponsavel.dado}} download={{orgaoCtrl.form.documentoComprobatorioResponsavel.nome}}>Visualizar Cópia de RG e CPF do Responsável Legal</md-button></div><br><br><section ng-show=\"orgaoCtrl.form.organizacao.tipoOrganizacao == \'Órgão superior\'\">Informações sobre Ato Comprobatório da Competência anexado a este formulário<div layout=row layout-align=\"center center\"><md-input-container class=md-block flex=25>Tipo do ato: {{orgaoCtrl.form.tipoAtoNomeacaoResponsavel}}</md-input-container><md-input-container class=md-block flex=25>Nº: {{orgaoCtrl.form.numeroAtoNomeacaoResponsavel}}</md-input-container><div class=md-block flex=25>Data do ato: {{orgaoCtrl.form.dataAtoNomeacaoResponsavel | date : \"dd/MM/yyyy\"}}</div></div><div layout=row layout-align=\"center center\"><md-input-container class=md-block flex=25>Seção: {{orgaoCtrl.form.secaoAtoNomeacaoResponsavel}}</md-input-container><md-input-container class=md-block flex=25>Página: {{orgaoCtrl.form.paginaAtoNomeacaoResponsavel}}</md-input-container><div class=md-block flex=25>Data da publicação: {{orgaoCtrl.form.dataPublicacaoAtoNomeacaoResponsavel | date : \"dd/MM/yyyy\"}}</div></div></section></section></section><section flex=90 flex-offset=5><div class=texto-secundario>Usuários administradores</div><md-divider></md-divider><section flex-offset=5><br><section ng-show=\"orgaoCtrl.form.administradores.length > 0\"><br><section layout=row><md-card flex=95><md-table-container><table md-table><thead md-head><tr md-row><th md-column style=\"text-align: center\"><span>CPF</span></th><th md-column style=\"text-align: center\"><span>Nome</span></th><th md-column style=\"text-align: center\"><span>E-mail</span></th><th md-column style=\"text-align: center\"><span>Permissão especial**</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"administrador in orgaoCtrl.form.administradores\"><td md-cell style=\"text-align: center\">{{administrador.cpf}}</td><td md-cell style=\"text-align: center\">{{administrador.nome}}</td><td md-cell style=\"text-align: center\">{{administrador.email}}</td><td md-cell style=\"text-align: center\"><md-checkbox ng-checked=\"orgaoCtrl.form.responsavelImoveis.indexOf(administrador) > -1\" disabled></md-checkbox></td></tr></tbody></table></md-table-container></md-card></section><p>**Administradores que possuem permissão especial para representar a Unidade Executora requerente em assinaturas de contrato e termos tendo por objeto bens imóveis.</p></section></section></section><br><section flex=90 flex-offset=5><div class=texto-secundario>Sistemas Autorizados a serem utilizados pelas Unidades Executoras</div><md-divider></md-divider><section flex-offset=5><br><section flex=90 flex-offset=5 ng-show=\"orgaoCtrl.formAvaliacaoSolicitacao.modulos.length > 0\"><section flex-offset=5><md-card flex=95><md-table-container><table md-table><thead md-head><tr md-row><th md-column style=\"text-align: center\"><span>Sistema</span></th><th md-column style=\"text-align: center\"><span>Módulo</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"modulo in orgaoCtrl.formAvaliacaoSolicitacao.modulos\"><td md-cell style=\"text-align: center\">{{modulo.modulo.sistema.nome}}</td><td md-cell style=\"text-align: center\">{{modulo.modulo.nome}}</td></tr></tbody></table></md-table-container></md-card></section></section></section><div ng-show=orgaoCtrl.form.avaliacao><h1 class=md-title-com-borda>Manifestação do Gestor</h1><section flex=90 flex-offset=5><section><p>Usuário: {{ orgaoCtrl.form.avaliacao.avaliador.cpf}} - {{ orgaoCtrl.form.avaliacao.avaliador.nome}}</p><p>Data: {{ orgaoCtrl.form.avaliacao.data | date : \'dd/MM/yyyy\' }}</p><p>Decisão: {{ orgaoCtrl.form.avaliacao.situacao}}</p><p ng-show=\"orgaoCtrl.form.avaliacao.situacao == \'NEGADA\'\">Manifestação do Gestor: {{ orgaoCtrl.form.avaliacao.observacao}}</p></section></section></div><div layout=row layout-align=end><md-button class=md-raised ng-click=orgaoCtrl.voltarConsultarSolicitAtivacaoOrgao()>Voltar</md-button></div></section></form></div>");
$templateCache.put("scripts/orgao/views/editar-orgao.tmpl.html","<div class=padding-right-pagina ng-init=\"orgaoCtrl.carregarOrgaos(); orgaoCtrl.recuperarOrgao();\n      orgaoCtrl.consultarTipoAdministracao(); orgaoCtrl.consultarPoder(); orgaoCtrl.consultarEsferasPoder();\"><div class=md-title-com-borda>Editar Órgão UGE - Órgão Superior​ ou Entidade</div><form name=orgaoForm novalidate><div layout=row><md-input-container class=md-block flex=50><label>CNPJ:</label><input name=cnpj ng-model=orgaoCtrl.form.cnpj cpf-cnpj-mask></md-input-container><md-input-container class=md-block flex=50><label>Nome do Órgão UGE - Órgão Superior​ ou Entidade:</label><input name=nome ng-model=orgaoCtrl.form.nome required><div ng-messages=orgaoForm.nome.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Sigla:</label><input name=sigla ng-model=orgaoCtrl.form.sigla></md-input-container><md-input-container class=md-block flex=50><label>Código UG:</label><input name=codigoUg ng-model=orgaoCtrl.form.codigoUg></md-input-container></div><div layout=row><md-input-container flex=50><label>Tipo:</label><md-select name=tipoAdministracao ng-model=orgaoCtrl.form.tipoAdministracao ng-model-options=\"{trackBy: \'$value.id\'}\" required><md-option ng-repeat=\"tipoAdministracao in orgaoCtrl.tiposAdministracao\" ng-value=tipoAdministracao>{{tipoAdministracao.descricao}}</md-option></md-select><div ng-messages=orgaoForm.tipoAdministracao.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=50><label>Esfera:</label><md-select name=esferaPoder ng-model=orgaoCtrl.form.esferaPoder ng-disabled=orgaoCtrl.isTipoAdministracaoEspecialDesabilitar() ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"esfera in orgaoCtrl.esferasPoder\" ng-value=esfera>{{esfera.descricao}}</md-option></md-select></md-input-container></div><div layout=row><md-input-container flex=50><label>Poder:</label><md-select ng-model=orgaoCtrl.form.poder ng-disabled=orgaoCtrl.isTipoAdministracaoEspecialDesabilitar() ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"poder in orgaoCtrl.poderes\" ng-value=poder>{{poder.descricao}}</md-option></md-select></md-input-container></div><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button class=md-raised ng-click=orgaoCtrl.voltarConsultarOrgao()>Voltar</md-button><md-button class=md-raised ng-click=orgaoCtrl.limpar()>Limpar</md-button><md-button type=submit class=md-raised ng-disabled=orgaoCtrl.desabilitarGravar() ng-click=orgaoCtrl.salvarEdicao()>Gravar</md-button></div></form></div>");
$templateCache.put("scripts/orgao/views/solicitar-ativacao-orgao.tmpl.html","<div class=padding-right-pagina ng-init=\"orgaoCtrl.carregarUsuario(); orgaoCtrl.consultar(); orgaoCtrl.recuperarFormularioPadrao()\"><div class=md-title-com-borda>Pedido de Ativação de Unidade</div><form name=solicitarAtivacaoOrgaoForm><div><div class=texto-secundario>Solicitante</div><div><ul><li>Através desse formulário é possível solicitar a ativação de uma Unidade para acessar sistemas de informação da Secretaria de Patrimônio da União.</li><li>Se você já é um usuário cadastrado, por favor, informe seu nome ou CPF.</li><li>Caso o seu cadastro não seja encontrado, será solicitado que você informe alguns dados pessoais.</li></ul><div layout=row><md-input-container flex=80><label>Nome ou CPF:</label><md-chips ng-model=orgaoCtrl.solicitantesSelecionados md-transform-chip=orgaoCtrl.transformChip($chip) md-require-match=true required><md-autocomplete md-no-cache=true md-input-minlength=3 md-delay=700 md-selected-item=orgaoCtrl.solicitacao.solicitante md-search-text=orgaoCtrl.filtroSolicitante md-items=\"item in orgaoCtrl.pesquisarSolicitante(orgaoCtrl.filtroSolicitante)\" md-item-text=item.nome md-select-on-match=true placeholder=\"Informe o nome ou CPF\"><md-item-template><span md-highlight-text=orgaoCtrl.filtroSolicitante>{{item.nome}}</span></md-item-template><md-not-found><md-button ng-click=\"orgaoCtrl.showFormCadastroSolicitante=true\">Cadastrar usuário</md-button></md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip.nome}}</strong></span></md-chip-template></md-chips></md-input-container></div><div ng-show=orgaoCtrl.showFormCadastroSolicitante layout=row><div flex=80 layout=column class=border-tabela><div layout=row><md-input-container flex=30><label>CPF:</label><input name=cpfSolicitante ng-model=orgaoCtrl.formSolicitante.cpf ui-br-cpf-mask><div ng-messages=solicitarAtivacaoOrgaoForm.cpfSolicitante.$error><div ng-message=cpf><small>CPF inválido</small></div></div></md-input-container><md-input-container flex=70><label>Nome:</label><input name=nomeSolicitante ng-model=orgaoCtrl.formSolicitante.nome></md-input-container></div><div><md-input-container class=md-block><label>E-mail:</label><input type=email name=emailSolicitante ng-model=orgaoCtrl.formSolicitante.email><div ng-messages=solicitarAtivacaoOrgaoForm.emailSolicitante.$error><div ng-message=email><small>Email inválido</small></div></div></md-input-container></div><div layout=row layout-align=end><md-button class=md-raised ng-click=orgaoCtrl.fecharFormSolicitante()>Cancelar</md-button><md-button class=md-raised ng-disabled=orgaoCtrl.desabilitarSalvarSolicitante() ng-click=orgaoCtrl.salvarSolicitante()>Gravar</md-button></div></div></div></div></div><div><div class=texto-secundario>Dados da Unidade</div><div><ul><li>Informe a Unidade que deverá ser ativado para ter acesso aos sistemas.</li><li>Caso o seu cadastro não seja encontrado, será solicitado que você informe alguns dados pessoais.</li></ul><div><section layout=row><md-input-container flex=30><label>Tipo:</label><md-select name=tipoAdministracao ng-model=orgaoCtrl.query.tipoAdministracaoId md-on-open=orgaoCtrl.consultarTipoAdministracao() required><md-option ng-repeat=\"tipoAdministracao in orgaoCtrl.tiposAdministracao\" ng-value=tipoAdministracao.id>{{tipoAdministracao.descricao}}</md-option></md-select><div ng-messages=solicitarAtivacaoOrgaoForm.tipoAdministracao.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=25><label>Esfera:</label><md-select name=esferaPoder ng-model=orgaoCtrl.query.esferaId md-on-open=orgaoCtrl.consultarEsferasPoder() ng-disabled=orgaoCtrl.isTipoAdministracaoEspecialDesabilitar()><md-option ng-repeat=\"esfera in orgaoCtrl.esferasPoder\" ng-value={{esfera.id}}>{{esfera.descricao}}</md-option></md-select><div ng-messages=solicitarAtivacaoOrgaoForm.esferaPoder.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container flex=25><label>Poder:</label><md-select name=poder ng-model=orgaoCtrl.query.poderId md-on-open=orgaoCtrl.consultarPoder() ng-disabled=orgaoCtrl.isTipoAdministracaoEspecialDesabilitar()><md-option ng-repeat=\"poder in orgaoCtrl.poderes\" ng-value=poder.id>{{poder.descricao}}</md-option></md-select><div ng-messages=solicitarAtivacaoOrgaoForm.poder.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></section></div><br><section ng-show=\"orgaoCtrl.showFormCadastroEntidade && (orgaoCtrl.query.tipoAdministracaoId === 15 || orgaoCtrl.query.tipoAdministracaoId === 16)\" layout=row style=\"margin-bottom: 2%\"><md-content flex=80 style=\"border: solid #34aa53 1px\" class=md-primary.md-hue-2><md-input-container class=md-block><label>CNPJ:</label><input name=cnpjOrgaoEntidade ng-model=orgaoCtrl.formCadastroEntidade.cnpj cpf-cnpj-mask><div ng-messages=solicitarAtivacaoOrgaoForm.cnpjOrgaoEntidade.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=cnpj><small>CNPJ inválido</small></div></div></md-input-container><md-input-container class=md-block><label>Entidade:</label><input name=nomeOrgaoEntidade ng-model=orgaoCtrl.formCadastroEntidade.nome><div ng-messages=solicitarAtivacaoOrgaoForm.nomeOrgaoEntidade.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block><label>Código UG(SIAFI):</label><input name=codigoOrgaoEntidade ng-model=orgaoCtrl.formCadastroEntidade.codigoUg><div ng-messages=solicitarAtivacaoOrgaoForm.codigoOrgaoEntidade.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><section layout=row layout-align=center><md-button class=\"md-primary md-raised\" ng-disabled=orgaoCtrl.desabilitarSalvarEntidade() ng-click=orgaoCtrl.salvarEntidade()>Gravar</md-button><md-button class=md-raised ng-click=orgaoCtrl.fecharFormCadastroEntidade()>Cancelar</md-button></section></md-content></section><section flex=80 layout-margin=10 style=margin-left:0px><label>Unidade Executora:</label><md-autocomplete ng-model=orgaoCtrl.form.organizacao placeholder=\"Informe o nome ou código\" md-selected-item=orgaoCtrl.form.organizacao md-search-text=orgaoCtrl.filtroNomeOrgao md-items=\"unidade in orgaoCtrl.carregarUnidadePorNome()\" md-item-text=unidade.nome md-no-cache=true md-input-minlength=3 md-delay=700 style=margin-left:0px><span md-highlight-text=orgaoCtrl.filtroNomeOrgao>{{unidade.codigoUg}} - {{unidade.nome}}</span><md-not-found><md-button ng-show=\"orgaoCtrl.query.tipoAdministracaoId === 15 || orgaoCtrl.query.tipoAdministracaoId === 16\" ng-click=\"orgaoCtrl.showFormCadastroEntidade=true\">Cadastrar entidade</md-button></md-not-found></md-autocomplete><div ng-messages=orgaoCtrl.orgaos.$error><div ng-message=required><small>Campo obrigatório</small></div></div></section><div ng-if=orgaoCtrl.form.organizacao><p layout=row>CNPJ: {{orgaoCtrl.form.organizacao.cnpj}}</p><p layout=row>Código UG(SIAFI): {{orgaoCtrl.form.organizacao.codigoUg}}</p><p>Localização da sede</p><div layout=row><p flex=20>Endereço: xxxxxxxxxxxx</p><p flex=20>CEP: xx.xxx/xxx</p><p flex=20>Estado: xx</p><p flex=20>Município: YYYYY</p></div><div layout=row><md-input-container class=md-block flex=20><label>Telefone:</label><input type=tel name=telefone ng-model=orgaoCtrl.form.telefone ng-required=orgaoCtrl.form.organizacao ui-br-phone-number><div ng-messages=solicitarAtivacaoOrgaoForm.telefone.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=30><label>E-mail institucional:</label><input type=email name=email ng-model=orgaoCtrl.form.emailInstitucional autocomplete=off ng-required=orgaoCtrl.form.organizacao><div ng-messages=solicitarAtivacaoOrgaoForm.email.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=email><small>Email inválido</small></div></div></md-input-container><md-input-container class=md-block flex=30><label>Confirmar e-mail institucional:</label><input type=email name=emailConfirmacao ng-model=orgaoCtrl.form.emailInstitucionalConfirmacao autocomplete=off ng-required=orgaoCtrl.form.organizacao><div ng-messages=solicitarAtivacaoOrgaoForm.emailConfirmacao.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=email><small>Email inválido</small></div><div ng-if=\"orgaoCtrl.form.emailInstitucionalConfirmacao && orgaoCtrl.form.emailInstitucional != orgaoCtrl.form.emailInstitucionalConfirmacao\"><small>A confirmação de email não coincide</small></div></div></md-input-container></div></div></div></div><div><div class=texto-secundario>Autorização</div><div><ul><li>Informe como será feito o acesso aos sistemas.</li><li>Indique se será usado ou não certificado digital.<ng-md-icon class=tooltip icon=help style=fill:#788489 size=22 alt=Autorização ng-click=\"orgaoCtrl.apresentarAjuda(\'A solicitação de acesso ao sistema poderá ser apenas\n                              realizada: Se órgão da Administração direta do Poder Executivo Federal: pelo representante\n                              legal do Ministério ao qual se vincula, ou pela autoridade deste designada regimental ou\n                              especialmente para tal fim; Se órgão da Administração direta municipal ou estadual: pelo\n                              respectivo chefe do Poder Executivo;\')\"></ng-md-icon></li></ul><div layout=row style=\"margin-left: 5%\"><md-radio-group ng-model=orgaoCtrl.form.exigeCertificadoDigital layout=row><md-radio-button ng-value=true>Com certificado</md-radio-button><br><md-radio-button ng-value=false>Sem certificado</md-radio-button></md-radio-group></div><ul><li>No link abaixo, é possivel fazer o download do formulário padrão de solicitação de ativação de Unidade.</li></ul><div layout=row><md-button class=md-raised ng-click=orgaoCtrl.downloadFormularioPadrao()>Download<md-tooltip md-direction=right>Download Formulário de Autorização</md-tooltip></md-button></div><ul><li>Baixe o arquivo, preencha e use o campo \"Upload do Formulário de Autorização\" para enviar uma cópia do arquivo assinado.</li></ul><div><lf-ng-md-file-input name=docFormAutorizacao lf-files=orgaoCtrl.formularioAutorizacao flex=40 lf-filesize=5MB lf-totalsize=10MB accept=application/pdf lf-placeholder=\"Upload do Formulário de Autorização (pdf)\" lf-remove-label=Remover lf-browse-label=Procurar... lf-required></lf-ng-md-file-input></div><div ng-messages=solicitarAtivacaoOrgaoForm.docFormAutorizacao.$error style=color:red><div ng-message=required>Obrigatório.</div><div ng-message=filesize>O arquivo excede o limite de 5MB</div><div ng-message=totalsize>A requisição excede o limite de 10MB</div></div></div></div><div style=\"margin-bottom: 1%\"><div class=texto-secundario>Responsável Legal da Unidade Executora Requerente</div><div><ul><li>Informe os dados do Responsável legal da Unidade.</li><li>Também é necessário enviar alguns documentos que comprovem que a pessoa informada é realmente o representante legal.</li></ul><div layout=row><md-input-container class=md-block flex=80><label>Nome ou CPF:</label><md-chips ng-model=orgaoCtrl.responsaveisSelecionados md-transform-chip=orgaoCtrl.transformChip($chip) md-require-match=true md-on-add=orgaoCtrl.adicionarResponsavelAdministrador(orgaoCtrl.responsaveisSelecionados) md-on-remove=orgaoCtrl.removerResponsavelAdministrador(orgaoCtrl.responsaveisSelecionados) required><md-autocomplete placeholder=\"Informe o nome ou CPF\" md-selected-item=orgaoCtrl.form.responsavelSelecionado md-search-text=orgaoCtrl.filtroResponsavel md-items=\"item in orgaoCtrl.pesquisarResponsavel()\" md-item-text=item.nome md-no-cache=true md-input-minlength=3 md-delay=700><span md-highlight-text=orgaoCtrl.filtroResponsavel>{{item.nome}}</span><md-not-found><md-button ng-click=\"orgaoCtrl.showFormCadastroResponsavel=true\">cadastrar usuário</md-button></md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip.nome}}</strong></span></md-chip-template></md-chips></md-input-container></div><div ng-show=orgaoCtrl.showFormCadastroResponsavel flex=80 layout=column class=border-tabela style=\"margin-bottom: 2%\"><div><div layout=row><md-input-container class=md-block flex=30><label>CPF:</label><input name=cpfResponsavel ng-model=orgaoCtrl.formResponsavel.cpf ui-br-cpf-mask><div ng-messages=solicitarAtivacaoOrgaoForm.cpfResponsavel.$error><div ng-message=cpf><small>CPF inválido</small></div></div></md-input-container><md-input-container class=md-block flex=70><label>Nome:</label><input name=nomeResponsavel ng-model=orgaoCtrl.formResponsavel.nome></md-input-container></div><div><md-input-container class=md-block><label>E-mail:</label><input type=email name=emailResponsavel ng-model=orgaoCtrl.formResponsavel.email><div ng-messages=solicitarAtivacaoOrgaoForm.emailResponsavel.$error><div ng-message=email><small>Email inválido</small></div></div></md-input-container></div><div layout=row layout-align=end><md-button class=md-raised ng-click=orgaoCtrl.fecharFormResponsavel()>Cancelar</md-button><md-button class=md-raised ng-disabled=orgaoCtrl.desabilitarSalvarAdministrador() ng-click=orgaoCtrl.salvarSolicitante()>Gravar</md-button></div></div></div><div layout=row style=\"margin-bottom: 2%\"><div layout=column flex=40><div layout=row><lf-ng-md-file-input flex=90 class=md-block name=documentoComprobatorioResponsavel lf-files=orgaoCtrl.documentoComprobatorioResponsavel lf-required lf-filesize=5MB lf-totalsize=10MB accept=application/pdf lf-placeholder=\"Documento comprobatório do Responsável Legal (pdf)\" lf-remove-label=Remover lf-browse-label=Procurar...></lf-ng-md-file-input><div flex=10 style=\"margin-top: 1.5%; text-align: center\"><ng-md-icon class=tooltip icon=help style=fill:#788489 size=22 alt=Autorização ng-click=\"orgaoCtrl.apresentarAjuda(\'A qualificação do representante legal deverá ser comprovada mediante inserção de cópia\n                            digitalizada do ato que delegue competência para representar o órgão ou entidade, ainda que especificamente para acesso ao sistema\n                            (portaria de nomeação ou investidura no cargo, ata de eleição/posse da Diretoria ou instrumento equivalente)\')\"></ng-md-icon></div></div><div layout=row ng-messages=solicitarAtivacaoOrgaoForm.documentoComprobatorioResponsavel.$error style=color:red><div ng-message=required>Obrigatório.</div><div ng-message=filesize>O arquivo excede o limite de 5MB</div><div ng-message=totalsize>A requisição excede o limite de 10MB</div><div ng-message=mimetype>O arquivo deve ser uma imagem</div></div></div><div layout=column flex=40><div layout=row><lf-ng-md-file-input class=md-block flex=90 name=documentoPessoalResponsavel lf-files=orgaoCtrl.documentoPessoalResponsavel lf-required lf-filesize=5MB lf-totalsize=10MB accept=application/pdf lf-placeholder=\"Cópia de RG e CPF do Responsável Legal (pdf)\" lf-remove-label=Remover lf-browse-label=Procurar...></lf-ng-md-file-input><div flex=10 style=\"margin-top: 1.5%; text-align: center\"><ng-md-icon class=tooltip icon=help style=fill:#788489 size=22 alt=Autorização ng-click=\"orgaoCtrl.apresentarAjuda(\'A qualificação do representante legal deverá ser comprovada mediante inserção de cópia\n                            digitalizada do ato que delegue competência para representar o órgão ou entidade, ainda que especificamente para acesso ao sistema\n                            (portaria de nomeação ou investidura no cargo, ata de eleição/posse da Diretoria ou instrumento equivalente)\')\"></ng-md-icon></div></div><div layout=row flex=10 ng-messages=solicitarAtivacaoOrgaoForm.documentoPessoalResponsavel.$error style=color:red><div ng-message=required>Obrigatório.</div><div ng-message=filesize>O arquivo excede o limite de 5MB</div><div ng-message=totalsize>A requisição excede o limite de 10MB</div><div ng-message=mimetype>O arquivo deve ser uma imagem</div></div></div></div><div ng-show=\"!orgaoCtrl.isTipoAdministracaoEspecialDesabilitar() && orgaoCtrl.query.tipoAdministracaoId\">Informações sobre Ato Comprobatório da Competência anexado a este formulário<div layout=row layout-align=left><div layout=column flex=40><div layout=row><md-input-container flex=70 style=\"margin-bottom: 0\"><label>Tipo do ato:</label><input name=tipoAto ng-model=orgaoCtrl.form.tipoAtoNomeacaoResponsavel ng-required=!orgaoCtrl.isTipoAdministracaoEspecialSolicitarAtivacaoOrgao()><div ng-messages=solicitarAtivacaoOrgaoForm.tipoAto.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><div flex=15 style=\"padding-left: 2%; padding-top: 4%\"><ng-md-icon class=tooltip icon=help style=\"fill:#788489; text-align: center\" size=22 alt=Autorização ng-click=\"orgaoCtrl.apresentarAjuda(\'Lei, Decreto, Decreto-lei, Regimento Interno, Resolução, Portaria e etc...\')\"></ng-md-icon></div></div></div><div layout=column flex=40><md-input-container class=md-block style=\"margin-bottom: 0\"><label>Nº:</label><input name=numeroAto ng-model=orgaoCtrl.form.numeroAtoNomeacaoResponsavel flex=70 md-maxlength=10 ng-pattern=/^[0-9_]*$/ ng-required=!orgaoCtrl.isTipoAdministracaoEspecialSolicitarAtivacaoOrgao()><div ng-messages=solicitarAtivacaoOrgaoForm.numeroAto.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=md-maxlength><small>O campo deve ter no máximo 10 caracteres</small></div><div ng-message=pattern><small>O campo só permite o uso de números.</small></div></div></md-input-container></div></div><div layout=row layout-align=\"left center\"><div layout=column flex=40><md-input-container class=md-block style=\"margin-bottom: 0; margin-top: 0\"><label>Seção:</label><input name=secao ng-model=orgaoCtrl.form.secaoAtoNomeacaoResponsavel flex=70 md-maxlength=10 ng-pattern=/^[0-9_]*$/ ng-required=!orgaoCtrl.isTipoAdministracaoEspecialSolicitarAtivacaoOrgao()><div ng-messages=solicitarAtivacaoOrgaoForm.secao.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=md-maxlength><small>O campo deve ter no máximo 10 caracteres</small></div><div ng-message=pattern><small>O campo só permite o uso de números.</small></div></div></md-input-container></div><div layout=column flex=40><md-input-container class=md-block style=\"margin-bottom: 0; margin-top: 0\"><label>Página:</label><input name=pagina ng-model=orgaoCtrl.form.paginaAtoNomeacaoResponsavel flex=70 md-maxlength=10 ng-pattern=/^[0-9_]*$/ ng-required=!orgaoCtrl.isTipoAdministracaoEspecialSolicitarAtivacaoOrgao()><div ng-messages=solicitarAtivacaoOrgaoForm.pagina.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=md-maxlength><small>O campo deve ter no máximo 10 caracteres</small></div><div ng-message=pattern><small>O campo só permite o uso de números.</small></div></div></md-input-container></div></div><div layout=row layout-align=\"left center\"><div layout=column flex=40><div layout=row layout-align=\"start center\"><div flex=30><span class=espaco-label-data>Data da publicação:</span></div><md-datepicker name=dataPublicacao ng-model=orgaoCtrl.form.dataPublicacaoAtoNomeacaoResponsavel ng-model=orgaoCtrl.form.dataPublicacao md-placeholder=\"Data do ato\" ng-required=!orgaoCtrl.isTipoAdministracaoEspecialSolicitarAtivacaoOrgao()></md-datepicker><div ng-messages=solicitarAtivacaoOrgaoForm.dataPublicacao.$error><div ng-message=required><small>Campo obrigatório</small></div></div></div></div><div layout=column flex=40><div layout=row layout-align=\"start center\"><div flex=30><span class=espaco-label-data>Data Final:</span></div><md-datepicker name=dataAto ng-model=orgaoCtrl.form.dataAtoNomeacaoResponsavel md-placeholder=\"Data do ato\" ng-required=!orgaoCtrl.isTipoAdministracaoEspecialSolicitarAtivacaoOrgao()></md-datepicker><div ng-messages=solicitarAtivacaoOrgaoForm.dataAto.$error><div ng-message=required><small>Campo obrigatório</small></div></div></div></div></div></div></div></div><div><div class=texto-secundario>Usuários administradores</div><div><ul><li>Usuários administradores tem a responsabilidade de conceder acesso aos sistemas de informação a outras pessoas.</li><li>Indique pelo menos duas pessoas com esse papel.</li><li>Informe também se esses administradores possuem permissão especial para representar o Unidade Executora requerente em assinaturas de contrato e termos tendo por objeto bens imóveis.</li></ul><div layout=row><md-input-container class=md-block flex=80><label>Nome ou CPF:</label><md-chips ng-model=orgaoCtrl.administradoresSelecionados md-transform-chip=orgaoCtrl.transformChip($chip) md-require-match=true md-on-add=orgaoCtrl.adicionarAdministradorAuxiliar() md-on-remove=orgaoCtrl.removerAdministradorResponsavel() required><md-autocomplete placeholder=\"Informe o nome ou CPF\" md-selected-item=orgaoCtrl.administradorSelecionado md-search-text=orgaoCtrl.filtroAdministrador md-items=\"item in orgaoCtrl.pesquisarAdministrador()\" md-item-text=item.nome md-no-cache=true md-input-minlength=3 md-delay=700><span md-highlight-text=orgaoCtrl.filtroAdministrador>{{item.nome}}</span><md-not-found><md-button ng-click=\"orgaoCtrl.showFormCadastroAdministrador=true\">Cadastrar usuário</md-button></md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip.nome}}</strong></span></md-chip-template></md-chips></md-input-container></div><div flex=80 layout=column class=border-tabela ng-show=orgaoCtrl.showFormCadastroAdministrador><div layout=row><md-input-container flex=30><label>CPF:</label><input name=cpfAdministrador ng-model=orgaoCtrl.formAdministrador.cpf ui-br-cpf-mask><div ng-messages=solicitarAtivacaoOrgaoForm.cpfSolicitante.$error><div ng-message=cpf><small>CPF inválido</small></div></div></md-input-container><md-input-container flex=70><label>Nome:</label><input name=nomeAdministrador ng-model=orgaoCtrl.formAdministrador.nome></md-input-container></div><div><md-input-container class=md-block><label>E-mail:</label><input type=email name=emailAdministrador ng-model=orgaoCtrl.formAdministrador.email><div ng-messages=solicitarAtivacaoOrgaoForm.emailAdministrador.$error><div ng-message=email><small>Email inválido</small></div></div></md-input-container></div><div layout=row layout-align=end><md-button class=md-raised ng-click=orgaoCtrl.fecharFormAdministrador()>Cancelar</md-button><md-button class=md-raised ng-disabled=orgaoCtrl.desabilitarSalvarAdministrador() ng-click=orgaoCtrl.salvarAdministrador()>Gravar</md-button></div></div><div ng-show=\"orgaoCtrl.administradoresSelecionados.length > 0\"><div layout=row><div flex=80><md-table-container><table md-table><thead md-head><tr md-row><th md-column style=\"text-align: center\"><span>CPF</span></th><th md-column style=\"text-align: center\"><span>Nome</span></th><th md-column style=\"text-align: center\"><span>Permissão especial</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"administrador in orgaoCtrl.administradoresSelecionados\"><td md-cell style=\"text-align: center\">{{administrador.cpf}}</td><td md-cell style=\"text-align: center\">{{administrador.nome}}</td><td md-cell style=\"text-align: center\"><md-checkbox ng-model=administrador.responsavelImovel aria-label=\"Administrador responsável\"></md-checkbox></td></tr></tbody></table></md-table-container></div></div></div><section flex=90 flex-offset=5><div class=texto-secundario>Sistemas Autorizados a serem utilizados pela Unidade Executora</div><md-divider></md-divider><section flex-offset=5><br><div layout=row layout-align=left><md-input-container class=md-block flex=45><label>Sistema:</label><md-select name=sistema ng-model=orgaoCtrl.query.idSistema md-on-open=\"orgaoCtrl.consultarSistemasPublic(); orgaoCtrl.form.modulo={}\"><md-option ng-repeat=\"sistema in orgaoCtrl.sistemas\" ng-value={{sistema.id}}>{{sistema.nome}}</md-option></md-select></md-input-container></div><div layout=row layout-align=left><md-input-container class=md-block class=md-block flex=45><label>Módulo</label><md-select name=modulo ng-model=orgaoCtrl.form.modulo md-on-open=orgaoCtrl.carregarModulosPublic()><md-option ng-repeat=\"modulo in orgaoCtrl.modulos\" ng-value={{modulo}}>{{modulo.nome}}</md-option></md-select></md-input-container></div></section></section><br><section layout=row layout-align=center><md-button class=\"md-primary md-raised\" ng-click=orgaoCtrl.validarModuloAutorizadoSolicitacao()>Associar</md-button></section><section flex=90 flex-offset=5 ng-show=\"orgaoCtrl.formAvaliacaoSolicitacao.modulos.length > 0\"><section flex-offset=5><md-card flex=95><md-table-container><table md-table><thead md-head><tr md-row><th md-column style=\"text-align: center\"><span>Sistema</span></th><th md-column style=\"text-align: center\"><span>Módulo</span></th><th md-column style=\"text-align: center\"><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"modulo in orgaoCtrl.formAvaliacaoSolicitacao.modulos\"><td md-cell style=\"text-align: center\">{{modulo.sistema.nome}}</td><td md-cell style=\"text-align: center\">{{modulo.nome}}</td><td md-cell style=\"text-align: center\"><ng-md-icon icon=delete style=fill:#788489 size=22 alt=Excluir ng-click=orgaoCtrl.removerModuloAutorizadoSolicitacao($index)><md-tooltip>Excluir</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container></md-card></section></section><!--<br/>--><!--<div layout=\"row\" layout-align=\"center\">--><!--<div vc-recaptcha key=\"orgaoCtrl.reCaptcha\" ng-model=\"orgaoCtrl.responseCaptcha\"></div>--><!--</div>--><md-divider style=margin-top:1%></md-divider><div layout=row layout-align=end class=margin-top><md-button class=md-raised ng-click=orgaoCtrl.fecharFormUsuario()>Cancelar</md-button><md-button type=submit class=md-raised ng-click=orgaoCtrl.validarSolicitacaoAtivacaoOrgao()>Confirmar</md-button></div></div></div></form></div>");
$templateCache.put("scripts/orgao/views/tratar-solicit-ativacao-orgao.tmpl.html","<div class=padding-right-pagina ng-init=\"orgaoCtrl.recuperarSolicitAtivacaoOrgao(); orgaoCtrl.recuperaGestorAvaliador();\"><h1 class=md-title-com-borda>Tratar Pedido de Ativação de Unidade Executora</h1><form name=solicitarAtivacaoOrgaoForm><div flex=90 flex-offset=5><div class=texto-secundario>Solicitante</div><md-divider></md-divider><div flex-offset=5><div><p>CPF: {{ orgaoCtrl.form.solicitante.cpf}}</p><p>Nome: {{ orgaoCtrl.form.solicitante.nome}}</p><p>E-mail: {{ orgaoCtrl.form.solicitante.email}}</p></div></div></div><br><section flex=90 flex-offset=5><div class=texto-secundario>Dados da Unidade Executora</div><md-divider></md-divider><section flex-offset=5><div ng-if=orgaoCtrl.form.organizacao><p layout=row>Unidade Executora: {{orgaoCtrl.form.organizacao.nome}}</p><p layout=row>CNPJ: {{orgaoCtrl.form.organizacao.cnpj}}</p><p layout=row>Código UG(SIAFI): {{orgaoCtrl.form.organizacao.codigoUg}}</p><div layout=row><p flex=25>Tipo: {{orgaoCtrl.form.organizacao.tipoAdministracao.descricao}}</p><p flex=25>Esfera: {{orgaoCtrl.form.organizacao.esferaPoder.descricao}}</p><p flex=25>Poder: {{orgaoCtrl.form.organizacao.poder.descricao}}</p></div></div><div ng-if=!orgaoCtrl.form.organizacao><p layout=row>Entidade: {{orgaoCtrl.form.nomeEntidade}}</p><p layout=row>CNPJ: {{orgaoCtrl.form.cnpjEntidade}}</p><p layout=row>Código UG(SIAFI): {{orgaoCtrl.form.codUgEntidade}}</p><p layout=row>Tipo: {{orgaoCtrl.form.tipoEntidade.descricao}}</p></div><br>Localização da sede<div layout=row flex-offset=5><p flex=20>Endereço: xxxxxxxxxxxx</p><p flex=20>CEP: xx.xxx/xxx</p><p flex=20>Estado: xx</p><p flex=20>Município: YYYYY</p></div><div layout=row><p flex=20>Telefone: {{orgaoCtrl.form.telefone}}</p><p flex=20>E-mail: {{orgaoCtrl.form.emailInstitucional}}</p></div></section></section><br><section flex=90 flex-offset=5><div class=texto-secundario>Autorização</div><md-divider></md-divider><section flex-offset=5><br><section layout=row layout-align=\"left center\"><md-radio-group ng-model=orgaoCtrl.form.exigeCertificadoDigital layout=row><md-radio-button ng-value=true disabled>Com certificado</md-radio-button><br><md-radio-button ng-value=false disabled>Sem certificado</md-radio-button></md-radio-group></section><br><section><md-button class=\"md-primary md-raised\" ng-href=data:image/JPEG;base64,{{orgaoCtrl.form.formularioAutorizacao.dado}} download={{orgaoCtrl.form.formularioAutorizacao.nome}}>Visualizar Formulário de Autorização</md-button></section></section></section><section flex=90 flex-offset=5><div class=texto-secundario>Responsável Legal da Unidade Executora Requerente</div><md-divider></md-divider><section flex-offset=5><br><section layout=row><section><p>CPF: {{ orgaoCtrl.form.responsavelOrgao.cpf}}</p><p>Nome: {{ orgaoCtrl.form.responsavelOrgao.nome}}</p><p>E-mail: {{ orgaoCtrl.form.responsavelOrgao.email}}</p></section></section><br><div flex=50><md-button class=\"md-primary md-raised\" ng-href=data:image/JPEG;base64,{{orgaoCtrl.form.documentoComprobatorioResponsavel.dado}} download={{orgaoCtrl.form.documentoComprobatorioResponsavel.nome}}>Visualizar Documento comprobatório do Responsável Legal</md-button><br><md-button class=\"md-primary md-raised\" flex=100 ng-href=data:image/JPEG;base64,{{orgaoCtrl.form.documentoComprobatorioResponsavel.dado}} download={{orgaoCtrl.form.documentoComprobatorioResponsavel.nome}}>Visualizar Cópia de RG e CPF do Responsável Legal</md-button></div><br><br><section ng-show=\"orgaoCtrl.form.organizacao.tipoOrganizacao == \'Órgão superior\'\">Informações sobre Ato Comprobatório da Competência anexado a este formulário<div layout=row layout-align=\"center center\"><md-input-container class=md-block flex=25>Tipo do ato: {{orgaoCtrl.form.tipoAtoNomeacaoResponsavel}}</md-input-container><md-input-container class=md-block flex=25>Nº: {{orgaoCtrl.form.numeroAtoNomeacaoResponsavel}}</md-input-container><div class=md-block flex=25>Data do ato: {{orgaoCtrl.form.dataAtoNomeacaoResponsavel | date : \"dd/MM/yyyy\"}}</div></div><div layout=row layout-align=\"center center\"><md-input-container class=md-block flex=25>Seção: {{orgaoCtrl.form.secaoAtoNomeacaoResponsavel}}</md-input-container><md-input-container class=md-block flex=25>Página: {{orgaoCtrl.form.paginaAtoNomeacaoResponsavel}}</md-input-container><div class=md-block flex=25>Data da publicação: {{orgaoCtrl.form.dataPublicacaoAtoNomeacaoResponsavel | date : \"dd/MM/yyyy\"}}</div></div></section></section></section><section flex=90 flex-offset=5><div class=texto-secundario>Usuários administradores</div><md-divider></md-divider><section flex-offset=5><br><section ng-show=\"orgaoCtrl.form.administradores.length > 0\"><br><section layout=row><md-card flex=95><md-table-container><table md-table><thead md-head><tr md-row><th md-column style=\"text-align: center\"><span>CPF</span></th><th md-column style=\"text-align: center\"><span>Nome</span></th><th md-column style=\"text-align: center\"><span>E-mail</span></th><th md-column style=\"text-align: center\"><span>Permissão especial**</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"administrador in orgaoCtrl.form.administradores\"><td md-cell style=\"text-align: center\">{{administrador.cpf}}</td><td md-cell style=\"text-align: center\">{{administrador.nome}}</td><td md-cell style=\"text-align: center\">{{administrador.email}}</td><td md-cell style=\"text-align: center\"><md-checkbox ng-checked=\"orgaoCtrl.form.responsavelImoveis.indexOf(administrador) > -1\" disabled></md-checkbox></td></tr></tbody></table></md-table-container></md-card></section><p>**Administradores que possuem permissão especial para representar a Unidade Executora requerente em assinaturas de contrato e termos tendo por objeto bens imóveis.</p></section></section></section><br><section flex=90 flex-offset=5><div class=texto-secundario>Sistemas Autorizados a serem utilizados pelas Unidades Executoras</div><md-divider></md-divider><section flex-offset=5><br><div layout=row layout-align=left><md-input-container class=md-block flex=45><label>Sistema:</label><md-select name=sistema ng-model=orgaoCtrl.query.idSistema md-on-open=\"orgaoCtrl.consultarSistemas(); orgaoCtrl.form.modulo={}\"><md-option ng-repeat=\"sistema in orgaoCtrl.sistemas\" ng-value={{sistema.id}}>{{sistema.nome}}</md-option></md-select></md-input-container></div><div layout=row layout-align=left><md-input-container class=md-block class=md-block flex=45><label>Módulo</label><md-select name=modulo ng-model=orgaoCtrl.form.modulo md-on-open=orgaoCtrl.carregarModulos() ng-change=orgaoCtrl.carregarPermissoes()><md-option ng-repeat=\"modulo in orgaoCtrl.modulos\" ng-value={{modulo}}>{{modulo.nome}}</md-option></md-select></md-input-container></div></section></section><br><section layout=row layout-align=center><md-button class=\"md-primary md-raised\" ng-click=orgaoCtrl.validarModuloAutorizado()>Associar</md-button></section><section flex=90 flex-offset=5 ng-show=\"orgaoCtrl.formAvaliacaoSolicitacao.modulos.length > 0\"><section flex-offset=5><md-card flex=95><md-table-container><table md-table><thead md-head><tr md-row><th md-column style=\"text-align: center\"><span>Sistema</span></th><th md-column style=\"text-align: center\"><span>Módulo</span></th><th md-column style=\"text-align: center\"><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"modulo in orgaoCtrl.formAvaliacaoSolicitacao.modulos\"><td md-cell style=\"text-align: center\">{{modulo.modulo.sistema.nome}}</td><td md-cell style=\"text-align: center\">{{modulo.modulo.nome}}</td><td md-cell style=\"text-align: center\"><ng-md-icon icon=delete style=fill:#788489 size=22 alt=Excluir ng-click=orgaoCtrl.removerModuloAutorizado(modulo)><md-tooltip>Excluir</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container></md-card></section></section><h1 class=md-title-com-borda>Manifestação do Gestor</h1><section flex=90 flex-offset=5><section><p>Usuário: {{ orgaoCtrl.formAvaliacaoSolicitacao.avaliador.cpf}} - {{ orgaoCtrl.formAvaliacaoSolicitacao.avaliador.nome}}</p><p>Data: {{ orgaoCtrl.formAvaliacaoSolicitacao.data | date : \'dd/MM/yyyy\' }}</p><div layout=row layout-align=left><md-input-container class=md-block flex=45><label>Decisao</label><md-select ng-model=orgaoCtrl.formAvaliacaoSolicitacao.aprovada><md-option ng-repeat=\"opcao in orgaoCtrl.opcoesDecisao\" ng-value=\"{{ opcao.value }}\">{{opcao.key}}</md-option></md-select></md-input-container></div><div layout=row layout-align=left ng-show=\"orgaoCtrl.formAvaliacaoSolicitacao.aprovada == false\"><md-input-container class=md-block flex=45><label>Manifestação do Gestor</label><textarea name=observacao ng-model=orgaoCtrl.formAvaliacaoSolicitacao.observacao ng-required=\"orgaoCtrl.formAvaliacaoSolicitacao.aprovada == false\" md-maxlength=150></textarea><div ng-messages=solicitarAtivacaoOrgaoForm.observacao.$error><div ng-message=md-maxlength>O campo deve ter no máximo 150 caracteres</div></div></md-input-container></div></section></section><br><div layout=row layout-align=center><md-button class=md-raised ng-click=orgaoCtrl.voltarConsultarSolicitAtivacaoOrgao()>Voltar</md-button><md-button type=submit class=\"md-primary md-raised\" ng-click=orgaoCtrl.tratarSolicitacaoAtivacaoOrgao()>Responder</md-button></div></form></div>");
$templateCache.put("scripts/perfil/views/cadastrar-perfil.tmpl.html","<div class=padding-right-pagina><div class=md-title-com-borda>Cadastrar Perfil</div><form name=formPerfil novalidate><div layout=column><div layout=row><md-input-container flex=50><label>Sistema do Perfil</label><md-select name=sistema ng-model=perfilCtrl.query.idSistema md-on-open=perfilCtrl.carregarSistemas()><md-option ng-repeat=\"sistema in perfilCtrl.sistemas\" value={{sistema.id}}>{{sistema.nome}}</md-option></md-select></md-input-container><md-input-container flex=50><label>Módulo do Perfil</label><md-select name=modulo ng-model=perfilCtrl.form.modulo md-on-open=perfilCtrl.carregarModulos()><md-option ng-repeat=\"modulo in perfilCtrl.modulos\" ng-value={{modulo}}>{{modulo.nome}}</md-option></md-select></md-input-container></div><div layout=row><md-input-container flex=50><label>Nome do Perfil</label><input name=nome ng-model=perfilCtrl.form.nome required><div ng-messages=formPerfil.nome.$error><div ng-message=required>Campo obrigatório!</div></div></md-input-container><md-input-container flex=50><label>Descrição do Perfil</label><input name=descricao ng-model=perfilCtrl.form.descricao required md-maxlength=150><div ng-messages=formPerfil.descricao.$error><div ng-message=required>Campo obrigatório!</div><div ng-message=md-maxlength>O campo deve ter no máximo 255 caracteres</div></div></md-input-container></div><div layout=row><md-input-container flex=100><md-checkbox ng-model=perfilCtrl.form.perfilSistema aria-label=\"Perfil sistema\">Perfil Sistema</md-checkbox></md-input-container></div><md-divider></md-divider><div layout=column><label class=md-title-com-borda>Filtro de Permissões</label><div layout=row><md-input-container flex=50><label>Sistema da Permissão</label><md-select ng-form=formPerfil name=sistema_filtro_permissoes ng-model=perfilCtrl.queryFiltro.idSistema md-on-open=perfilCtrl.carregarSistemasFiltro()><md-option ng-repeat=\"sistema in perfilCtrl.sistemas_filtro_permissoes\" value={{sistema.id}}>{{sistema.nome}}</md-option></md-select></md-input-container><md-input-container flex=50><label>Módulo da Permissão</label><md-select ng-form=formPerfil name=modulos_filtro_permissoes ng-model=perfilCtrl.form.moduloFiltro md-on-open=perfilCtrl.carregarModulosFiltro() ng-change=perfilCtrl.carregarPermissoes() required><md-option ng-repeat=\"modulo in perfilCtrl.modulos_filtro_permissoes\" ng-value={{modulo}}>{{modulo.nome}}</md-option></md-select></md-input-container></div></div><div layout=row><div flex=100 ng-show=\"perfilCtrl.permissoes.length > 0\"><div style=\"border: 1px solid #ccc; padding: 10px; position: relative\"><md-table-container><table md-table md-row-select multiple ng-model=perfilCtrl.form.permissoes><thead md-head><tr md-row><th md-column md-order-by=nome ng-click=\"ordenacaoAtual=\'nome\'; direcaoOrdenacao = !direcaoOrdenacao\"><span>Nome da Permissão</span> <span ng-show=\"ordenacaoAtual==\'nome\' && !direcaoOrdenacao\"></span><!-- Seta para cima --> <span ng-show=\"ordenacaoAtual==\'nome\' && direcaoOrdenacao\"></span><!-- Seta para baixo --></th><th md-column md-order-by=codigoSistemico ng-click=\"ordenacaoAtual=\'codigoSistemico\'; direcaoOrdenacao = !direcaoOrdenacao\"><span>Código Sistêmico</span> <span ng-show=\"ordenacaoAtual==\'codigoSistemico\' && !direcaoOrdenacao\"></span> <span ng-show=\"ordenacaoAtual==\'codigoSistemico\' && direcaoOrdenacao\"></span></th><th md-column md-order-by=modulo.sistema.nome ng-click=\"ordenacaoAtual=\'modulo.sistema.nome\'; direcaoOrdenacao = !direcaoOrdenacao\"><span>Sistema da Permissão</span> <span ng-show=\"ordenacaoAtual==\'modulo.sistema.nome\' && !direcaoOrdenacao\"></span> <span ng-show=\"ordenacaoAtual==\'modulo.sistema.nome\' && direcaoOrdenacao\"></span></th><th md-column md-order-by=modulo.nome ng-click=\"ordenacaoAtual=\'modulo.nome\'; direcaoOrdenacao = !direcaoOrdenacao\"><span>Módulo da Permissão</span> <span ng-show=\"ordenacaoAtual==\'modulo.nome\' && !direcaoOrdenacao\"></span> <span ng-show=\"ordenacaoAtual==\'modulo.nome\' && direcaoOrdenacao\"></span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=permissao md-select-id=id ng-repeat=\"permissao in perfilCtrl.permissoes | orderBy:ordenacaoAtual:direcaoOrdenacao | limitTo: perfilCtrl.query.limit : (perfilCtrl.query.page -1) * perfilCtrl.query.limit\"><td md-cell>{{permissao.nome}}</td><td md-cell>{{permissao.codigoSistemico}}</td><td md-cell>{{permissao.modulo.sistema.nome}}</td><td md-cell>{{permissao.modulo.nome}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=perfilCtrl.query.limit md-limit-options=\"[20, 50, 100]\" md-page=perfilCtrl.query.page md-total={{perfilCtrl.permissoes.length}} md-on-paginate=perfilCtrl.consultar md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></div></div></div><md-divider></md-divider><div layout=row layout-align=\"end center\" style=\"position: relative; bottom: 0; right: 0\"><md-button class=md-raised ng-click=perfilCtrl.voltar();>Voltar</md-button><md-button class=md-raised ng-click=perfilCtrl.limpar();>Limpar</md-button><md-button type=submit class=md-raised ng-disabled=formPerfil.$invalid ng-click=perfilCtrl.salvar()>Gravar</md-button></div></div></form></div>");
$templateCache.put("scripts/perfil/views/consultar-perfil.tmpl.html","<div class=padding-right-pagina ng-init=perfilCtrl.inicializarConsulta();><h1 class=md-title>Consultar Perfis</h1><div layout=column layout-align=center><form name=perfilForm class=caixa-consulta><div layout=row><md-input-container flex=50 class=padding-right-input><label>Sistema</label><md-select ng-model=perfilCtrl.query.idSistema md-on-open=perfilCtrl.carregarSistemas()><md-option ng-repeat=\"sistema in perfilCtrl.sistemas\" value=\"{{ sistema.id }}\">{{sistema.nome}}</md-option></md-select></md-input-container><md-input-container flex=50><label>Módulo</label><md-select ng-model=perfilCtrl.query.idModulo md-on-open=perfilCtrl.carregarModulos()><md-option ng-repeat=\"modulo in perfilCtrl.modulos\" value=\"{{ modulo.id }}\">{{modulo.nome}}</md-option></md-select></md-input-container></div><div layout=row><md-input-container flex=100><label>Nome do Perfil</label><input ng-model=perfilCtrl.query.nome></md-input-container></div><div layout=row><md-input-container flex=100><label>Descrição</label><input ng-model=perfilCtrl.query.descricao></md-input-container></div></form><div layout=row layout-align=end class=margin-top><md-button type=reset class=md-raised ng-click=perfilCtrl.limparConsultar()>Limpar</md-button><md-button type=submit class=md-raised ng-click=perfilCtrl.consultar()>Consultar</md-button><md-button type=submit class=md-raised ng-click=perfilCtrl.criarNovoPerfil()>Novo</md-button></div></div><md-divider></md-divider><md-divider></md-divider><div layout=column><div class=md-title-com-borda>Permissões do Perfil</div></div><md-table-container><table md-table ng-model=perfilCtrl.selecionado md-progress=promise><thead md-head md-order=perfilCtrl.query.order md-on-reorder=perfilCtrl.consultar><tr md-row><th md-column md-order-by=nome><span>Nome do Perfil</span></th><th md-column md-order-by=codigoSistemico><span>Descrição do Perfil</span></th><th md-column md-order-by=modulo.sistema.nome><span>Sistema</span></th><th md-column md-order-by=modulo.nome><span>Módulo</span></th><th md-column><span>Ações</span></th></tr></thead><tbody md-body><tr ng-class=\"{desabilitada: perfil.perfilSistema}\" md-row md-select=perfil md-select-id=id md-auto-select ng-repeat=\"perfil in perfilCtrl.perfis |\n                            orderBy: perfilCtrl.query.order | limitTo: perfilCtrl.query.limit :\n                            (perfilCtrl.query.page -1) * perfilCtrl.query.limit\"><td md-cell>{{perfil.modulo.sistema.nome}}</td><td md-cell>{{perfil.modulo.nome}}</td><td md-cell>{{perfil.nome}}</td><td md-cell>{{perfil.descricao}}</td><td md-cell><ng-md-icon icon=search style=fill:#788489 size=22 alt=Detalhar ng-click=perfilCtrl.detalhar(perfil.id)><md-tooltip>Detalhar</md-tooltip></ng-md-icon><ng-md-icon id=concederAcesso_Button exibir-elemento-por-permissao=ACESSOS.CONCEDER_ACESSO_EM_LOTE icon=add style=fill:#788489 size=22 ng-click=perfilCtrl.concederAcessoEmLote(perfil.id)><md-tooltip>Conceder Acesso em Lote</md-tooltip></ng-md-icon><ng-md-icon icon=create ng-show=!perfil.perfilSistema style=fill:#788489 size=22 alt=Editar ng-click=perfilCtrl.editar(perfil.id)><md-tooltip>Editar</md-tooltip></ng-md-icon><ng-md-icon icon=delete ng-show=!perfil.perfilSistema style=fill:#788489 size=22 alt=Excluir ng-click=\"perfilCtrl.excluir($event, perfil.id)\"><md-tooltip>Excluir</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=perfilCtrl.query.limit md-limit-options=\"[20, 50, 100]\" md-page=perfilCtrl.query.page md-total={{perfilCtrl.perfis.length}} md-on-paginate=perfilCtrl.consultar md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></div>");
$templateCache.put("scripts/perfil/views/detalhar-perfil.tmpl.html","<div class=padding-right-pagina ng-init=perfilCtrl.recuperarPerfil();><h1 class=md-title-com-borda>Detalhar Perfil</h1><form name=perfilForm><div layout=row><md-input-container class=md-block flex=100><label>Nome do Perfil</label><input name=nome ng-model=perfilCtrl.form.nome disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex=100><label>Descrição do Perfil</label><input name=descricao ng-model=perfilCtrl.form.descricao disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex=100><md-checkbox ng-model=perfilCtrl.form.perfilSistema aria-label=\"Perfil sistema\" disabled>Perfil Sistema</md-checkbox></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Sistema do Perfil</label><input name=sistema ng-model=perfilCtrl.form.modulo.sistema.nome disabled></md-input-container><md-input-container class=md-block flex=50><label>Módulo do Perfil</label><input name=modulo ng-model=perfilCtrl.form.modulo.nome disabled></md-input-container></div><div class=md-title-com-borda>Permissões do Perfil</div><div layout=row class=margin-top><div flex=100 ng-show=\"perfilCtrl.form.permissoes.length > 0\"><md-table-container><table md-table><thead md-head><tr md-row><th md-column md-order-by=nome ng-click=\"ordenacaoAtual=\'nome\'; direcaoOrdenacao = !direcaoOrdenacao\"><span>Nome da Permissão</span> <span ng-show=\"ordenacaoAtual==\'nome\' && !direcaoOrdenacao\"></span><!-- Seta para cima --> <span ng-show=\"ordenacaoAtual==\'nome\' && direcaoOrdenacao\"></span><!-- Seta para baixo --></th><th md-column md-order-by=codigoSistemico ng-click=\"ordenacaoAtual=\'codigoSistemico\'; direcaoOrdenacao = !direcaoOrdenacao\"><span>Código Sistêmico</span> <span ng-show=\"ordenacaoAtual==\'codigoSistemico\' && !direcaoOrdenacao\"></span> <span ng-show=\"ordenacaoAtual==\'codigoSistemico\' && direcaoOrdenacao\"></span></th><th md-column md-order-by=modulo.sistema.nome ng-click=\"ordenacaoAtual=\'modulo.sistema.nome\'; direcaoOrdenacao = !direcaoOrdenacao\"><span>Sistema da Permissão</span> <span ng-show=\"ordenacaoAtual==\'modulo.sistema.nome\' && !direcaoOrdenacao\"></span> <span ng-show=\"ordenacaoAtual==\'modulo.sistema.nome\' && direcaoOrdenacao\"></span></th><th md-column md-order-by=modulo.nome ng-click=\"ordenacaoAtual=\'modulo.nome\'; direcaoOrdenacao = !direcaoOrdenacao\"><span>Módulo da Permissão</span> <span ng-show=\"ordenacaoAtual==\'modulo.nome\' && !direcaoOrdenacao\"></span> <span ng-show=\"ordenacaoAtual==\'modulo.nome\' && direcaoOrdenacao\"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat=\"permissao in perfilCtrl.form.permissoes |\n                                orderBy:ordenacaoAtual:direcaoOrdenacao | limitTo: perfilCtrl.query.limit :\n                                (perfilCtrl.query.page -1) * perfilCtrl.query.limit\"><td md-cell>{{permissao.nome}}</td><td md-cell>{{permissao.codigoSistemico}}</td><td md-cell>{{permissao.modulo.sistema.nome}}</td><td md-cell>{{permissao.modulo.nome}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=perfilCtrl.query.limit md-limit-options=\"[5, 10, 15]\" md-page=perfilCtrl.query.page md-total={{perfilCtrl.form.permissoes.length}} md-on-paginate=perfilCtrl.consultar md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></div></div><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button class=md-raised ng-click=perfilCtrl.voltar()>Voltar</md-button></div></form></div>");
$templateCache.put("scripts/perfil/views/editar-perfil.tmpl.html","<div class=padding-right-pagina ng-init=perfilCtrl.recuperarPerfil()><div class=md-title-com-borda>Editar Perfil</div><form name=formPerfil novalidate><div layout=row><md-input-container class=md-block flex=100><label>Nome do Perfil *</label><input name=nome ng-model=perfilCtrl.form.nome required><div ng-messages=formPerfil.nome.$error><div ng-message=required>Campo obrigatório!</div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=100><label>Descrição *</label><input name=descricao ng-model=perfilCtrl.form.descricao required md-maxlength=150><div ng-messages=formPerfil.descricao.$error><div ng-message=required>Campo obrigatório!</div><div ng-message=md-maxlength>O campo deve ter no máximo 255 caracteres</div></div></md-input-container></div><div layout=row><md-input-container class=md-block><md-checkbox ng-model=perfilCtrl.form.perfilSistema aria-label=\"Perfil sistema\">Perfil Sistema</md-checkbox></md-input-container></div><md-divider></md-divider><div layout=column><label class=md-title-com-borda>Filtro de Permissões</label><div layout=row><md-input-container flex=50><label>Sistema da Permissão</label><md-select ng-form=formPerfil name=sistema_filtro_permissoes ng-model=perfilCtrl.queryFiltro.idSistema md-on-open=perfilCtrl.carregarSistemasFiltro()><md-option ng-repeat=\"sistema in perfilCtrl.sistemas_filtro_permissoes\" value={{sistema.id}}>{{sistema.nome}}</md-option></md-select></md-input-container><md-input-container flex=50><label>Módulo da Permissão</label><md-select ng-form=formPerfil name=modulos_filtro_permissoes ng-model=perfilCtrl.form.moduloFiltro md-on-open=perfilCtrl.carregarModulosFiltro() ng-change=perfilCtrl.carregarPermissoes() required><md-option ng-repeat=\"modulo in perfilCtrl.modulos_filtro_permissoes\" ng-value={{modulo}}>{{modulo.nome}}</md-option></md-select></md-input-container></div></div><div layout=row><div flex=100 ng-show=\"perfilCtrl.permissoes.length > 0\"><div style=\"border: 1px solid #ccc; padding: 10px; position: relative\"><md-table-container><table md-table md-row-select multiple ng-model=perfilCtrl.form.permissoes><thead md-head><tr md-row><th md-order-by=nome md-column ng-click=\"ordenacaoAtual=\'nome\'; direcaoOrdenacao = !direcaoOrdenacao\"><span>Nome da Permissão</span> <span ng-show=\"ordenacaoAtual==\'nome\' && !direcaoOrdenacao\"></span><!-- Seta para cima --> <span ng-show=\"ordenacaoAtual==\'nome\' && direcaoOrdenacao\"></span><!-- Seta para baixo --></th><th md-column md-order-by=codigoSistemico ng-click=\"ordenacaoAtual=\'codigoSistemico\'; direcaoOrdenacao = !direcaoOrdenacao\"><span>Código Sistêmico</span> <span ng-show=\"ordenacaoAtual==\'codigoSistemico\' && !direcaoOrdenacao\"></span> <span ng-show=\"ordenacaoAtual==\'codigoSistemico\' && direcaoOrdenacao\"></span></th><th md-column md-order-by=modulo.sistema.nome ng-click=\"ordenacaoAtual=\'modulo.sistema.nome\'; direcaoOrdenacao = !direcaoOrdenacao\"><span>Sistema da Permissão</span> <span ng-show=\"ordenacaoAtual==\'modulo.sistema.nome\' && !direcaoOrdenacao\"></span> <span ng-show=\"ordenacaoAtual==\'modulo.sistema.nome\' && direcaoOrdenacao\"></span></th><th md-column md-order-by=modulo.nome ng-click=\"ordenacaoAtual=\'modulo.nome\'; direcaoOrdenacao = !direcaoOrdenacao\"><span>Módulo da Permissão</span> <span ng-show=\"ordenacaoAtual==\'modulo.nome\' && !direcaoOrdenacao\"></span> <span ng-show=\"ordenacaoAtual==\'modulo.nome\' && direcaoOrdenacao\"></span></th></tr></thead><tbody md-body><tr md-row md-auto-select md-select=permissao md-select-id=id ng-repeat=\"permissao in perfilCtrl.permissoes | orderBy:ordenacaoAtual:direcaoOrdenacao | limitTo: perfilCtrl.query.limit : (perfilCtrl.query.page -1) * perfilCtrl.query.limit\"><td md-cell>{{permissao.nome}}</td><td md-cell>{{permissao.codigoSistemico}}</td><td md-cell>{{permissao.modulo.sistema.nome}}</td><td md-cell>{{permissao.modulo.nome}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=perfilCtrl.query.limit md-limit-options=\"[20, 50, 100]\" md-page=perfilCtrl.query.page md-total={{perfilCtrl.permissoes.length}} md-on-paginate=perfilCtrl.consultar md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></div></div></div><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button class=md-raised ng-click=perfilCtrl.voltar()>Voltar</md-button><md-button class=md-raised ng-click=perfilCtrl.limpar();>Limpar</md-button><md-button type=submit class=md-raised ng-disabled=formPerfil.$invalid ng-click=perfilCtrl.salvarEdicao()>Gravar</md-button></div></form></div>");
$templateCache.put("scripts/permissao/views/cadastrar-permissao.tmpl.html","<div class=padding-right-pagina ng-init=permissaoCtrl.carregarAcoesHttp();><div class=md-title-com-borda>Cadastrar Permissão</div><form name=form novalidate><div layout=row><md-input-container flex=50><label>Sistema</label><md-select name=sistema ng-model=permissaoCtrl.query.idSistema md-on-open=permissaoCtrl.carregarSistemas()><md-option ng-repeat=\"sistema in permissaoCtrl.sistemas\" value={{sistema.id}}>{{sistema.nome}}</md-option></md-select></md-input-container><md-input-container flex=50><label>Módulo</label><md-select id=modulo name=modulo ng-model=permissaoCtrl.form.modulo md-on-open=permissaoCtrl.carregarModulos() required><md-option ng-repeat=\"modulo in permissaoCtrl.modulos\" ng-value={{modulo}}>{{modulo.nome}}</md-option></md-select><div ng-messages=form.modulo.$error><div ng-message=required><small>Campo obrigatorio</small></div><div ng-message=md-maxlength><small>O campo deve ter no máximo 150 caracteres</small></div></div></md-input-container></div><div layout=row><md-input-container flex=50><label>Nome da Permissão</label><input name=nome ng-model=permissaoCtrl.form.nome required md-maxlength=150 class=caixa-consulta><div ng-messages=form.nome.$error><div ng-message=required><small>Campo obrigatorio</small></div><div ng-message=md-maxlength><small>O campo deve ter no máximo 150 caracteres</small></div></div></md-input-container><md-input-container flex=50><label>Código Sistêmico</label><input name=codigoSistemico ng-model=permissaoCtrl.form.codigoSistemico required md-maxlength=150 ng-pattern=/^[a-zA-Z0-9_\\.]*$/ ><div ng-messages=form.codigoSistemico.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=md-maxlength><small>O campo deve ter no máximo 150 caracteres</small></div><div ng-message=pattern><small>O campo não permite o uso de caracteres especiais.</small></div></div></md-input-container></div><md-input-container class=md-block flex=100><label>Descrição</label><input name=descricao ng-model=permissaoCtrl.form.descricao required md-maxlength=150><div ng-messages=form.descricao.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=md-maxlength><small>O campo deve ter no máximo 150 caracteres</small></div></div></md-input-container><div layout=row><md-input-container flex=100><label>Padrão URL *</label><input name=padraoUrl ng-model=permissaoCtrl.form.padraoUrl md-maxlength=150 ng-pattern=/^[a-zA-Z0-9_/]*$/ ><div ng-messages=form.padraoUrl.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=md-maxlength><small>O campo deve ter no máximo 150 caracteres</small></div><div ng-message=pattern><small>O campo não permite o uso de caracteres especiais.</small></div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=20><md-checkbox ng-model=permissaoCtrl.form.exigeCertificadoDigital aria-label=\"Exige Certificado Digital\">Exige Certificado Digital</md-checkbox></md-input-container><md-input-container class=md-block flex=20><md-checkbox ng-model=permissaoCtrl.form.permissaoSistema aria-label=\"Permissão sistema\">Permissão Sistema</md-checkbox></md-input-container></div><div layout=row layout-margin=20 class=texto-secundario>Ações</div><div layout=row flex=100><div layout=row layout-align=\"center center\" flex=25 ng-repeat=\"acao in permissaoCtrl.acoesHttp\"><md-checkbox value={{acao}} ng-checked=\"permissaoCtrl.marcarAcao(acao, permissaoCtrl.form.acoes)\" ng-click=\"permissaoCtrl.toggle(acao, permissaoCtrl.form.acoes)\">{{ acao }}</md-checkbox></div></div></form><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button class=md-raised ng-click=permissaoCtrl.voltar();>Voltar</md-button><md-button type=button class=md-raised ng-click=permissaoCtrl.limpar()>Limpar</md-button><md-button id=salvar_Button type=submit class=md-raised ng-disabled=form.$invalid ng-click=permissaoCtrl.salvar()>Gravar</md-button></div></div>");
$templateCache.put("scripts/permissao/views/consultar-permissao.tmpl.html","<div class=padding-right-pagina ng-init=permissaoCtrl.inicializarConsulta();><h1 class=md-title>Consultar Permissões</h1><div layout=column layout-align=center><form name=permissaoForm class=caixa-consulta><div layout=row><md-input-container flex=100 class=padding-right-input><label>Sistema</label><md-select ng-model=permissaoCtrl.query.idSistema md-on-open=permissaoCtrl.carregarSistemas()><md-option ng-repeat=\"sistema in permissaoCtrl.sistemas\" value={{sistema.id}}>{{sistema.nome}}</md-option></md-select></md-input-container><md-input-container flex=100><label>Módulo</label><md-select ng-model=permissaoCtrl.query.idModulo md-on-open=permissaoCtrl.carregarModulos()><md-option ng-repeat=\"modulo in permissaoCtrl.modulos\" value=\"{{ modulo.id }}\">{{modulo.nome}}</md-option></md-select></md-input-container></div><div layout=row><div layout=row layout-align=center flex=100><md-input-container flex=50><label>Nome da Permissão</label><input ng-model=permissaoCtrl.query.nome></md-input-container><md-input-container flex=50><label>Código Sistêmico</label><input ng-model=permissaoCtrl.query.codigoSistemico></md-input-container></div></div></form><div layout=row layout-align=end class=margin-top><md-button type=reset class=md-raised ng-click=permissaoCtrl.limparConsultar()>Limpar</md-button><md-button id=consultar_Button type=submit class=md-raised ng-click=permissaoCtrl.consultar()>Consultar</md-button><md-button id=cadastrar_Button type=submit class=md-raised ng-click=permissaoCtrl.criarNovaPermissao()>Novo</md-button></div></div><div><md-table-container><table md-table ng-model=permissaoCtrl.selecionado md-progress=promise><thead md-head md-order=permissaoCtrl.query.order md-on-reorder=permissaoCtrl.consultar ng-if=\"permissaoCtrl.permissoes.length > 0\"><tr md-row><th md-column md-order-by=sistame.nome><span>Sistema</span></th><th md-column md-order-by=sistame.nome><span>Módulo</span></th><th md-column md-order-by=nome><span>Nome da Permissão</span></th><th md-column md-order-by=codigoSistemico><span>Código Sistêmico</span></th><th md-column><span>Ações</span></th></tr></thead><tbody md-body><tr ng-class=\"{desabilitada: permissao.permissaoSistema}\" md-row md-select-id=id md-auto-select ng-repeat=\"permissao in permissaoCtrl.permissoes |\n                        orderBy: permissaoCtrl.query.order | limitTo: permissaoCtrl.query.limit :\n                        (permissaoCtrl.query.page -1) * permissaoCtrl.query.limit\"><td md-cell>{{permissao.modulo.sistema.nome}}</td><td md-cell>{{permissao.modulo.nome}}</td><td md-cell>{{permissao.nome}}</td><td md-cell>{{permissao.codigoSistemico}}</td><td md-cell><ng-md-icon id=detalhar_Button icon=search style=fill:#788489 size=22 alt=Detalhar ng-click=permissaoCtrl.detalhar(permissao.id)><md-tooltip>Detalhar</md-tooltip></ng-md-icon><ng-md-icon id=alterar_Button icon=create style=fill:#788489 size=22 alt=Editar ng-click=permissaoCtrl.editar(permissao.id) ng-show=!permissao.permissaoSistema><md-tooltip>Editar</md-tooltip></ng-md-icon><ng-md-icon icon=delete style=fill:#788489 size=22 alt=Excluir ng-click=\"permissaoCtrl.excluir($event, permissao.id, permissao.modulo.sistema.nome)\" ng-show=!permissao.permissaoSistema><md-tooltip>Excluir</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"permissaoCtrl.permissoes.length > 0\" md-limit=permissaoCtrl.query.limit md-limit-options=\"[20, 50, 100]\" md-page=permissaoCtrl.query.page md-total={{permissaoCtrl.permissoes.length}} md-on-paginate=permissaoCtrl.consultar md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></div></div>");
$templateCache.put("scripts/permissao/views/detalhar-permissao.tmpl.html","<div class=padding-right-pagina ng-init=\"permissaoCtrl.recuperarPermissao(); permissaoCtrl.carregarAcoesHttp();\"><div class=md-title-com-borda>Detalhar Permissão</div><form name=permissaoForm onsubmit=permissaoCtrl.cadastrar()><div layout=row><md-input-container class=md-block flex=50><label>Sistema</label><input ng-model=permissaoCtrl.form.modulo.sistema.nome disabled></md-input-container><md-input-container class=md-block flex=50><label>Módulo</label><input ng-model=permissaoCtrl.form.modulo.nome disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Nome da Permissão</label><input ng-model=permissaoCtrl.form.nome disabled></md-input-container><md-input-container class=md-block flex=50><label>Código Sistêmico</label><input ng-model=permissaoCtrl.form.codigoSistemico disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex=100><label>Descrição</label><input ng-model=permissaoCtrl.form.descricao disabled></md-input-container></div><div layout=row><div layout=column flex=45 class=texto-cinza>Ações</div></div><div layout=row><div layout=row layout-align=\"center center\" flex=25 ng-repeat=\"acao in permissaoCtrl.acoesHttp\"><md-checkbox value={{acao}} ng-checked=\"permissaoCtrl.marcarAcao(acao, permissaoCtrl.form.acoes)\" disabled>{{ acao }}</md-checkbox></div></div><div layout=row><md-input-container class=md-block flex=100><label>Padrão URL</label><input ng-model=permissaoCtrl.form.padraoUrl disabled></md-input-container></div><div layout=row><md-checkbox ng-model=permissaoCtrl.form.exigeCertificadoDigital aria-label=\"Exige Certificado Digital\" disabled>Exige Certificado Digital</md-checkbox></div><div layout=row><md-input-container class=md-block flex=20><md-checkbox ng-model=permissaoCtrl.form.exigeCertificadoDigital aria-label=\"Exige Certificado Digital\" disabled>Exige Certificado Digital</md-checkbox></md-input-container><md-input-container class=md-block flex=20><md-checkbox ng-model=permissaoCtrl.form.permissaoSistema aria-label=\"Permissão sistema\" disabled>Permissão Sistema</md-checkbox></md-input-container></div><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button id=voltar_Button class=md-raised ng-click=permissaoCtrl.voltar()>Voltar</md-button></div></form></div>");
$templateCache.put("scripts/permissao/views/editar-permissao.tmpl.html","<div class=padding-right-pagina ng-init=permissaoCtrl.recuperarPermissao();permissaoCtrl.carregarAcoesHttp();><div class=md-title-com-borda>Editar Permissão</div><form name=permissaoForm><div layout=row><md-input-container class=md-block flex=50><label>Sistema</label><input ng-model=permissaoCtrl.form.modulo.sistema.nome disabled></md-input-container><md-input-container class=md-block flex=50><label>Módulo</label><input ng-model=permissaoCtrl.form.modulo.nome disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Nome da Permissão</label><input ng-model=permissaoCtrl.form.nome></md-input-container><md-input-container class=md-block flex=50><label>Código Sistêmico</label><input ng-model=permissaoCtrl.form.codigoSistemico></md-input-container></div><div layout=row><md-input-container class=md-block flex=100><label>Descrição</label><input ng-model=permissaoCtrl.form.descricao></md-input-container></div><div layout=row><div layout=column flex=45 class=texto-cinza>Ações</div></div><div layout=row><div layout=row flex=100><div layout=row layout-align=\"center center\" flex=25 ng-repeat=\"acao in permissaoCtrl.acoesHttp\"><md-checkbox value={{acao}} ng-checked=\"permissaoCtrl.marcarAcao(acao, permissaoCtrl.form.acoes)\" ng-click=\"permissaoCtrl.toggle(acao, permissaoCtrl.form.acoes)\">{{ acao }}</md-checkbox></div></div></div><div layout=row layout-align=center><md-input-container class=md-block flex=100><label>Padrão URL</label><input name=padraoUrl ng-model=permissaoCtrl.form.padraoUrl md-maxlength=150 ng-pattern=/^[a-zA-Z0-9_]*$/ ><div ng-messages=form.padraoUrl.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=md-maxlength><small>O campo deve ter no máximo 150 caracteres</small></div><div ng-message=pattern><small>O campo não permite o uso de caracteres especiais.</small></div></div></md-input-container></div><div layout=row layout-align=start><md-input-container class=md-block flex=20><md-checkbox ng-model=permissaoCtrl.form.exigeCertificadoDigital aria-label=\"Certificado Digital\">Certificado Digital</md-checkbox></md-input-container><md-input-container class=md-block flex=20><md-checkbox ng-model=permissaoCtrl.form.permissaoSistema aria-label=\"Permissão sistema\">Permissão Sistema</md-checkbox></md-input-container></div><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button type=reset class=md-raised ng-click=permissaoCtrl.voltar()>Voltar</md-button><md-button id=salvarEdicao_Button type=submit class=md-raised ng-click=permissaoCtrl.salvarEdicao()>Gravar</md-button></div></form></div>");
$templateCache.put("scripts/saml/views/usuarioautenticado.tmpl.html","<div layout-xs=column ng-init=samlCtrl.recuperarUsuario()>Bora ver no que vai dar...</div>");
$templateCache.put("scripts/sistema/views/cadastrar-sistema.tmpl.html","<div class=padding-right-pagina><h1 class=md-title-com-borda>Cadastrar Sistema</h1><form name=formSistema><div layout=row><md-input-container flex=70><label>Nome</label><input name=nome ng-model=sistemaCtrl.form.nome required><div ng-messages=formSistema.nome.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container><md-input-container flex=30><label>Sigla</label><input name=sigla ng-model=sistemaCtrl.form.sigla maxlength=10 required><div ng-messages=formSistema.sigla.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=100><label>Descrição</label><input name=descricao ng-model=sistemaCtrl.form.descricao required><div ng-messages=formSistema.descricao.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=70><label>Esquema</label><input name=esquema ng-model=sistemaCtrl.form.esquema required><div ng-messages=formSistema.esquema.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container><md-input-container flex=30><label>Código Sistema</label><input name=codigoSistema ng-model=sistemaCtrl.form.codigoSistema required><div ng-messages=formSistema.codigoSistema.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=70><label>Origem</label><md-select name=origem ng-model=sistemaCtrl.form.origem required><md-option ng-repeat=\"origem in sistemaCtrl.comboOrigens\" ng-value=origem>{{origem}}</md-option></md-select><div ng-messages=formSistema.origem.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><div layout=row><md-input-container flex=50><lf-ng-md-file-input lf-files=sistemaCtrl.files lf-filesize=5MB lf-totalsize=10MB lf-mimetype=image/* lf-placeholder=\"Selecione a logo do sistema\" lf-remove-label=Remover preview lf-browse-label=Procurar></lf-ng-md-file-input><div ng-messages=formSistema.files.$error style=color:red><div ng-message=filesize>O arquivo excede o limite de 5MB</div><div ng-message=totalsize>A requisição excede o limite de 10MB</div><div ng-message=mimetype>O arquivo deve ser uma imagem</div></div></md-input-container></div><span class=texto-secundario>Módulo</span><div layout=row style=margin-top:1%><md-input-container class=md-block flex=30 style=margin:0px><label>Sigla *</label><input name=moduloSigla ng-model=sistemaCtrl.formModulo.sigla><div ng-messages=formSistema.moduloSigla.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container><md-input-container class=md-block flex=70 style=margin:0px><label>Descrição *</label><input name=moduloNome ng-model=sistemaCtrl.formModulo.nome><div ng-messages=formSistema.moduloNome.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=30 style=margin:0px><label>Código Módulo *</label><input name=codigoModulo ng-model=sistemaCtrl.formModulo.codigoModulo><div ng-messages=formSistema.codigoModulo.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container><md-input-container class=md-block flex=70 style=margin:0px><label>Url *</label><input name=moduloUrl ng-model=sistemaCtrl.formModulo.url><div ng-messages=formSistema.moduloUrl.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><div layout=row layout-align=end layout-margin=10><md-button ng-click=sistemaCtrl.cadastrarModulo() class=md-raised>Adicionar</md-button></div><div><div><table md-table ng-show=\"sistemaCtrl.form.modulos.length > 0\"><thead md-head><tr md-row><th md-column><span>Sigla</span></th><th md-column><span>Descrição</span></th><th md-column><span>Código Módulo</span></th><th md-column><span>URL</span></th><th md-column style=\"text-align: center\"><span>Excluir</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"modulo in sistemaCtrl.form.modulos\"><td md-cell>{{modulo.sigla}}</td><td md-cell>{{modulo.nome}}</td><td md-cell>{{modulo.codigoModulo}}</td><td md-cell>{{modulo.url}}</td><td md-cell style=\"text-align: center\"><ng-md-icon icon=delete style=fill:#788489 size=22 alt=Excluir ng-click=sistemaCtrl.excluirModulo(modulo)><md-tooltip>Excluir</md-tooltip></ng-md-icon></td></tr></tbody></table></div><div layout=row layout-margin=20 layout-align=start><md-input-container flex=45><md-checkbox ng-model=sistemaCtrl.form.interno aria-label=\"Acesso somente para usuários internos\">Acesso somente para usuários internos</md-checkbox></md-input-container></div><md-divider></md-divider><div layout=row layout-align=end layout-margin=10><md-button class=md-raised ng-click=sistemaCtrl.voltar()>Voltar</md-button><md-button class=md-raised ng-click=sistemaCtrl.limpar()>Limpar</md-button><md-button type=submit class=md-raised ng-disabled=sistemaCtrl.desabilitarGravar() ng-click=sistemaCtrl.salvar() layout-aling=end>Gravar</md-button></div></div></form></div>");
$templateCache.put("scripts/sistema/views/consultar-sistema.tmpl.html","<div class=padding-right-pagina ng-init=sistemaCtrl.inicializarConsulta();><h1 class=md-title>Consultar Sistemas</h1><div layout=column layout-align=center flex=100><form name=formSistema class=caixa-consulta flex=100><div layout=row flex=100><md-input-container class=\"md-block padding-right-input\" flex=50><label>Nome</label><md-select ng-model=sistemaCtrl.query.id md-on-open=sistemaCtrl.carregarSistemas()><md-option ng-repeat=\"sistema in sistemaCtrl.comboSistemas\" value=\"{{ sistema.id }}\">{{sistema.nome}}</md-option></md-select></md-input-container><md-input-container class=md-block flex=50><label>Descrição</label><input ng-model=sistemaCtrl.query.descricao></md-input-container></div></form><div layout=row layout-align=end class=margin-top><md-button type=reset class=md-raised ng-click=sistemaCtrl.limparConsultar()>Limpar</md-button><md-button type=submit class=md-raised ng-click=sistemaCtrl.consultar()>Consultar</md-button><md-button type=submit class=md-raised ng-click=sistemaCtrl.criarNovoSistema()>Novo</md-button></div></div><div layout-margin=10><md-table-container><table md-table ng-model=sistemaCtrl.selecionado md-progress=promise><thead md-head md-order=sistemaCtrl.query.order md-on-reorder=sistemaCtrl.consultar ng-if=\"sistemaCtrl.sistemas.length > 0\"><tr md-row><th md-column md-order-by=nome>Sistema</th><th md-column md-order-by=codigoSistema>Código Sistema</th><th md-column md-order-by=descricao>Descrição</th><th md-column md-order-by=sigla>Sigla</th><th md-column md-order-by=esquema>Esquema</th><th md-column>Ações</th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"sistema in sistemaCtrl.sistemas |\n                            orderBy: sistemaCtrl.query.order | limitTo: sistemaCtrl.query.limit :\n                            (sistemaCtrl.query.page -1) * sistemaCtrl.query.limit\"><td md-cell>{{sistema.nome}}</td><td md-cell>{{sistema.codigoSistema}}</td><td md-cell>{{sistema.descricao}}</td><td md-cell>{{sistema.sigla}}</td><td md-cell>{{sistema.esquema}}</td><td md-cell><ng-md-icon icon=search style=fill:#788489 size=22 alt=Detalhar ng-click=sistemaCtrl.detalhar(sistema.id)><md-tooltip>Detalhar</md-tooltip></ng-md-icon><ng-md-icon icon=create style=fill:#788489 size=22 alt=Editar ng-click=sistemaCtrl.editar(sistema.id)><md-tooltip>Editar</md-tooltip></ng-md-icon><ng-md-icon icon=delete style=fill:#788489 size=22 alt=Excluir ng-click=\"sistemaCtrl.excluir($event, sistema.id)\"><md-tooltip>Excluir</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"sistemaCtrl.sistemas.length > 0\" md-limit=sistemaCtrl.query.limit md-limit-options=\"[20, 50, 100]\" md-page=sistemaCtrl.query.page md-total={{sistemaCtrl.sistemas.length}} md-on-paginate=sistemaCtrl.consultar md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></div></div>");
$templateCache.put("scripts/sistema/views/detalhar-sistema.tmpl.html","<div class=padding-right-pagina ng-init=sistemaCtrl.recuperarSistema()><div class=md-title-com-borda>Detalhar Sistema</div><form name=formSistema novalidate><div layout=row><div><img ng-src=data:image/JPEG;base64,{{sistemaCtrl.form.logo.dado}} ng-show=sistemaCtrl.form.logo height=150></div></div><div layout=row><md-input-container flex=50><label>Nome</label><input name=nome ng-model=sistemaCtrl.form.nome disabled required><div ng-messages=formSistema.nome.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container><md-input-container flex=50><label>Sigla</label><input name=sigla ng-model=sistemaCtrl.form.sigla maxlength=10 disabled required><div ng-messages=formSistema.sigla.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><div layout=row><md-input-container flex=100><label>Descrição</label><input name=descricao ng-model=sistemaCtrl.form.descricao disabled required><div ng-messages=formSistema.descricao.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Esquema</label><input name=esquema ng-model=sistemaCtrl.form.esquema disabled required><div ng-messages=formSistema.esquema.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container><md-input-container flex=50><label>Código Sistema</label><input name=codigoSistema ng-model=sistemaCtrl.form.codigoSistema disabled required></md-input-container></div><div layout=row><md-input-container class=md-block flex=70><label>Origem *</label><input name=origem ng-model=sistemaCtrl.form.origem disabled required><div ng-messages=formSistema.origem.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><span class=texto-secundario>Módulo</span><div ng-show=\"(sistemaCtrl.form.modulos | filter : { excluido : false }).length > 0\" style=\"margin-top: 1%\"><div layout=row><div flex=100><table md-table><thead md-head><tr md-row><th md-column><span>Sigla</span></th><th md-column><span>Descrição</span></th><th md-column><span>Código Módulo</span></th><th md-column><span>URL</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"modulo in sistemaCtrl.form.modulos | filter : { excluido : false }\"><td md-cell>{{modulo.sigla}}</td><td md-cell>{{modulo.nome}}</td><td md-cell>{{modulo.codigoModulo}}</td><td md-cell>{{modulo.url}}</td></tr></tbody></table></div></div></div><div layout=row><md-input-container class=md-block flex=45 style=\"margin: 0px\"><md-checkbox ng-model=sistemaCtrl.form.interno aria-label=\"Acesso somente para usuários internos\" disabled>Acesso somente para usuários internos</md-checkbox></md-input-container></div><div layout=row layout-align=end><md-button class=md-raised ng-click=sistemaCtrl.voltar()>Voltar</md-button></div></form></div>");
$templateCache.put("scripts/sistema/views/editar-sistema.tmpl.html","<div class=padding-right-pagina ng-init=sistemaCtrl.recuperarSistema()><div class=md-title-com-borda>Editar Sistema</div><form name=formSistema novalidate><div layout=row><div><img ng-src=data:image/JPEG;base64,{{sistemaCtrl.form.logo.dado}} ng-show=sistemaCtrl.form.logo height=150></div></div><div layout=row><md-input-container flex=50><label>Nome</label><input name=nome ng-model=sistemaCtrl.form.nome required><div ng-messages=formSistema.nome.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container><md-input-container flex=50><label>Sigla</label><input name=sigla ng-model=sistemaCtrl.sigla maxlength=10 required disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex=100><label>Descrição</label><input name=descricao ng-model=sistemaCtrl.form.descricao required><div ng-messages=formSistema.descricao.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Esquema</label><input name=esquema ng-model=sistemaCtrl.form.esquema required><div ng-messages=formSistema.esquema.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container><md-input-container flex=50><label>Código Sistema</label><input name=codigoSistema disabled required ng-model=sistemaCtrl.form.codigoSistema><div ng-messages=formSistema.codigoSistema.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=70><label>Origem</label><md-select name=origem ng-model=sistemaCtrl.form.origem md-on-open=sistemaCtrl.carregarOrigens() required><md-option ng-repeat=\"origem in sistemaCtrl.comboOrigens\" ng-value=origem>{{origem}}</md-option></md-select><div ng-messages=formSistema.origem.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><div layout=row><md-input-container flex=50><lf-ng-md-file-input lf-files=sistemaCtrl.files lf-filesize=5MB lf-totalsize=10MB lf-mimetype=image/* lf-placeholder=\"Selecione a logo do sistema\" lf-remove-label=Remover preview lf-browse-label=Procurar...></lf-ng-md-file-input><div ng-messages=formSistema.files.$error style=color:red><div ng-message=filesize>O arquivo excede o limite de 5MB</div><div ng-message=totalsize>A requisição excede o limite de 10MB</div><div ng-message=mimetype>O arquivo deve ser uma imagem</div></div></md-input-container></div><span class=texto-secundario>Módulo</span><div layout=row style=margin-top:1%><md-input-container class=md-block flex=30 style=margin:0px><label>Sigla</label><input name=moduloSigla ng-model=sistemaCtrl.formModulo.sigla><div ng-messages=formSistema.moduloSigla.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container><md-input-container class=md-block flex=70 style=margin:0px><label>Descrição</label><input name=moduloNome required ng-model=sistemaCtrl.formModulo.nome><div ng-messages=formSistema.moduloNome.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=30 style=margin:0px><label>Código Módulo</label><input name=codigoModulo required ng-model=sistemaCtrl.formModulo.codigoModulo><div ng-messages=formSistema.codigoModulo.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container><md-input-container class=md-block flex=70 style=margin:0px><label>Url</label><input name=moduloUrl ng-model=sistemaCtrl.formModulo.url><div ng-messages=formSistema.moduloUrl.$error><div ng-message=required>Campo obrigatório</div></div></md-input-container></div><div layout=row layout-align=end><md-button class=md-raised ng-click=sistemaCtrl.cadastrarModulo()>Adicionar</md-button></div><div><table md-table ng-show=\"sistemaCtrl.form.modulos.length > 0\"><thead md-head><tr md-row><th md-column><span>Sigla</span></th><th md-column><span>Descrição</span></th><th md-column><span>Código Módulo</span></th><th md-column><span>URL</span></th><th md-column style=\"text-align: center\"><span>Excluir</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"modulo in sistemaCtrl.form.modulos\"><td md-cell>{{modulo.sigla}}</td><td md-cell>{{modulo.nome}}</td><td md-cell>{{modulo.codigoModulo}}</td><td md-cell>{{modulo.url}}</td><td md-cell style=\"text-align: center\"><ng-md-icon icon=delete style=fill:#788489 size=22 alt=Excluir ng-click=sistemaCtrl.excluirModulo(modulo)><md-tooltip>Excluir</md-tooltip></ng-md-icon></td></tr></tbody></table></div><div layout=row><md-input-container class=md-block flex=100><md-checkbox ng-model=sistemaCtrl.form.interno aria-label=\"Acesso somente para usuários internos\">Acesso somente para usuários internos</md-checkbox></md-input-container></div><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button class=md-raised ng-click=sistemaCtrl.voltar()>Voltar</md-button><md-button class=md-raised ng-click=sistemaCtrl.limpar()>Limpar</md-button><md-button type=submit class=md-raised ng-disabled=sistemaCtrl.desabilitarGravar() ng-click=sistemaCtrl.salvarEdicao()>Gravar</md-button></div></form></div>");
$templateCache.put("scripts/unidade/views/associar-jurisdicao.tmpl.html","<div class=padding-right-pagina ng-init=\"grupoUnidadeCtrl.consultarJurisdicoes(); grupoUnidadeCtrl.carregarOrgaos();\"><div class=md-title-com-borda>Associar Jurisdição</div><div class=texto-secundario>Unidade Executora</div><form name=unidadeForm><div layout=row flex=100><md-input-container flex=50><label>Unidade Executora:</label><md-chips ng-model=grupoUnidadeCtrl.unidadesSelecionadas md-transform-chip=grupoUnidadeCtrl.transformChip($chip) md-require-match=true md-on-add=grupoUnidadeCtrl.recuperaUnidadeSelecionada() md-on-remove=\"grupoUnidadeCtrl.jurisdicoesSelecionadas = [];\" required><md-autocomplete placeholder=\"Informe o nome ou código da unidade executora\" md-min-length=3 md-selected-item=grupoUnidadeCtrl.unidadeSelecionada.id md-search-text=grupoUnidadeCtrl.query.nome md-items=\"item in grupoUnidadeCtrl.pesquisarUnidadeFiltro()\" md-item-text=item.nome md-no-cache=true md-input-minlength=3 md-delay=700 md-on-add=\"\" md-input-id=unidadeSelecionada required><span md-highlight-text=grupoUnidadeCtrl.query.nome>{{item.nome}} - {{item.siglaCompleta}}</span><md-not-found><md-button ng-click=\"grupoUnidadeCtrl.showFormCadastroUnidade=true\">cadastrar unidade</md-button></md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip.nome}}</strong></span></md-chip-template></md-chips></md-input-container></div><div ng-show=grupoUnidadeCtrl.showFormCadastroUnidade layout=row layout-align=center><md-content class=border-tabela flex=100><div layout=row><md-input-container class=md-block flex=100><label>Nome:</label><input name=nome ng-model=grupoUnidadeCtrl.formUnidade.nome required><div ng-messages=unidadeForm.nome.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row layout-align=end><md-button class=md-raised ng-click=grupoUnidadeCtrl.fecharFormUnidade()>Cancelar</md-button><md-button class=md-raised ng-click=grupoUnidadeCtrl.salvarUnidade()>Salvar usuário</md-button></div></md-content></div><div><div class=texto-secundario>Jurisdição</div><div layout=row layout-align=20><fieldset class=standard style=\"border: 0\"><div layout=row><md-checkbox id=todasJurisdicoes aria-label=\"Selecionar Todos\" ng-checked=grupoUnidadeCtrl.isSelecionadoJurisdicao() md-indeterminate=grupoUnidadeCtrl.isIndeterminado() ng-click=grupoUnidadeCtrl.alterarTodosJurisdicao()><span ng-if=grupoUnidadeCtrl.isSelecionadoJurisdicao()>Des</span>selecionar Todos</md-checkbox></div><div layout=row layout-wrap flex><div flex=25 ng-repeat=\"jurisdicao in grupoUnidadeCtrl.jurisdicoes\"><md-checkbox ng-checked=\"grupoUnidadeCtrl.isExistenteJurisdicao(jurisdicao, grupoUnidadeCtrl.jurisdicoesSelecionadas)\" ng-click=\"grupoUnidadeCtrl.alterarJurisdicao(jurisdicao, grupoUnidadeCtrl.jurisdicoesSelecionadas)\">{{ jurisdicao.nome }}</md-checkbox></div></div></fieldset></div></div><br><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button class=md-raised ng-click=grupoUnidadeCtrl.limpar();>Limpar</md-button><md-button id=associar_Button type=submit class=md-raised ng-disabled=grupoUnidadeCtrl.isJurisdicaoSelecionada() ng-click=grupoUnidadeCtrl.associarJurisdicaoUnidade()>Associar</md-button></div></form></div>");
$templateCache.put("scripts/unidade/views/associar-unidade.tmpl.html","<div class=padding-right-pagina ng-init=grupoUnidadeCtrl.carregarOrgaos()><div class=md-title-com-borda>Associar Administrador a Unidade Executora</div><form name=unidadeForm novalidate><div class=texto-secundario>Unidade Executora</div><div class=caixa-consulta><div layout=row flex=100><md-input-container flex=50><label>Órgão UGE - Órgão Superior​ ou Entidade:</label><md-autocomplete ng-model=grupoUnidadeCtrl.form.orgaoSuperior placeholder=\"Informe um órgão/entidade\" md-selected-item=grupoUnidadeCtrl.form.orgaoSuperior md-search-text=grupoUnidadeCtrl.filtroNomeOrgao md-items=\"item in grupoUnidadeCtrl.pesquisarOrgao()\" md-item-text=\"item.codigoUg + \' - \' + item.nome\" md-no-cache=true md-input-minlength=3 md-delay=700 md-input-id=orgaoSuperior><span md-highlight-text=grupoUnidadeCtrl.filtroNomeOrgao>{{item.codigoUg}} - {{item.nome}}</span><md-not-found>Não encontrado.</md-not-found></md-autocomplete><div ng-messages=grupoUnidadeForm.orgaos.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container flex=30><label>Grupo Unidade:</label><md-select name=grupoUnidade ng-model=grupoUnidadeCtrl.query.idGrupoUnidade md-on-open=grupoUnidadeCtrl.consultarGrupoUnidadePorOrgao() ng-disabled=\"!grupoUnidadeCtrl.form.orgaoSuperior || grupoUnidadeCtrl.query.semGrupoUnidade\"><md-option ng-repeat=\"grupo in grupoUnidadeCtrl.gruposUnidades\" ng-value=grupo.id>{{grupo.nome}}</md-option></md-select></md-input-container><div layout=row layout-align=\"center center\" style=\"margin-left: 2%\"><md-checkbox ng-model=grupoUnidadeCtrl.query.semGrupoUnidade aria-label=\"Sem grupo\" ng-disabled=!grupoUnidadeCtrl.form.orgaoSuperior ng-change=\"grupoUnidadeCtrl.query.idGrupoUnidade=\'\'\">Sem grupo</md-checkbox></div></div></div><div layout=row flex=100><md-input-container flex=50><label>UG Executora:</label><md-chips ng-model=grupoUnidadeCtrl.unidadesSelecionadas md-transform-chip=grupoUnidadeCtrl.transformChip($chip) md-require-match=true md-on-add=\"grupoUnidadeCtrl.recuperaUnidadeSelecionada(); grupoUnidadeCtrl.administradoresSelecionados = [];\" md-on-remove=\"grupoUnidadeCtrl.administradoresSelecionados = [];\" required><md-autocomplete placeholder=\"Informe o nome ou código\" md-min-length=3 md-selected-item=grupoUnidadeCtrl.unidadeSelecionada.id md-search-text=grupoUnidadeCtrl.query.nome md-items=\"item in grupoUnidadeCtrl.pesquisarUnidadeFiltro()\" md-item-text=\"item.codigoUg + \' - \' + item.nome\" md-no-cache=true md-input-minlength=3 md-delay=700 md-on-add=\"\" md-input-id=unidadeSelecionada required><span md-highlight-text=grupoUnidadeCtrl.query.nome>{{item.codigoUg}} - {{item.nome}}</span><md-not-found ng-show=\"grupoUnidadeCtrl.query.nome.length \"><md-button ng-click=\"grupoUnidadeCtrl.showFormCadastroUnidade=true\">cadastrar unidade</md-button></md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip.nome}}</strong></span></md-chip-template></md-chips></md-input-container><div ng-show=grupoUnidadeCtrl.showFormCadastroUnidade layout=row layout-align=center><div flex=100 class=border-tabela><div layout=row><md-input-container class=md-block><label>Nome:</label><input name=nome ng-model=grupoUnidadeCtrl.formUnidade.nome required><div ng-messages=unidadeForm.nome.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row layout-align=center><md-button class=md-raised ng-click=grupoUnidadeCtrl.salvarUnidade()>Salvar usuário</md-button><md-button class=md-raised ng-click=grupoUnidadeCtrl.fecharFormUnidade()>Cancelar</md-button></div></div></div></div><div class=texto-secundario>Administradores</div><div layout=row><md-input-container flex=50><label>Sistema:</label><md-select name=sistema ng-model=grupoUnidadeCtrl.form.sistema md-on-open=grupoUnidadeCtrl.consultarSistemas() ng-change=grupoUnidadeCtrl.consultarUsuarioAssociados() md-on-close=grupoUnidadeCtrl.carregarModulos() required><md-option ng-repeat=\"sistema in grupoUnidadeCtrl.sistemas\" ng-value=sistema>{{sistema.nome}}</md-option></md-select><div ng-messages=unidadeForm.sistema.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=50 ng-show=\"grupoUnidadeCtrl.modulos.length > 1\"><label>Módulo</label><md-select name=modulo ng-model=grupoUnidadeCtrl.form.modulo md-on-open=grupoUnidadeCtrl.carregarModulos();><md-option ng-repeat=\"modulo in grupoUnidadeCtrl.modulos\" ng-value={{modulo}}>{{modulo.nome}}</md-option></md-select></md-input-container></div><div layout=row><md-input-container flex=50><label>Nome ou CPF:</label><md-chips ng-model=grupoUnidadeCtrl.administradoresSelecionados md-transform-chip=grupoUnidadeCtrl.transformChip($chip) md-require-match=true md-on-add=grupoUnidadeCtrl.adicionarAdministradoresSelecionadoAuxiliar() md-on-remove=grupoUnidadeCtrl.desassociarUnidadeSistemaUsuario($index) required><md-autocomplete placeholder=\"Informe o nome ou CPF\" md-selected-item=grupoUnidadeCtrl.administradorSelecionado.id md-search-text=grupoUnidadeCtrl.filtroAdministrador md-items=\"item in grupoUnidadeCtrl.pesquisarAdministrador()\" md-item-text=item.nome md-no-cache=true md-input-minlength=3 md-delay=700 md-input-id=administradorSelecionado><span md-highlight-text=grupoUnidadeCtrl.filtroAdministrador>{{item.nome}}</span><md-not-found><md-button ng-click=\"grupoUnidadeCtrl.showFormCadastroUsuario=true\">cadastrar usuário</md-button></md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip.nome}}</strong></span></md-chip-template></md-chips></md-input-container></div><div ng-show=grupoUnidadeCtrl.showFormCadastroUsuario layout=column><div flex=100 class=border-tabela><div layout=row><md-input-container flex=30 class=md-block><label>CPF:</label><input name=cpf ng-model=grupoUnidadeCtrl.formUsuario.cpf ui-br-cpf-mask required><div ng-messages=unidadeForm.cpf.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=cpf><small>CPF inválido</small></div></div></md-input-container><md-input-container flex=70 class=md-block><label>Nome:</label><input name=nome ng-model=grupoUnidadeCtrl.formUsuario.nome required><div ng-messages=unidadeForm.nome.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div><md-input-container flex=100 class=md-block><label>E-mail:</label><input type=email name=email ng-model=grupoUnidadeCtrl.formUsuario.email required><div ng-messages=unidadeForm.email.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=email><small>Email inválido</small></div></div></md-input-container></div><div layout=row layout-align=end><md-button class=md-raised ng-click=grupoUnidadeCtrl.fecharFormUsuario()>Cancelar</md-button><md-button class=md-raised ng-click=grupoUnidadeCtrl.salvarUsuario()>Salvar usuário</md-button></div></div></div></form></div><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button class=md-raised ng-click=grupoUnidadeCtrl.limpar();>Limpar</md-button><md-button id=associar_Button type=submit class=md-raised ng-disabled=grupoUnidadeCtrl.desabilitarAssociacao() ng-click=grupoUnidadeCtrl.associarUnidadeSistemaUsuario()>Associar</md-button></div>");
$templateCache.put("scripts/unidade/views/cadastrar-unidade.tmpl.html","<div class=padding-right-pagina ng-init=unidadeCtrl.carregarOrgaos()><div class=md-title-com-borda>Cadastrar Unidade</div><form name=unidadeForm novalidate><div layout=row style=\"margin-bottom: 2%\"><div class=md-block flex=50><label>Órgão Superior ou Entidade:</label><md-autocomplete name=organizacaoSuperior ng-model=unidadeCtrl.form.organizacaoSuperior placeholder=\"Informe um órgão/entidade\" md-selected-item=unidadeCtrl.form.organizacaoSuperior md-search-text=unidadeCtrl.filtroNomeOrgao md-items=\"item in unidadeCtrl.pesquisarOrgao()\" md-item-text=\"item.codigoUg + \' - \' + item.nome\" md-no-cache=true md-input-minlength=3 md-delay=700 md-input-id=organizacaoSuperior required><span md-highlight-text=unidadeCtrl.filtroNomeOrgao>{{item.codigoUg}} - {{item.nome}}</span><md-not-found>Não encontrado.</md-not-found></md-autocomplete><div ng-messages=unidadeForm.organizacaoSuperior.$error><div ng-message=required><small>Campo obrigatório</small></div></div></div></div><div layout=row><md-input-container class=md-block flex=50><label>CNPJ:</label><input name=cnpj ng-model=unidadeCtrl.form.cnpj cpf-cnpj-mask><div ng-messages=unidadeForm.cnpj.$error><div ng-message=required><small>Campo Obrigatório</small></div><div ng-messages=unidadeForm.cnpj.$error><div ng-message=required><small>Campo obrigatório</small></div></div></div></md-input-container><md-input-container class=md-block flex=50><label>Sigla:</label><input name=sigla ng-model=unidadeCtrl.form.sigla><div ng-messages=unidadeForm.sigla.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Nome da Unidade:</label><input name=nome ng-model=unidadeCtrl.form.nome required><div ng-messages=unidadeForm.nome.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=50><label>Código UG:</label><input name=codigoUg ng-model=unidadeCtrl.form.codigoUg required><div ng-messages=unidadeForm.codigoUg.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button class=md-raised ng-click=unidadeCtrl.voltar()>Voltar</md-button><md-button class=md-raised ng-click=unidadeCtrl.limpar()>Limpar</md-button><md-button id=salvar_Button type=submit class=md-raised ng-disabled=unidadeCtrl.desabilitarGravar() ng-click=unidadeCtrl.salvar()>Gravar</md-button></div></form></div>");
$templateCache.put("scripts/unidade/views/consultar-unidade.tmpl.html","<div class=padding-right-pagina ng-init=unidadeCtrl.inicializarConsulta();><h1 class=md-title>Consultar Unidades Executora</h1><div layout=column layout-align=center><form name=unidadeForm class=caixa-consulta><div layout=row><div flex=50><label>Órgão Superior ou Entidade:</label><md-autocomplete ng-model=unidadeCtrl.form.organizacaoSuperior placeholder=\"Informe um órgão/entidade\" md-selected-item=unidadeCtrl.form.organizacaoSuperior md-search-text=unidadeCtrl.filtroNomeOrgao md-items=\"item in unidadeCtrl.pesquisarOrgao()\" md-item-text=\"item.codigoUg + \' - \' + item.nome\" md-no-cache=true md-input-minlength=3 md-delay=700 class=padding-right-input><span md-highlight-text=unidadeCtrl.filtroNomeOrgao>{{item.codigoUg}} - {{item.nome}}</span><md-not-found>Não encontrado.</md-not-found></md-autocomplete><div ng-messages=unidadeForm.orgaos.$error><div ng-message=required><small>Campo obrigatório</small></div></div></div><md-input-container flex=50><label>Nome Unidade Executora</label><input ng-model=unidadeCtrl.query.nome></md-input-container></div><md-input-container class=md-block flex=50><label>Situação</label><md-select ng-model=unidadeCtrl.query.strAtivo><md-option ng-repeat=\"opcao in unidadeCtrl.opcoesAtivoInativo\" value={{opcao.value}}>{{opcao.key}}</md-option></md-select></md-input-container></form><div layout=row layout-align=end class=margin-top><md-button type=reset class=md-raised ng-click=unidadeCtrl.limparConsultar()>Limpar</md-button><md-button id=consultar_Button type=submit class=md-raised ng-click=unidadeCtrl.consultar()>Consultar</md-button><md-button type=submit class=md-raised ng-click=unidadeCtrl.criarNovaUnidade()>Novo</md-button></div></div><md-table-container><table md-table ng-model=unidadeCtrl.selecionado md-progress=promise><thead md-head md-order=unidadeCtrl.query.order md-on-reorder=unidadeCtrl.consultar ng-if=\"unidadeCtrl.unidades.length > 0\"><tr md-row><th md-column md-order-by=orgao><span>Órgão UGE - Órgão Superior​ ou Entidade</span></th><th md-column md-order-by=nome><span>Nome</span></th><th md-column md-order-by=ativo><span>Ativo</span></th><th md-column><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"unidade in unidadeCtrl.unidades\"><td md-cell>{{unidade.organizacaoSuperior.id}} - {{unidade.organizacaoSuperior.nome}}</td><td md-cell>{{unidade.id}} - {{unidade.nome}}</td><td md-cell><md-switch ng-model=unidade.ativo ng-change=unidadeCtrl.ativarInativar(unidade)>{{unidade.ativo && \"Ativo\" || \"Inativo\"}}</md-switch></td><td md-cell><ng-md-icon id=detalhar_Button icon=search style=fill:#788489 size=22 alt=Detalhar ng-click=unidadeCtrl.detalhar(unidade.id)><md-tooltip>Detalhar</md-tooltip></ng-md-icon><ng-md-icon id=alterar_Button icon=create style=fill:#788489 size=22 alt=Editar ng-click=unidadeCtrl.editar(unidade.id)><md-tooltip>Editar</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"unidadeCtrl.unidades.length > 0\" md-limit=unidadeCtrl.queryAtiva.limit md-limit-options=\"[20, 50, 100]\" md-page=unidadeCtrl.queryAtiva.page md-total={{unidadeCtrl.totalElements}} md-on-paginate=unidadeCtrl.carregarPagina md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></div>");
$templateCache.put("scripts/unidade/views/detalhar-unidade.tmpl.html","<div class=padding-right-pagina ng-init=unidadeCtrl.recuperarUnidadeDetalhar()><h1 class=md-title-com-borda>Detalhar Unidade Executora</h1><form name=unidadeForm><div layout=row><md-input-container class=md-block flex=50><label>Nome da Ug Executora:</label><input name=nome ng-model=unidadeCtrl.form.organizacaoSuperior.nome disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Cnpj:</label><input name=cnpj ng-model=unidadeCtrl.form.cnpj disabled></md-input-container><md-input-container class=md-block flex=50><label>Sigla:</label><input name=sigla ng-model=unidadeCtrl.form.sigla disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Nome da Ug Executora:</label><input name=nome ng-model=unidadeCtrl.form.nome disabled></md-input-container><md-input-container class=md-block flex=50><label>Código Ug:</label><input name=codigoUg ng-model=unidadeCtrl.form.codigoUg disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Situação</label><input name=codigoUg ng-model=unidadeCtrl.form.ativo disabled></md-input-container><md-input-container flex=50><label>Tipo:</label><input name=tipo ng-model=unidadeCtrl.form.tipoAdministracao.descricao disabled></md-input-container></div></form><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button id=voltar_Button class=md-raised ng-click=unidadeCtrl.voltar()>Voltar</md-button><md-button type=submit class=md-raised ng-disabled=unidadeCtrl.desabilitarGravar() ng-click=unidadeCtrl.salvar()>Gravar</md-button></div></div>");
$templateCache.put("scripts/unidade/views/editar-unidade.tmpl.html","<div layout-xs=column ng-init=\"unidadeCtrl.carregarOrgaos(); unidadeCtrl.recuperarUnidade(); unidadeCtrl.consultarTipoAdministracao()\"><h1 class=md-title>Editar Unidade Executora</h1><form name=unidadeForm><div layout=row style=\"margin-bottom: 2%\"><form class=md-block><div flex=50><label>Órgão UGE - Órgão Superior​ ou Entidade:</label><md-autocomplete name=organizacaoSuperior ng-model=unidadeCtrl.form.organizacaoSuperior placeholder=\"Informe um órgão/entidade\" md-selected-item=unidadeCtrl.form.organizacaoSuperior md-search-text=unidadeCtrl.filtroNomeOrgao md-items=\"item in unidadeCtrl.pesquisarOrgao()\" md-item-text=\"item.codigoUg + \' - \' + item.nome\" md-no-cache=true md-input-minlength=3 md-delay=700 required><span md-highlight-text=unidadeCtrl.filtroNomeOrgao>{{item.codigoUg}} - {{item.nome}}</span><md-not-found>Não encontrado.</md-not-found></md-autocomplete><div ng-messages=unidadeForm.organizacaoSuperior.$error><div ng-message=required><small>Campo obrigatório</small></div></div></div></form></div><div layout=row><md-input-container class=md-block flex=50><label>Cnpj:</label><input name=cnpj ng-model=unidadeCtrl.form.cnpj cpf-cnpj-mask><div ng-messages=unidadeForm.cnpj.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=cnpj><small>CNPJ inválido</small></div></div></md-input-container><md-input-container class=md-block flex=50><label>Sigla:</label><input name=sigla ng-model=unidadeCtrl.form.sigla><div ng-messages=unidadeForm.sigla.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Nome da Ug Executora:</label><input name=nome ng-model=unidadeCtrl.form.nome required><div ng-messages=unidadeForm.nome.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=50><label>Código Ug:</label><input name=codigoUg ng-model=unidadeCtrl.form.codigoUg required><div ng-messages=unidadeForm.codigoUg.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row layout-align=end><md-button class=md-raised ng-click=unidadeCtrl.voltar()>Voltar</md-button><md-button class=md-raised ng-click=unidadeCtrl.limpar()>Limpar</md-button><md-button id=salvarEdicao_Button type=submit class=md-raised ng-disabled=unidadeCtrl.desabilitarGravar() ng-click=unidadeCtrl.salvar()>Gravar</md-button></div></form></div>");
$templateCache.put("scripts/usuario/views/alteracao-cadastro.tmpl.html","<div layout-xs=column ng-init=usuarioCtrl.recuperarUsuarioEditar();><md-content layout-padding><h1 class=md-title>Alterar Dados do Usuário</h1><md-divider style=\"margin-bottom: 30px\"></md-divider><form name=form novalidate><div layout=row layout-align=center><md-input-container class=md-block flex=30><label>Nome</label><input ng-model=usuarioCtrl.form.nome disabled></md-input-container><md-input-container class=md-block flex=30><label>CPF</label><input ng-model=usuarioCtrl.form.cpf ui-br-cpf-mask disabled></md-input-container></div><div layout=row layout-align=center><md-input-container class=md-block flex=30><label>Telefone Trabalho</label><input name=telefoneTrabalho ng-model=usuarioCtrl.form.telefoneTrabalho ui-br-phone-number required><div ng-messages=form.telefoneTrabalho.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=30><label>Celular</label><input name=celular ng-model=usuarioCtrl.form.telefoneCelular ui-br-phone-number><div ng-messages=form.celular.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row layout-align=center><md-input-container class=md-block flex=30><label>Cargo</label><input name=cargo ng-model=usuarioCtrl.form.cargo></md-input-container><md-input-container class=md-block flex=30><label>Unidade padrão</label><md-autocomplete placeholder=\"Informe o nome ou código\" md-min-length=3 md-selected-item=usuarioCtrl.form.unidadeExecutoraPadrao md-search-text=usuarioCtrl.query.unidadeExecutoraPadrao md-items=\"item in usuarioCtrl.pesquisarUnidadeFiltro()\" md-item-text=\"item.codigoUg + \' - \' + item.nome\" md-no-cache=true md-input-minlength=3 md-delay=700 md-on-add=\"\" required><span md-highlight-text=usuarioCtrl.query.unidadeExecutoraPadrao>{{item.codigoUg}} - {{item.nome}}</span><md-not-found>Não encontrado.</md-not-found></md-autocomplete><div ng-messages=form.unidadeExecutoraPadrao.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row layout-align=center><md-input-container class=md-block flex=30><label>Departamento</label><input name=departamento ng-model=usuarioCtrl.form.departamento></md-input-container><md-input-container class=md-block flex=30><label>Sala</label><input name=sala ng-model=usuarioCtrl.form.sala></md-input-container></div><div layout=row layout-align=center><md-input-container class=md-block flex=60><label>Matrícula</label><input name=matricula ng-model=usuarioCtrl.form.matricula></md-input-container></div><div layout=row layout-align=center ng-show=!usuarioCtrl.form.interno><md-input-container class=md-block flex=30><label>Senha</label><input type=password name=senha ng-model=usuarioCtrl.form.senha autocomplete=off><div ng-messages=form.senha.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=30><label>Confirmar Senha</label><input type=password name=confirmarSenha ng-model=usuarioCtrl.form.confirmarSenha autocomplete=off><div ng-messages=form.confirmarSenha.$error><div ng-message=required><small>Campo obrigatório</small></div></div><div ng-show=\"form.confirmarSenha.$dirty && usuarioCtrl.form.confirmarSenha != usuarioCtrl.form.senha\"><small>As senhas informadas não coincidem</small></div></md-input-container></div><div layout=row layout-align=center><img ng-src=data:image/JPEG;base64,{{usuarioCtrl.form.foto.dado}} ng-show=usuarioCtrl.form.foto height=150><md-input-container flex=30><lf-ng-md-file-input lf-files=usuarioCtrl.foto lf-filesize=5MB lf-totalsize=10MB lf-mimetype=image/* lf-placeholder=\"Selecione a foto\" lf-remove-label=Remover preview lf-browse-label=Procurar...></lf-ng-md-file-input><div ng-messages=form.foto.$error style=color:red><div ng-message=filesize>O arquivo excede o limite de 5MB</div><div ng-message=totalsize>A requisição excede o limite de 10MB</div><div ng-message=mimetype>O arquivo deve ser uma imagem</div></div></md-input-container></div><section layout=row layout-align=center></section><div layout=row layout-align=center><md-button class=md-raised ng-click=usuarioCtrl.limpar()>Limpar</md-button><md-button id=salvarEdicao_Button type=submit class=md-raised ng-click=usuarioCtrl.salvarEdicao($event)>Enviar</md-button></div></form></md-content></div>");
$templateCache.put("scripts/usuario/views/cadastrar-usuario.tmpl.html","<div class=padding-right-pagina><div class=md-title-com-borda>Cadastro Usuário</div><form name=form novalidate><div layout=row><md-input-container class=md-block flex=30><label>CPF</label><input name=cpf ng-model=usuarioCtrl.form.cpf ui-br-cpf-mask required><div ng-messages=form.cpf.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container flex=70><label>Nome do usuário</label><input name=nome ng-model=usuarioCtrl.form.nome required><div ng-messages=form.nome.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row layout-align=center><md-input-container flex=100 class=\"md-icon-float md-block\"><label>Unidade de Lotação<ng-md-icon icon=help style=fill:#788489 size=26 alt=Ajuda></ng-md-icon><md-tooltip>Este campo pode ser utilizado para associar uma unidade/UG Executora/departamento/setor/órgão a um usuário ou perfil dentro do sistema acessos</md-tooltip></label><md-autocomplete ng-model=usuarioCtrl.form.usuario.unidadeExecutoraPadrao md-selected-item=usuarioCtrl.form.unidadeExecutoraPadrao md-search-text=textoBusca md-items=\"unidade in usuarioCtrl.carregarUnidadePorNome(textoBusca)\" md-item-text=unidade.nome md-no-cache=true md-input-minlength=3 md-delay=700 required><md-item-template><span md-highlight-text=textoBusca md-highlight-flags=gi ng-if=unidade.siglaCompleta>{{unidade.nome}} - {{unidade.siglaCompleta}}</span> <span md-highlight-text=textoBusca md-highlight-flags=gi ng-if=\"unidade.sigla && !unidade.siglaCompleta\">{{unidade.nome}} - {{unidade.sigla}}</span> <span md-highlight-text=textoBusca md-highlight-flags=gi ng-if=\"!unidade.sigla && !unidade.siglaCompleta\">{{unidade.nome}}</span></md-item-template><md-not-found>Unidade não encontrada.</md-not-found></md-autocomplete></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>E-mail</label><input name=email ng-model=usuarioCtrl.form.email required><div ng-messages=form.email.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=50><label>Confirmação do E-mail</label><input name=confirmacaoEmail ng-model=usuarioCtrl.form.confirmacaoEmail required><div ng-messages=form.confirmacaoEmail.$error><div ng-message=required><small>Campo obrigatório</small></div></div><div ng-show=\"form.confirmacaoEmail.$dirty && usuarioCtrl.form.confirmacaoEmail != usuarioCtrl.form.email\"><small>Os e-mails informados não coincidem</small></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Situação</label><md-select ng-model=usuarioCtrl.form.ativo><md-option ng-repeat=\"tipo in usuarioCtrl.opcoesAtivoInativo\" value=\"{{ tipo.value }}\">{{tipo.key}}</md-option></md-select><div ng-messages=form.tipo.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=50><label>Cargo</label><input name=cargo ng-model=usuarioCtrl.form.cargo></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Telefone Trabalho</label><input name=telefoneTrabalho ng-model=usuarioCtrl.form.telefoneTrabalho ui-br-phone-number></md-input-container><md-input-container class=md-block flex=50><label>Celular</label><input name=celular ng-model=usuarioCtrl.form.telefoneCelular ui-br-phone-number><div ng-messages=form.celular.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=33><label>Departamento</label><input name=departamento ng-model=usuarioCtrl.form.departamento></md-input-container><md-input-container class=md-block flex=33><label>Sala</label><input name=sala ng-model=usuarioCtrl.form.sala></md-input-container><md-input-container class=md-block flex=33><label>Matrícula</label><input name=matricula ng-model=usuarioCtrl.form.matricula></md-input-container></div><md-divider></md-divider><div layout=row layout-align=end class=margin-top><md-button class=md-raised ng-click=usuarioCtrl.voltar()>Voltar</md-button><md-button class=md-raised ng-click=usuarioCtrl.limparEdicao()>Limpar</md-button><md-button id=salvar_Button type=submit class=md-raised ng-click=usuarioCtrl.salvar()>Enviar</md-button></div></form></div>");
$templateCache.put("scripts/usuario/views/cadastro-realizado.tmpl.html","<div class=padding-right-pagina><h2 class=md-title-com-borda>Finalizacao do Cadastro</h2><h3 style=\"text-align: center; line-height: 300%; margin-top: 80px\">Seu cadastro foi finalizado com sucesso!<br>Favor aguardar a aprovação do(s) perfil(s) pelo Gestor responsável.<br>*Se você é um usuário do MP, a sua credencial de acesso será a senha da rede.<br></h3></div>");
$templateCache.put("scripts/usuario/views/consulta-perfil-usuario.tmpl.html","<div class=padding-right-pagina ng-init=usuarioCtrl.inicializarConsultaUsuarioUnidade();><h1 class=md-title>Consulta Perfis Usuários</h1><form name=form><div class=caixa-consulta><div layout=row><div class=md-block flex=50><label>Unidade Executora:</label><md-autocomplete ng-model=usuarioCtrl.form.orgaoSuperior placeholder=\"Informe uma unidade executora\" md-selected-item=usuarioCtrl.form.orgaoSuperior md-search-text=usuarioCtrl.filtroNomeOrgao md-items=\"item in usuarioCtrl.pesquisarOrgao()\" md-item-text=\"item.codigoUg + \' - \' + item.nome\" md-no-cache=true md-input-id=orgaoSuperior md-selected-item-change=usuarioCtrl.recuperarJurisdicoesUnidade() md-delay=700 md-min-length=3><span md-highlight-text=usuarioCtrl.filtroNomeOrgao>{{item.nome}} - {{item.siglaCompleta}}</span><md-not-found>Não encontrado.</md-not-found></md-autocomplete><div ng-messages=grupoUnidadeForm.orgaos.$error><div ng-message=required><small>Campo obrigatório</small></div></div></div><div class=md-block flex=50><label>Jurisdições:</label><div class=md-block><span ng-repeat=\"jurisdicao in usuarioCtrl.jurisdicoes\"><span ng-if=!$last>{{jurisdicao.sigla}} /</span> <span ng-if=$last>{{jurisdicao.sigla}}</span></span></div></div></div></div><div layout=row layout-align=end class=margin-top><md-button type=reset class=md-raised ng-click=usuarioCtrl.limparConsultar()>Limpar</md-button><md-button id=consultarPerfilUsuario_Button type=submit class=md-raised ng-click=usuarioCtrl.consultarPerfilUsuario()>Consultar</md-button></div></form><md-table-container><table md-table ng-model=usuarioCtrl.selecionado md-progress=promise><thead md-head md-order=usuarioCtrl.queryConsultaPerfil.order><tr md-row><th md-column md-order-by=cpf><span>CPF</span></th><th md-column md-order-by=usuario><span>Usuário</span></th><th md-column md-order-by=sistema><span>Sistema</span></th><th md-column md-order-by=modulo><span>Módulo</span></th><th md-column md-order-by=perfil><span>Perfil</span></th><th md-column md-order-by=statusPerfil><span>Status Perfil</span></th><th md-column md-order-by=statusUsuario><span>Situação do Usuário</span></th><th md-column style=\"text-align: center\"><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"usuarioPerfil in usuarioCtrl.relatorioPerfilUsuarios | orderBy: usuarioCtrl.queryConsultaPerfil.order | limitTo: usuarioCtrl.queryConsultaPerfil.limit : (usuarioCtrl.queryConsultaPerfil.page -1) * usuarioCtrl.queryConsultaPerfil.limit\"><td md-cell>{{usuarioPerfil.cpf}}</td><td md-cell>{{usuarioPerfil.usuario}}</td><td md-cell>{{usuarioPerfil.sistema}}</td><td md-cell>{{usuarioPerfil.modulo}}</td><td md-cell>{{usuarioPerfil.perfil}}</td><td md-cell>{{usuarioPerfil.statusPerfil}}</td><td md-cell><md-switch id=ativarInativar ng-model=usuarioPerfil.ativo ng-change=usuarioCtrl.ativarInativar(usuarioPerfil)>{{usuarioPerfil.ativo && \"Ativo\" || \"Inativo\"}}</md-switch></td><td md-cell style=\"text-align: center\"><ng-md-icon id=concederAcesso_Button icon=add style=fill:#788489 size=22 alt=\"Adicionar Acesso\" exibir-elemento-por-permissao=ACESSOS.CONCEDER_ACESSO ng-click=usuarioCtrl.addAcesso(usuarioPerfil.id)><md-tooltip>Adicionar Acesso</md-tooltip></ng-md-icon><ng-md-icon id=detalhar_Button icon=search style=fill:#788489 size=22 alt=Detalhar ng-click=usuarioCtrl.detalhar(usuarioPerfil.id)><md-tooltip>Detalhar</md-tooltip></ng-md-icon><ng-md-icon id=alterar_Button icon=create style=fill:#788489 size=22 alt=Editar exibir-elemento-por-permissao=ACESSOS.ALTERAR_USUARIO ng-click=usuarioCtrl.editar(usuarioPerfil.id)><md-tooltip>Editar</md-tooltip></ng-md-icon><ng-md-icon id=excluir_Button icon=delete style=fill:#788489 size=22 alt=Excluir exibir-elemento-por-permissao=ACESSOS.EXCLUIR_USUARIO ng-click=\"usuarioCtrl.excluir($event, usuarioPerfil.id)\"><md-tooltip>Excluir</md-tooltip></ng-md-icon><ng-md-icon id=swap_horiz icon=swap_horiz style=fill:#788489 size=22 alt=\"Movimentar Usuário (Alterar Lotação)\" exibir-elemento-por-permissao=ACESSOS.MOVIMENTAR_USUARIO ng-click=usuarioCtrl.movimentarUsuario(usuarioPerfil.id)><md-tooltip>Movimentar Usuário (Alteração Lotação)</md-tooltip></ng-md-icon><ng-md-icon icon=do_not_disturb style=fill:#788489 size=22 alt=\"Revogar Acesso\" ng-click=usuarioCtrl.revogarPerfilAcessoAssociado(usuarioPerfil.perfilId) ng-if=\"usuarioPerfil.perfilAtivo === true\"><md-tooltip>Revogar Acesso</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"usuarioCtrl.relatorioPerfilUsuarios.length > 0\" md-limit=usuarioCtrl.queryConsultaPerfil.limit md-limit-options=\"[20, 50, 100]\" md-page=usuarioCtrl.queryConsultaPerfil.page md-total={{usuarioCtrl.relatorioPerfilUsuarios.length}} md-on-paginate=usuarioCtrl.consultarPerfilUsuario md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></div>");
$templateCache.put("scripts/usuario/views/consultar-solicit-ativacao-usuario.tmpl.html","<div class=padding-right-pagina ng-init=usuarioCtrl.carregarSituacaoSolicitacao();><h1 class=md-title>Consultar/Tratar Solicitações de Ativação de Usuário</h1><div layout=column layout-align=center><form name=solicitacaoAcessoForm class=caixa-consulta><div layout=row><md-input-container flex=30 class=padding-right-input><label>CPF do usuário</label><input ng-model=usuarioCtrl.query.cpfUsuario ui-br-cpf-mask></md-input-container><md-input-container flex=70><label>Nome do usuário</label><input ng-model=usuarioCtrl.query.nomeUsuario></md-input-container></div><div layout=row><md-input-container class=md-block flex=100><label>Situação</label><md-select ng-model=usuarioCtrl.query.situacaoSolicitacao md-on-open=\"\"><md-option ng-repeat=\"opcao in usuarioCtrl.situacoesSolicitacao\" value={{opcao}}>{{opcao}}</md-option></md-select></md-input-container></div><div layout=row><div layout=row flex=50 layout-align=\"start center\"><span class=espaco-label-data>Data Inicio:</span><md-datepicker ng-model=usuarioCtrl.query.inicio md-placeholder=Inicio></md-datepicker></div><div layout=row flex=50 layout-align=\"start center\"><span class=espaco-label-data>Data Fim:</span><md-datepicker ng-model=usuarioCtrl.query.fim md-placeholder=Fim></md-datepicker></div></div></form><div layout=row layout-align=end class=margin-top><md-button type=reset class=md-raised ng-click=usuarioCtrl.limpar()>Limpar</md-button><md-button type=submit class=md-raised ng-click=usuarioCtrl.consultar()>Consultar</md-button></div></div><div><md-table-container><table md-table ng-model=usuarioCtrl.selecionado md-progress=promise><thead md-head ng-if=\"usuarioCtrl.solicitacoes.length > 0\"><tr md-row><th md-column><span>CPF</span></th><th md-column><span>Usuário</span></th><th md-column><span>Data solicitação</span></th><th md-column><span>Situação</span></th><th md-column><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"solicitacaoAtivacao in usuarioCtrl.solicitacoes |\n                            orderBy: usuarioCtrl.query.order | limitTo: usuarioCtrl.query.limit :\n                            (usuarioCtrl.query.page -1) * usuarioCtrl.query.limit\"><td md-cell>{{solicitacaoAtivacao.solicitacao.solicitante.cpf}}</td><td md-cell>{{solicitacaoAtivacao.solicitacao.solicitante.nome}}</td><td md-cell ng-if=solicitacaoAtivacao.solicitacao.data>{{solicitacaoAtivacao.solicitacao.data | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td md-cell ng-if=!solicitacaoAtivacao.solicitacao.data>Nunca Expira</td><td md-cell>{{solicitacaoAtivacao.solicitacao.situacao}}</td><td md-cell><ng-md-icon icon=add style=fill:#788489 size=22 alt=Aprovar ng-click=usuarioCtrl.tratar(solicitacaoAtivacao.id) ng-show=\"solicitacaoAtivacao.solicitacao.situacao == \'PENDENTE\'\"><md-tooltip>Aprovar</md-tooltip></ng-md-icon><ng-md-icon icon=clear style=fill:#788489 size=22 alt=Rejeitar ng-click=usuarioCtrl.recusar(solicitacaoAtivacao.id) ng-show=\"solicitacaoAtivacao.solicitacao.situacao == \'PENDENTE\'\"><md-tooltip>Rejeitar</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"usuarioCtrl.solicitacoes.length > 0\" md-limit=usuarioCtrl.query.limit md-limit-options=\"[20, 50, 100]\" md-page=usuarioCtrl.query.page md-total={{usuarioCtrl.solicitacoes.length}} md-on-paginate=usuarioCtrl.consultar md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></div></div>");
$templateCache.put("scripts/usuario/views/consultar-usuario.tmpl.html","<div class=padding-right-pagina ng-init=usuarioCtrl.inicializarConsulta();><h1 class=md-title>Consultar Usuários</h1><div layout=column layout-align=center><form class=caixa-consulta><div layout=row><md-input-container flex=30 class=padding-right-input><label>CPF</label><input ng-model=usuarioCtrl.query.cpf ui-br-cpf-mask></md-input-container></div><div layout=row><md-input-container class=md-block flex=30 class=padding-right-input><label>Tipo</label><md-select ng-model=usuarioCtrl.query.strInterno><md-option ng-repeat=\"tipo in usuarioCtrl.opcoesInternoExterno\" value=\"{{ tipo.value }}\">{{tipo.key}}</md-option></md-select><div ng-messages=form.tipo.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container flex=70><label>Nome</label><input ng-model=usuarioCtrl.query.nome></md-input-container></div></form><div layout=row layout-align=end class=margin-top><md-button type=reset class=md-raised ng-click=usuarioCtrl.limparConsultar()>Limpar</md-button><md-button id=consultarUsuario_Button type=submit class=md-raised ng-click=usuarioCtrl.consultarUsuario()>Consultar</md-button><md-button id=criarUsuario_Buttom type=submit class=md-raised ng-click=usuarioCtrl.criarNovoUsuario()>Novo</md-button></div></div><md-table-container ng-show=usuarioCtrl.usuarios><table md-table ng-model=usuarioCtrl.selecionado md-progress=promise><thead md-head md-order=usuarioCtrl.query.order><tr md-row><th md-column md-order-by=cpf><span>CPF</span></th><th md-column md-order-by=nome><span>Nome</span></th><th md-column md-order-by=tipo><span>Tipo do Usuário</span></th><th md-column md-order-by=situacao><span>Situação</span></th><th md-column><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"usuario in usuarioCtrl.usuarios | orderBy: usuarioCtrl.query.order | limitTo: usuarioCtrl.query.limit : (usuarioCtrl.query.page -1) * usuarioCtrl.query.limit\"><td md-cell>{{usuario.cpf}}</td><td md-cell>{{usuario.nome}}</td><td md-cell>{{usuario.interno && \"Interno\" || \"Externo\"}}</td><td md-cell><md-switch id=ativarInativar ng-model=usuario.ativo ng-change=usuarioCtrl.ativarInativar(usuario)>{{usuario.ativo && \"Ativo\" || \"Inativo\"}}</md-switch></td><td md-cell><ng-md-icon id=concederAcesso_Button icon=add style=fill:#788489 size=22 alt=\"Adicionar Acesso\" exibir-elemento-por-permissao=ACESSOS.CONCEDER_ACESSO ng-click=usuarioCtrl.addAcesso(usuario.id)><md-tooltip>Adicionar Acesso</md-tooltip></ng-md-icon><ng-md-icon id=detalhar_Button icon=search style=fill:#788489 size=22 alt=Detalhar ng-click=usuarioCtrl.detalhar(usuario.id)><md-tooltip>Detalhar</md-tooltip></ng-md-icon><ng-md-icon id=alterar_Button icon=create style=fill:#788489 size=22 alt=Editar exibir-elemento-por-permissao=ACESSOS.ALTERAR_USUARIO ng-click=usuarioCtrl.editar(usuario.id)><md-tooltip>Editar</md-tooltip></ng-md-icon><ng-md-icon id=excluir_Button icon=delete style=fill:#788489 size=22 alt=Excluir exibir-elemento-por-permissao=ACESSOS.EXCLUIR_USUARIO ng-click=\"usuarioCtrl.excluir($event, usuario.id)\"><md-tooltip>Excluir</md-tooltip></ng-md-icon><ng-md-icon id=swap_horiz icon=swap_horiz style=fill:#788489 size=22 alt=\"Movimentar Usuário (Alterar Lotação)\" exibir-elemento-por-permissao=ACESSOS.MOVIMENTAR_USUARIO ng-click=usuarioCtrl.movimentarUsuario(usuario.id)><md-tooltip>Movimentar Usuário (Alteração Lotação)</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container><md-table-pagination ng-if=\"usuarioCtrl.usuarios.length > 0\" md-limit=usuarioCtrl.query.limit md-limit-options=\"[20, 50, 100]\" md-page=usuarioCtrl.query.page md-total={{usuarioCtrl.usuarios.length}} md-on-paginate=usuarioCtrl.consultarUsuario md-page-select md-label=\"{page: \'Página:\', rowsPerPage: \'Itens por página:\', of: \'de\'}\"></md-table-pagination></div>");
$templateCache.put("scripts/usuario/views/detalhar-usuario.tmpl.html","<div class=padding-right-pagina ng-init=\"usuarioCtrl.recuperarUsuarioDetalhar(); usuarioCtrl.listarPerfisAssociados();\"><form name=form novalidate><div layout=row><md-input-container class=md-block flex=50><label>Nome do usuário</label><input name=nome ng-model=usuarioCtrl.form.nome disabled></md-input-container><md-input-container class=md-block flex=50><label>CPF</label><input name=cpf ng-model=usuarioCtrl.form.cpf ui-br-cpf-mask disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Tipo</label><input name=tipo ng-model=usuarioCtrl.form.interno disabled></md-input-container><md-input-container class=md-block flex=50><label>Unidade padrão</label><input name=unidadeExecutoraPadrao ng-model=usuarioCtrl.form.unidadeExecutoraPadrao.nome disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>E-mail</label><input name=email ng-model=usuarioCtrl.form.email disabled></md-input-container><md-input-container class=md-block flex=50><label>Situação</label><input name=ativo ng-model=usuarioCtrl.form.ativo disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Cargo</label><input name=cargo ng-model=usuarioCtrl.form.cargo disabled></md-input-container><md-input-container class=md-block flex=50><label>Departamento</label><input name=departamento ng-model=usuarioCtrl.form.departamento disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Celular</label><input name=celular ng-model=usuarioCtrl.form.telefoneCelular ui-br-phone-number disabled></md-input-container><md-input-container class=md-block flex=50><label>Telefone Trabalho</label><input name=telefoneTrabalho ng-model=usuarioCtrl.form.telefoneTrabalho ui-br-phone-number disabled></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Sala</label><input name=sala ng-model=usuarioCtrl.form.sala disabled></md-input-container><md-input-container class=md-block flex=50><label>Matrícula</label><input name=matricula ng-model=usuarioCtrl.form.matricula disabled></md-input-container></div><div layout=row layout-align=center ng-show=!usuarioCtrl.form.interno><md-input-container class=md-block flex=100><label>Senha</label><input type=password name=senha ng-model=usuarioCtrl.form.senha disabled autocomplete=off></md-input-container></div><div><div><div><md-table-container><table md-table><thead md-head><tr md-row><th md-column style=\"text-align: center\"><span>Sistema</span></th><th md-column style=\"text-align: center\"><span>Módulo</span></th><th md-column style=\"text-align: center\"><span>Perfil</span></th><th md-column style=\"text-align: center\"><span>Unidade</span></th><th md-column style=\"text-align: center\"><span>Jurisdição</span></th><th md-column style=\"text-align: center\"><span>Status</span></th><th md-column style=\"text-align: center\"><span>Validade</span></th><th md-column style=\"text-align: center\"><span>Ações</span></th></tr></thead><tbody md-body><tr md-row md-select-id=id md-auto-select ng-repeat=\"acesso in usuarioCtrl.acessosAssociados\"><td md-cell style=\"text-align: center\">{{acesso.modulo.sistema.nome}}</td><td md-cell style=\"text-align: center\">{{acesso.modulo.nome}}</td><td md-cell style=\"text-align: center\">{{acesso.perfil.nome}}</td><td md-cell style=\"text-align: center\">{{acesso.unidadeExecutora.nome}}</td><td md-cell style=\"text-align: center\"><span ng-repeat=\"jurisdicao in acesso.unidadeExecutora.jurisdicoes\"><span ng-if=!$last>{{jurisdicao.sigla}} /</span> <span ng-if=$last>{{jurisdicao.sigla}}</span></span></td><td md-cell style=\"text-align: center\">{{acesso.status}}</td><td md-cell style=\"text-align: center\">{{acesso.validadeDate | date : \"dd/MM/yyyy\"}}</td><td md-cell class=alinhamento-coluna-table><ng-md-icon icon=delete style=fill:#788489 size=22 alt=Excluir ng-click=usuarioCtrl.revogarAcessoAssociado(acesso.id) ng-if=\"acesso.status == \'Ativo\' && acesso.perfil.nome !== \'Usuário Autenticado\'\"><md-tooltip>Excluir</md-tooltip></ng-md-icon></td></tr></tbody></table></md-table-container></div></div></div></form><md-divider></md-divider><br><br><historico-unidade-padrao ng-if=usuarioCtrl.form.id id-usuario=usuarioCtrl.form.id atualizar-historico=true></historico-unidade-padrao><div layout=row layout-align=end class=margin-top><md-button id=voltar_Button class=md-raised ng-click=usuarioCtrl.voltar()>Fechar</md-button></div></div>");
$templateCache.put("scripts/usuario/views/editar-usuario.tmpl.html","<div class=padding-right-pagina ng-init=\"usuarioCtrl.recuperarUsuarioEditar(); usuarioCtrl.listarPerfisAssociados();\"><h1 class=md-title-com-borda>Editar Usuário</h1><form name=form novalidate><div layout=row><md-input-container class=md-block flex=50><label>Nome do usuário</label><input name=nome ng-model=usuarioCtrl.form.nome required><div ng-messages=form.nome.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=50><label>CPF</label><input name=cpf ng-model=usuarioCtrl.form.cpf ui-br-cpf-mask required disabled><div ng-messages=form.cpf.$error><div ng-message=required><small>Campo obrigatório</small></div><div ng-message=cpf><small>CPF inválido</small></div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Tipo</label><md-select ng-model=usuarioCtrl.form.interno><md-option ng-repeat=\"tipo in usuarioCtrl.opcoesInternoExterno\" ng-value=\"{{ tipo.value }}\">{{tipo.key}}</md-option></md-select><div ng-messages=form.tipo.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=50><label>Unidade padrão</label><md-autocomplete placeholder=\"Informe o nome ou código\" md-min-length=3 md-selected-item=usuarioCtrl.form.unidadeExecutoraPadrao md-search-text=usuarioCtrl.query.unidadeExecutoraPadrao md-items=\"item in usuarioCtrl.pesquisarUnidadeFiltro()\" md-item-text=\"item.codigoUg + \' - \' + item.nome\" md-no-cache=true md-input-minlength=3 md-delay=700 md-on-add=\"\" required disabled><span md-highlight-text=usuarioCtrl.query.unidadeExecutoraPadrao>{{item.codigoUg}} - {{item.nome}}</span><md-not-found>Não encontrado.</md-not-found></md-autocomplete><div ng-messages=form.unidadeExecutoraPadrao.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>E-mail</label><input name=email ng-model=usuarioCtrl.form.email required><div ng-messages=form.email.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=50><label>Confirmação do E-mail</label><input name=confirmacaoEmail ng-model=usuarioCtrl.form.confirmacaoEmail required><div ng-messages=form.confirmacaoEmail.$error><div ng-message=required><small>Campo obrigatório</small></div></div><div ng-show=\"form.confirmacaoEmail.$dirty && usuarioCtrl.form.confirmacaoEmail != usuarioCtrl.form.email\"><small>Os e-mails informados não coincidem</small></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Situação</label><md-select ng-model=usuarioCtrl.form.ativo><md-option ng-repeat=\"ativo in usuarioCtrl.opcoesAtivoInativo\" ng-value=\"{{ ativo.value }}\">{{ativo.key}}</md-option></md-select><div ng-messages=form.tipo.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=50><label>Cargo</label><input name=cargo ng-model=usuarioCtrl.form.cargo required><div ng-messages=form.cargo.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Telefone Trabalho</label><input name=telefoneTrabalho ng-model=usuarioCtrl.form.telefoneTrabalho ui-br-phone-number required><div ng-messages=form.telefoneTrabalho.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=50><label>Celular</label><input name=celular ng-model=usuarioCtrl.form.telefoneCelular ui-br-phone-number><div ng-messages=form.celular.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=50><label>Departamento</label><input name=departamento ng-model=usuarioCtrl.form.departamento></md-input-container><md-input-container class=md-block flex=50><label>Sala</label><input name=sala ng-model=usuarioCtrl.form.sala></md-input-container></div><div layout=row ng-show=!usuarioCtrl.form.interno><md-input-container class=md-block flex=50><label>Senha</label><input type=password name=senha ng-model=usuarioCtrl.form.senha autocomplete=off><div ng-messages=form.senha.$error><div ng-message=required><small>Campo obrigatório</small></div></div></md-input-container><md-input-container class=md-block flex=50><label>Confirmar Senha</label><input type=password name=confirmarSenha ng-model=usuarioCtrl.form.confirmarSenha autocomplete=off><div ng-messages=form.confirmarSenha.$error><div ng-message=required><small>Campo obrigatório</small></div></div><div ng-show=\"form.confirmarSenha.$dirty && usuarioCtrl.form.confirmarSenha != usuarioCtrl.form.senha\"><small>As senhas informadas não coincidem</small></div></md-input-container></div><div layout=row><md-input-container class=md-block flex=100><label>Matrícula</label><input name=matricula ng-model=usuarioCtrl.form.matricula></md-input-container></div></form><div layout=row layout-align=end><md-button class=md-raised ng-click=usuarioCtrl.voltar()>Fechar</md-button><md-button class=md-raised ng-click=usuarioCtrl.limparEdicao()>Limpar</md-button><md-button id=salvarEdicao_Button type=submit class=md-raised ng-click=usuarioCtrl.salvarEdicao()>Enviar</md-button></div></div>");
$templateCache.put("scripts/usuario/views/finalizacao-cadastro.tmpl.html","<div layout-xs=column ng-init=usuarioCtrl.recuperarSolicitacaoFinalizarCadastroUsuario()><md-content layout-padding><h1 class=md-title>Finalização do Cadastro</h1><md-divider style=\"margin-bottom: 30px\"></md-divider><form name=usuarioCtrl.finalizacaoCadastroForm novalidate><div layout=row layout-align=center><md-input-container class=md-block flex=50><label>Nome</label><input ng-model=usuarioCtrl.form.usuario.nome disabled></md-input-container><md-input-container class=md-block flex=50><label>CPF</label><input ng-model=usuarioCtrl.form.usuario.cpf ui-br-cpf-mask disabled></md-input-container></div><div layout=row layout-align=center><md-input-container class=md-block flex=50><label>Telefone Trabalho</label><input ng-required=!usuarioCtrl.form.usuario.telefoneCelular name=telefoneTrabalho ng-model=usuarioCtrl.form.usuario.telefoneTrabalho ui-br-phone-number></md-input-container><md-input-container class=md-block flex=50><label>Celular</label><input ng-required=!usuarioCtrl.form.usuario.telefoneTrabalho name=celular ng-model=usuarioCtrl.form.usuario.telefoneCelular ui-br-phone-number></md-input-container></div><div layout=row layout-align=center><md-input-container flex=100 class=\"md-icon-float md-block\"><label>Unidade de Lotação<ng-md-icon icon=help style=fill:#788489 size=26 alt=Ajuda></ng-md-icon><md-tooltip>Este campo pode ser utilizado para associar uma unidade/UG Executora/departamento/setor/órgão a um usuário ou perfil dentro do sistema acessos</md-tooltip></label><md-autocomplete ng-model=usuarioCtrl.form.usuario.unidadeExecutoraPadrao md-selected-item=usuarioCtrl.form.usuario.unidadeExecutoraPadrao md-search-text=textoBusca md-items=\"unidade in usuarioCtrl.carregarUnidadePorNome(textoBusca)\" md-item-text=unidade.nome md-no-cache=true md-input-minlength=3 md-delay=700 required><md-item-template><span md-highlight-text=textoBusca md-highlight-flags=gi>{{unidade.nome}} - {{unidade.siglaCompleta}}</span></md-item-template><md-not-found>Unidade não encontrada.</md-not-found></md-autocomplete></md-input-container></div><div layout=row layout-align=center><md-input-container class=md-block flex=50><label>Departamento</label><input name=departamento ng-change=\"usuarioCtrl.upperCase(\'departamento\')\" ng-model=usuarioCtrl.form.usuario.departamento></md-input-container><md-input-container class=md-block flex=50><label>Sala</label><input name=sala ng-change=\"usuarioCtrl.upperCase(\'sala\')\" ng-model=usuarioCtrl.form.usuario.sala></md-input-container></div><div layout=row layout-align=center ng-if=!usuarioCtrl.form.usuario.interno><md-input-container class=md-block flex=50><label>Cargo</label><input name=cargo ng-change=\"usuarioCtrl.upperCase(\'cargo\')\" ng-model=usuarioCtrl.form.usuario.cargo></md-input-container><md-input-container class=md-block flex=50><label>Matrícula</label><input name=matricula ng-model=usuarioCtrl.form.usuario.matricula></md-input-container></div></form><solicitar-acesso model=usuarioCtrl.acessosAssociadosObj></solicitar-acesso><div layout=row layout-align=end-center><md-button class=md-raised ng-click=usuarioCtrl.limpar()>Limpar</md-button><md-button type=submit class=\"md-primary md-raised\" ng-click=usuarioCtrl.enviarCadastroUsuario() ng-disabled=usuarioCtrl.bloquearEnviarFinalizacao>Enviar</md-button></div></md-content></div>");
$templateCache.put("scripts/usuario/views/movimentar-usuario.tmpl.html","<div class=padding-right-pagina ng-init=\"usuarioCtrl.recuperarUsuarioMovimentar(); usuarioCtrl.recuperarOrigens();\" nf-if=usuarioCtrl.movimentarUsuarioDto><h1 class=md-title-com-borda>Movimentar Usuário</h1><form><div class=md-padding ng-cloak><div class=dados-usuario><p><span>Nome do Usuário: </span>{{usuarioCtrl.usuario.nome}}</p><p><span>CPF: </span>{{usuarioCtrl.usuario.cpf}}</p><p><span>Unidade Padrão: </span>{{usuarioCtrl.usuario.unidadeExecutoraPadrao.nome}}</p></div></div><md-divider></md-divider><div layout=row><md-input-container class=md-block flex=50><label>Estrutura Organizacional</label><md-select name=origem ng-if=usuarioCtrl.origens ng-model=usuarioCtrl.origem required><md-option ng-repeat=\"origem in usuarioCtrl.origens\" ng-value=origem>{{origem}}</md-option></md-select></md-input-container></div><div layout=row><md-input-container flex=100 flex-xs=100><label>Unidade<ng-md-icon icon=help style=fill:#788489 size=26 alt=Ajuda></ng-md-icon><md-tooltip>Este campo pode ser utilizado para associar uma unidade/UG Executora/departamento/setor/órgão a um usuário ou perfil dentro do sistema acessos</md-tooltip></label><md-autocomplete ng-model=usuarioCtrl.movimentarUsuarioDto.unidadeExecutora md-selected-item=usuarioCtrl.movimentarUsuarioDto.unidadeExecutora md-search-text=ugExecutora md-items=\"ug in usuarioCtrl.carregarUnidadePorNome(ugExecutora)\" md-item-text=ug.nome md-no-cache=true md-input-minlength=3 md-delay=700 md-min-length=3 required ng-disabled=!usuarioCtrl.origem><span md-highlight-text=ugExecutora ng-if=ug.siglaCompleta>{{ug.nome}} - {{ug.siglaCompleta}}</span> <span md-highlight-text=ugExecutora ng-if=\"ug.sigla && !ug.siglaCompleta\">{{ug.nome}} - {{ug.sigla}}</span> <span md-highlight-text=ugExecutora ng-if=\"!ug.sigla && !ug.siglaCompleta\">{{ug.nome}}</span><md-not-found>Unidade não encontrada. É necessário cadastrá-la e ativá-la antes de realizar a solicitação.</md-not-found></md-autocomplete></md-input-container></div><div layout=row><md-checkbox ng-model=usuarioCtrl.movimentarUsuarioDto.replicarPermissoes aria-label=replicar>Deseja replicar as permissões da unidade anterior para a nova unidade?</md-checkbox></div><div layout=row><md-checkbox ng-model=usuarioCtrl.movimentarUsuarioDto.revogarPermissoes aria-label=revogar>Deseja revogar as permissões da unidade anterior?</md-checkbox></div><div layout=row layout-align=end layout-margin=10><md-button class=md-raised ng-click=usuarioCtrl.voltar()>Voltar</md-button><md-button type=submit class=md-raised ng-click=usuarioCtrl.gravarMovimentacaoUsuario() layout-aling=end>Gravar</md-button></div></form></div>");
$templateCache.put("scripts/usuario/views/usuario-erro-ldap.tmpl.html","<div class=padding-right-pagina><div class=md-title-com-borda>Ocorreu um erro ao acessar seus dados de login no LDAP</div><h2 style=\"margin-top: 50px; text-align: center\">Erro de Autenticação!</h2><h3 style=\"text-align: center; line-height: 200%; margin-top: 50px\">Aguarde um momento e tente novamente.<br><br>Em caso de persistir o erro, favor encaminhar para o administrador</h3></div>");
$templateCache.put("scripts/usuario/views/usuario-sem-cadastro.tmpl.html","<div class=padding-right-pagina><div class=md-title-com-borda>Usuário sem Acesso</div><h2 style=\"margin-top: 50px; text-align: center\">Sem acesso ao sistema!</h2><h3 style=\"text-align: center; line-height: 200%; margin-top: 50px\">Você não possui acesso a esse sistema.<br><br>Encaminhamos uma mensagem para o seu e-mail com o link para realizar o cadastro e solicitar acesso.</h3><h3 style=\"text-align: center; line-height: 200%; margin-top: 50px\">Dica: se a mensagem não chegar na caixa de entrada, verifique a caixa de Spam.</h3></div>");}]);